// AUTO-GENERATED — 勿手改。重新生成: python3 scripts/generate-site-data.py
/* eslint-disable */

export const SITE_DATA = {
  "countries": [
    {
      "id": "AL",
      "name": "阿尔巴尼亚",
      "name_en": "Albania",
      "flag": "🇦🇱",
      "continent": "Europe",
      "popularity": 27,
      "description": "低价海岸线+奥斯曼遗迹，背包客小众之选。",
      "description_en": "Affordable coastline and Ottoman heritage; a backpacker's hidden gem."
    },
    {
      "id": "AD",
      "name": "安道尔",
      "name_en": "Andorra",
      "flag": "🇦🇩",
      "continent": "Europe",
      "popularity": 39,
      "description": "滑雪+免税，比利牛斯山夹缝中难出圈。",
      "description_en": "Skiing and duty-free; tucked in the Pyrenees, often overlooked."
    },
    {
      "id": "AT",
      "name": "奥地利",
      "name_en": "Austria",
      "flag": "🇦🇹",
      "continent": "Europe",
      "popularity": 12,
      "description": "维也纳音乐+阿尔卑斯山，古典美代表。",
      "description_en": "Vienna music and the Alps; the epitome of classical beauty."
    },
    {
      "id": "BY",
      "name": "白俄罗斯",
      "name_en": "Belarus",
      "flag": "🇧🇾",
      "continent": "Europe",
      "popularity": 43,
      "description": "签证难+政治封闭，游客极少。",
      "description_en": "Strict visas and political isolation; very few tourists."
    },
    {
      "id": "BE",
      "name": "比利时",
      "name_en": "Belgium",
      "flag": "🇧🇪",
      "continent": "Europe",
      "popularity": 19,
      "description": "布鲁日童话+欧盟总部，但体量有限。",
      "description_en": "Bruges fairy tale and EU headquarters; compact but charming."
    },
    {
      "id": "BA",
      "name": "波黑",
      "name_en": "Bosnia and Herzegovina",
      "flag": "🇧🇦",
      "continent": "Europe",
      "popularity": 37,
      "description": "莫斯塔尔古桥渐热，战后形象仍拖累。",
      "description_en": "Mostar's old bridge is rising in popularity; post-war image still holds it back."
    },
    {
      "id": "BG",
      "name": "保加利亚",
      "name_en": "Bulgaria",
      "flag": "🇧🇬",
      "continent": "Europe",
      "popularity": 28,
      "description": "黑海沙滩+玫瑰谷，东欧隐形选手。",
      "description_en": "Black Sea beaches and Rose Valley; Eastern Europe's underrated pick."
    },
    {
      "id": "HR",
      "name": "克罗地亚",
      "name_en": "Croatia",
      "flag": "🇭🇷",
      "continent": "Europe",
      "popularity": 7,
      "description": "《权游》+杜布罗夫尼克，亚得里亚海顶流。",
      "description_en": "Game of Thrones and Dubrovnik; the Adriatic's top destination."
    },
    {
      "id": "CY",
      "name": "塞浦路斯",
      "name_en": "Cyprus",
      "flag": "🇨🇾",
      "continent": "Europe",
      "popularity": 31,
      "description": "地中海度假，存在感被希腊压制。",
      "description_en": "Mediterranean getaway; often overshadowed by Greece."
    },
    {
      "id": "CZ",
      "name": "捷克",
      "name_en": "Czechia",
      "flag": "🇨🇿",
      "continent": "Europe",
      "popularity": 14,
      "description": "布拉格广场，东欧性价比之王。",
      "description_en": "Prague's squares; Eastern Europe's best value for money."
    },
    {
      "id": "DK",
      "name": "丹麦",
      "name_en": "Denmark",
      "flag": "🇩🇰",
      "continent": "Europe",
      "popularity": 16,
      "description": "哥本哈根设计+乐高，北欧幸福标杆。",
      "description_en": "Copenhagen design and Lego; the Nordic happiness benchmark."
    },
    {
      "id": "EE",
      "name": "爱沙尼亚",
      "name_en": "Estonia",
      "flag": "🇪🇪",
      "continent": "Europe",
      "popularity": 30,
      "description": "塔林数字游民天堂，波罗的海三国最热。",
      "description_en": "Tallinn digital nomad haven; the hottest of the Baltic three."
    },
    {
      "id": "FI",
      "name": "芬兰",
      "name_en": "Finland",
      "flag": "🇫🇮",
      "continent": "Europe",
      "popularity": 18,
      "description": "圣诞老人村+极光，冬季旅游扛把子。",
      "description_en": "Santa Claus Village and Northern Lights; winter travel champion."
    },
    {
      "id": "FR",
      "name": "法国",
      "name_en": "France",
      "flag": "🇫🇷",
      "continent": "Europe",
      "popularity": 1,
      "description": "全球游客量第一，巴黎铁塔无敌。",
      "description_en": "World's top tourist destination; the Eiffel Tower and romance reign."
    },
    {
      "id": "DE",
      "name": "德国",
      "name_en": "Germany",
      "flag": "🇩🇪",
      "continent": "Europe",
      "popularity": 4,
      "description": "柏林墙+新天鹅堡，欧洲经济文化双中心。",
      "description_en": "Berlin Wall and Neuschwanstein Castle; Europe's economic and cultural hub."
    },
    {
      "id": "GR",
      "name": "希腊",
      "name_en": "Greece",
      "flag": "🇬🇷",
      "continent": "Europe",
      "popularity": 6,
      "description": "圣托里尼+雅典卫城，度假天花板。",
      "description_en": "Santorini and the Acropolis; the ultimate holiday destination."
    },
    {
      "id": "HU",
      "name": "匈牙利",
      "name_en": "Hungary",
      "flag": "🇭🇺",
      "continent": "Europe",
      "popularity": 20,
      "description": "布达佩斯温泉+渔人堡，中东欧性价比之选。",
      "description_en": "Budapest thermal baths and Fisherman's Bastion; Central Europe's best value."
    },
    {
      "id": "IS",
      "name": "冰岛",
      "name_en": "Iceland",
      "flag": "🇮🇸",
      "continent": "Europe",
      "popularity": 13,
      "description": "极光+火山，社交媒体自然奇观顶流。",
      "description_en": "Northern Lights and volcanoes; nature's spectacle and social media star."
    },
    {
      "id": "IE",
      "name": "爱尔兰",
      "name_en": "Ireland",
      "flag": "🇮🇪",
      "continent": "Europe",
      "popularity": 15,
      "description": "都柏林酒吧+《正常人》取景，英语游学热。",
      "description_en": "Dublin pubs and Normal People filming spots; English study abroad hotspot."
    },
    {
      "id": "IT",
      "name": "意大利",
      "name_en": "Italy",
      "flag": "🇮🇹",
      "continent": "Europe",
      "popularity": 2,
      "description": "罗马+威尼斯+五渔村，文化美食双王炸。",
      "description_en": "Rome, Venice and Cinque Terre; culture and cuisine at their best."
    },
    {
      "id": "LV",
      "name": "拉脱维亚",
      "name_en": "Latvia",
      "flag": "🇱🇻",
      "continent": "Europe",
      "popularity": 33,
      "description": "里加新艺术建筑，旅游配套较弱。",
      "description_en": "Riga's Art Nouveau architecture; tourism infrastructure still developing."
    },
    {
      "id": "LI",
      "name": "列支敦士登",
      "name_en": "Liechtenstein",
      "flag": "🇱🇮",
      "continent": "Europe",
      "popularity": 41,
      "description": "阿尔卑斯袖珍国，存在感接近零。",
      "description_en": "Alpine microstate; low profile but charming."
    },
    {
      "id": "LT",
      "name": "立陶宛",
      "name_en": "Lithuania",
      "flag": "🇱🇹",
      "continent": "Europe",
      "popularity": 34,
      "description": "十字架山+维尔纽斯，波罗的海三国最冷。",
      "description_en": "Hill of Crosses and Vilnius; the quietest of the Baltic three."
    },
    {
      "id": "LU",
      "name": "卢森堡",
      "name_en": "Luxembourg",
      "flag": "🇱🇺",
      "continent": "Europe",
      "popularity": 36,
      "description": "欧盟「办公室」，景点仅够半日游。",
      "description_en": "EU 'office'; sights fit a half-day visit."
    },
    {
      "id": "MT",
      "name": "马耳他",
      "name_en": "Malta",
      "flag": "🇲🇹",
      "continent": "Europe",
      "popularity": 29,
      "description": "《权游》取景+英语游学，岛国体量小。",
      "description_en": "Game of Thrones filming location and English study; small island nation."
    },
    {
      "id": "MD",
      "name": "摩尔多瓦",
      "name_en": "Moldova",
      "flag": "🇲🇩",
      "continent": "Europe",
      "popularity": 42,
      "description": "欧洲最穷国，酒庄旅游未成气候。",
      "description_en": "Europe's poorest country; wine tourism still emerging."
    },
    {
      "id": "MC",
      "name": "摩纳哥",
      "name_en": "Monaco",
      "flag": "🇲🇨",
      "continent": "Europe",
      "popularity": 35,
      "description": "F1+赌场，富豪专属，大众匆匆一瞥。",
      "description_en": "F1 and casinos; luxury playground, quick stop for most."
    },
    {
      "id": "ME",
      "name": "黑山",
      "name_en": "Montenegro",
      "flag": "🇲🇪",
      "continent": "Europe",
      "popularity": 22,
      "description": "科托尔湾「峡湾」+免签，巴尔干潜力股。",
      "description_en": "Kotor Bay 'fjord' and visa-free; Balkans' rising star."
    },
    {
      "id": "NL",
      "name": "荷兰",
      "name_en": "Netherlands",
      "flag": "🇳🇱",
      "continent": "Europe",
      "popularity": 10,
      "description": "阿姆斯特丹运河+梵高，自由与艺术标签鲜明。",
      "description_en": "Amsterdam canals and Van Gogh; freedom and art define it."
    },
    {
      "id": "MK",
      "name": "北马其顿",
      "name_en": "North Macedonia",
      "flag": "🇲🇰",
      "continent": "Europe",
      "popularity": 38,
      "description": "奥赫里德湖美但交通不便，巴尔干小透明。",
      "description_en": "Lake Ohrid is stunning but access is tricky; Balkans' hidden gem."
    },
    {
      "id": "NO",
      "name": "挪威",
      "name_en": "Norway",
      "flag": "🇳🇴",
      "continent": "Europe",
      "popularity": 24,
      "description": "峡湾震撼但物价劝退，游客量受限。",
      "description_en": "Fjords are stunning but high costs limit visitor numbers."
    },
    {
      "id": "PL",
      "name": "波兰",
      "name_en": "Poland",
      "flag": "🇵🇱",
      "continent": "Europe",
      "popularity": 21,
      "description": "克拉科夫老城+奥斯维辛，历史游核心。",
      "description_en": "Kraków old town and Auschwitz; at the heart of history tourism."
    },
    {
      "id": "PT",
      "name": "葡萄牙",
      "name_en": "Portugal",
      "flag": "🇵🇹",
      "continent": "Europe",
      "popularity": 9,
      "description": "里斯本电车+波尔图酒庄，欧美网红最爱。",
      "description_en": "Lisbon trams and Porto wine cellars; favourite of influencers worldwide."
    },
    {
      "id": "RO",
      "name": "罗马尼亚",
      "name_en": "Romania",
      "flag": "🇷🇴",
      "continent": "Europe",
      "popularity": 26,
      "description": "吸血鬼城堡+特兰西瓦尼亚，神秘感为主。",
      "description_en": "Dracula's castle and Transylvania; mystery and folklore."
    },
    {
      "id": "RU",
      "name": "俄罗斯",
      "name_en": "Russia",
      "flag": "🇷🇺",
      "continent": "Europe",
      "popularity": 44,
      "description": "战争前莫斯科较热，目前游客归零。",
      "description_en": "Moscow was popular before the war; tourism has collapsed."
    },
    {
      "id": "SM",
      "name": "圣马力诺",
      "name_en": "San Marino",
      "flag": "🇸🇲",
      "continent": "Europe",
      "popularity": 40,
      "description": "邮票王国，游客多为意大利顺路打卡。",
      "description_en": "Stamp kingdom; often a side trip from Italy."
    },
    {
      "id": "RS",
      "name": "塞尔维亚",
      "name_en": "Serbia",
      "flag": "🇷🇸",
      "continent": "Europe",
      "popularity": 25,
      "description": "贝尔格莱德夜生活+东欧朋克风，免签但宣传弱。",
      "description_en": "Belgrade nightlife and Eastern European edge; visa-free but underpromoted."
    },
    {
      "id": "SK",
      "name": "斯洛伐克",
      "name_en": "Slovakia",
      "flag": "🇸🇰",
      "continent": "Europe",
      "popularity": 32,
      "description": "布拉迪斯拉发一日游，高塔特拉山徒步冷门。",
      "description_en": "Bratislava day trip; High Tatras hiking is an underrated gem."
    },
    {
      "id": "SI",
      "name": "斯洛文尼亚",
      "name_en": "Slovenia",
      "flag": "🇸🇮",
      "continent": "Europe",
      "popularity": 23,
      "description": "布莱德湖「童话岛」，生态旅游新秀。",
      "description_en": "Lake Bled 'fairy-tale island'; eco-tourism newcomer."
    },
    {
      "id": "ES",
      "name": "西班牙",
      "name_en": "Spain",
      "flag": "🇪🇸",
      "continent": "Europe",
      "popularity": 3,
      "description": "巴塞罗那+伊比萨岛，年游客量超8000万。",
      "description_en": "Barcelona and Ibiza; over 80 million visitors a year."
    },
    {
      "id": "SE",
      "name": "瑞典",
      "name_en": "Sweden",
      "flag": "🇸🇪",
      "continent": "Europe",
      "popularity": 17,
      "description": "斯德哥尔摩+ABBA博物馆，北欧中性冷淡风鼻祖。",
      "description_en": "Stockholm and ABBA Museum; Nordic minimalism at its best."
    },
    {
      "id": "CH",
      "name": "瑞士",
      "name_en": "Switzerland",
      "flag": "🇨🇭",
      "continent": "Europe",
      "popularity": 11,
      "description": "阿尔卑斯少女峰+精准奢华，游客消费力极强。",
      "description_en": "Jungfrau and Alpine precision; high-spending visitors."
    },
    {
      "id": "TR",
      "name": "土耳其",
      "name_en": "Turkey",
      "flag": "🇹🇷",
      "continent": "Europe",
      "popularity": 8,
      "description": "卡帕多奇亚热气球+伊斯坦布尔，亚欧游客皆爱。",
      "description_en": "Cappadocia hot air balloons and Istanbul; loved by Asian and European travellers alike."
    },
    {
      "id": "UA",
      "name": "乌克兰",
      "name_en": "Ukraine",
      "flag": "🇺🇦",
      "continent": "Europe",
      "popularity": 45,
      "description": "战前利沃夫小众，现为全球最危险旅行地之一。",
      "description_en": "Lviv was a niche pick before the war; now among the world's most dangerous destinations."
    },
    {
      "id": "GB",
      "name": "英国",
      "name_en": "United Kingdom",
      "flag": "🇬🇧",
      "continent": "Europe",
      "popularity": 5,
      "description": "伦敦+爱丁堡+哈利波特，英语国家流量霸主。",
      "description_en": "London, Edinburgh and Harry Potter; the English-speaking world's top draw."
    },
    {
      "id": "VA",
      "name": "梵蒂冈",
      "name_en": "Vatican City",
      "flag": "🇻🇦",
      "continent": "Europe",
      "popularity": 46,
      "description": "罗马必打卡，但作为「国家」常被忽略。",
      "description_en": "Must-see from Rome; often overlooked as a 'country' in its own right."
    }
  ],
  "visas": [
    {
      "country_id": "AL",
      "type": "visa-free",
      "schengen": 0,
      "description": "免签",
      "official_url": "/"
    },
    {
      "country_id": "AD",
      "type": "visa-required",
      "schengen": 1,
      "description": "需西班牙申根签",
      "official_url": "https://web.blscn.cn/chinese/"
    },
    {
      "country_id": "AT",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/aut/"
    },
    {
      "country_id": "BY",
      "type": "visa-free",
      "schengen": 0,
      "description": "免签",
      "official_url": "/"
    },
    {
      "country_id": "BE",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/bel"
    },
    {
      "country_id": "BA",
      "type": "visa-free",
      "schengen": 0,
      "description": "免签",
      "official_url": "/"
    },
    {
      "country_id": "BG",
      "type": "visa-required",
      "schengen": 1,
      "description": "独立签证",
      "official_url": "https://visa.vfsglobal.com/chn/zh/bgr/"
    },
    {
      "country_id": "HR",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/hrv"
    },
    {
      "country_id": "CY",
      "type": "visa-required",
      "schengen": 0,
      "description": "独立签证",
      "official_url": "http://www.mfa.gov.cy/mfa/embassies/embassy_beijing.nsf/DMLcontactus_ol/DMLcontactus_ol?OpenDocument"
    },
    {
      "country_id": "CZ",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/cze/"
    },
    {
      "country_id": "DK",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/dnk/"
    },
    {
      "country_id": "EE",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/est/"
    },
    {
      "country_id": "FI",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/fin/"
    },
    {
      "country_id": "FR",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://france-visas.gouv.fr/zh/web/france-visas/"
    },
    {
      "country_id": "DE",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/deu/"
    },
    {
      "country_id": "GR",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://cn-gr.gvcworld.eu/cn"
    },
    {
      "country_id": "HU",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/hun/"
    },
    {
      "country_id": "IS",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/isl/"
    },
    {
      "country_id": "IE",
      "type": "visa-required",
      "schengen": 0,
      "description": "独立签证",
      "official_url": "https://visa.vfsglobal.com/chn/zh/irl/"
    },
    {
      "country_id": "IT",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/ita/"
    },
    {
      "country_id": "LV",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/lva/"
    },
    {
      "country_id": "LI",
      "type": "visa-required",
      "schengen": 1,
      "description": "需瑞士申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/che"
    },
    {
      "country_id": "LT",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://cn.mfa.lt/cn/GuanYuWoMen/ShiGuan/LianXiFangShi/121"
    },
    {
      "country_id": "LU",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/lux"
    },
    {
      "country_id": "MT",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/mlt/"
    },
    {
      "country_id": "MD",
      "type": "visa-required",
      "schengen": 0,
      "description": "独立签证",
      "official_url": "https://www.evisa.gov.md/"
    },
    {
      "country_id": "MC",
      "type": "visa-required",
      "schengen": 1,
      "description": "需法国申根签",
      "official_url": "https://france-visas.gouv.fr/zh/web/france-visas/"
    },
    {
      "country_id": "ME",
      "type": "visa-free",
      "schengen": 0,
      "description": "免签（有效期内英美申根签，或当地旅行社邀请函）",
      "official_url": "/"
    },
    {
      "country_id": "NL",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://ind.nl/en/short-stay/short-stay-holiday-or-business-visa"
    },
    {
      "country_id": "MK",
      "type": "visa-free",
      "schengen": 0,
      "description": "持有英美加拿大实体签证，可以免签入境，签证有效期要比入境停留时间多5天",
      "official_url": "/"
    },
    {
      "country_id": "NO",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/nor/"
    },
    {
      "country_id": "PL",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/pol/"
    },
    {
      "country_id": "PT",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/prt/"
    },
    {
      "country_id": "RO",
      "type": "visa-required",
      "schengen": 1,
      "description": "独立签证",
      "official_url": "https://evisa.mae.ro/?lang=en-US#"
    },
    {
      "country_id": "RU",
      "type": "visa-required",
      "schengen": 0,
      "description": "独立签证",
      "official_url": "https://evisa.kdmid.ru/"
    },
    {
      "country_id": "SM",
      "type": "visa-free",
      "schengen": 1,
      "description": "免签",
      "official_url": "/"
    },
    {
      "country_id": "RS",
      "type": "visa-free",
      "schengen": 0,
      "description": "免签",
      "official_url": "/"
    },
    {
      "country_id": "SK",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://ezov.mzv.sk/e-zov/?siteLanguage=en"
    },
    {
      "country_id": "SI",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/svn"
    },
    {
      "country_id": "ES",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://web.blscn.cn/chinese/"
    },
    {
      "country_id": "SE",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/swe/"
    },
    {
      "country_id": "CH",
      "type": "visa-required",
      "schengen": 1,
      "description": "申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/che/"
    },
    {
      "country_id": "TR",
      "type": "visa-free",
      "schengen": 0,
      "description": "免签",
      "official_url": "/"
    },
    {
      "country_id": "UA",
      "type": "visa-required",
      "schengen": 0,
      "description": "独立签证",
      "official_url": "https://visa.vfsglobal.com/chn/zh/ukr/"
    },
    {
      "country_id": "GB",
      "type": "visa-required",
      "schengen": 0,
      "description": "独立签证",
      "official_url": "https://visas-immigration.service.gov.uk/alt-language-selection-skip-visa"
    },
    {
      "country_id": "VA",
      "type": "visa-required",
      "schengen": 1,
      "description": "需意大利申根签",
      "official_url": "https://visa.vfsglobal.com/chn/zh/ita/"
    }
  ],
  "attractions": [
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "埃菲尔铁塔",
      "attractions_name_en": "Eiffel Tower",
      "description": "巴黎的标志性建筑，可以登顶俯瞰全城美景，尤其夜景璀璨迷人。",
      "official_link": "https://www.toureiffel.paris/en",
      "price_range": "11.80 - 29.40 (根据层高和方式)",
      "currency": "EUR",
      "description_en": "Iconic Paris landmark; climb for city views, especially stunning at night.",
      "price_range_en": "€11.80 - €29.40 (by level and option)",
      "official_link_en": "https://www.toureiffel.paris/en"
    },
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "卢浮宫",
      "attractions_name_en": "Louvre Museum",
      "description": "世界三大博物馆之一，藏有《蒙娜丽莎》、《维纳斯》等无数珍宝。",
      "official_link": "https://www.louvre.fr/zh-hans",
      "price_range": "22",
      "currency": "EUR",
      "description_en": "One of the world's top museums; home to the Mona Lisa, Venus de Milo and countless treasures.",
      "price_range_en": "€22",
      "official_link_en": "https://www.louvre.fr/zh-hans"
    },
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "巴黎圣母院",
      "attractions_name_en": "Notre-Dame de Paris",
      "description": "哥特式建筑的杰作，虽然在修复中，但其历史地位和外观依然令人震撼。",
      "official_link": "https://www.notredamedeparis.fr/",
      "price_range": "免费参观（塔楼部分曾收费，目前内部修复中）",
      "currency": "EUR",
      "description_en": "Masterpiece of Gothic architecture; under restoration but still impressive in scale and history.",
      "price_range_en": "Free (tower was paid; interior currently under restoration)",
      "official_link_en": "https://www.notredamedeparis.fr/"
    },
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "奥赛博物馆",
      "attractions_name_en": "Musée d'Orsay",
      "description": "由旧火车站改建而成，以印象派和后印象派艺术藏品为主。",
      "official_link": "https://www.musee-orsay.fr/",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "Converted from a former railway station; strong on Impressionist and Post-Impressionist art.",
      "price_range_en": "€16",
      "official_link_en": "https://www.musee-orsay.fr/"
    },
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "凡尔赛宫",
      "attractions_name_en": "Palace of Versailles",
      "description": "法国国王的行宫，以其奢华的建筑、花园和镜厅而闻名。",
      "official_link": "https://en.chateauversailles.fr/",
      "price_range": "19.50 (宫殿) - 28.50 (包含花园音乐喷泉或夜间表演)",
      "currency": "EUR",
      "description_en": "Royal palace famous for lavish architecture, gardens and the Hall of Mirrors.",
      "price_range_en": "€19.50 (palace) - €28.50 (with gardens fountains or evening show)",
      "official_link_en": "https://en.chateauversailles.fr/"
    },
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "凯旋门",
      "attractions_name_en": "Arc de Triomphe",
      "description": "位于香榭丽舍大街的西端，是纪念拿破仑战争胜利的标志性建筑。",
      "official_link": "https://www.paris-arc-de-triomphe.fr/",
      "price_range": "13",
      "currency": "EUR",
      "description_en": "Iconic monument at the western end of the Champs-Élysées, commemorating Napoleonic victories.",
      "price_range_en": "€13",
      "official_link_en": "https://www.paris-arc-de-triomphe.fr/"
    },
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "塞纳河游船",
      "attractions_name_en": "Seine River Cruise",
      "description": "乘坐游船欣赏塞纳河两岸的巴黎地标建筑，体验别样的浪漫。",
      "official_link": "https://www.bateaux-mouches.fr/zh",
      "price_range": "15 - 20 (根据公司和包含内容)",
      "currency": "EUR",
      "description_en": "Cruise the Seine past Paris landmarks; a classic way to see the city.",
      "price_range_en": "€15 - €20 (varies by operator and inclusions)",
      "official_link_en": "https://www.bateaux-mouches.fr/zh"
    },
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "香榭丽舍大街",
      "attractions_name_en": "Champs-Élysées",
      "description": "巴黎最著名的街道，集购物、餐饮、文化于一体，通向凯旋门。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Paris's most famous avenue; shopping, dining and culture, leading to the Arc de Triomphe.",
      "price_range_en": "Free (public street)",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "蒙马特高地与圣心大教堂",
      "attractions_name_en": "Montmartre & Sacré-Cœur Basilica",
      "description": "艺术家的聚集地，可以俯瞰巴黎全景，圣心大教堂是其标志。",
      "official_link": "圣心大教堂无门票，免费参观",
      "price_range": "免费（登穹顶约6-8欧元）",
      "currency": "EUR",
      "description_en": "Artists' quarter with panoramic views; the Sacré-Cœur basilica is the landmark.",
      "price_range_en": "Free (dome approx. €6-8)",
      "official_link_en": "Sacré-Cœur basilica free; no ticket required"
    },
    {
      "id": "FR",
      "cityname": "巴黎",
      "cityname_en": "Paris",
      "attractions_name": "巴黎歌剧院（加尼叶宫）",
      "attractions_name_en": "Opéra Garnier",
      "description": "法国歌剧和芭蕾的殿堂，建筑本身就是一件艺术品。",
      "official_link": "https://www.operadeparis.fr/",
      "price_range": "14 - 20 (参观)",
      "currency": "EUR",
      "description_en": "Temple of French opera and ballet; the building itself is a work of art.",
      "price_range_en": "€14 - €20 (visit)",
      "official_link_en": "https://www.operadeparis.fr/"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "天使湾",
      "attractions_name_en": "Baie des Anges",
      "description": "尼斯最著名的海湾，拥有美丽的鹅卵石海滩和蔚蓝的海水。",
      "official_link": "无官方购票链接，为公共海湾",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Nice's most famous bay, with a beautiful pebble beach and clear blue water.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public bay"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "英国人散步大道",
      "attractions_name_en": "Promenade des Anglais",
      "description": "沿着天使湾延伸的著名海滨大道，是散步、骑行和欣赏海景的绝佳地点。",
      "official_link": "无官方购票链接，为公共道路",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The iconic seafront promenade along the bay—perfect for a stroll, a bike ride, or simply taking in the sea views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public road"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "尼斯老城",
      "attractions_name_en": "Old Nice",
      "description": "迷宫般的狭窄街道，色彩斑斓的建筑，充满当地特色的小店和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A maze of narrow streets and colourful buildings, packed with local shops and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "城堡山",
      "attractions_name_en": "Castle Hill",
      "description": "登上山顶可以俯瞰尼斯全景、天使湾和港口。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Climb to the top for sweeping views over Nice, the bay and the harbour.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "马蒂斯博物馆",
      "attractions_name_en": "Matisse Museum",
      "description": "收藏了法国著名画家亨利·马蒂斯不同时期的作品。",
      "official_link": "https://www.musee-matisse-nice.org/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Houses works by the French painter Henri Matisse from across his career.",
      "price_range_en": "€10",
      "official_link_en": "https://www.musee-matisse-nice.org/"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "现代艺术与当代艺术博物馆",
      "attractions_name_en": "Museum of Modern and Contemporary Art (MAMAC)",
      "description": "收藏20世纪下半叶至今的艺术作品，包括波普艺术和新现实主义。",
      "official_link": "https://www.mamac-nice.org/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Art from the late 20th century to the present, including Pop Art and Nouveau Réalisme.",
      "price_range_en": "€10",
      "official_link_en": "https://www.mamac-nice.org/"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "凤凰园",
      "attractions_name_en": "Phoenix Parc Floral de Nice",
      "description": "一个大型植物园，内有热带温室和各种动植物。",
      "official_link": "https://www.parc-phoenix.org/",
      "price_range": "5.2",
      "currency": "EUR",
      "description_en": "A large botanical garden with a tropical greenhouse and a variety of plants and animals.",
      "price_range_en": "€5.20",
      "official_link_en": "https://www.parc-phoenix.org/"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "俄罗斯东正教大教堂",
      "attractions_name_en": "Saint Nicholas Russian Orthodox Cathedral",
      "description": "尼斯乃至法国最大的俄罗斯东正教教堂，建筑风格独特。",
      "official_link": "http://www.cathedrale-russe-nice.fr/",
      "price_range": "免费（建议捐款）",
      "currency": "EUR",
      "description_en": "The largest Russian Orthodox church in Nice and in France, with distinctive architecture.",
      "price_range_en": "Free (donation suggested)",
      "official_link_en": "http://www.cathedrale-russe-nice.fr/"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "西米埃修道院",
      "attractions_name_en": "Cimiez Monastery",
      "description": "拥有美丽的玫瑰园和修道院博物馆，是罗马古城遗址的一部分。",
      "official_link": "无需购票",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Lovely rose garden and monastery museum, set among ancient Roman ruins.",
      "price_range_en": "Free",
      "official_link_en": "No ticket required"
    },
    {
      "id": "FR",
      "cityname": "尼斯",
      "cityname_en": "Nice",
      "attractions_name": "萨雷亚广场市集",
      "attractions_name_en": "Cours Saleya Market",
      "description": "每天开放（周一除外）的鲜花和农产品市场，充满当地生活气息。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A daily flower and produce market (closed Mondays) with a real local buzz.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "FR",
      "cityname": "马赛",
      "cityname_en": "Marseille",
      "attractions_name": "圣母加德大教堂",
      "attractions_name_en": "Notre-Dame de la Garde Basilica",
      "description": "马赛的标志，坐落在城市最高点，可以俯瞰整个马赛城和地中海。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Marseille's landmark basilica on the city's highest point, with views over the city and the Mediterranean.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "FR",
      "cityname": "马赛",
      "cityname_en": "Marseille",
      "attractions_name": "马赛老港",
      "attractions_name_en": "Old Port of Marseille",
      "description": "马赛的心脏地带，渔船和游艇停靠，周边有许多餐厅和酒吧。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The heart of Marseille—fishing boats and yachts, surrounded by restaurants and bars.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FR",
      "cityname": "马赛",
      "cityname_en": "Marseille",
      "attractions_name": "欧洲与地中海文明博物馆 (MuCEM)",
      "attractions_name_en": "Museum of European and Mediterranean Civilisations (MuCEM)",
      "description": "现代建筑与古老堡垒相结合，展示地中海文化。",
      "official_link": "https://www.mucem.org/en",
      "price_range": "11",
      "currency": "EUR",
      "description_en": "Striking modern architecture alongside an ancient fort, celebrating Mediterranean culture.",
      "price_range_en": "€11",
      "official_link_en": "https://www.mucem.org/en"
    },
    {
      "id": "FR",
      "cityname": "马赛",
      "cityname_en": "Marseille",
      "attractions_name": "伊夫堡",
      "attractions_name_en": "Château d'If",
      "description": "位于伊夫岛上的著名监狱，因大仲马的小说《基督山伯爵》而闻名。",
      "official_link": "http://www.chateau-if.fr/",
      "price_range": "6 (船票另计)",
      "currency": "EUR",
      "description_en": "The famous island prison that inspired Dumas's The Count of Monte Cristo.",
      "price_range_en": "€6 (boat fare separate)",
      "official_link_en": "http://www.chateau-if.fr/"
    },
    {
      "id": "FR",
      "cityname": "马赛",
      "cityname_en": "Marseille",
      "attractions_name": "圣约翰堡",
      "attractions_name_en": "Fort Saint-Jean",
      "description": "位于老港入口处，与MuCEM相连，是历史悠久的防御工事。",
      "official_link": "https://www.mucem.org/en/visit/fort-saint-jean",
      "price_range": "包含在MuCEM门票内",
      "currency": "EUR",
      "description_en": "Historic fort at the entrance to the old port, linked to MuCEM.",
      "price_range_en": "Included in MuCEM ticket",
      "official_link_en": "https://www.mucem.org/en/visit/fort-saint-jean"
    },
    {
      "id": "FR",
      "cityname": "马赛",
      "cityname_en": "Marseille",
      "attractions_name": "卡朗格峡湾国家公园",
      "attractions_name_en": "Calanques National Park",
      "description": "壮丽的石灰岩峡湾，拥有碧绿的海水和徒步线路。",
      "official_link": "无官方购票链接，为自然公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Stunning limestone calanques with turquoise water and hiking trails.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; nature park"
    },
    {
      "id": "FR",
      "cityname": "马赛",
      "cityname_en": "Marseille",
      "attractions_name": "隆尚宫",
      "attractions_name_en": "Palais Longchamp",
      "description": "宏伟的建筑群，包括博物馆、喷泉和花园，是城市供水工程的象征。",
      "official_link": "无门票，免费参观公园及外部建筑，博物馆需购票",
      "price_range": "免费（博物馆另行收费）",
      "currency": "EUR",
      "description_en": "Grand palace complex with museums, fountains and gardens—a symbol of the city's waterworks.",
      "price_range_en": "Free (museums charge separately)",
      "official_link_en": "Park and exterior free; museum tickets required"
    },
    {
      "id": "FR",
      "cityname": "马赛",
      "cityname_en": "Marseille",
      "attractions_name": "马赛历史博物馆",
      "attractions_name_en": "Marseille History Museum",
      "description": "了解马赛从古至今的历史，包括古希腊和古罗马遗迹。",
      "official_link": "https://musee-histoire.marseille.fr/",
      "price_range": "6",
      "currency": "EUR",
      "description_en": "Discover Marseille's history from antiquity to today, including Greek and Roman remains.",
      "price_range_en": "€6",
      "official_link_en": "https://musee-histoire.marseille.fr/"
    },
    {
      "id": "FR",
      "cityname": "马赛",
      "cityname_en": "Marseille",
      "attractions_name": "圣维克多修道院",
      "attractions_name_en": "Saint Victor's Abbey",
      "description": "马赛最古老的修道院之一，地下室藏有早期基督教遗迹。",
      "official_link": "无需购票",
      "price_range": "2（地下室）",
      "currency": "EUR",
      "description_en": "One of Marseille's oldest abbeys, with early Christian remains in the crypt.",
      "price_range_en": "€2 (crypt)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "富维耶圣母院",
      "attractions_name_en": "Basilica of Notre-Dame de Fourvière",
      "description": "坐落在富维耶山上，是里昂的标志性建筑，俯瞰城市。",
      "official_link": "https://www.fourviere.org/",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Lyon's landmark basilica on the hill of Fourvière, looking out over the city.",
      "price_range_en": "Free",
      "official_link_en": "https://www.fourviere.org/"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "里昂老城 ( Vieux Lyon )",
      "attractions_name_en": "Old Lyon",
      "description": "欧洲保存最完好的文艺复兴时期老城之一，拥有独特的“Traboules”小巷。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Europe's best-preserved Renaissance quarters, with its unique traboule passageways.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "里昂美术馆",
      "attractions_name_en": "Museum of Fine Arts of Lyon",
      "description": "法国最大的美术馆之一，收藏了从中世纪到现代的艺术品。",
      "official_link": "https://www.mba-lyon.fr/",
      "price_range": "8 - 12 (根据展览)",
      "currency": "EUR",
      "description_en": "One of France's largest fine-arts museums, from medieval to modern.",
      "price_range_en": "€8–€12 (depending on exhibitions)",
      "official_link_en": "https://www.mba-lyon.fr/"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "高卢-罗马文明博物馆",
      "attractions_name_en": "Lugdunum - Musée et Théâtres Romains (Museum and Roman Theatres)",
      "description": "位于古罗马剧场旁边，展示里昂作为高卢首都的历史。",
      "official_link": "https://lugdunum.grandlyon.com/",
      "price_range": "7",
      "currency": "EUR",
      "description_en": "Next to the Roman theatres, telling the story of Lyon as capital of Roman Gaul.",
      "price_range_en": "€7",
      "official_link_en": "https://lugdunum.grandlyon.com/"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "圣让首席大教堂",
      "attractions_name_en": "Cathédrale Saint-Jean-Baptiste",
      "description": "里昂老城中心的大教堂，融合了罗马式和哥特式建筑风格。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The cathedral at the heart of Vieux Lyon, blending Romanesque and Gothic styles.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "特拉布勒小巷",
      "attractions_name_en": "Traboules",
      "description": "里昂特有的秘密通道，连接着房屋和街道，曾是丝绸工人运输货物的通道。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Lyon's secret passageways linking buildings and streets—once used by silk workers.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "金头公园",
      "attractions_name_en": "Parc de la Tête d'Or",
      "description": "法国最大的城市公园之一，内有湖泊、植物园和动物园。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of France's largest urban parks, with lakes, a botanical garden and a zoo.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "国际木偶博物馆 (盖纳克木偶博物馆)",
      "attractions_name_en": "Musée Gadagne (International Puppet Museum)",
      "description": "位于老城内的博物馆，展示里昂著名的木偶艺术和城市历史。",
      "official_link": "https://www.gadagne-lyon.fr/",
      "price_range": "6 (单个博物馆)，9 (两个博物馆)",
      "currency": "EUR",
      "description_en": "Museum in the old town celebrating Lyon's famous puppetry and local history.",
      "price_range_en": "€6 (one museum), €9 (both museums)",
      "official_link_en": "https://www.gadagne-lyon.fr/"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "沃土广场",
      "attractions_name_en": "Place des Terreaux",
      "description": "里昂市中心的重要广场，周边有市政厅和美术馆。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Lyon's central square, flanked by the town hall and fine-arts museum.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "FR",
      "cityname": "里昂",
      "cityname_en": "Lyon",
      "attractions_name": "里昂灯光节",
      "attractions_name_en": "Fête des Lumières",
      "description": "每年12月举行的盛大灯光艺术节，吸引全球游客。",
      "official_link": "节庆活动，无单独购票链接，部分表演可能需要预约",
      "price_range": "免费（部分特殊活动可能收费）",
      "currency": "EUR",
      "description_en": "The spectacular Festival of Lights each December draws visitors from around the world.",
      "price_range_en": "Free (some events may charge)",
      "official_link_en": "Festival; no single ticket link; some events may require booking"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "水镜广场",
      "attractions_name_en": "Miroir d'eau",
      "description": "波尔多最受欢迎的景点之一，一个巨大的水面，倒映着历史建筑。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Bordeaux's most popular spots—a vast water mirror reflecting the historic façades.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "波尔多大剧院",
      "attractions_name_en": "Grand Théâtre de Bordeaux",
      "description": "18世纪的新古典主义建筑杰作，被誉为法国最美丽的剧院之一。",
      "official_link": "https://www.opera-bordeaux.com/",
      "price_range": "4.80 (参观)",
      "currency": "EUR",
      "description_en": "An 18th-century neoclassical masterpiece, often called one of France's most beautiful theatres.",
      "price_range_en": "€4.80 (visit)",
      "official_link_en": "https://www.opera-bordeaux.com/"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "圣安德烈大教堂",
      "attractions_name_en": "Cathédrale Saint-André",
      "description": "波尔多最大的教堂，哥特式建筑的典范，其钟楼可俯瞰城市。",
      "official_link": "无门票，免费参观",
      "price_range": "免费（登钟楼约6）",
      "currency": "EUR",
      "description_en": "Bordeaux's largest church and a fine example of Gothic architecture; the bell tower offers city views.",
      "price_range_en": "Free (tower approx. €6)",
      "official_link_en": "Free admission"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "葡萄酒城",
      "attractions_name_en": "Cité du Vin",
      "description": "一个现代化的葡萄酒主题博物馆，全面介绍葡萄酒的历史、文化和酿造过程。",
      "official_link": "https://www.laciteduvin.com/en",
      "price_range": "22",
      "currency": "EUR",
      "description_en": "A modern wine museum covering the history, culture and making of wine.",
      "price_range_en": "€22",
      "official_link_en": "https://www.laciteduvin.com/en"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "坎康斯广场",
      "attractions_name_en": "Place des Quinconces",
      "description": "欧洲最大的城市广场之一，是许多活动和节日的举办地。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Europe's largest city squares and a hub for events and festivals.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "波尔多博物馆",
      "attractions_name_en": "Musée des Beaux-Arts de Bordeaux",
      "description": "收藏了从中世纪到20世纪的欧洲艺术作品。",
      "official_link": "https://www.musba-bordeaux.fr/",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "European art from the Middle Ages to the 20th century.",
      "price_range_en": "€8",
      "official_link_en": "https://www.musba-bordeaux.fr/"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "圣米歇尔教堂",
      "attractions_name_en": "Basilique Saint-Michel",
      "description": "拥有波尔多最高的尖塔，是联合国教科文组织世界遗产。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Bordeaux's tallest spire and a UNESCO World Heritage site.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "阿基坦博物馆",
      "attractions_name_en": "Musée d'Aquitaine",
      "description": "展示阿基坦大区从史前时期到现代的历史和考古发现。",
      "official_link": "https://www.musee-aquitaine-bordeaux.fr/",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "The history and archaeology of the Aquitaine region from prehistoric times to the present.",
      "price_range_en": "€5",
      "official_link_en": "https://www.musee-aquitaine-bordeaux.fr/"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "梅花广场",
      "attractions_name_en": "Place de la Bourse",
      "description": "经典的路易十五时期建筑群，是波尔多城市规划的代表作。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A classic Louis XV ensemble and a landmark of Bordeaux's town planning.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "FR",
      "cityname": "波尔多",
      "cityname_en": "Bordeaux",
      "attractions_name": "葡萄酒学校 (波尔多葡萄酒贸易和葡萄酒中心)",
      "attractions_name_en": "École du Vin de Bordeaux (Bordeaux Wine School)",
      "description": "提供各种葡萄酒品鉴课程和体验活动。",
      "official_link": "https://www.bordeaux-wine-school.com/",
      "price_range": "价格因课程而异",
      "currency": "EUR",
      "description_en": "Wine tastings, courses and experiences for every level.",
      "price_range_en": "Varies by course",
      "official_link_en": "https://www.bordeaux-wine-school.com/"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "雅典卫城",
      "attractions_name_en": "Acropolis of Athens",
      "description": "古希腊文明的象征，包含帕特农神庙、伊瑞克提翁神庙等著名建筑。",
      "official_link": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1N",
      "price_range": "20 (通票30)",
      "currency": "EUR",
      "description_en": "The symbol of ancient Greece, with the Parthenon, Erechtheion and other iconic monuments.",
      "price_range_en": "€20 (combo ticket €30)",
      "official_link_en": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1N"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "卫城博物馆",
      "attractions_name_en": "Acropolis Museum",
      "description": "现代化的博物馆，展出从雅典卫城发掘出的文物。",
      "official_link": "https://www.theacropolismuseum.gr/en",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "A modern museum housing finds from the Acropolis site.",
      "price_range_en": "€15",
      "official_link_en": "https://www.theacropolismuseum.gr/en"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "宪法广场",
      "attractions_name_en": "Syntagma Square",
      "description": "雅典的中心广场，国会大厦所在地，每小时有卫兵换岗仪式。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Athens' central square in front of Parliament, with the hourly changing of the guard.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "帕特农神庙",
      "attractions_name_en": "Parthenon",
      "description": "雅典卫城的主体建筑，供奉雅典娜女神，古希腊建筑艺术的巅峰。",
      "official_link": "包含在雅典卫城门票内",
      "price_range": "包含在雅典卫城门票内",
      "currency": "EUR",
      "description_en": "The Acropolis's centrepiece, dedicated to Athena—a peak of ancient Greek architecture.",
      "price_range_en": "Included in Acropolis ticket",
      "official_link_en": "Included in Acropolis ticket"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "普拉卡区",
      "attractions_name_en": "Plaka",
      "description": "雅典最古老的街区，充满波西米亚风情，有许多商店、餐厅和咖啡馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Athens' oldest neighbourhood, with a bohemian feel, full of shops, restaurants and cafés.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "古罗马市集",
      "attractions_name_en": "Roman Agora",
      "description": "雅典古罗马时期重要的商业和公共中心遗址。",
      "official_link": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1N",
      "price_range": "10 (通票30)",
      "currency": "EUR",
      "description_en": "Remains of Athens' Roman-era commercial and civic heart.",
      "price_range_en": "€10 (combo ticket €30)",
      "official_link_en": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1N"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "国家考古博物馆",
      "attractions_name_en": "National Archaeological Museum",
      "description": "希腊最大的考古博物馆，藏有大量古希腊艺术珍品。",
      "official_link": "https://www.namuseum.gr/gr/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Greece's largest archaeological museum, with a superb collection of ancient Greek art.",
      "price_range_en": "€12",
      "official_link_en": "https://www.namuseum.gr/gr/"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "宙斯神庙",
      "attractions_name_en": "Temple of Olympian Zeus",
      "description": "古希腊最大的神庙之一，虽然只剩下几根立柱，但依然宏伟。",
      "official_link": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1N",
      "price_range": "10 (通票30)",
      "currency": "EUR",
      "description_en": "One of the largest ancient Greek temples; only a few columns remain, but the scale is still impressive.",
      "price_range_en": "€10 (combo ticket €30)",
      "official_link_en": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1N"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "蒙纳斯提拉奇广场",
      "attractions_name_en": "Monastiraki Square",
      "description": "充满活力的跳蚤市场和商业区，可以欣赏卫城美景。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A lively flea market and shopping area with great views of the Acropolis.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "GR",
      "cityname": "雅典",
      "cityname_en": "Athens",
      "attractions_name": "吕卡维多斯山",
      "attractions_name_en": "Mount Lycabettus",
      "description": "雅典的最高点，可乘坐缆车登顶，欣赏城市全景和日落。",
      "official_link": "缆车无官方购票链接，景点免费",
      "price_range": "往返缆车约10",
      "currency": "EUR",
      "description_en": "Athens' highest point; take the cable car up for panoramic views and sunset.",
      "price_range_en": "Cable car return approx. €10",
      "official_link_en": "No official cable car ticket link; attraction free"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "白塔",
      "attractions_name_en": "White Tower of Thessaloniki",
      "description": "塞萨洛尼基的标志性建筑，曾是防御工事和监狱，现在是博物馆。",
      "official_link": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1N",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Thessaloniki's landmark—once a fort and prison, now a museum.",
      "price_range_en": "€8",
      "official_link_en": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1N"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "罗马市集与剧场",
      "attractions_name_en": "Roman Forum & Odeon",
      "description": "城市的古罗马中心，遗址包含市集、剧场和浴场。",
      "official_link": "无需购票",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The city's Roman heart—remains of the forum, theatre and baths.",
      "price_range_en": "Free",
      "official_link_en": "No ticket required"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "凯旋门和加莱里乌斯圆形大厅",
      "attractions_name_en": "Arch of Galerius and Rotunda",
      "description": "罗马皇帝加莱里乌斯时期的纪念性建筑群。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Monumental complex from the reign of the Roman emperor Galerius.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "圣迪米特里奥斯教堂",
      "attractions_name_en": "Church of Saint Demetrius",
      "description": "供奉塞萨洛尼基主保圣人圣迪米特里奥斯，宏伟的拜占庭式教堂。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Grand Byzantine church dedicated to the city's patron saint, St Demetrios.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "拜占庭文化博物馆",
      "attractions_name_en": "Museum of Byzantine Culture",
      "description": "收藏了大量拜占庭时期文物，展示了该时期的艺术和历史。",
      "official_link": "https://www.mbp.gr/en/",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Rich collection of Byzantine art and history.",
      "price_range_en": "€8",
      "official_link_en": "https://www.mbp.gr/en/"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "阿纳波利（上城）",
      "attractions_name_en": "Ano Poli (Upper Town)",
      "description": "塞萨洛尼基的老城区，保留了许多奥斯曼时期的建筑和拜占庭城墙。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The old upper town, with Ottoman-era buildings and Byzantine walls.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "考古博物馆",
      "attractions_name_en": "Archaeological Museum of Thessaloniki",
      "description": "展出从史前到罗马时期的塞萨洛尼基及其周边地区的考古发现。",
      "official_link": "https://www.amth.gr/en/",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Archaeological finds from Thessaloniki and the region, from prehistory to Roman times.",
      "price_range_en": "€8",
      "official_link_en": "https://www.amth.gr/en/"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "阿吉亚索菲亚教堂",
      "attractions_name_en": "Hagia Sophia of Thessaloniki",
      "description": "联合国教科文组织世界遗产，拜占庭建筑的典范。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage site and a fine example of Byzantine architecture.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "滨海大道",
      "attractions_name_en": "Nea Paralia (Waterfront)",
      "description": "沿着城市海岸线延伸的现代化滨海步道，适合散步和休闲。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A modern waterfront promenade along the coast—ideal for a stroll or a break.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "塞萨洛尼基",
      "cityname_en": "Thessaloniki",
      "attractions_name": "亚里士多德广场",
      "attractions_name_en": "Aristotle Square",
      "description": "塞萨洛尼基最著名的广场，周边有许多咖啡馆、商店和酒店。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Thessaloniki's most famous square, surrounded by cafés, shops and hotels.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "伊亚小镇",
      "attractions_name_en": "Oia Village",
      "description": "圣托里尼最著名的村庄，以其标志性的蓝顶教堂和世界级日落而闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Santorini's most famous village—iconic blue-domed churches and world-class sunsets.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "费拉小镇",
      "attractions_name_en": "Fira Town",
      "description": "圣托里尼的首府，悬崖小镇，连接着老港口和缆车。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Santorini's cliff-top capital, linking the old port and the cable car.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "阿克罗蒂里遗址",
      "attractions_name_en": "Akrotiri Archaeological Site",
      "description": "古老的米诺斯文明遗址，被称为“希腊的庞贝城”。",
      "official_link": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1P&place=000000017",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Ancient Minoan site often called the \"Pompeii of Greece\".",
      "price_range_en": "€12",
      "official_link_en": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1P&place=000000017"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "红沙滩",
      "attractions_name_en": "Red Beach",
      "description": "独特的红色沙滩，被火山岩包围，风景独特。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A unique red-sand beach surrounded by volcanic cliffs.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "黑沙滩（卡马利海滩）",
      "attractions_name_en": "Perissa Beach / Kamari Beach",
      "description": "火山活动形成的黑色沙滩，是圣托里尼著名的海滩之一。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Volcanic black sand—one of Santorini's best-known beaches.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "火山岛和温泉",
      "attractions_name_en": "Santorini Volcano & Hot Springs",
      "description": "乘坐游船前往火山岛徒步，并在温泉中游泳。",
      "official_link": "游船公司提供购票，无官方统一链接",
      "price_range": "20 - 30 (船费)",
      "currency": "EUR",
      "description_en": "Boat trip to the volcano for a walk and a swim in the hot springs.",
      "price_range_en": "€20–€30 (boat)",
      "official_link_en": "Tickets from boat operators; no single official link"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "圣托里尼葡萄酒博物馆",
      "attractions_name_en": "Koutsoyannopoulos Wine Museum",
      "description": "家族经营的地下博物馆，展示圣托里尼葡萄酒酿造历史。",
      "official_link": "https://www.santoriniwinemuseum.com/",
      "price_range": "10 (含品酒)",
      "currency": "EUR",
      "description_en": "Family-run underground museum on Santorini's wine-making history, with tasting.",
      "price_range_en": "€10 (includes tasting)",
      "official_link_en": "https://www.santoriniwinemuseum.com/"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "费罗斯特法尼小镇",
      "attractions_name_en": "Firostefani Village",
      "description": "位于费拉北部，拥有著名的蓝顶教堂（“三蓝顶”），景色优美。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "North of Fira, with the famous \"three blue domes\" and lovely views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "圣托里尼灯塔 (阿克罗蒂里灯塔)",
      "attractions_name_en": "Akrotiri Lighthouse",
      "description": "岛上最古老的灯塔之一，位于岛屿西南角，观赏日落的好地方。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of the island's oldest lighthouses, on the southwest tip—great for sunset.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "圣托里尼",
      "cityname_en": "Santorini",
      "attractions_name": "圣托里尼史前博物馆",
      "attractions_name_en": "Museum of Prehistoric Thera",
      "description": "位于费拉，展出阿克罗蒂里遗址出土的文物。",
      "official_link": "https://archaeologicalmuseums.gr/en/museum/5df34af3deca5e2d79e8c191/museum-of-prehistoric-thira",
      "price_range": "6 (通票15)",
      "currency": "EUR",
      "description_en": "In Fira, displaying finds from the Akrotiri site.",
      "price_range_en": "€6 (combo ticket €15)",
      "official_link_en": "https://archaeologicalmuseums.gr/en/museum/5df34af3deca5e2d79e8c191/museum-of-prehistoric-thira"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "罗德岛中世纪老城",
      "attractions_name_en": "Medieval City of Rhodes",
      "description": "欧洲保存最完好的中世纪城市之一，有城墙、骑士街和宫殿。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分景点收费）",
      "currency": "EUR",
      "description_en": "One of Europe's best-preserved medieval towns—walls, Street of the Knights and palaces.",
      "price_range_en": "Free (some sights charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "骑士宫",
      "attractions_name_en": "Palace of the Grand Master of the Knights",
      "description": "中世纪老城内的标志性建筑，曾是圣约翰骑士团团长的居所。",
      "official_link": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1P&place=000000016",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "The medieval old town's landmark—once the Grand Master's palace.",
      "price_range_en": "€10",
      "official_link_en": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1P&place=000000016"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "骑士街",
      "attractions_name_en": "Street of the Knights",
      "description": "中世纪老城内保存最完好的街道，两旁是骑士们的行会会所。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The old town's best-preserved street, lined with the knights' inns.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "曼德拉基港口",
      "attractions_name_en": "Mandraki Harbour",
      "description": "罗德岛的主要港口，传说罗德岛巨像曾立于此。",
      "official_link": "无官方购票链接，为公共港口",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Rhodes' main harbour—where the Colossus is said to have stood.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public port"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "林多斯卫城",
      "attractions_name_en": "Acropolis of Lindos",
      "description": "位于林多斯村的山顶，有雅典娜神庙遗址，可俯瞰美丽海湾。",
      "official_link": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1P&place=000000015",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "The acropolis above Lindos village—temple of Athena and stunning bay views.",
      "price_range_en": "€12",
      "official_link_en": "https://hhticket.gr/tap_b2c_new/english/tap.exe?PM=P1P&place=000000015"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "蝴蝶谷",
      "attractions_name_en": "Valley of the Butterflies",
      "description": "一个天然的公园，夏季有成千上万的蝴蝶聚集。",
      "official_link": "https://valleyofbutterflies.com/tickets/",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "A natural park where thousands of butterflies gather in summer.",
      "price_range_en": "€5",
      "official_link_en": "https://valleyofbutterflies.com/tickets/"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "考古博物馆",
      "attractions_name_en": "Archaeological Museum of Rhodes",
      "description": "位于骑士医院旧址内，展出罗德岛及其周边地区的考古发现。",
      "official_link": "http://odysseus.culture.gr/h/1/eh155.jsp?obj_id=3312",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "In the former Knights' hospital—archaeological finds from Rhodes and the region.",
      "price_range_en": "€8",
      "official_link_en": "http://odysseus.culture.gr/h/1/eh155.jsp?obj_id=3312"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "圣保罗湾",
      "attractions_name_en": "Saint Paul's Bay",
      "description": "林多斯附近一个景色优美的海湾，适合游泳和日光浴。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A pretty bay near Lindos, ideal for swimming and sunbathing.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "法利拉基海滩",
      "attractions_name_en": "Faliraki Beach",
      "description": "罗德岛最受欢迎的海滩之一，拥有各种水上活动和夜生活。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Rhodes' most popular beaches—watersports by day, nightlife after dark.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "GR",
      "cityname": "罗德岛",
      "cityname_en": "Rhodes",
      "attractions_name": "古罗德卫城",
      "attractions_name_en": "Ancient Acropolis of Rhodes",
      "description": "罗德市外的古希腊卫城遗址，有阿波罗神庙和剧场遗迹。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Ancient acropolis outside Rhodes town—temple of Apollo and theatre remains.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "科孚老城",
      "attractions_name_en": "Old Town of Corfu",
      "description": "联合国教科文组织世界遗产，威尼斯式建筑和狭窄的鹅卵石街道。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage site—Venetian architecture and narrow cobbled streets.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "老堡垒",
      "attractions_name_en": "Old Fortress of Corfu",
      "description": "科孚岛的标志性防御工事，可以登顶俯瞰老城和大海。",
      "official_link": "http://odysseus.culture.gr/h/3/eh355.jsp?obj_id=954",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Corfu's iconic fort—climb up for views over the old town and the sea.",
      "price_range_en": "€10",
      "official_link_en": "http://odysseus.culture.gr/h/3/eh355.jsp?obj_id=954"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "新堡垒",
      "attractions_name_en": "New Fortress of Corfu",
      "description": "另一座威尼斯堡垒，与老堡垒共同守护着城市。",
      "official_link": "http://odysseus.culture.gr/h/2/eh255.jsp?obj_id=27065",
      "price_range": "6",
      "currency": "EUR",
      "description_en": "Another Venetian fortress, guarding the city with the Old Fort.",
      "price_range_en": "€6",
      "official_link_en": "http://odysseus.culture.gr/h/2/eh255.jsp?obj_id=27065"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "圣斯皮里顿教堂",
      "attractions_name_en": "Church of Saint Spyridon",
      "description": "科孚岛最重要的教堂，供奉岛屿的守护神圣斯皮里顿。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Corfu's most important church, dedicated to the island's patron saint, Spyridon.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "阿喀琉斯宫",
      "attractions_name_en": "Achilleion Palace",
      "description": "奥地利皇后茜茜公主的夏宫，以希腊神话英雄阿喀琉斯为主题。",
      "official_link": "http://achillion-corfu.gr/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Empress Sisi's summer palace, themed around the hero Achilles.",
      "price_range_en": "€10",
      "official_link_en": "http://achillion-corfu.gr/"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "卡诺尼和庞蒂科尼西",
      "attractions_name_en": "Kanoni & Pontikonisi (Mouse Island)",
      "description": "观赏飞机降落的最佳地点，以及标志性的“老鼠岛”和弗拉赫纳修道院。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Famous for plane-spotting, the \"Mouse Island\" and Vlacherna Monastery.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "佩拉莱斯海滩",
      "attractions_name_en": "Paleokastritsa Beach",
      "description": "科孚岛最著名的海滩之一，拥有清澈碧绿的海水和石灰岩悬崖。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Corfu's most famous beaches—clear green water and limestone cliffs.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "考古博物馆",
      "attractions_name_en": "Archaeological Museum of Corfu",
      "description": "展出从科孚岛发现的考古文物，包括戈尔贡梅杜莎雕像。",
      "official_link": "http://odysseus.culture.gr/h/1/eh155.jsp?obj_id=3420",
      "price_range": "6",
      "currency": "EUR",
      "description_en": "Archaeological finds from Corfu, including the Gorgon Medusa pediment.",
      "price_range_en": "€6",
      "official_link_en": "http://odysseus.culture.gr/h/1/eh155.jsp?obj_id=3420"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "圣乔治宫",
      "attractions_name_en": "Palace of St. Michael and St. George",
      "description": "曾是英国总督府，现在是亚洲艺术博物馆。",
      "official_link": "无线上购买链接",
      "price_range": "6",
      "currency": "EUR",
      "description_en": "Former British Governor's residence, now the Museum of Asian Art.",
      "price_range_en": "€6",
      "official_link_en": "No online ticket link"
    },
    {
      "id": "GR",
      "cityname": "科孚岛",
      "cityname_en": "Corfu",
      "attractions_name": "西达里运河爱",
      "attractions_name_en": "Canal D'Amour (Sidari)",
      "description": "西达里地区独特的岩石地貌和海蚀洞，传说在此游泳能找到真爱。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Sidari's distinctive rock formations and sea caves—legend says a swim here finds true love.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "罗马斗兽场",
      "attractions_name_en": "Colosseum",
      "description": "古罗马帝国最著名的建筑之一，曾是角斗士竞技的场所。",
      "official_link": "https://ticketing.colosseo.it/zh/",
      "price_range": "18 (含罗马广场和帕拉蒂尼山)",
      "currency": "EUR",
      "description_en": "One of the Roman Empire's most famous buildings—home of gladiatorial games.",
      "price_range_en": "€18 (includes Roman Forum and Palatine)",
      "official_link_en": "https://ticketing.colosseo.it/zh/"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "罗马广场",
      "attractions_name_en": "Roman Forum",
      "description": "古罗马的政治、经济、文化中心遗址。",
      "official_link": "包含在罗马斗兽场门票内",
      "price_range": "包含在罗马斗兽场门票内",
      "currency": "EUR",
      "description_en": "The heart of ancient Rome—political, commercial and cultural centre.",
      "price_range_en": "Included in Colosseum ticket",
      "official_link_en": "Included in Colosseum ticket"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "帕拉蒂尼山",
      "attractions_name_en": "Palatine Hill",
      "description": "罗马七丘之一，古罗马帝王宫殿的所在地。",
      "official_link": "包含在罗马斗兽场门票内",
      "price_range": "包含在罗马斗兽场门票内",
      "currency": "EUR",
      "description_en": "One of Rome's seven hills—site of the imperial palaces.",
      "price_range_en": "Included in Colosseum ticket",
      "official_link_en": "Included in Colosseum ticket"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "特莱维喷泉",
      "attractions_name_en": "Trevi Fountain",
      "description": "罗马最大的巴洛克风格喷泉，传说在此投掷硬币可重回罗马。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Rome's largest Baroque fountain—toss a coin in to ensure your return.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "梵蒂冈博物馆",
      "attractions_name_en": "Vatican Museums",
      "description": "世界上最重要的博物馆之一，收藏了大量艺术珍品，包括西斯廷教堂。",
      "official_link": "https://www.museivaticani.va/content/museivaticani/en.html",
      "price_range": "20",
      "currency": "EUR",
      "description_en": "One of the world's greatest museums—masterpieces galore, including the Sistine Chapel.",
      "price_range_en": "€20",
      "official_link_en": "https://www.museivaticani.va/content/museivaticani/en.html"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "圣彼得大教堂",
      "attractions_name_en": "St. Peter's Basilica",
      "description": "世界上最大的教堂，天主教的中心，米开朗基罗的《圣殇》在此。",
      "official_link": "https://www.basilicasanpietro.va/",
      "price_range": "无门票，免费参观（登穹顶收费）",
      "currency": "EUR",
      "description_en": "The world's largest church and Catholic heart—home to Michelangelo's Pietà.",
      "price_range_en": "Free (dome climb charge)",
      "official_link_en": "https://www.basilicasanpietro.va/"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "万神殿",
      "attractions_name_en": "Pantheon",
      "description": "保存完好的古罗马建筑，曾是供奉众神的庙宇，后改为教堂。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分时段可能需要预约）",
      "currency": "EUR",
      "description_en": "Remarkably preserved ancient Roman temple-turned-church.",
      "price_range_en": "Free (booking may be required at busy times)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "西斯廷教堂",
      "attractions_name_en": "Sistine Chapel",
      "description": "梵蒂冈博物馆的一部分，以米开朗基罗的壁画《创世纪》和《最后的审判》闻名。",
      "official_link": "包含在梵蒂冈博物馆门票内",
      "price_range": "包含在梵蒂冈博物馆门票内",
      "currency": "EUR",
      "description_en": "Part of the Vatican Museums—Michelangelo's Genesis and Last Judgement frescoes.",
      "price_range_en": "Included in Vatican Museums ticket",
      "official_link_en": "Included in Vatican Museums ticket"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "纳沃纳广场",
      "attractions_name_en": "Piazza Navona",
      "description": "巴洛克艺术的杰作，有贝尼尼的四河喷泉。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A Baroque masterpiece, with Bernini's Fountain of the Four Rivers.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "博尔盖塞美术馆",
      "attractions_name_en": "Borghese Gallery and Museum",
      "description": "收藏了贝尼尼和卡拉瓦乔等大师的雕塑和绘画作品。",
      "official_link": "https://galleriaborghese.cultura.gov.it/en",
      "price_range": "15 (需提前预约)",
      "currency": "EUR",
      "description_en": "Sculpture and painting by Bernini, Caravaggio and other masters—booking required.",
      "price_range_en": "€15 (advance booking required)",
      "official_link_en": "https://galleriaborghese.cultura.gov.it/en"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "圣天使堡",
      "attractions_name_en": "Castel Sant'Angelo",
      "description": "原为哈德良皇帝的陵墓，后用作教皇堡垒和监狱，现为博物馆。",
      "official_link": "https://www.beniculturali.it/luogo/museo-nazionale-di-castel-sant-angelo",
      "price_range": "15 (可能因展览而异)",
      "currency": "EUR",
      "description_en": "Hadrian's mausoleum, later a papal fortress and prison—now a museum.",
      "price_range_en": "€15 (may vary with exhibitions)",
      "official_link_en": "https://www.beniculturali.it/luogo/museo-nazionale-di-castel-sant-angelo"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "西班牙阶梯",
      "attractions_name_en": "Spanish Steps",
      "description": "连接西班牙广场和山上天主圣三教堂的著名巴洛克式台阶。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The famous Baroque steps linking Piazza di Spagna and Trinità dei Monti.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "特拉斯提弗列",
      "attractions_name_en": "Trastevere",
      "description": "罗马的一个迷人街区，以狭窄的鹅卵石街道、热闹的广场和传统餐馆闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A charming neighbourhood—narrow cobbled streets, lively piazzas and traditional trattorias.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "卡拉卡拉浴场",
      "attractions_name_en": "Baths of Caracalla",
      "description": "古罗马最宏伟的公共浴场遗址之一，展现了罗马人的日常生活。",
      "official_link": "https://www.archeoroma.beniculturali.it/en/the-baths-of-caracalla",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "One of ancient Rome's grandest bath complexes—a glimpse of daily Roman life.",
      "price_range_en": "€8",
      "official_link_en": "https://www.archeoroma.beniculturali.it/en/the-baths-of-caracalla"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "卡比托利欧博物馆",
      "attractions_name_en": "Capitoline Museums",
      "description": "世界上第一座公共博物馆，收藏有大量古罗马雕塑和文物。",
      "official_link": "https://www.museicapitolini.org/en/",
      "price_range": "16 (常设展览)",
      "currency": "EUR",
      "description_en": "The world's first public museum—Roman sculpture and antiquities.",
      "price_range_en": "€16 (permanent collection)",
      "official_link_en": "https://www.museicapitolini.org/en/"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "多利亚潘菲利美术馆",
      "attractions_name_en": "Doria Pamphilj Gallery",
      "description": "一座私人艺术收藏馆，藏品包括委拉斯开兹的《教皇英诺森十世肖像》等杰作。",
      "official_link": "https://www.doriapamphilj.it/en/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "A private collection including masterpieces like Velázquez's Portrait of Innocent X.",
      "price_range_en": "€15",
      "official_link_en": "https://www.doriapamphilj.it/en/"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "真理之口",
      "attractions_name_en": "Bocca della Verità",
      "description": "一块刻有男性面孔的古老大理石雕刻，传说撒谎的人把手伸进去会被咬掉。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费 (捐款建议)",
      "currency": "EUR",
      "description_en": "An ancient marble mask—legend says it will bite the hand of anyone who tells a lie.",
      "price_range_en": "Free (donation suggested)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "圣母大教堂",
      "attractions_name_en": "Basilica di Santa Maria Maggiore",
      "description": "罗马最大的四座特级宗座圣殿之一，以其保存完好的早期基督教艺术和马赛克而闻名。",
      "official_link": "https://www.basilica.net/",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Rome's four major basilicas—famous for its early Christian art and mosaics.",
      "price_range_en": "Free",
      "official_link_en": "https://www.basilica.net/"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "国家博物馆（马西莫宫）",
      "attractions_name_en": "National Roman Museum (Palazzo Massimo alle Terme)",
      "description": "收藏了古罗马艺术品、雕塑、硬币和珠宝，包括许多著名的马赛克和壁画。",
      "official_link": "https://www.museonazionaleromano.beniculturali.it/en/palazzo-massimo-alle-terme/",
      "price_range": "12 (通票可参观所有国家博物馆分馆)",
      "currency": "EUR",
      "description_en": "Roman art, sculpture, coins and jewellery—including famous mosaics and frescoes.",
      "price_range_en": "€12 (combo for all National Museum sites)",
      "official_link_en": "https://www.museonazionaleromano.beniculturali.it/en/palazzo-massimo-alle-terme/"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "阿皮亚古道",
      "attractions_name_en": "Appian Way",
      "description": "古罗马最重要的道路之一，现在是考古公园，两旁有陵墓和古迹。",
      "official_link": "无官方购票链接，部分区域可能收费",
      "price_range": "免费 (部分地下墓穴和景点可能收费)",
      "currency": "EUR",
      "description_en": "One of ancient Rome's great roads—now an archaeological park with tombs and ruins.",
      "price_range_en": "Free (some catacombs and sites charge)",
      "official_link_en": "No official ticket link; some areas may charge"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "鲜花广场",
      "attractions_name_en": "Campo de' Fiori",
      "description": "罗马最古老的市场之一，白天是热闹的鲜花、水果市场，晚上则变成餐厅和酒吧的聚集地。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Rome's oldest markets—flowers and produce by day, restaurants and bars by night.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "IT",
      "cityname": "罗马",
      "cityname_en": "Rome",
      "attractions_name": "人民广场",
      "attractions_name_en": "Piazza del Popolo",
      "description": "一个宏伟的新古典主义广场，以其方尖碑、喷泉和三座教堂而闻名。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A grand neoclassical square with an obelisk, fountains and three churches.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "佛罗伦萨大教堂 (圣母百花大教堂)",
      "attractions_name_en": "Florence Cathedral (Duomo)",
      "description": "佛罗伦萨的标志，拥有布鲁内莱斯基的穹顶和乔托的钟楼。",
      "official_link": "https://www.duomo.firenze.it/en/",
      "price_range": "20 (通票，含穹顶、钟楼、洗礼堂等)",
      "currency": "EUR",
      "description_en": "Florence's icon—Brunelleschi's dome and Giotto's bell tower.",
      "price_range_en": "€20 (combo: dome, bell tower, baptistery, etc.)",
      "official_link_en": "https://www.duomo.firenze.it/en/"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "乌菲兹美术馆",
      "attractions_name_en": "Uffizi Gallery",
      "description": "世界上最重要的美术馆之一，收藏了大量文艺复兴时期的杰作。",
      "official_link": "https://www.uffizi.it/en/the-uffizi",
      "price_range": "25",
      "currency": "EUR",
      "description_en": "One of the world's greatest galleries—masterpieces of the Renaissance.",
      "price_range_en": "€25",
      "official_link_en": "https://www.uffizi.it/en/the-uffizi"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "学院美术馆",
      "attractions_name_en": "Accademia Gallery",
      "description": "收藏了米开朗基罗的《大卫》雕像。",
      "official_link": "https://www.galleriaaccademiafirenze.it/en/tickets/",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "Home to Michelangelo's David.",
      "price_range_en": "€16",
      "official_link_en": "https://www.galleriaaccademiafirenze.it/en/tickets/"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "老桥",
      "attractions_name_en": "Ponte Vecchio",
      "description": "佛罗伦萨最古老的桥梁，两旁是珠宝店。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Florence's oldest bridge, lined with jewellers.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "领主广场",
      "attractions_name_en": "Piazza della Signoria",
      "description": "佛罗伦萨的政治中心，有旧宫和众多雕塑。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Florence's political heart—the Palazzo Vecchio and open-air sculpture.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "旧宫",
      "attractions_name_en": "Palazzo Vecchio",
      "description": "佛罗伦萨的市政厅，曾是美第奇家族的居所。",
      "official_link": "https://www.italy-museum.com/florence/palazzo-vecchio-museum-tickets",
      "price_range": "12.5",
      "currency": "EUR",
      "description_en": "Florence's town hall—once home to the Medici.",
      "price_range_en": "€12.50",
      "official_link_en": "https://www.italy-museum.com/florence/palazzo-vecchio-museum-tickets"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "皮蒂宫",
      "attractions_name_en": "Pitti Palace",
      "description": "巨大的文艺复兴时期宫殿，内有多个博物馆和波波里花园。",
      "official_link": "https://www.uffizi.it/en/pitti-palace",
      "price_range": "16 (根据参观区域)",
      "currency": "EUR",
      "description_en": "A vast Renaissance palace with several museums and the Boboli Gardens.",
      "price_range_en": "€16 (varies by areas)",
      "official_link_en": "https://www.uffizi.it/en/pitti-palace"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "波波里花园",
      "attractions_name_en": "Boboli Gardens",
      "description": "位于皮蒂宫后面，是意大利式园林的典范。",
      "official_link": "包含在皮蒂宫门票内（或单独购票）",
      "price_range": "10 (单独购票)",
      "currency": "EUR",
      "description_en": "Behind the Pitti Palace—a classic Italian formal garden.",
      "price_range_en": "€10 (separate ticket)",
      "official_link_en": "Included in Pitti Palace ticket (or separate)"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "米开朗基罗广场",
      "attractions_name_en": "Piazzale Michelangelo",
      "description": "俯瞰佛罗伦萨全景的最佳地点，尤其是日落时分。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The best spot for a panoramic view of Florence—especially at sunset.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "佛罗伦萨",
      "cityname_en": "Florence",
      "attractions_name": "圣十字大教堂",
      "attractions_name_en": "Basilica of Santa Croce",
      "description": "许多意大利名人的安息之地，包括米开朗基罗、伽利略等。",
      "official_link": "https://www.santacroceopera.it/en/",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Resting place of Michelangelo, Galileo and other great Italians.",
      "price_range_en": "€8",
      "official_link_en": "https://www.santacroceopera.it/en/"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "圣马可广场",
      "attractions_name_en": "St. Mark's Square",
      "description": "威尼斯的中心广场，被誉为“欧洲最美的客厅”。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Venice's central square—often called \"Europe's finest drawing room\".",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "圣马可大教堂",
      "attractions_name_en": "St. Mark's Basilica",
      "description": "威尼斯最著名的教堂，融合了拜占庭、哥特和文艺复兴风格。",
      "official_link": "http://www.basilicasanmarco.it/informazioni-per-i-turisti/orari-di-apertura/?lang=en",
      "price_range": "3 (入内参观，部分区域另收费)",
      "currency": "EUR",
      "description_en": "Venice's most famous church—Byzantine, Gothic and Renaissance in one.",
      "price_range_en": "€3 (entry; some areas extra)",
      "official_link_en": "http://www.basilicasanmarco.it/informazioni-per-i-turisti/orari-di-apertura/?lang=en"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "总督宫",
      "attractions_name_en": "Doge's Palace",
      "description": "威尼斯共和国总督的府邸，哥特式建筑的杰作。",
      "official_link": "https://palazzoducale.visitmuve.it/en/home/",
      "price_range": "30 (含科雷尔博物馆等)",
      "currency": "EUR",
      "description_en": "The Doges' palace—a Gothic masterpiece.",
      "price_range_en": "€30 (includes Correr Museum etc.)",
      "official_link_en": "https://palazzoducale.visitmuve.it/en/home/"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "叹息桥",
      "attractions_name_en": "Bridge of Sighs",
      "description": "连接总督宫和监狱的桥梁，囚犯经过此桥时会叹息。",
      "official_link": "包含在总督宫门票内",
      "price_range": "包含在总督宫门票内",
      "currency": "EUR",
      "description_en": "The bridge linking the palace to the prison—prisoners sighed as they crossed.",
      "price_range_en": "Included in Doge's Palace ticket",
      "official_link_en": "Included in Doge's Palace ticket"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "叹息桥",
      "attractions_name_en": "Rialto Bridge",
      "description": "威尼斯最古老的桥梁之一，横跨大运河，是重要的地标。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Venice's oldest bridges spanning the Grand Canal—an iconic landmark.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "贡多拉游船",
      "attractions_name_en": "Gondola Ride",
      "description": "体验威尼斯水城魅力的经典方式。",
      "official_link": "无官方购票链接，船夫直接收费",
      "price_range": "80 (白天，每船) - 120 (夜晚，每船)",
      "currency": "EUR",
      "description_en": "The classic way to experience Venice on the water.",
      "price_range_en": "€80 (day, per boat)–€120 (evening, per boat)",
      "official_link_en": "No official ticket link; gondoliers charge directly"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "玻璃岛 (穆拉诺岛)",
      "attractions_name_en": "Murano Island",
      "description": "以其传统的玻璃制作工艺而闻名。",
      "official_link": "无官方购票链接，船票另计",
      "price_range": "免费（参观玻璃工厂可能收费）",
      "currency": "EUR",
      "description_en": "Famous for its traditional glass-making.",
      "price_range_en": "Free (glass factory visits may charge)",
      "official_link_en": "No official ticket link; boat tickets sold separately"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "彩色岛 (布拉诺岛)",
      "attractions_name_en": "Burano Island",
      "description": "以其色彩斑斓的房屋和蕾丝制作而闻名。",
      "official_link": "无官方购票链接，船票另计",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Famous for its brightly coloured houses and lace-making.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; boat tickets sold separately"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "丽都岛",
      "attractions_name_en": "Lido di Venezia",
      "description": "威尼斯著名的海滩度假胜地，每年举办威尼斯电影节。",
      "official_link": "无官方购票链接，船票另计",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Venice's beach resort and home of the Venice Film Festival.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; boat tickets sold separately"
    },
    {
      "id": "IT",
      "cityname": "威尼斯",
      "cityname_en": "Venice",
      "attractions_name": "威尼斯圣马可钟楼",
      "attractions_name_en": "St. Mark's Campanile",
      "description": "圣马可广场上的钟楼，可以登顶俯瞰威尼斯全景。",
      "official_link": "https://basilicasanmarco.skiperformance.com/en/store#/en/buy?skugroup_id=2524",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "The campanile on St Mark's Square—climb for panoramic views of Venice.",
      "price_range_en": "€10",
      "official_link_en": "https://basilicasanmarco.skiperformance.com/en/store#/en/buy?skugroup_id=2524"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "米兰大教堂",
      "attractions_name_en": "Milan Cathedral (Duomo)",
      "description": "意大利最大的哥特式教堂，也是世界第五大教堂。",
      "official_link": "https://www.duomomilano.it/en/",
      "price_range": "5 (入内) - 20 (含登顶和博物馆)",
      "currency": "EUR",
      "description_en": "Italy's largest Gothic cathedral and the world's fifth-largest church.",
      "price_range_en": "€5 (entry)–€20 (with roof and museum)",
      "official_link_en": "https://www.duomomilano.it/en/"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "埃马努埃莱二世长廊",
      "attractions_name_en": "Galleria Vittorio Emanuele II",
      "description": "华丽的购物长廊，被誉为“米兰的客厅”。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A lavish shopping arcade—\"Milan's drawing room\".",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "斯福尔扎城堡",
      "attractions_name_en": "Sforza Castle",
      "description": "米兰的重要历史建筑，曾是米兰公爵的居所，内有多个博物馆。",
      "official_link": "https://www.milanocastello.it/en",
      "price_range": "5 (博物馆)",
      "currency": "EUR",
      "description_en": "Milan's great fortress—once the ducal residence, now several museums.",
      "price_range_en": "€5 (museums)",
      "official_link_en": "https://www.milanocastello.it/en"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "圣玛利亚感恩教堂 (最后的晚餐)",
      "attractions_name_en": "Santa Maria delle Grazie (The Last Supper)",
      "description": "达芬奇壁画《最后的晚餐》所在地。",
      "official_link": "https://cenacolovinciano.org/en/",
      "price_range": "15 (需提前数月预约)",
      "currency": "EUR",
      "description_en": "Home to Leonardo's Last Supper.",
      "price_range_en": "€15 (book months ahead)",
      "official_link_en": "https://cenacolovinciano.org/en/"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "斯卡拉歌剧院",
      "attractions_name_en": "La Scala Opera House",
      "description": "世界上最著名的歌剧院之一，拥有博物馆。",
      "official_link": "https://www.teatroallascala.org/en/",
      "price_range": "12 (博物馆)",
      "currency": "EUR",
      "description_en": "One of the world's most famous opera houses—with a museum.",
      "price_range_en": "€12 (museum)",
      "official_link_en": "https://www.teatroallascala.org/en/"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "布雷拉美术馆",
      "attractions_name_en": "Pinacoteca di Brera",
      "description": "米兰最重要的美术馆之一，收藏了大量意大利文艺复兴时期的绘画作品。",
      "official_link": "https://pinacotecabrera.org/en/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "One of Milan's top galleries—Italian Renaissance painting.",
      "price_range_en": "€15",
      "official_link_en": "https://pinacotecabrera.org/en/"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "垂直森林",
      "attractions_name_en": "Bosco Verticale",
      "description": "现代建筑的典范，两栋种满树木的住宅大楼。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（外部参观）",
      "currency": "EUR",
      "description_en": "A landmark of modern architecture—two tower blocks covered in trees.",
      "price_range_en": "Free (exterior only)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "纳维利区",
      "attractions_name_en": "Navigli District",
      "description": "米兰的运河区，夜晚酒吧和餐厅林立，充满活力。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Milan's canal district—bars and restaurants, lively at night.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "圣西罗体育场",
      "attractions_name_en": "San Siro Stadium (Stadio Giuseppe Meazza)",
      "description": "国际米兰和AC米兰的主场，可参观博物馆和球场。",
      "official_link": "https://www.sansirostadium.com/en/",
      "price_range": "20 (博物馆和球场之旅)",
      "currency": "EUR",
      "description_en": "Home of Inter and AC Milan—museum and stadium tour.",
      "price_range_en": "€20 (museum and stadium tour)",
      "official_link_en": "https://www.sansirostadium.com/en/"
    },
    {
      "id": "IT",
      "cityname": "米兰",
      "cityname_en": "Milan",
      "attractions_name": "米兰时尚区 (黄金四角区)",
      "attractions_name_en": "Quadrilatero della Moda",
      "description": "世界上最重要的时尚中心之一，汇集了众多奢侈品品牌店。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "One of the world's top fashion districts—luxury brands galore.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "那不勒斯国家考古博物馆",
      "attractions_name_en": "National Archaeological Museum of Naples",
      "description": "收藏了大量庞贝和赫库兰尼姆出土的文物。",
      "official_link": "https://museoarcheologiconapoli.it/en/timetables-and-fares/",
      "price_range": "22",
      "currency": "EUR",
      "description_en": "A superb collection of finds from Pompeii and Herculaneum.",
      "price_range_en": "€22",
      "official_link_en": "https://museoarcheologiconapoli.it/en/timetables-and-fares/"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "庞贝古城",
      "attractions_name_en": "Pompeii Archaeological Park",
      "description": "被维苏威火山灰掩埋的古罗马城市遗址，保存完好。",
      "official_link": "https://pompeiisites.org/en/",
      "price_range": "18",
      "currency": "EUR",
      "description_en": "The Roman city preserved under volcanic ash—extraordinarily intact.",
      "price_range_en": "€18",
      "official_link_en": "https://pompeiisites.org/en/"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "维苏威火山",
      "attractions_name_en": "Mount Vesuvius",
      "description": "欧洲大陆唯一的活火山，可以徒步登顶俯瞰那不勒斯湾。",
      "official_link": "https://www.pompeii-tickets.com/pompeii-volcano-mount-vesuvius-tickets/",
      "price_range": "11.50 (入园费，不含交通)",
      "currency": "EUR",
      "description_en": "Mainland Europe's only active volcano—hike to the crater for bay views.",
      "price_range_en": "€11.50 (park fee, transport separate)",
      "official_link_en": "https://www.pompeii-tickets.com/pompeii-volcano-mount-vesuvius-tickets/"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "那不勒斯地下城",
      "attractions_name_en": "Napoli Sotterranea",
      "description": "探索那不勒斯地下深处的古老隧道和洞穴。",
      "official_link": "https://www.napolisotterranea.org/en/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "Explore ancient tunnels and caverns beneath Naples.",
      "price_range_en": "€15",
      "official_link_en": "https://www.napolisotterranea.org/en/"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "蛋堡",
      "attractions_name_en": "Castel dell'Ovo",
      "description": "那不勒斯最古老的城堡，位于海边，景色优美。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Naples' oldest castle, on the waterfront with lovely views.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "新堡",
      "attractions_name_en": "Castel Nuovo",
      "description": "那不勒斯市中心的地标性城堡，曾是那不勒斯国王的居所。",
      "official_link": "无在线购买链接",
      "price_range": "6",
      "currency": "EUR",
      "description_en": "A landmark castle in the centre—once home to the kings of Naples.",
      "price_range_en": "€6",
      "official_link_en": "No online ticket link"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "那不勒斯王宫",
      "attractions_name_en": "Royal Palace of Naples",
      "description": "曾是波旁王朝那不勒斯国王的宫殿，现在是博物馆。",
      "official_link": "https://palazzorealenapoli.it/en/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "The former Bourbon royal palace—now a museum.",
      "price_range_en": "€10",
      "official_link_en": "https://palazzorealenapoli.it/en/"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "圣热内罗地下墓穴",
      "attractions_name_en": "Catacombs of San Gennaro",
      "description": "那不勒斯最大的地下墓穴，早期基督教的墓葬地。",
      "official_link": "https://www.catacombedinapoli.it/en/",
      "price_range": "11",
      "currency": "EUR",
      "description_en": "Naples' largest catacombs—early Christian burial site.",
      "price_range_en": "€11",
      "official_link_en": "https://www.catacombedinapoli.it/en/"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "圣塞维诺礼拜堂 (基督蒙纱像)",
      "attractions_name_en": "Sansevero Chapel Museum (Veiled Christ)",
      "description": "收藏了著名的《基督蒙纱像》，雕刻精美。",
      "official_link": "https://www.museosansevero.it/en/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Home to the famous Veiled Christ—a sculptural marvel.",
      "price_range_en": "€10",
      "official_link_en": "https://www.museosansevero.it/en/"
    },
    {
      "id": "IT",
      "cityname": "那不勒斯",
      "cityname_en": "Naples",
      "attractions_name": "赫库兰尼姆古城",
      "attractions_name_en": "Herculaneum Archaeological Park",
      "description": "同样被维苏威火山灰掩埋的古城，比庞贝保存更完好。",
      "official_link": "https://www.coopculture.it/en/products/regular-entrance-ticket-for-the-archaeological-park-of-herculaneum/",
      "price_range": "13",
      "currency": "EUR",
      "description_en": "Another town buried by Vesuvius—often even better preserved than Pompeii.",
      "price_range_en": "€13",
      "official_link_en": "https://www.coopculture.it/en/products/regular-entrance-ticket-for-the-archaeological-park-of-herculaneum/"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "普拉多博物馆",
      "attractions_name_en": "Prado Museum",
      "description": "世界上最重要的美术馆之一，收藏了大量西班牙和欧洲古典大师的杰作，如戈雅、委拉斯开兹等。",
      "official_link": "https://www.museodelprado.es/en",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "One of the world's greatest galleries—Spanish and European masters from Goya to Velázquez.",
      "price_range_en": "€15",
      "official_link_en": "https://www.museodelprado.es/en"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "丽池公园",
      "attractions_name_en": "El Retiro Park",
      "description": "马德里市中心的绿色肺叶，拥有美丽的雕塑、喷泉和玻璃宫。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Madrid's green heart—sculptures, fountains and the Crystal Palace.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "马德里皇宫",
      "attractions_name_en": "Royal Palace of Madrid",
      "description": "西班牙王室的正式居所，是西欧最大的皇宫之一，内部装饰华丽。",
      "official_link": "https://tickets.patrimonionacional.es/en/tickets/palacio-real-de-madrid",
      "price_range": "上午/下午 00時00分00秒 ",
      "currency": "EUR",
      "description_en": "The Spanish royal family's official residence—one of the largest palaces in Western Europe.",
      "price_range_en": "Varies (check official site)",
      "official_link_en": "https://tickets.patrimonionacional.es/en/tickets/palacio-real-de-madrid"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "马约尔广场",
      "attractions_name_en": "Plaza Mayor",
      "description": "马德里最著名的广场之一，历史悠久，周边有许多餐厅和商店。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Madrid's most famous squares—historic, surrounded by cafés and shops.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "索菲亚王后艺术中心",
      "attractions_name_en": "Reina Sofía Museum",
      "description": "专注于20世纪艺术，收藏了毕加索的《格尔尼卡》等现代艺术杰作。",
      "official_link": "https://www.museoreinasofia.es/en",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "20th-century art—home to Picasso's Guernica and other modern masterpieces.",
      "price_range_en": "€12",
      "official_link_en": "https://www.museoreinasofia.es/en"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "圣米格尔市场",
      "attractions_name_en": "Mercado de San Miguel",
      "description": "历史悠久的铁艺市场，现在是一个美食市场，提供各种西班牙小吃和饮品。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（消费另计）",
      "currency": "EUR",
      "description_en": "A historic wrought-iron market hall—now a gourmet tapas and drinks spot.",
      "price_range_en": "Free (pay as you eat)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "德波神庙",
      "attractions_name_en": "Temple of Debod",
      "description": "从埃及运来的古埃及神庙，在马德里重建成公园景点，是观赏日落的好地方。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "An ancient Egyptian temple rebuilt in a Madrid park—great for sunset.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "太阳门广场",
      "attractions_name_en": "Puerta del Sol",
      "description": "马德里最热闹的广场之一，西班牙公路网的零公里标志所在地。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Madrid's busiest square—Spain's kilometre zero for the road network.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "西班牙广场",
      "attractions_name_en": "Plaza de España",
      "description": "位于马德里市中心，有塞万提斯纪念碑和堂吉诃德、桑丘的雕像。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "In the centre—monument to Cervantes and statues of Don Quixote and Sancho.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "ES",
      "cityname": "马德里",
      "cityname_en": "Madrid",
      "attractions_name": "提森-博内米萨博物馆",
      "attractions_name_en": "Thyssen-Bornemisza Museum",
      "description": "收藏了从中世纪到20世纪末的艺术作品，弥补了普拉多和索菲亚王后博物馆的空白。",
      "official_link": "https://www.museothyssen.org/en",
      "price_range": "13",
      "currency": "EUR",
      "description_en": "Art from the Middle Ages to the late 20th century—fills the gap between the Prado and Reina Sofía.",
      "price_range_en": "€13",
      "official_link_en": "https://www.museothyssen.org/en"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "圣家族大教堂",
      "attractions_name_en": "Sagrada Familia",
      "description": "高迪的未完成杰作，哥特式和新艺术风格的结合，巴塞罗那的标志。",
      "official_link": "https://sagradafamilia.org/en/",
      "price_range": "26 - 36 (根据包含内容)",
      "currency": "EUR",
      "description_en": "Gaudí's unfinished masterpiece—Gothic meets Art Nouveau, Barcelona's icon.",
      "price_range_en": "€26–€36 (depending on options)",
      "official_link_en": "https://sagradafamilia.org/en/"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "奎尔公园",
      "attractions_name_en": "Park Güell",
      "description": "高迪设计的公园，充满奇幻色彩的建筑和马赛克装饰。",
      "official_link": "https://parkguell.barcelona/en",
      "price_range": "10 (限定区域)",
      "currency": "EUR",
      "description_en": "Gaudí's whimsical park—fantastical buildings and mosaics.",
      "price_range_en": "€10 (monumental zone)",
      "official_link_en": "https://parkguell.barcelona/en"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "哥特区",
      "attractions_name_en": "Gothic Quarter",
      "description": "巴塞罗那最古老的街区，迷宫般的街道，充满历史韵味。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Barcelona's oldest quarter—a maze of streets full of history.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "巴特罗之家",
      "attractions_name_en": "Casa Batlló",
      "description": "高迪的另一件杰作，被称为“骨头之家”，外形独特。",
      "official_link": "https://www.casabatllo.es/en/",
      "price_range": "35 - 45 (根据时间段和包含内容)",
      "currency": "EUR",
      "description_en": "Another Gaudí gem—the \"house of bones\" with its surreal façade.",
      "price_range_en": "€35–€45 (time and options)",
      "official_link_en": "https://www.casabatllo.es/en/"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "米拉之家",
      "attractions_name_en": "Casa Milà (La Pedrera)",
      "description": "高迪设计的公寓楼，外形像波浪，是现代主义建筑的代表。",
      "official_link": "https://www.lapedrera.com/en/",
      "price_range": "28",
      "currency": "EUR",
      "description_en": "Gaudí's wave-like apartment block—a modernist icon.",
      "price_range_en": "€28",
      "official_link_en": "https://www.lapedrera.com/en/"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "兰布拉大道",
      "attractions_name_en": "La Rambla",
      "description": "巴塞罗那最著名的步行街，连接着加泰罗尼亚广场和哥伦布纪念碑。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Barcelona's most famous boulevard—from Plaça Catalunya to the Columbus monument.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "巴塞罗那大教堂",
      "attractions_name_en": "Barcelona Cathedral",
      "description": "哥特式大教堂，位于哥特区中心，历史悠久。",
      "official_link": "https://catedralbcn.org/",
      "price_range": "免费（部分时段收费）",
      "currency": "EUR",
      "description_en": "Gothic cathedral at the heart of the Barri Gòtic.",
      "price_range_en": "Free (some times charge)",
      "official_link_en": "https://catedralbcn.org/"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "博盖利亚市场",
      "attractions_name_en": "La Boqueria Market",
      "description": "欧洲最著名的农产品市场之一，充满活力，可品尝当地美食。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（消费另计）",
      "currency": "EUR",
      "description_en": "One of Europe's most famous food markets—colourful and full of local flavours.",
      "price_range_en": "Free (pay as you eat)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "蒙特惠奇山",
      "attractions_name_en": "Montjuïc",
      "description": "俯瞰巴塞罗那的制高点，有城堡、博物馆和魔幻喷泉。",
      "official_link": "https://ajuntament.barcelona.cat/castelldemontjuic/en",
      "price_range": "城堡：5（缆车另计）",
      "currency": "EUR",
      "description_en": "The hill overlooking Barcelona—castle, museums and the magic fountain.",
      "price_range_en": "Castle €5 (cable car separate)",
      "official_link_en": "https://ajuntament.barcelona.cat/castelldemontjuic/en"
    },
    {
      "id": "ES",
      "cityname": "巴塞罗那",
      "cityname_en": "Barcelona",
      "attractions_name": "毕加索博物馆",
      "attractions_name_en": "Picasso Museum",
      "description": "收藏了毕加索早期和青年时期的作品，深入了解其艺术生涯。",
      "official_link": "https://www.museupicasso.bcn.cat/en",
      "price_range": "14",
      "currency": "EUR",
      "description_en": "Picasso's early and formative years—a deep dive into his development.",
      "price_range_en": "€14",
      "official_link_en": "https://www.museupicasso.bcn.cat/en"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "塞维利亚王宫",
      "attractions_name_en": "Alcázar of Seville",
      "description": "欧洲最古老的皇家宫殿之一，穆德哈尔式建筑的杰作，联合国教科文组织世界遗产。",
      "official_link": "https://alcazarsevilla.org/prepara-la-visita/",
      "price_range": "14.5",
      "currency": "EUR",
      "description_en": "One of Europe's oldest royal palaces—Mudéjar masterpiece and UNESCO site.",
      "price_range_en": "€14.50",
      "official_link_en": "https://alcazarsevilla.org/prepara-la-visita/"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "塞维利亚大教堂和希拉尔达塔",
      "attractions_name_en": "Seville Cathedral and Giralda Tower",
      "description": "世界第三大教堂，曾是清真寺的宣礼塔，可登塔俯瞰城市。",
      "official_link": "https://www.catedraldesevilla.es/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "The world's third-largest church—former mosque minaret, climb for city views.",
      "price_range_en": "€12",
      "official_link_en": "https://www.catedraldesevilla.es/en/"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "西班牙广场",
      "attractions_name_en": "Plaza de España",
      "description": "宏伟的半圆形广场，融合了文艺复兴和摩尔风格，是城市地标。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A grand semicircular plaza—Renaissance meets Moorish, a city landmark.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "都市阳伞",
      "attractions_name_en": "Metropol Parasol (Las Setas)",
      "description": "现代木质结构建筑，独特的设计，可登顶俯瞰城市。",
      "official_link": "https://setasdesevilla.com/en/",
      "price_range": "5 - 15 (根据参观时段)",
      "currency": "EUR",
      "description_en": "Striking modern wooden structure—head up for panoramic views.",
      "price_range_en": "€5–€15 (by time)",
      "official_link_en": "https://setasdesevilla.com/en/"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "圣十字区",
      "attractions_name_en": "Barrio Santa Cruz",
      "description": "塞维利亚的老犹太区，狭窄的街道，充满鲜花和庭院。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Seville's old Jewish quarter—narrow streets, flowers and patios.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "黄金塔",
      "attractions_name_en": "Torre del Oro",
      "description": "瓜达尔基维尔河畔的十二边形瞭望塔，曾用于防御和存放黄金。",
      "official_link": "https://sevillecityguide.com/torredeloro.html",
      "price_range": "3",
      "currency": "EUR",
      "description_en": "A 12-sided tower on the Guadalquivir—once for defence and gold.",
      "price_range_en": "€3",
      "official_link_en": "https://sevillecityguide.com/torredeloro.html"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "玛丽亚路易莎公园",
      "attractions_name_en": "Parque de María Luisa",
      "description": "塞维利亚最大的公园，绿树成荫，风景优美，紧邻西班牙广场。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Seville's largest park—shady and pretty, next to the Plaza de España.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "弗拉明戈表演",
      "attractions_name_en": "Flamenco Show",
      "description": "体验安达卢西亚文化的精髓，许多Tablao提供表演和晚餐。",
      "official_link": "https://museodelbaileflamenco.com/en/",
      "price_range": "20 - 50+ (根据表演和是否含餐)",
      "currency": "EUR",
      "description_en": "The soul of Andalusian culture—many tablaos offer show and dinner.",
      "price_range_en": "€20–€50+ (show, with/without dinner)",
      "official_link_en": "https://museodelbaileflamenco.com/en/"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "塞维利亚斗牛场",
      "attractions_name_en": "Maestranza Bullring",
      "description": "西班牙最古老的斗牛场之一，有斗牛博物馆。",
      "official_link": "https://www.realmaestranza.com/",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "One of Spain's oldest bullrings—with a bullfighting museum.",
      "price_range_en": "€8",
      "official_link_en": "https://www.realmaestranza.com/"
    },
    {
      "id": "ES",
      "cityname": "塞维利亚",
      "cityname_en": "Seville",
      "attractions_name": "印第安总档案馆",
      "attractions_name_en": "Archivo General de Indias",
      "description": "曾是商品交易所，现在是保存西班牙帝国殖民地文献的档案馆。",
      "official_link": "无需购票",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Former merchant exchange—now the archive of Spain's colonial documents.",
      "price_range_en": "Free",
      "official_link_en": "No ticket required"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "阿尔罕布拉宫",
      "attractions_name_en": "Alhambra",
      "description": "摩尔王朝的杰出建筑群，包含纳斯里德宫、赫内拉利费花园等，联合国教科文组织世界遗产。",
      "official_link": "https://www.alhambra.org/en/alhambra-tickets.html",
      "price_range": "14.85 (需提前数月预约)",
      "currency": "EUR",
      "description_en": "The Moorish palace complex—Nasrid palaces, Generalife gardens, UNESCO World Heritage. Book months ahead.",
      "price_range_en": "€14.85 (book months ahead)",
      "official_link_en": "https://www.alhambra.org/en/alhambra-tickets.html"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "纳斯里德宫",
      "attractions_name_en": "Nasrid Palaces",
      "description": "阿尔罕布拉宫的核心部分，精美的摩尔式庭院和建筑。",
      "official_link": "包含在阿尔罕布拉宫门票内",
      "price_range": "包含在阿尔罕布拉宫门票内",
      "currency": "EUR",
      "description_en": "The heart of the Alhambra—exquisite Moorish courtyards and halls.",
      "price_range_en": "Included in Alhambra ticket",
      "official_link_en": "Included in Alhambra ticket"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "赫内拉利费花园",
      "attractions_name_en": "Generalife Gardens",
      "description": "阿尔罕布拉宫外的夏宫和花园，水景和绿植精美。",
      "official_link": "包含在阿尔罕布拉宫门票内",
      "price_range": "包含在阿尔罕布拉宫门票内",
      "currency": "EUR",
      "description_en": "Summer palace and gardens beyond the Alhambra—water and greenery.",
      "price_range_en": "Included in Alhambra ticket",
      "official_link_en": "Included in Alhambra ticket"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "阿尔拜辛区",
      "attractions_name_en": "Albaicín",
      "description": "格拉纳达的老摩尔区，狭窄的街道和白色房屋，是世界遗产。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Granada's old Moorish quarter—narrow streets, white houses, World Heritage.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "圣尼古拉斯瞭望台",
      "attractions_name_en": "Mirador de San Nicolás",
      "description": "观赏阿尔罕布拉宫和内华达山脉全景的最佳地点，尤其日落时分。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The best view of the Alhambra and the Sierra Nevada—especially at sunset.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "格拉纳达大教堂",
      "attractions_name_en": "Granada Cathedral",
      "description": "西班牙文艺复兴时期的代表作，位于市中心。",
      "official_link": "https://catedraldegranada.com/",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "A masterpiece of Spanish Renaissance—right in the centre.",
      "price_range_en": "€5",
      "official_link_en": "https://catedraldegranada.com/"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "皇家礼拜堂",
      "attractions_name_en": "Royal Chapel of Granada",
      "description": "毗邻大教堂，是费尔南多二世和伊莎贝尔一世的安息之地。",
      "official_link": "https://www.capillarealgranada.com/en/",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "Next to the cathedral—resting place of Ferdinand and Isabella.",
      "price_range_en": "€5",
      "official_link_en": "https://www.capillarealgranada.com/en/"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "萨克罗蒙特区",
      "attractions_name_en": "Sacromonte",
      "description": "格拉纳达吉卜赛人的聚居区，以洞穴房屋和弗拉明戈表演闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（弗拉明戈表演另计）",
      "currency": "EUR",
      "description_en": "Granada's cave-house quarter and flamenco heart—performances extra.",
      "price_range_en": "Free (flamenco shows charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "科学公园",
      "attractions_name_en": "Parque de las Ciencias",
      "description": "互动式科学博物馆，适合家庭游客。",
      "official_link": "https://www.parqueciencias.com/",
      "price_range": "上午/下午 00時00分00秒 ",
      "currency": "EUR",
      "description_en": "Hands-on science museum—great for families.",
      "price_range_en": "Varies (check official site)",
      "official_link_en": "https://www.parqueciencias.com/"
    },
    {
      "id": "ES",
      "cityname": "格拉纳达",
      "cityname_en": "Granada",
      "attractions_name": "卡门住宅",
      "attractions_name_en": "Carmens of Granada",
      "description": "格拉纳达特有的带围墙花园的房屋，许多现已改造成酒店或餐厅。",
      "official_link": "无特定官方购票链接，部分可能开放参观或作为住宿地点",
      "price_range": "免费（部分私人花园可能收费）",
      "currency": "EUR",
      "description_en": "Granada's typical walled-garden houses—many now hotels or restaurants.",
      "price_range_en": "Free (some private gardens charge)",
      "official_link_en": "No specific official ticket link; some may offer visits or accommodation"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "艺术科学城",
      "attractions_name_en": "City of Arts and Sciences",
      "description": "现代建筑群，包含歌剧院、科学博物馆、天文馆和海洋馆。",
      "official_link": "https://tickets.cac.es/internetCAC/?language=en",
      "price_range": "不同场馆有不同价格，海洋馆约34，科学博物馆约9",
      "currency": "EUR",
      "description_en": "A futuristic complex—opera house, science museum, planetarium and oceanarium.",
      "price_range_en": "Varies (e.g. oceanarium ~€34, science museum ~€9)",
      "official_link_en": "https://tickets.cac.es/internetCAC/?language=en"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "瓦伦西亚大教堂",
      "attractions_name_en": "Valencia Cathedral",
      "description": "瓦伦西亚的标志性建筑，据称收藏了圣杯。",
      "official_link": "https://catedraldevalencia.es/",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Valencia's landmark cathedral—said to hold the Holy Grail.",
      "price_range_en": "€8",
      "official_link_en": "https://catedraldevalencia.es/"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "中央市场",
      "attractions_name_en": "Central Market (Mercado Central)",
      "description": "欧洲最古老、最大的食品市场之一，新艺术风格建筑，充满活力。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（消费另计）",
      "currency": "EUR",
      "description_en": "One of Europe's oldest and largest food markets—Art Nouveau and buzzing.",
      "price_range_en": "Free (pay as you buy)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "丝绸交易所",
      "attractions_name_en": "La Lonja de la Seda",
      "description": "哥特式民用建筑的杰作，联合国教科文组织世界遗产。",
      "official_link": "https://www.valencia.es/en/cas/va/la-lonja-de-la-seda",
      "price_range": "2",
      "currency": "EUR",
      "description_en": "A Gothic civil masterpiece and UNESCO World Heritage site.",
      "price_range_en": "€2",
      "official_link_en": "https://www.valencia.es/en/cas/va/la-lonja-de-la-seda"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "老城区",
      "attractions_name_en": "Ciutat Vella (Old Town)",
      "description": "瓦伦西亚的历史中心，狭窄的街道，古老的建筑和广场。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Valencia's historic centre—narrow streets, old buildings and squares.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "瓦伦西亚生物公园",
      "attractions_name_en": "Bioparc Valencia",
      "description": "独特的“沉浸式动物园”，模拟非洲生态系统。",
      "official_link": "https://www.bioparcvalencia.es/en/",
      "price_range": "26.9",
      "currency": "EUR",
      "description_en": "An immersive zoo that recreates African ecosystems.",
      "price_range_en": "€26.90",
      "official_link_en": "https://www.bioparcvalencia.es/en/"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "瓦伦西亚港口 (海滩)",
      "attractions_name_en": "Port of Valencia / Malvarrosa Beach",
      "description": "西班牙最大的港口之一，附近有美丽的城市海滩。",
      "official_link": "无官方购票链接，为公共区域/海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Spain's largest ports—with fine city beaches nearby.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area/beach"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "瓦伦西亚市政广场",
      "attractions_name_en": "Plaza del Ayuntamiento",
      "description": "瓦伦西亚最主要的广场，市政厅所在地。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Valencia's main square—home to the town hall.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "法雅博物馆",
      "attractions_name_en": "Museo Fallero",
      "description": "展示瓦伦西亚传统节日“法雅节”的历史和精美木偶。",
      "official_link": "https://www.fallas.com/",
      "price_range": "2",
      "currency": "EUR",
      "description_en": "The history of the Falles festival and its elaborate figures.",
      "price_range_en": "€2",
      "official_link_en": "https://www.fallas.com/"
    },
    {
      "id": "ES",
      "cityname": "瓦伦西亚",
      "cityname_en": "Valencia",
      "attractions_name": "图里亚花园",
      "attractions_name_en": "Turia Gardens",
      "description": "建在旧图里亚河床上的公园，贯穿城市，是休闲运动的好去处。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "A park in the old Turia riverbed—running through the city, perfect for walks and sport.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "梵蒂冈博物馆",
      "attractions_name_en": "Vatican Museums",
      "description": "世界上最重要的博物馆之一，收藏了教皇们几个世纪以来的艺术珍品。",
      "official_link": "https://www.museivaticani.va/content/museivaticani/en.html",
      "price_range": "20",
      "currency": "EUR",
      "description_en": "One of the world's greatest museums—centuries of papal art and treasures.",
      "price_range_en": "€20",
      "official_link_en": "https://www.museivaticani.va/content/museivaticani/en.html"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "西斯廷教堂",
      "attractions_name_en": "Sistine Chapel",
      "description": "梵蒂冈博物馆的一部分，以米开朗基罗的《创世纪》和《最后的审判》壁画闻名于世。",
      "official_link": "包含在梵蒂冈博物馆门票内",
      "price_range": "包含在梵蒂冈博物馆门票内",
      "currency": "EUR",
      "description_en": "Part of the Vatican Museums—Michelangelo's Genesis and Last Judgement.",
      "price_range_en": "Included in Vatican Museums ticket",
      "official_link_en": "Included in Vatican Museums ticket"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "圣彼得大教堂",
      "attractions_name_en": "St. Peter's Basilica",
      "description": "世界上最大的教堂，天主教的中心，米开朗基罗的《圣殇》雕塑和贝尔尼尼的青铜华盖在此。",
      "official_link": "无门票，免费参观（登穹顶收费）",
      "price_range": "免费（登穹顶约10-12）",
      "currency": "EUR",
      "description_en": "The world's largest church—Michelangelo's Pietà, Bernini's baldachin. Catholic heart.",
      "price_range_en": "Free (dome climb ~€10–€12)",
      "official_link_en": "Free admission (dome paid)"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "圣彼得广场",
      "attractions_name_en": "St. Peter's Square",
      "description": "圣彼得大教堂前的巨大广场，由贝尔尼尼设计，两侧是宏伟的柱廊。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The vast square in front of St Peter's—Bernini's colonnades.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "梵蒂冈花园",
      "attractions_name_en": "Vatican Gardens",
      "description": "梵蒂冈城国大部分区域被美丽的花园覆盖，拥有喷泉、雕塑和植物。",
      "official_link": "https://www.museivaticani.va/content/museivaticani/en.html",
      "price_range": "通常包含在梵蒂冈博物馆或与巴士游览联票中，约30-40",
      "currency": "EUR",
      "description_en": "Much of the Vatican is gardens—fountains, sculpture and greenery.",
      "price_range_en": "Usually with Vatican Museums or bus tour, ~€30–€40",
      "official_link_en": "https://www.museivaticani.va/content/museivaticani/en.html"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "梵蒂冈宗座宫殿",
      "attractions_name_en": "Apostolic Palace",
      "description": "位于梵蒂冈城内的宫殿群，是教皇的官邸和办公场所，大部分不对外开放。",
      "official_link": "无官方购票链接，部分区域可能作为导览一部分",
      "price_range": "通常不对外开放",
      "currency": "EUR",
      "description_en": "The papal residence and offices—mostly not open to the public.",
      "price_range_en": "Generally not open to public",
      "official_link_en": "No official ticket link; some areas may be part of tours"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "宗座档案馆",
      "attractions_name_en": "Vatican Apostolic Archive",
      "description": "教皇私人图书馆和档案馆，收藏了大量教会和世界历史文献（需特殊许可）。",
      "official_link": "https://www.archivioapostolicovaticano.va/content/aav/en.html",
      "price_range": "需特殊许可，不对普通游客开放",
      "currency": "EUR",
      "description_en": "The papal archives and library—special access only.",
      "price_range_en": "Special permission; not open to general visitors",
      "official_link_en": "https://www.archivioapostolicovaticano.va/content/aav/en.html"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "梵蒂冈药房",
      "attractions_name_en": "Vatican Pharmacy",
      "description": "梵蒂冈城内唯一的药房，以提供特殊药物和化妆品闻名。",
      "official_link": "无官方购票链接，为购物场所",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "The Vatican's only pharmacy—known for special medicines and cosmetics.",
      "price_range_en": "Free (purchases extra)",
      "official_link_en": "No official ticket link; shopping venue"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "梵蒂冈邮局",
      "attractions_name_en": "Vatican Post Office",
      "description": "梵蒂冈拥有自己的邮政系统，可以购买独特的邮票和明信片并寄出。",
      "official_link": "无官方购票链接，为公共服务",
      "price_range": "免费（邮寄费用另计）",
      "currency": "EUR",
      "description_en": "Vatican's own postal service—unique stamps and postcards.",
      "price_range_en": "Free (postage extra)",
      "official_link_en": "No official ticket link; public service"
    },
    {
      "id": "VA",
      "cityname": "梵蒂冈城",
      "cityname_en": "Vatican City",
      "attractions_name": "梵蒂冈纪念品商店",
      "attractions_name_en": "Vatican Souvenir Shops",
      "description": "遍布梵蒂冈城内外，提供各种宗教用品、纪念品和书籍。",
      "official_link": "无官方购票链接，为购物场所",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Shops inside and near the Vatican—religious items, souvenirs and books.",
      "price_range_en": "Free (purchases extra)",
      "official_link_en": "No official ticket link; shopping venue"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "勃兰登堡门",
      "attractions_name_en": "Brandenburg Gate",
      "description": "柏林的标志性建筑，曾是分裂的象征，现代表统一与和平。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Berlin's iconic gate—once a symbol of division, now of unity and peace.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "德国国会大厦",
      "attractions_name_en": "Reichstag Building",
      "description": "德国联邦议会的所在地，拥有著名的玻璃穹顶，可俯瞰城市。",
      "official_link": "https://www.bundestag.de/besuche/",
      "price_range": "免费（需提前预约）",
      "currency": "EUR",
      "description_en": "Home of the Bundestag—famous glass dome with city views. Book ahead.",
      "price_range_en": "Free (advance booking required)",
      "official_link_en": "https://www.bundestag.de/besuche/"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "博物馆岛",
      "attractions_name_en": "Museum Island",
      "description": "位于施普雷河上的博物馆群，包含佩加蒙博物馆、旧国家画廊等。",
      "official_link": "https://www.smb.museum/en/",
      "price_range": "10-12 (单个博物馆), 通票约19",
      "currency": "EUR",
      "description_en": "Museum island on the Spree—Pergamon, Old National Gallery and more.",
      "price_range_en": "€10–€12 (single), combo ~€19",
      "official_link_en": "https://www.smb.museum/en/"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "柏林墙纪念碑",
      "attractions_name_en": "Berlin Wall Memorial",
      "description": "记录柏林墙历史的纪念地，包含原始墙体、瞭望塔和展览。",
      "official_link": "https://www.berliner-mauer-gedenkstaette.de/en/",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Memorial to the Wall—original sections, watchtower and exhibition.",
      "price_range_en": "Free",
      "official_link_en": "https://www.berliner-mauer-gedenkstaette.de/en/"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "东边画廊",
      "attractions_name_en": "East Side Gallery",
      "description": "柏林墙遗址上最长的一段露天画廊，绘有超过100幅涂鸦艺术作品。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The longest stretch of the Wall—over 100 murals in the open air.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "柏林电视塔",
      "attractions_name_en": "Berlin TV Tower",
      "description": "柏林最高的建筑，观景台可360度俯瞰城市全景。",
      "official_link": "https://tv-turm.de/en/",
      "price_range": "25 - 28",
      "currency": "EUR",
      "description_en": "Berlin's tallest structure—360° views from the viewing deck.",
      "price_range_en": "€25–€28",
      "official_link_en": "https://tv-turm.de/en/"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "查理检查站",
      "attractions_name_en": "Checkpoint Charlie",
      "description": "冷战时期柏林墙上东西柏林最重要的检查站之一。",
      "official_link": "无官方购票链接，景点外部免费",
      "price_range": "查理检查站博物馆约16",
      "currency": "EUR",
      "description_en": "The Cold War's most famous crossing between East and West Berlin.",
      "price_range_en": "Checkpoint Charlie Museum ~€16",
      "official_link_en": "No official ticket link; exterior free"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "柏林大教堂",
      "attractions_name_en": "Berlin Cathedral",
      "description": "柏林最大的教堂，拥有宏伟的穹顶，可登顶俯瞰风景。",
      "official_link": "https://www.berlinerdom.de/en/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Berlin's largest church—grand dome, climb for views.",
      "price_range_en": "€10",
      "official_link_en": "https://www.berlinerdom.de/en/"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "犹太博物馆",
      "attractions_name_en": "Jewish Museum Berlin",
      "description": "独特的建筑和丰富的展览，讲述德国犹太人的历史和文化。",
      "official_link": "https://www.jmberlin.de/en",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Striking building and powerful exhibitions on German Jewish history.",
      "price_range_en": "€8",
      "official_link_en": "https://www.jmberlin.de/en"
    },
    {
      "id": "DE",
      "cityname": "柏林",
      "cityname_en": "Berlin",
      "attractions_name": "大屠杀纪念碑",
      "attractions_name_en": "Memorial to the Murdered Jews of Europe",
      "description": "纪念欧洲被谋杀的犹太人，由2711块混凝土石碑组成。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Memorial to the murdered Jews of Europe—2,711 concrete stelae.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "玛丽安广场",
      "attractions_name_en": "Marienplatz",
      "description": "慕尼黑的市中心广场，有新市政厅和钟楼的报时表演。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费（登钟楼收费）",
      "currency": "EUR",
      "description_en": "Munich's central square—Neues Rathaus and the glockenspiel.",
      "price_range_en": "Free (tower charge)",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "宝马世界与博物馆",
      "attractions_name_en": "BMW Welt & Museum",
      "description": "宝马汽车的展示中心和博物馆，展示品牌历史和未来概念。",
      "official_link": "https://www.bmw-welt.com/en.html",
      "price_range": "世界免费，博物馆约10",
      "currency": "EUR",
      "description_en": "BMW showroom and museum—brand history and future concepts.",
      "price_range_en": "World free, museum ~€10",
      "official_link_en": "https://www.bmw-welt.com/en.html"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "英国花园",
      "attractions_name_en": "English Garden",
      "description": "欧洲最大的城市公园之一，有湖泊、茶馆和冲浪点。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Europe's largest urban parks—lakes, beer garden and river surfing.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "宁芬堡宫",
      "attractions_name_en": "Nymphenburg Palace",
      "description": "巴伐利亚统治者的夏宫，拥有华丽的宫殿和广阔的花园。",
      "official_link": "https://nymphenburg.bsv-ticketshop.de/de",
      "price_range": "8 - 15 (根据参观区域)",
      "currency": "EUR",
      "description_en": "Bavarian rulers' summer palace—lavish rooms and vast gardens.",
      "price_range_en": "€8–€15 (by area)",
      "official_link_en": "https://nymphenburg.bsv-ticketshop.de/de"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "德意志博物馆",
      "attractions_name_en": "Deutsches Museum",
      "description": "世界上最大的科技博物馆之一，展品涵盖科学和技术领域。",
      "official_link": "https://www.deutsches-museum.de/en",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "One of the world's largest science and technology museums.",
      "price_range_en": "€15",
      "official_link_en": "https://www.deutsches-museum.de/en"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "慕尼黑老城",
      "attractions_name_en": "Old Town Munich",
      "description": "步行探索老城区的历史建筑、教堂和商店。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Explore the old town on foot—historic buildings, churches and shops.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "新市政厅",
      "attractions_name_en": "New Town Hall",
      "description": "玛丽安广场上的哥特式建筑，拥有著名的钟楼报时表演。",
      "official_link": "无官方购票链接，市政厅外部免费",
      "price_range": "钟楼约4",
      "currency": "EUR",
      "description_en": "Gothic town hall on Marienplatz—famous glockenspiel. Tower ~€4.",
      "price_range_en": "Tower ~€4",
      "official_link_en": "No official ticket link; town hall exterior free"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "圣母教堂",
      "attractions_name_en": "Frauenkirche",
      "description": "慕尼黑的标志性教堂之一，双塔是城市天际线的重要组成部分。",
      "official_link": "无门票，免费参观（登塔收费）",
      "price_range": "免费（登塔约7.50）",
      "currency": "EUR",
      "description_en": "Munich's iconic twin-tower church—a landmark on the skyline.",
      "price_range_en": "Free (tower ~€7.50)",
      "official_link_en": "Free admission (tower paid)"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "慕尼黑皇家啤酒屋",
      "attractions_name_en": "Hofbräuhaus München",
      "description": "世界上最著名的啤酒屋之一，体验巴伐利亚啤酒文化。",
      "official_link": "无官方购票链接，为餐饮场所",
      "price_range": "免费（餐饮消费另计）",
      "currency": "EUR",
      "description_en": "One of the world's most famous beer halls—pure Bavarian tradition.",
      "price_range_en": "Free (food and drink extra)",
      "official_link_en": "No official ticket link; dining venue"
    },
    {
      "id": "DE",
      "cityname": "慕尼黑",
      "cityname_en": "Munich",
      "attractions_name": "安联竞技场",
      "attractions_name_en": "Allianz Arena",
      "description": "拜仁慕尼黑足球俱乐部的主场，可参观球场和博物馆。",
      "official_link": "https://allianz-arena.com/en",
      "price_range": "19 (体育场和博物馆)",
      "currency": "EUR",
      "description_en": "Home of Bayern Munich—stadium and museum tour.",
      "price_range_en": "€19 (stadium and museum)",
      "official_link_en": "https://allianz-arena.com/en"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "罗马广场",
      "attractions_name_en": "Römerberg",
      "description": "法兰克福的老市政厅广场，周边是重建后的历史建筑。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Frankfurt's old town hall square—rebuilt historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "歌德故居",
      "attractions_name_en": "Goethe House",
      "description": "德国最伟大的作家约翰·沃尔夫冈·冯·歌德的出生地和故居。",
      "official_link": "https://www.goethehaus-frankfurt.de/en/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Birthplace and home of Germany's greatest writer, Goethe.",
      "price_range_en": "€10",
      "official_link_en": "https://www.goethehaus-frankfurt.de/en/"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "圣巴尔多禄茂座堂",
      "attractions_name_en": "Frankfurt Cathedral (Kaiserdom)",
      "description": "曾是神圣罗马帝国皇帝选举和加冕的地点。",
      "official_link": "无门票，免费参观（登塔收费）",
      "price_range": "免费（登塔约3）",
      "currency": "EUR",
      "description_en": "Where Holy Roman emperors were elected and crowned.",
      "price_range_en": "Free (tower ~€3)",
      "official_link_en": "Free admission (tower paid)"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "美因河畔",
      "attractions_name_en": "Main River",
      "description": "乘坐游船欣赏法兰克福的天际线，或在河畔散步。",
      "official_link": "游船公司提供购票，无官方统一链接",
      "price_range": "10 - 20 (游船)",
      "currency": "EUR",
      "description_en": "Cruise for skyline views or stroll along the Main.",
      "price_range_en": "€10–€20 (boat)",
      "official_link_en": "Tickets from boat operators; no single official link"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "施泰德艺术馆",
      "attractions_name_en": "Städel Museum",
      "description": "德国最重要的美术馆之一，收藏了从中世纪到现代的欧洲艺术作品。",
      "official_link": "https://www.staedelmuseum.de/en",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "One of Germany's top galleries—European art from medieval to modern.",
      "price_range_en": "€16",
      "official_link_en": "https://www.staedelmuseum.de/en"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "法兰克福旧歌剧院",
      "attractions_name_en": "Old Opera House (Alte Oper)",
      "description": "曾是歌剧院，现为音乐厅和会议中心，建筑精美。",
      "official_link": "无官方购票链接，外部免费",
      "price_range": "免费（参加活动需购票）",
      "currency": "EUR",
      "description_en": "Former opera house—now a concert and events venue, beautiful building.",
      "price_range_en": "Free (tickets for events)",
      "official_link_en": "无官方购票链接，外部免费"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "采尔大街",
      "attractions_name_en": "Zeil",
      "description": "法兰克福最主要的购物街，拥有众多百货公司和商店。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Frankfurt's main shopping street—department stores and high-street brands.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "欧洲中央银行",
      "attractions_name_en": "European Central Bank",
      "description": "现代建筑，可以参观其游客中心了解欧洲货币政策。",
      "official_link": "无需买票",
      "price_range": "免费（需预约）",
      "currency": "EUR",
      "description_en": "Modern HQ—visit the info centre to learn about the euro (book ahead).",
      "price_range_en": "Free (booking required)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "法兰克福动物园",
      "attractions_name_en": "Frankfurt Zoo",
      "description": "德国最古老的动物园之一，拥有丰富的动物种类。",
      "official_link": "https://www.zoo-frankfurt.de/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "One of Germany's oldest zoos—a wide variety of animals.",
      "price_range_en": "€12",
      "official_link_en": "https://www.zoo-frankfurt.de/en/"
    },
    {
      "id": "DE",
      "cityname": "法兰克福",
      "cityname_en": "Frankfurt",
      "attractions_name": "博物馆岸",
      "attractions_name_en": "Museumsufer",
      "description": "美因河两岸的博物馆区，汇集了十多个博物馆。",
      "official_link": "各博物馆独立购票",
      "price_range": "5 - 16 (单个博物馆)",
      "currency": "EUR",
      "description_en": "Museum strip on both banks of the Main—over a dozen museums.",
      "price_range_en": "€5–€16 (per museum)",
      "official_link_en": "Each museum has its own ticketing"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "科隆大教堂",
      "attractions_name_en": "Cologne Cathedral",
      "description": "德国最著名的地标之一，哥特式建筑的杰作，联合国教科文组织世界遗产。",
      "official_link": "无门票，免费参观（登塔、珍宝馆收费）",
      "price_range": "免费（登塔约6，珍宝馆约6）",
      "currency": "EUR",
      "description_en": "One of Germany's most famous landmarks—Gothic masterpiece and UNESCO site.",
      "price_range_en": "Free (tower ~€6, treasury ~€6)",
      "official_link_en": "Free admission (tower and treasury paid)"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "罗马-日耳曼博物馆",
      "attractions_name_en": "Roman-Germanic Museum",
      "description": "位于科隆大教堂旁，展出科隆从石器时代到中世纪早期的考古发现。",
      "official_link": "https://roemisch-germanisches-museum.de/Service_General-shy-information",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Next to the cathedral—Cologne from the Stone Age to the early Middle Ages.",
      "price_range_en": "€12",
      "official_link_en": "https://roemisch-germanisches-museum.de/Service_General-shy-information"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "霍亨索伦桥",
      "attractions_name_en": "Hohenzollern Bridge",
      "description": "横跨莱茵河的著名铁路桥，以爱情锁而闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The famous railway bridge over the Rhine—covered in love locks.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "路德维希博物馆",
      "attractions_name_en": "Museum Ludwig",
      "description": "收藏了大量20世纪和21世纪的现代艺术作品，包括毕加索和波普艺术。",
      "official_link": "https://www.museum-ludwig.de/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "20th- and 21st-century art—Picasso, Pop Art and more.",
      "price_range_en": "€12",
      "official_link_en": "https://www.museum-ludwig.de/en/"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "老城",
      "attractions_name_en": "Old Town Cologne",
      "description": "莱茵河畔的老城区，有狭窄的街道、啤酒馆和教堂。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Old town by the Rhine—narrow streets, beer halls and churches.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "科隆巧克力博物馆",
      "attractions_name_en": "Imhoff-Schokoladenmuseum",
      "description": "详细介绍巧克力的历史和制作过程，并提供品尝。",
      "official_link": "https://www.schokoladenmuseum.de/en/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "The story of chocolate and how it's made—with tastings.",
      "price_range_en": "€15",
      "official_link_en": "https://www.schokoladenmuseum.de/en/"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "4711古龙水之家",
      "attractions_name_en": "4711 House of Eau de Cologne",
      "description": "古龙水诞生地，可以了解古龙水历史并购买产品。",
      "official_link": "无官方购票链接，为商店/体验",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Birthplace of Eau de Cologne—history and shopping.",
      "price_range_en": "Free (purchases extra)",
      "official_link_en": "No official ticket link; shop/experience"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "莱茵河游船",
      "attractions_name_en": "Rhine River Cruise",
      "description": "乘坐游船欣赏科隆沿岸的风景和古迹。",
      "official_link": "游船公司提供购票，无官方统一链接",
      "price_range": "15 - 25 (游船)",
      "currency": "EUR",
      "description_en": "Cruise the Rhine past Cologne's sights.",
      "price_range_en": "€15–€25 (boat)",
      "official_link_en": "Tickets from boat operators; no single official link"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "大圣马丁教堂",
      "attractions_name_en": "Great St. Martin Church",
      "description": "科隆老城区的标志性罗马式教堂，外观独特。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The old town's distinctive Romanesque church.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "DE",
      "cityname": "科隆",
      "cityname_en": "Cologne",
      "attractions_name": "科隆动物园",
      "attractions_name_en": "Cologne Zoo",
      "description": "德国最古老的动物园之一，拥有多样化的动物。",
      "official_link": "https://www.koelnerzoo.de/en/",
      "price_range": "23",
      "currency": "EUR",
      "description_en": "One of Germany's oldest zoos—diverse animal collection.",
      "price_range_en": "€23",
      "official_link_en": "https://www.koelnerzoo.de/en/"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "汉堡港",
      "attractions_name_en": "Port of Hamburg",
      "description": "德国最大的港口，世界第三大集装箱港，可乘坐游船游览。",
      "official_link": "游船公司提供购票，无官方统一链接",
      "price_range": "20 - 30 (游船)",
      "currency": "EUR",
      "description_en": "Germany's largest port and the world's third-busiest container port—explore by boat.",
      "price_range_en": "€20–€30 (boat)",
      "official_link_en": "Tickets from boat operators; no single official link"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "微缩景观世界",
      "attractions_name_en": "Miniatur Wunderland",
      "description": "世界上最大的铁路模型景观，展示了德国、瑞士、美国等地的微缩世界。",
      "official_link": "https://www.miniatur-wunderland.com/",
      "price_range": "20",
      "currency": "EUR",
      "description_en": "The world's largest model railway—miniature worlds from Germany to the USA.",
      "price_range_en": "€20",
      "official_link_en": "https://www.miniatur-wunderland.com/"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "仓库城",
      "attractions_name_en": "Speicherstadt",
      "description": "世界上最大的连续仓储建筑群，红砖建筑，联合国教科文组织世界遗产。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分博物馆收费）",
      "currency": "EUR",
      "description_en": "The world's largest warehouse complex—red-brick UNESCO site.",
      "price_range_en": "Free (some museums charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "易北爱乐音乐厅",
      "attractions_name_en": "Elbphilharmonie Hamburg",
      "description": "汉堡的标志性现代建筑，拥有独特的波浪形屋顶，可登顶观景。",
      "official_link": "https://www.elbphilharmonie.de/en/",
      "price_range": "免费（观景平台），音乐会票价另计",
      "currency": "EUR",
      "description_en": "Hamburg's iconic concert hall—wave-shaped roof and viewing platform.",
      "price_range_en": "Free (viewing platform); concert tickets extra",
      "official_link_en": "https://www.elbphilharmonie.de/en/"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "绳索街",
      "attractions_name_en": "Reeperbahn",
      "description": "汉堡著名的红灯区和娱乐区，夜生活丰富。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（消费另计）",
      "currency": "EUR",
      "description_en": "Hamburg's famous red-light and entertainment strip—lively at night.",
      "price_range_en": "Free (spending extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "汉堡市政厅",
      "attractions_name_en": "Hamburg City Hall",
      "description": "宏伟的砂岩建筑，是汉堡市议会和参议院的所在地。",
      "official_link": "无门票，免费参观（部分区域导览收费）",
      "price_range": "免费（导览约5）",
      "currency": "EUR",
      "description_en": "Grand sandstone town hall—home to the city parliament.",
      "price_range_en": "Free (guided tour ~€5)",
      "official_link_en": "无门票，免费参观（部分区域导览收费）"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "汉堡鱼市",
      "attractions_name_en": "Hamburg Fish Market",
      "description": "历史悠久的露天市场，每周日开放，提供各种海鲜和美食。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（消费另计）",
      "currency": "EUR",
      "description_en": "Historic Sunday market—seafood, snacks and a real local buzz.",
      "price_range_en": "Free (pay as you buy)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "圣米歇尔教堂",
      "attractions_name_en": "St. Michael's Church",
      "description": "汉堡最重要的巴洛克式教堂，可以登塔俯瞰城市和港口。",
      "official_link": "https://www.st-michaelis.de/en/",
      "price_range": "8 (登塔)",
      "currency": "EUR",
      "description_en": "Hamburg's main Baroque church—climb the tower for city and port views.",
      "price_range_en": "€8 (tower)",
      "official_link_en": "https://www.st-michaelis.de/en/"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "国际海事博物馆",
      "attractions_name_en": "International Maritime Museum",
      "description": "收藏了大量海事相关的展品，包括模型船、制服和航海仪器。",
      "official_link": "https://www.imm-hamburg.de/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "Everything maritime—model ships, uniforms and navigational instruments.",
      "price_range_en": "€15",
      "official_link_en": "https://www.imm-hamburg.de/"
    },
    {
      "id": "DE",
      "cityname": "汉堡",
      "cityname_en": "Hamburg",
      "attractions_name": "莱比锡大街和阿尔斯特湖",
      "attractions_name_en": "Jungfernstieg and Alster Lakes",
      "description": "汉堡的时尚购物街，紧邻内阿尔斯特湖和外阿尔斯特湖，可游船。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（游船另计）",
      "currency": "EUR",
      "description_en": "Fashionable shopping street by the Inner and Outer Alster lakes—boat trips available.",
      "price_range_en": "Free (boat trips extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "伦敦塔",
      "attractions_name_en": "Tower of London",
      "description": "英国最具代表性的历史建筑之一，曾是王宫、监狱，现为世界遗产，收藏皇室珠宝。",
      "official_link": "https://www.hrp.org.uk/tower-of-london/",
      "price_range": "34.8",
      "currency": "GBP",
      "description_en": "One of Britain's most iconic landmarks—palace, prison, World Heritage site and Crown Jewels.",
      "price_range_en": "£34.80",
      "official_link_en": "https://www.hrp.org.uk/tower-of-london/"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "大英博物馆",
      "attractions_name_en": "British Museum",
      "description": "世界上最古老、最著名的博物馆之一，收藏了来自世界各地的文物。",
      "official_link": "https://www.britishmuseum.org/",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "One of the world's oldest and greatest museums—treasures from every continent.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.britishmuseum.org/"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "伦敦眼",
      "attractions_name_en": "London Eye",
      "description": "泰晤士河南岸的巨型摩天轮，提供伦敦城市全景。",
      "official_link": "https://www.londoneye.com/",
      "price_range": "33+",
      "currency": "GBP",
      "description_en": "The giant wheel on the South Bank—panoramic views over London.",
      "price_range_en": "£33+",
      "official_link_en": "https://www.londoneye.com/"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "白金汉宫",
      "attractions_name_en": "Buckingham Palace",
      "description": "英国君主的官方居所和主要办公地点，夏季可参观部分区域。",
      "official_link": "https://www.royal.uk/royal-residences-buckingham-palace",
      "price_range": "32 (国家厅) - 75 (皇家日套票)",
      "currency": "GBP",
      "description_en": "The monarch's London residence—summer opening of the State Rooms.",
      "price_range_en": "£32 (State Rooms)–£75 (Royal Day)",
      "official_link_en": "https://www.royal.uk/royal-residences-buckingham-palace"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "威斯敏斯特教堂",
      "attractions_name_en": "Westminster Abbey",
      "description": "英国君主加冕和安葬的地点，哥特式建筑杰作。",
      "official_link": "https://www.westminster-abbey.org/",
      "price_range": "29",
      "currency": "GBP",
      "description_en": "Where British monarchs are crowned and buried—Gothic masterpiece.",
      "price_range_en": "£29",
      "official_link_en": "https://www.westminster-abbey.org/"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "泰晤士河游船",
      "attractions_name_en": "River Thames Cruise",
      "description": "乘坐游船欣赏泰晤士河两岸的地标建筑，如大本钟、伦敦桥等。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "15 - 30 (根据公司和路线)",
      "currency": "GBP",
      "description_en": "Cruise the Thames past Big Ben, Tower Bridge and more.",
      "price_range_en": "£15–£30 (operator and route)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "国家美术馆",
      "attractions_name_en": "National Gallery",
      "description": "收藏了13世纪中期至20世纪初的西欧绘画作品，包括梵高、莫奈等大师。",
      "official_link": "https://www.nationalgallery.org.uk/",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "Western European painting from the 13th to early 20th century—Van Gogh, Monet and more.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.nationalgallery.org.uk/"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "大本钟 (伊丽莎白塔)",
      "attractions_name_en": "Big Ben (Elizabeth Tower)",
      "description": "威斯敏斯特宫的钟楼，伦敦的标志性建筑之一。目前内部参观需要英国居民预约。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费（内部参观暂限英国居民预约）",
      "currency": "GBP",
      "description_en": "The clock tower of the Palace of Westminster—London's icon. Interior tours currently for UK residents only.",
      "price_range_en": "Free (interior booking for UK residents only)",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "碎片大厦",
      "attractions_name_en": "The Shard",
      "description": "伦敦最高的建筑，观景台提供无与伦比的城市360度全景。",
      "official_link": "https://www.theviewfromtheshard.com/",
      "price_range": "32 - 45+",
      "currency": "GBP",
      "description_en": "London's tallest building—360° views from the viewing gallery.",
      "price_range_en": "£32–£45+",
      "official_link_en": "https://www.theviewfromtheshard.com/"
    },
    {
      "id": "GB",
      "cityname": "伦敦",
      "cityname_en": "London",
      "attractions_name": "圣保罗大教堂",
      "attractions_name_en": "St. Paul's Cathedral",
      "description": "克里斯托弗·雷恩爵士设计的杰作，拥有宏伟的穹顶，可登顶俯瞰伦敦。",
      "official_link": "https://www.stpauls.co.uk/",
      "price_range": "25",
      "currency": "GBP",
      "description_en": "Sir Christopher Wren's masterpiece—grand dome and panoramic views.",
      "price_range_en": "£25",
      "official_link_en": "https://www.stpauls.co.uk/"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "爱丁堡城堡",
      "attractions_name_en": "Edinburgh Castle",
      "description": "坐落在火山岩上的古老城堡，俯瞰爱丁堡全城，是苏格兰的标志。",
      "official_link": "https://www.edinburghcastle.scot/",
      "price_range": "21 - 25 (在线预订更便宜)",
      "currency": "GBP",
      "description_en": "Ancient castle on volcanic rock—overlooking the city, Scotland's icon.",
      "price_range_en": "£21–£25 (cheaper online)",
      "official_link_en": "https://www.edinburghcastle.scot/"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "皇家英里大道",
      "attractions_name_en": "Royal Mile",
      "description": "连接爱丁堡城堡和荷里路德宫的古老街道，充满历史建筑和商店。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "The historic mile between the castle and Holyrood—buildings and shops.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "荷里路德宫",
      "attractions_name_en": "Palace of Holyroodhouse",
      "description": "苏格兰君主的官方居所，曾是玛丽女王的故居。",
      "official_link": "https://www.rct.uk/visit/palace-of-holyroodhouse",
      "price_range": "19.5",
      "currency": "GBP",
      "description_en": "The monarch's official residence in Scotland—once home to Mary Queen of Scots.",
      "price_range_en": "£19.50",
      "official_link_en": "https://www.rct.uk/visit/palace-of-holyroodhouse"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "亚瑟王座",
      "attractions_name_en": "Arthur's Seat",
      "description": "位于爱丁堡市中心的一座死火山，可徒步登顶，欣赏城市和周边地区美景。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "An extinct volcano in the city—hike up for views over Edinburgh and beyond.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "卡尔顿山",
      "attractions_name_en": "Calton Hill",
      "description": "位于爱丁堡市中心东部的小山，有多个纪念碑和观景台，可俯瞰城市。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "Hill east of the centre—monuments and viewpoints over the city.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "苏格兰国家博物馆",
      "attractions_name_en": "National Museum of Scotland",
      "description": "收藏了从地质形成到现代苏格兰历史的丰富展品。",
      "official_link": "https://www.nms.ac.uk/national-museum-of-scotland/",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "From geology to modern Scotland—free permanent galleries.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.nms.ac.uk/national-museum-of-scotland/"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "苏格兰威士忌体验中心",
      "attractions_name_en": "Scotch Whisky Experience",
      "description": "互动式展览，深入了解苏格兰威士忌的制作过程和历史，含品鉴。",
      "official_link": "https://www.scotchwhiskyexperience.co.uk/",
      "price_range": "22+",
      "currency": "GBP",
      "description_en": "Interactive tour of how Scotch is made—with tastings.",
      "price_range_en": "£22+",
      "official_link_en": "https://www.scotchwhiskyexperience.co.uk/"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "圣吉尔斯大教堂",
      "attractions_name_en": "St Giles' Cathedral",
      "description": "位于皇家英里大道上的历史悠久的教堂，哥特式建筑。",
      "official_link": "无门票，免费参观（部分区域或导览收费）",
      "price_range": "免费（摄影许可约2，塔楼约6）",
      "currency": "GBP",
      "description_en": "Historic church on the Royal Mile—Gothic architecture.",
      "price_range_en": "Free (photo permit ~£2, tower ~£6)",
      "official_link_en": "无门票，免费参观（部分区域或导览收费）"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "玛丽金小巷",
      "attractions_name_en": "The Real Mary King's Close",
      "description": "隐藏在皇家英里大道下方的神秘街道，了解爱丁堡的黑暗历史。",
      "official_link": "https://www.realmarykingsclose.com/",
      "price_range": "23.5",
      "currency": "GBP",
      "description_en": "Hidden street beneath the Royal Mile—Edinburgh's darker history.",
      "price_range_en": "£23.50",
      "official_link_en": "https://www.realmarykingsclose.com/"
    },
    {
      "id": "GB",
      "cityname": "爱丁堡",
      "cityname_en": "Edinburgh",
      "attractions_name": "爱丁堡旧城与新城",
      "attractions_name_en": "Old Town & New Town",
      "description": "联合国教科文组织世界遗产，展示了中世纪和格鲁吉亚时期的建筑风格。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "UNESCO World Heritage—medieval and Georgian architecture.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "曼彻斯特座堂",
      "attractions_name_en": "Manchester Cathedral",
      "description": "哥特式建筑的宏伟教堂，位于城市中心。",
      "official_link": "无门票，免费参观（建议捐款）",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "Grand Gothic cathedral at the heart of the city.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（建议捐款）"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "约翰·赖兰兹图书馆",
      "attractions_name_en": "John Rylands Library",
      "description": "维多利亚时期哥特式建筑的杰作，拥有独特的阅读空间和珍贵藏书。",
      "official_link": "https://www.library.manchester.ac.uk/rylands/",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "Victorian Gothic masterpiece—reading rooms and rare books.",
      "price_range_en": "Free",
      "official_link_en": "https://www.library.manchester.ac.uk/rylands/"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "科学与工业博物馆",
      "attractions_name_en": "Science and Industry Museum",
      "description": "位于世界第一座客运火车站旧址，讲述曼彻斯特的工业革命历史。",
      "official_link": "https://www.scienceandindustrymuseum.org.uk/",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "In the world's first passenger railway station—Manchester's industrial revolution.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.scienceandindustrymuseum.org.uk/"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "老特拉福德球场",
      "attractions_name_en": "Old Trafford (Manchester United Museum & Tour)",
      "description": "曼联足球俱乐部的主场，可参观球场和博物馆。",
      "official_link": "https://www.manutd.com/en/Visit-Old-Trafford",
      "price_range": "28 - 35 (根据套餐)",
      "currency": "GBP",
      "description_en": "Home of Manchester United—stadium and museum tour.",
      "price_range_en": "£28–£35 (by package)",
      "official_link_en": "https://www.manutd.com/en/Visit-Old-Trafford"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "曼彻斯特市政厅",
      "attractions_name_en": "Manchester Town Hall",
      "description": "维多利亚时期哥特式建筑的杰作，目前正在修复中。",
      "official_link": "无官方购票链接，外部参观免费（内部暂不开放）",
      "price_range": "免费（内部暂不开放）",
      "currency": "GBP",
      "description_en": "Victorian Gothic town hall—currently under restoration.",
      "price_range_en": "Free (interior temporarily closed)",
      "official_link_en": "无官方购票链接，外部参观免费（内部暂不开放）"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "索尔福德码头",
      "attractions_name_en": "Salford Quays",
      "description": "曼彻斯特的现代化海滨区域，有媒体城UK、帝国战争博物馆北馆等。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "Manchester's modern waterfront—MediaCityUK, IWM North and more.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "帝国战争博物馆北馆",
      "attractions_name_en": "Imperial War Museum North",
      "description": "独特的建筑和展览，讲述战争对人民生活的影响。",
      "official_link": "https://www.iwm.org.uk/visits/iwm-north",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "Striking building and exhibitions on how war affects people.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.iwm.org.uk/visits/iwm-north"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "曼彻斯特艺术馆",
      "attractions_name_en": "Manchester Art Gallery",
      "description": "收藏了从17世纪至今的英国和国际艺术品。",
      "official_link": "https://manchesterartgallery.org/",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "British and international art from the 17th century to today.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://manchesterartgallery.org/"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "中国城",
      "attractions_name_en": "Chinatown Manchester",
      "description": "英国第三大唐人街，有许多中餐馆和亚洲商店。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮消费另计）",
      "currency": "GBP",
      "description_en": "Britain's third-largest Chinatown—restaurants and Asian shops.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "曼彻斯特",
      "cityname_en": "Manchester",
      "attractions_name": "坎菲尔德花园",
      "attractions_name_en": "Castlefield Urban Heritage Park",
      "description": "罗马堡垒遗址和工业革命时期的运河、仓库区，是历史保护区。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "Roman fort remains, canals and warehouses—a conservation area.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "利物浦大教堂",
      "attractions_name_en": "Liverpool Cathedral",
      "description": "英国最大的教堂之一，哥特式建筑，可登塔俯瞰城市。",
      "official_link": "https://www.liverpoolcathedral.org.uk/",
      "price_range": "免费（塔楼约6）",
      "currency": "GBP",
      "description_en": "One of Britain's largest cathedrals—Gothic, with tower views.",
      "price_range_en": "Free (tower ~£6)",
      "official_link_en": "https://www.liverpoolcathedral.org.uk/"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "码头顶",
      "attractions_name_en": "Pier Head",
      "description": "利物浦海滨的标志性区域，有“三女神”建筑和披头士雕像。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "Liverpool's iconic waterfront—the Three Graces and Beatles statues.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "阿尔伯特码头",
      "attractions_name_en": "Albert Dock",
      "description": "联合国教科文组织世界遗产，历史悠久的码头区，有博物馆、画廊和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分博物馆收费）",
      "currency": "GBP",
      "description_en": "UNESCO World Heritage—historic docks with museums, galleries and restaurants.",
      "price_range_en": "Free (some museums charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "披头士故事博物馆",
      "attractions_name_en": "The Beatles Story",
      "description": "位于阿尔伯特码头，全面展示披头士乐队的音乐生涯和历史。",
      "official_link": "https://www.beatlesstory.com/",
      "price_range": "19.5",
      "currency": "GBP",
      "description_en": "At Albert Dock—the Beatles' story and music.",
      "price_range_en": "£19.50",
      "official_link_en": "https://www.beatlesstory.com/"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "默西河游船",
      "attractions_name_en": "Mersey Ferry",
      "description": "乘坐渡轮穿越默西河，欣赏利物浦和伯肯海德的城市天际线。",
      "official_link": "https://www.merseyferries.co.uk/",
      "price_range": "12 (45分钟往返)",
      "currency": "GBP",
      "description_en": "Ferry across the Mersey—views of Liverpool and Birkenhead.",
      "price_range_en": "£12 (45-min return)",
      "official_link_en": "https://www.merseyferries.co.uk/"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "利物浦博物馆",
      "attractions_name_en": "Museum of Liverpool",
      "description": "位于码头顶，讲述利物浦从史前到现代的历史和文化。",
      "official_link": "https://www.liverpoolmuseums.org.uk/museum-of-liverpool",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "On the waterfront—Liverpool from prehistory to the present.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.liverpoolmuseums.org.uk/museum-of-liverpool"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "默西赛德海事博物馆",
      "attractions_name_en": "Merseyside Maritime Museum",
      "description": "位于阿尔伯特码头，讲述利物浦的海事历史和泰坦尼克号的故事。",
      "official_link": "https://www.liverpoolmuseums.org.uk/merseyside-maritime-museum",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "At Albert Dock—maritime history and the Titanic.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.liverpoolmuseums.org.uk/merseyside-maritime-museum"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "国际奴役博物馆",
      "attractions_name_en": "International Slavery Museum",
      "description": "位于默西赛德海事博物馆内，探讨奴隶贸易的历史和影响。",
      "official_link": "https://www.liverpoolmuseums.org.uk/international-slavery-museum",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "Inside the Maritime Museum—the slave trade and its legacy.",
      "price_range_en": "Free",
      "official_link_en": "https://www.liverpoolmuseums.org.uk/international-slavery-museum"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "洞穴俱乐部",
      "attractions_name_en": "The Cavern Club",
      "description": "披头士乐队早期演出的著名俱乐部，现在仍有现场音乐表演。",
      "official_link": "https://www.cavernclub.com/",
      "price_range": "免费（白天），晚上演出收费",
      "currency": "GBP",
      "description_en": "Where the Beatles played early on—still hosting live music.",
      "price_range_en": "Free (daytime); evening shows charge",
      "official_link_en": "https://www.cavernclub.com/"
    },
    {
      "id": "GB",
      "cityname": "利物浦",
      "cityname_en": "Liverpool",
      "attractions_name": "沃克艺术画廊",
      "attractions_name_en": "Walker Art Gallery",
      "description": "收藏了13世纪至今的欧洲绘画、雕塑和装饰艺术。",
      "official_link": "https://www.liverpoolmuseums.org.uk/walker-art-gallery",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "European painting, sculpture and decorative art from the 13th century.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.liverpoolmuseums.org.uk/walker-art-gallery"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "罗马浴场",
      "attractions_name_en": "Roman Baths",
      "description": "英国最重要的罗马遗址之一，保存完好的古罗马公共浴场。",
      "official_link": "https://www.romanbaths.co.uk/",
      "price_range": "28 - 30",
      "currency": "GBP",
      "description_en": "One of Britain's finest Roman sites—well-preserved baths.",
      "price_range_en": "£28–£30",
      "official_link_en": "https://www.romanbaths.co.uk/"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "巴斯修道院",
      "attractions_name_en": "Bath Abbey",
      "description": "哥特式教堂，以其独特的扇形拱顶和彩绘玻璃窗闻名。",
      "official_link": "无门票，免费参观（登塔、建议捐款）",
      "price_range": "免费（塔楼之旅约12）",
      "currency": "GBP",
      "description_en": "Gothic church—famous fan vaulting and stained glass.",
      "price_range_en": "Free (tower tour ~£12)",
      "official_link_en": "无门票，免费参观（登塔、建议捐款）"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "皇家新月楼",
      "attractions_name_en": "Royal Crescent",
      "description": "巴斯最著名的乔治亚式建筑群，由30栋联排别墅组成。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费（皇家新月楼1号博物馆约15）",
      "currency": "GBP",
      "description_en": "Bath's most famous Georgian terrace—30 houses in a crescent.",
      "price_range_en": "Free (No. 1 Royal Crescent museum ~£15)",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "普尔特尼桥",
      "attractions_name_en": "Pulteney Bridge",
      "description": "独特的桥梁，桥上建有商店，横跨雅芳河。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "A rare bridge lined with shops across the Avon.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "圆形广场",
      "attractions_name_en": "The Circus",
      "description": "另一组乔治亚式建筑群，由三排环形房屋组成。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "GBP",
      "description_en": "Another Georgian landmark—three curved terraces in a circle.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "简·奥斯汀中心",
      "attractions_name_en": "Jane Austen Centre",
      "description": "纪念英国著名作家简·奥斯汀在巴斯的生活和作品。",
      "official_link": "https://www.janeaustencentre.co.uk/",
      "price_range": "17.5",
      "currency": "GBP",
      "description_en": "Jane Austen's life and work in Bath.",
      "price_range_en": "£17.50",
      "official_link_en": "https://www.janeaustencentre.co.uk/"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "贝茨豪斯时装博物馆",
      "attractions_name_en": "Fashion Museum Bath",
      "description": "收藏了从16世纪至今的时尚服饰。",
      "official_link": "https://www.fashionmuseum.co.uk/",
      "price_range": "13.50 (与市政厅艺术画廊联票)",
      "currency": "GBP",
      "description_en": "Fashion from the 16th century to today.",
      "price_range_en": "£13.50 (combo with Assembly Rooms)",
      "official_link_en": "https://www.fashionmuseum.co.uk/"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "萨利·伦面包店",
      "attractions_name_en": "Sally Lunn's Historic Eating House & Museum",
      "description": "巴斯最古老的房子之一，以其独特的巴斯面包闻名。",
      "official_link": "https://www.sallylunns.co.uk/",
      "price_range": "免费（博物馆区），餐饮消费另计",
      "currency": "GBP",
      "description_en": "One of Bath's oldest buildings—famous for Bath buns.",
      "price_range_en": "Free (museum); café extra",
      "official_link_en": "https://www.sallylunns.co.uk/"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "维多利亚艺术馆",
      "attractions_name_en": "Victoria Art Gallery",
      "description": "收藏了从中世纪到现代的艺术作品，包括油画、雕塑和装饰艺术。",
      "official_link": "https://www.victoriagal.org.uk/",
      "price_range": "免费（特展收费）",
      "currency": "GBP",
      "description_en": "Art from the Middle Ages to modern—paintings, sculpture and decorative arts.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.victoriagal.org.uk/"
    },
    {
      "id": "GB",
      "cityname": "巴斯",
      "cityname_en": "Bath",
      "attractions_name": "肯尼特与埃文运河",
      "attractions_name_en": "Kennet and Avon Canal",
      "description": "沿着运河散步或乘坐运河船，欣赏乡村风光。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（船票另计）",
      "currency": "GBP",
      "description_en": "Walk the towpath or take a narrowboat—countryside views.",
      "price_range_en": "Free (boat trips extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "贝伦塔",
      "attractions_name_en": "Belém Tower",
      "description": "里斯本的标志，曼努埃尔式建筑的杰作，曾是防御工事和灯塔。",
      "official_link": "https://www.patrimoniocultural.gov.pt/en/museus-e-monumentos/torre-de-belem/",
      "price_range": "6 (与热罗尼莫斯修道院联票12)",
      "currency": "EUR",
      "description_en": "Lisbon's icon—Manueline masterpiece, once a fort and lighthouse.",
      "price_range_en": "€6 (combo with Jerónimos €12)",
      "official_link_en": "https://www.patrimoniocultural.gov.pt/en/museus-e-monumentos/torre-de-belem/"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "热罗尼莫斯修道院",
      "attractions_name_en": "Jerónimos Monastery",
      "description": "曼努埃尔式建筑的典范，葡萄牙航海时代的象征，世界遗产。",
      "official_link": "https://www.patrimoniocultural.gov.pt/en/museus-e-monumentos/mosteiro-dos-jeronimos/",
      "price_range": "10 (与贝伦塔联票12)",
      "currency": "EUR",
      "description_en": "Manueline architecture at its best—symbol of the Age of Discoveries, World Heritage.",
      "price_range_en": "€10 (combo with Belém Tower €12)",
      "official_link_en": "https://www.patrimoniocultural.gov.pt/en/museus-e-monumentos/mosteiro-dos-jeronimos/"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "圣乔治城堡",
      "attractions_name_en": "São Jorge Castle",
      "description": "位于里斯本高处，可以俯瞰城市和特茹河全景，历史悠久。",
      "official_link": "https://castelodesaojorge.pt/en/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "Castle on the hill—views over Lisbon and the Tagus.",
      "price_range_en": "€15",
      "official_link_en": "https://castelodesaojorge.pt/en/"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "商业广场",
      "attractions_name_en": "Praça do Comércio",
      "description": "里斯本最大的广场，面向特茹河，曾是皇宫所在地。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Lisbon's grand square by the Tagus—once the site of the royal palace.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "28路有轨电车",
      "attractions_name_en": "Tram 28",
      "description": "乘坐古老的黄色电车穿梭于里斯本狭窄的街道，体验城市风情。",
      "official_link": "无官方购票链接，为公共交通",
      "price_range": "3 (单次票)",
      "currency": "EUR",
      "description_en": "Ride the classic yellow tram through Lisbon's narrow streets—a city icon.",
      "price_range_en": "€3 (single)",
      "official_link_en": "无官方购票链接，为公共交通"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "阿尔法玛区",
      "attractions_name_en": "Alfama District",
      "description": "里斯本最古老的街区，迷宫般的巷道，充满了传统葡萄牙风情。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Lisbon's oldest quarter—a maze of alleys and traditional character.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "圣胡斯塔升降机",
      "attractions_name_en": "Santa Justa Lift",
      "description": "由埃菲尔学徒设计，连接里斯本上下城区，可俯瞰拜萨区。",
      "official_link": "无官方购票链接，为公共交通工具",
      "price_range": "5.30 (往返)",
      "currency": "EUR",
      "description_en": "Designed by a pupil of Eiffel—links the lower and upper city, with views over the Baixa.",
      "price_range_en": "€5.30 (return)",
      "official_link_en": "无官方购票链接，为公共交通工具"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "国家瓷砖博物馆",
      "attractions_name_en": "National Azulejo Museum",
      "description": "展示葡萄牙独特的瓷砖（Azulejo）艺术，从15世纪至今。",
      "official_link": "https://www.museunacionaldoazulejo.pt/en/bilhetes",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "Portugal's distinctive azulejo tile art from the 15th century to today.",
      "price_range_en": "€5",
      "official_link_en": "https://www.museunacionaldoazulejo.pt/en/bilhetes"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "发现者纪念碑",
      "attractions_name_en": "Padrão dos Descobrimentos",
      "description": "纪念葡萄牙航海大发现时代的英雄们，雕塑群面向特茹河。",
      "official_link": "https://padraodosdescobrimentos.pt/",
      "price_range": "6 (登顶)",
      "currency": "EUR",
      "description_en": "Monument to the Age of Discoveries—figures face the Tagus. Climb to the top for views.",
      "price_range_en": "€6 (top)",
      "official_link_en": "https://padraodosdescobrimentos.pt/"
    },
    {
      "id": "PT",
      "cityname": "里斯本",
      "cityname_en": "Lisbon",
      "attractions_name": "里斯本海洋水族馆",
      "attractions_name_en": "Lisbon Oceanarium",
      "description": "欧洲最大的室内水族馆之一，展示世界各地海洋生态系统。",
      "official_link": "https://www.oceanario.pt/en/",
      "price_range": "25",
      "currency": "EUR",
      "description_en": "One of Europe's largest indoor aquariums—ocean ecosystems from around the world.",
      "price_range_en": "€25",
      "official_link_en": "https://www.oceanario.pt/en/"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "莱罗书店",
      "attractions_name_en": "Livraria Lello",
      "description": "世界上最美丽的图书馆之一，被认为是《哈利·波特》的灵感来源之一。",
      "official_link": "https://www.livrarialello.pt/en/",
      "price_range": "8 (可抵扣购书款)",
      "currency": "EUR",
      "description_en": "One of the world's most beautiful bookshops—said to have inspired Harry Potter.",
      "price_range_en": "€8 (deductible from book purchase)",
      "official_link_en": "https://www.livrarialello.pt/en/"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "路易一世大桥",
      "attractions_name_en": "Dom Luís I Bridge",
      "description": "波尔图的标志性双层铁桥，连接波尔图和加亚新城。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Porto's iconic two-level iron bridge linking the city to Vila Nova de Gaia.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "克莱里戈斯塔和教堂",
      "attractions_name_en": "Clérigos Tower and Church",
      "description": "波尔图最高的建筑，可登顶俯瞰城市全景。",
      "official_link": "https://torredosclerigos.pt/en/",
      "price_range": "8 (教堂+塔楼+博物馆)",
      "currency": "EUR",
      "description_en": "Porto's tallest structure—climb the tower for panoramic city views.",
      "price_range_en": "€8 (church + tower + museum)",
      "official_link_en": "https://torredosclerigos.pt/en/"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "杜罗河游船",
      "attractions_name_en": "Douro River Cruise",
      "description": "乘坐游船欣赏两岸的波尔图和加亚新城美景，尤其适合品尝波特酒。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "15 - 20 (根据公司和路线)",
      "currency": "EUR",
      "description_en": "Cruise the Douro past Porto and Gaia—perfect with a glass of port.",
      "price_range_en": "€15–€20 (operator and route)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "波尔图大教堂",
      "attractions_name_en": "Porto Cathedral (Sé do Porto)",
      "description": "罗曼式和哥特式风格的宏伟教堂，位于波尔图老城高处。",
      "official_link": "无门票，免费参观（回廊收费）",
      "price_range": "免费（回廊约3）",
      "currency": "EUR",
      "description_en": "Romanesque and Gothic cathedral high in the old town.",
      "price_range_en": "Free (cloister ~€3)",
      "official_link_en": "无门票，免费参观（回廊收费）"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "波尔图酒窖 (加亚新城)",
      "attractions_name_en": "Port Wine Cellars (Vila Nova de Gaia)",
      "description": "位于杜罗河南岸，提供波特酒品鉴和酒窖参观。",
      "official_link": "https://www.sandeman.com/",
      "price_range": "15 - 30 (根据酒庄和品鉴套餐)",
      "currency": "EUR",
      "description_en": "On the south bank of the Douro—port tastings and cellar tours.",
      "price_range_en": "€15–€30 (winery and tasting)",
      "official_link_en": "https://www.sandeman.com/"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "圣本托火车站",
      "attractions_name_en": "São Bento Railway Station",
      "description": "以其精美的瓷砖壁画而闻名，描绘了葡萄牙的历史场景。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Famous for its azulejo panels depicting Portuguese history.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "圣弗朗西斯科教堂",
      "attractions_name_en": "Church of São Francisco",
      "description": "哥特式教堂，内部装饰华丽，尤其是大量镀金木雕。",
      "official_link": "https://www.ordemsaofrancisco.pt/igreja-e-museu/",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Gothic church with a lavish interior—especially the gilded woodwork.",
      "price_range_en": "€8",
      "official_link_en": "https://www.ordemsaofrancisco.pt/igreja-e-museu/"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "里贝拉区",
      "attractions_name_en": "Ribeira District",
      "description": "联合国教科文组织世界遗产，杜罗河畔的老城区，色彩斑斓的房屋和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—colourful houses and restaurants by the Douro.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "波尔图",
      "cityname_en": "Porto",
      "attractions_name": "水晶宫花园",
      "attractions_name_en": "Jardins do Palácio de Cristal",
      "description": "位于城市高处，提供美丽的杜罗河景和花园。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Gardens on the heights—lovely Douro views and greenery.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "佩纳宫",
      "attractions_name_en": "Pena Palace",
      "description": "融合多种建筑风格的浪漫主义宫殿，色彩鲜艳，世界遗产。",
      "official_link": "https://www.parquesdesintra.pt/en/",
      "price_range": "14 (宫殿+公园)",
      "currency": "EUR",
      "description_en": "Romantic palace mixing styles—vivid colours, World Heritage.",
      "price_range_en": "€14 (palace + park)",
      "official_link_en": "https://www.parquesdesintra.pt/en/"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "摩尔人城堡",
      "attractions_name_en": "Moorish Castle",
      "description": "位于山顶的古老城堡遗址，提供壮丽的景色。",
      "official_link": "https://www.parquesdesintra.pt/en/",
      "price_range": "8 (城堡)",
      "currency": "EUR",
      "description_en": "Ancient Moorish castle on the hilltop—stunning views.",
      "price_range_en": "€8 (castle)",
      "official_link_en": "https://www.parquesdesintra.pt/en/"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "雷加莱拉庄园",
      "attractions_name_en": "Quinta da Regaleira",
      "description": "神秘的庄园，拥有哥特式建筑、洞穴、瀑布和著名的倒置塔。",
      "official_link": "https://www.regaleira.pt/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Mystical estate—Gothic buildings, grottoes, waterfalls and the famous initiation well.",
      "price_range_en": "€12",
      "official_link_en": "https://www.regaleira.pt/en/"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "辛特拉国家宫殿",
      "attractions_name_en": "Sintra National Palace",
      "description": "位于辛特拉市中心的王宫，以其独特的双锥形烟囱而闻名。",
      "official_link": "https://www.parquesdesintra.pt/en/",
      "price_range": "10 (宫殿)",
      "currency": "EUR",
      "description_en": "Royal palace in the town centre—famous for its twin conical chimneys.",
      "price_range_en": "€10 (palace)",
      "official_link_en": "https://www.parquesdesintra.pt/en/"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "蒙塞拉特宫",
      "attractions_name_en": "Monserrate Palace",
      "description": "融合了哥特、印度和摩尔风格的异国情调宫殿，拥有独特的植物园。",
      "official_link": "https://www.parquesdesintra.pt/en/",
      "price_range": "10 (宫殿+公园)",
      "currency": "EUR",
      "description_en": "Exotic palace blending Gothic, Indian and Moorish styles—with a unique garden.",
      "price_range_en": "€10 (palace + park)",
      "official_link_en": "https://www.parquesdesintra.pt/en/"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "埃斯特雷拉圣母教堂",
      "attractions_name_en": "Sanctuary of Peninha",
      "description": "位于辛特拉山上，可俯瞰海岸线和乡村风光。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Church on the Sintra hills—views over the coast and countryside.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "辛特拉历史中心",
      "attractions_name_en": "Historic Centre of Sintra",
      "description": "联合国教科文组织世界遗产，迷人的小镇，有许多商店和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—charming town with shops and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "辛特拉自然公园",
      "attractions_name_en": "Sintra-Cascais Natural Park",
      "description": "覆盖辛特拉山区和沿海地区，拥有丰富的自然风光和徒步路线。",
      "official_link": "无官方购票链接，为自然公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Park covering the Sintra hills and coast—scenery and walking trails.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; nature park"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "罗卡角",
      "attractions_name_en": "Cabo da Roca",
      "description": "欧洲大陆的最西端，灯塔所在地，风景壮丽。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Mainland Europe's westernmost point—lighthouse and dramatic cliffs.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "辛特拉",
      "cityname_en": "Sintra",
      "attractions_name": "阿泽尼亚什海滩",
      "attractions_name_en": "Azenhas do Mar",
      "description": "辛特拉海岸线上的小渔村，有独特的白色房屋和天然泳池。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Small fishing village on the Sintra coast—white houses and natural pools.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "法鲁老城",
      "attractions_name_en": "Cidade Velha (Old Town Faro)",
      "description": "鹅卵石街道，历史建筑，被中世纪城墙环绕。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Cobbled streets and historic buildings inside medieval walls.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "法鲁大教堂",
      "attractions_name_en": "Faro Cathedral (Sé de Faro)",
      "description": "曾是清真寺，后改建为教堂，可登塔俯瞰城市和里亚福尔摩沙。",
      "official_link": "https://www.portugaltravel.org/cathedral-of-faro",
      "price_range": "3.5",
      "currency": "EUR",
      "description_en": "Former mosque turned cathedral—climb the tower for views over town and the Ria Formosa.",
      "price_range_en": "€3.50",
      "official_link_en": "https://www.portugaltravel.org/cathedral-of-faro"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "骨头教堂",
      "attractions_name_en": "Capela dos Ossos (Bone Chapel)",
      "description": "圣弗朗西斯科教堂内的一个小礼拜堂，墙壁由人类头骨和骨骼装饰。",
      "official_link": "https://www.visitevora.net/en/bones-chapel-evora/",
      "price_range": "3",
      "currency": "EUR",
      "description_en": "A small chapel in St Francis church—walls lined with human bones and skulls.",
      "price_range_en": "€3",
      "official_link_en": "https://www.visitevora.net/en/bones-chapel-evora/"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "里亚福尔摩沙自然公园",
      "attractions_name_en": "Ria Formosa Natural Park",
      "description": "泻湖系统，是重要的湿地和鸟类栖息地，可乘船游览。",
      "official_link": "游船公司提供购票，无官方统一链接",
      "price_range": "20 - 40 (游船)",
      "currency": "EUR",
      "description_en": "Lagoon system—important wetlands and birdlife; explore by boat.",
      "price_range_en": "€20–€40 (boat)",
      "official_link_en": "Tickets from boat operators; no single official link"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "法鲁海事博物馆",
      "attractions_name_en": "Museu Marítimo Almirante Ramalho Ortigão",
      "description": "展示阿尔加维地区的海事历史和渔业传统。",
      "official_link": "无官方购票链接，可能包含在其他博物馆联票中",
      "price_range": "3",
      "currency": "EUR",
      "description_en": "Maritime history and fishing traditions of the Algarve.",
      "price_range_en": "€3",
      "official_link_en": "无官方购票链接，可能包含在其他博物馆联票中"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "法鲁市政博物馆",
      "attractions_name_en": "Faro Municipal Museum",
      "description": "位于一座16世纪修道院内，展出罗马、摩尔和中世纪的考古文物。",
      "official_link": "https://www.portugaltravel.org/museu-municipal-de-faro",
      "price_range": "2",
      "currency": "EUR",
      "description_en": "In a 16th-century convent—Roman, Moorish and medieval archaeology.",
      "price_range_en": "€2",
      "official_link_en": "https://www.portugaltravel.org/museu-municipal-de-faro"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "法鲁码头",
      "attractions_name_en": "Faro Marina",
      "description": "现代化码头，有许多餐厅、咖啡馆和游船出发点。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Modern marina—restaurants, cafés and boat trips.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "滨海大道",
      "attractions_name_en": "Jardim Manuel Bivar",
      "description": "位于码头旁的公园和广场，是放松和欣赏风景的好地方。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Park and square by the marina—a pleasant spot to relax.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "科尔德莱斯教堂",
      "attractions_name_en": "Igreja do Carmo",
      "description": "巴洛克式教堂，其内部有骨头教堂。",
      "official_link": "包含在骨头教堂门票内",
      "price_range": "包含在骨头教堂门票内",
      "currency": "EUR",
      "description_en": "Baroque church that houses the bone chapel.",
      "price_range_en": "Included in bone chapel ticket",
      "official_link_en": "包含在骨头教堂门票内"
    },
    {
      "id": "PT",
      "cityname": "法鲁",
      "cityname_en": "Faro",
      "attractions_name": "法鲁海滩 (法鲁岛)",
      "attractions_name_en": "Faro Beach (Ilha de Faro)",
      "description": "位于泻湖外的沙滩岛屿，可通过桥梁到达，适合休闲度假。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Sandy island beyond the lagoon—reached by bridge, ideal for a beach day.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "科英布拉大学",
      "attractions_name_en": "University of Coimbra",
      "description": "葡萄牙最古老的大学，世界遗产，拥有著名的巴洛克式图书馆。",
      "official_link": "https://visit.uc.pt/en/info",
      "price_range": "12.50 (包含图书馆、皇家宫殿等)",
      "currency": "EUR",
      "description_en": "Portugal's oldest university and World Heritage site—famous Baroque library.",
      "price_range_en": "€12.50 (library, palace, etc.)",
      "official_link_en": "https://visit.uc.pt/en/info"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "若昂图书馆",
      "attractions_name_en": "Joanina Library",
      "description": "科英布拉大学内最著名的景点，巴洛克式图书馆，华丽壮观。",
      "official_link": "包含在科英布拉大学门票内",
      "price_range": "包含在科英布拉大学门票内",
      "currency": "EUR",
      "description_en": "The university's star attraction—a stunning Baroque library.",
      "price_range_en": "Included in University ticket",
      "official_link_en": "包含在科英布拉大学门票内"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "科英布拉新大教堂",
      "attractions_name_en": "New Cathedral of Coimbra (Sé Nova)",
      "description": "耶稣会教堂，巴洛克式风格，位于大学区附近。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Jesuit church in Baroque style—near the university quarter.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "科英布拉旧大教堂",
      "attractions_name_en": "Old Cathedral of Coimbra (Sé Velha)",
      "description": "葡萄牙最古老的教堂之一，罗曼式建筑，保留了军事防御特色。",
      "official_link": "无需购票",
      "price_range": "2.5",
      "currency": "EUR",
      "description_en": "One of Portugal's oldest churches—Romanesque, with military character.",
      "price_range_en": "€2.50",
      "official_link_en": "No ticket required"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "圣十字修道院",
      "attractions_name_en": "Santa Cruz Monastery",
      "description": "葡萄牙第一位国王阿方索一世的安息之地，有华丽的墓葬。",
      "official_link": "无门票，免费参观（部分区域收费）",
      "price_range": "免费（部分区域约2）",
      "currency": "EUR",
      "description_en": "Resting place of Afonso I—ornate tombs.",
      "price_range_en": "Free (some areas ~€2)",
      "official_link_en": "无门票，免费参观（部分区域收费）"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "葡萄牙小人国",
      "attractions_name_en": "Portugal dos Pequenitos",
      "description": "葡萄牙主题公园，展示了葡萄牙的建筑、历史和文化微缩模型。",
      "official_link": "无线上购买链接",
      "price_range": "10.5",
      "currency": "EUR",
      "description_en": "Theme park with miniature Portuguese buildings and landmarks.",
      "price_range_en": "€10.50",
      "official_link_en": "No online ticket link"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "蒙德哥河",
      "attractions_name_en": "Mondego River",
      "description": "葡萄牙最长的内陆河流，可在河畔散步或乘船游览。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（游船另计）",
      "currency": "EUR",
      "description_en": "Portugal's longest river—walk the banks or take a boat.",
      "price_range_en": "Free (boat trips extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "植物园",
      "attractions_name_en": "Botanical Garden of the University of Coimbra",
      "description": "欧洲最古老的植物园之一，风景优美，种类丰富。",
      "official_link": "https://www.uc.pt/en/jardimbotanico",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Europe's oldest botanical gardens—beautiful and diverse.",
      "price_range_en": "Free",
      "official_link_en": "https://www.uc.pt/en/jardimbotanico"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "圣诞老修道院",
      "attractions_name_en": "Monastery of Santa Clara-a-Velha",
      "description": "位于蒙德哥河畔的古老修道院遗址，曾被洪水淹没。",
      "official_link": "hhttps://bilheteira.patrimoniocultural.gov.pt/en/monument/34",
      "price_range": "4",
      "currency": "EUR",
      "description_en": "Ancient monastery ruins by the Mondego—partially lost to floods.",
      "price_range_en": "€4",
      "official_link_en": "hhttps://bilheteira.patrimoniocultural.gov.pt/en/monument/34"
    },
    {
      "id": "PT",
      "cityname": "科英布拉",
      "cityname_en": "Coimbra",
      "attractions_name": "科英布拉国家博物馆",
      "attractions_name_en": "National Museum of Machado de Castro (Museu Nacional de Machado de Castro)",
      "description": "位于旧主教宫内，收藏了从罗马到20世纪的雕塑、绘画等艺术品。",
      "official_link": "https://www.mnmc.dgpc.pt/en/",
      "price_range": "6",
      "currency": "EUR",
      "description_en": "In the old bishop's palace—sculpture, painting and more from Roman times to the 20th century.",
      "price_range_en": "€6",
      "official_link_en": "https://www.mnmc.dgpc.pt/en/"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "圣索菲亚大教堂",
      "attractions_name_en": "Hagia Sophia Grand Mosque",
      "description": "曾是教堂、清真寺、博物馆，现为清真寺，拜占庭和奥斯曼建筑的融合。",
      "official_link": "无官方购票链接，作为清真寺免费入内",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Church, mosque, then museum—now a mosque again. Byzantine and Ottoman in one.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，作为清真寺免费入内"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "蓝色清真寺 (苏丹艾哈迈德清真寺)",
      "attractions_name_en": "Blue Mosque (Sultan Ahmed Mosque)",
      "description": "奥斯曼帝国时期宏伟的清真寺，以其内部精美蓝色瓷砖而闻名。",
      "official_link": "无官方购票链接，作为清真寺免费入内",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Grand Ottoman mosque famous for its blue İznik tiles.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，作为清真寺免费入内"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "托普卡帕宫",
      "attractions_name_en": "Topkapi Palace",
      "description": "奥斯曼帝国苏丹的居所和行政中心，内有珍宝馆、后宫等。",
      "official_link": "https://www.topkapipalace-tickets.com/",
      "price_range": "650 (宫殿+后宫)",
      "currency": "TRY",
      "description_en": "Palace of the Ottoman sultans—treasury, harem and more.",
      "price_range_en": "₺650 (palace + harem)",
      "official_link_en": "https://www.topkapipalace-tickets.com/"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "大巴扎",
      "attractions_name_en": "Grand Bazaar",
      "description": "世界上最大的室内市集之一，拥有数千家商店，销售各种商品。",
      "official_link": "无官方购票链接，为公共市集",
      "price_range": "免费（购物消费另计）",
      "currency": "TRY",
      "description_en": "One of the world's largest covered bazaars—thousands of shops.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "无官方购票链接，为公共市集"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "地下水宫",
      "attractions_name_en": "Basilica Cistern",
      "description": "古老的地下水库，拥有数百根石柱，其中最著名的是美杜莎头像柱。",
      "official_link": "https://yerebatan.com/en",
      "price_range": "600",
      "currency": "TRY",
      "description_en": "Ancient underground cistern—hundreds of columns, including the Medusa heads.",
      "price_range_en": "₺600",
      "official_link_en": "https://yerebatan.com/en"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "苏莱曼清真寺",
      "attractions_name_en": "Süleymaniye Mosque",
      "description": "奥斯曼帝国建筑大师锡南的杰作，位于山顶，可俯瞰金角湾。",
      "official_link": "无官方购票链接，作为清真寺免费入内",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Sinan's masterpiece—on the hill with views over the Golden Horn.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，作为清真寺免费入内"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "独立大街",
      "attractions_name_en": "Istiklal Avenue",
      "description": "塔克西姆广场附近的热闹步行街，两旁是商店、餐厅和历史建筑。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Busy pedestrian street near Taksim—shops, restaurants and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "加拉塔塔",
      "attractions_name_en": "Galata Tower",
      "description": "拜占庭时期的古老石塔，可登顶俯瞰伊斯坦布尔全景。",
      "official_link": "https://www.galatatowertickets.com/",
      "price_range": "650",
      "currency": "TRY",
      "description_en": "Medieval stone tower—climb for panoramic views over Istanbul.",
      "price_range_en": "₺650",
      "official_link_en": "https://www.galatatowertickets.com/"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "香料市场 (埃及巴扎)",
      "attractions_name_en": "Spice Bazaar (Egyptian Bazaar)",
      "description": "充满异域风情的市集，销售香料、土耳其软糖、坚果等。",
      "official_link": "无官方购票链接，为公共市集",
      "price_range": "免费（购物消费另计）",
      "currency": "TRY",
      "description_en": "Exotic bazaar—spices, Turkish delight, nuts and more.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "无官方购票链接，为公共市集"
    },
    {
      "id": "TR",
      "cityname": "伊斯坦布尔",
      "cityname_en": "Istanbul",
      "attractions_name": "博斯普鲁斯海峡游船",
      "attractions_name_en": "Bosphorus Cruise",
      "description": "乘坐游船穿越连接欧亚大陆的海峡，欣赏两岸风光和地标。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "200 - 500+ (根据公司和路线)",
      "currency": "TRY",
      "description_en": "Cruise the strait between Europe and Asia—sights on both shores.",
      "price_range_en": "₺200–₺500+ (operator and route)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚 (格雷梅)",
      "cityname_en": "Cappadocia (Göreme)",
      "attractions_name": "格雷梅露天博物馆",
      "attractions_name_en": "Göreme Open-Air Museum",
      "description": "联合国教科文组织世界遗产，岩石凿成的教堂和修道院群。",
      "official_link": "https://cappadociaepass.com/cappadocia-attractions/goreme-open-air-museum.html",
      "price_range": "300",
      "currency": "TRY",
      "description_en": "UNESCO World Heritage—churches and monasteries carved into the rock.",
      "price_range_en": "₺300",
      "official_link_en": "https://cappadociaepass.com/cappadocia-attractions/goreme-open-air-museum.html"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚",
      "cityname_en": "Cappadocia",
      "attractions_name": "热气球飞行",
      "attractions_name_en": "Hot Air Balloon Ride",
      "description": "卡帕多奇亚最著名的体验，日出时分在“仙女烟囱”上空飞行。",
      "official_link": "各热气球公司提供购票，无官方统一链接",
      "price_range": "200 - 350 欧元（取决于季节和时长）",
      "currency": "TRY",
      "description_en": "Cappadocia's iconic experience—sunrise flight over the fairy chimneys.",
      "price_range_en": "€200–€350 (season and duration)",
      "official_link_en": "各热气球公司提供购票，无官方统一链接"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚",
      "cityname_en": "Cappadocia",
      "attractions_name": "帕夏贝 (僧侣谷)",
      "attractions_name_en": "Paşabağ (Monks Valley)",
      "description": "独特的“仙女烟囱”岩层，有些内部有凿刻的修道院。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Distinctive fairy chimneys—some with carved monastic cells inside.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚",
      "cityname_en": "Cappadocia",
      "attractions_name": "爱情谷",
      "attractions_name_en": "Love Valley",
      "description": "以其独特的心形或蘑菇状岩石而闻名，是徒步和拍照的好地方。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Famous for heart- and mushroom-shaped rocks—great for walking and photos.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚",
      "cityname_en": "Cappadocia",
      "attractions_name": "乌奇希萨尔城堡",
      "attractions_name_en": "Uçhisar Castle",
      "description": "卡帕多奇亚最高的岩石城堡，可登顶俯瞰全景。",
      "official_link": "https://www.uchisar.bel.tr/",
      "price_range": "100",
      "currency": "TRY",
      "description_en": "Cappadocia's highest rock castle—climb for panoramic views.",
      "price_range_en": "₺100",
      "official_link_en": "https://www.uchisar.bel.tr/"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚",
      "cityname_en": "Cappadocia",
      "attractions_name": "凯马克勒地下城",
      "attractions_name_en": "Kaymaklı Underground City",
      "description": "深入地下的多层古老城市，曾是避难所。",
      "official_link": "https://cappadociaepass.com/cappadocia-attractions/kaymakli-underground-city.html",
      "price_range": "200",
      "currency": "TRY",
      "description_en": "Multi-level underground city—once a refuge.",
      "price_range_en": "₺200",
      "official_link_en": "https://cappadociaepass.com/cappadocia-attractions/kaymakli-underground-city.html"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚",
      "cityname_en": "Cappadocia",
      "attractions_name": "代林库尤地下城",
      "attractions_name_en": "Derinkuyu Underground City",
      "description": "另一座更大更深的地下城市，拥有通风井和生活设施。",
      "official_link": "https://cappadociaepass.com/cappadocia-attractions/derinkuyu-underground-city.html",
      "price_range": "200",
      "currency": "TRY",
      "description_en": "Another, larger and deeper underground city—ventilation shafts and living quarters.",
      "price_range_en": "₺200",
      "official_link_en": "https://cappadociaepass.com/cappadocia-attractions/derinkuyu-underground-city.html"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚",
      "cityname_en": "Cappadocia",
      "attractions_name": "阿瓦诺斯 (陶瓷小镇)",
      "attractions_name_en": "Avanos",
      "description": "以其传统的陶艺制作而闻名，可以参观作坊并尝试制作。",
      "official_link": "无官方购票链接，参观作坊免费",
      "price_range": "免费（购买陶瓷另计）",
      "currency": "TRY",
      "description_en": "Famous for traditional pottery—visit workshops and try your hand.",
      "price_range_en": "Free (purchases extra)",
      "official_link_en": "无官方购票链接，参观作坊免费"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚",
      "cityname_en": "Cappadocia",
      "attractions_name": "鸽子谷",
      "attractions_name_en": "Pigeon Valley",
      "description": "徒步路线，沿途有许多凿刻在岩石中的鸽子窝。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Walking trail past rock-cut dovecotes.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "卡帕多奇亚",
      "cityname_en": "Cappadocia",
      "attractions_name": "红谷与玫瑰谷",
      "attractions_name_en": "Red Valley & Rose Valley",
      "description": "以其在日落时分呈现出的红色和粉色岩石而闻名，是徒步胜地。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Red and pink rock at sunset—a favourite for hiking.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "卡雷奇老城区",
      "attractions_name_en": "Kaleiçi (Old Town Antalya)",
      "description": "历史悠久的老城区，狭窄的街道，古老的房屋，港口和哈德良门。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Historic old town—narrow streets, old houses, harbour and Hadrian's Gate.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "哈德良门",
      "attractions_name_en": "Hadrian's Gate",
      "description": "古罗马皇帝哈德良访问安塔利亚时建造的凯旋门。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Roman triumphal arch built for Emperor Hadrian's visit.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "安塔利亚博物馆",
      "attractions_name_en": "Antalya Museum",
      "description": "收藏了从旧石器时代到奥斯曼帝国的考古文物，尤其是佩尔盖的雕塑。",
      "official_link": "hhttps://antalya.tc/explore/museums/antalya-museum",
      "price_range": "300",
      "currency": "TRY",
      "description_en": "Archaeology from the Palaeolithic to the Ottomans—especially Perge sculpture.",
      "price_range_en": "₺300",
      "official_link_en": "hhttps://antalya.tc/explore/museums/antalya-museum"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "杜登瀑布",
      "attractions_name_en": "Düden Waterfalls",
      "description": "一组瀑布，分为上杜登瀑布（内陆）和下杜登瀑布（入海）。",
      "official_link": "上杜登：约30，下杜登：免费（可乘船观赏）",
      "price_range": "约30",
      "currency": "TRY",
      "description_en": "Waterfalls—Upper Düden (inland) and Lower Düden (into the sea).",
      "price_range_en": "~₺30",
      "official_link_en": "上杜登：约30，下杜登：免费（可乘船观赏）"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "佩尔盖古城",
      "attractions_name_en": "Perge Ancient City",
      "description": "罗马帝国时期的古城遗址，有剧场、体育场、浴场和街道。",
      "official_link": "https://muze.gov.tr/muze-detay?SectionId=PRG01&DistId=PRG",
      "price_range": "200",
      "currency": "TRY",
      "description_en": "Roman city—theatre, stadium, baths and streets.",
      "price_range_en": "₺200",
      "official_link_en": "https://muze.gov.tr/muze-detay?SectionId=PRG01&DistId=PRG"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "阿斯潘多斯剧场",
      "attractions_name_en": "Aspendos Ancient City & Theatre",
      "description": "罗马帝国时期保存最完好的古剧场之一，至今仍用于演出。",
      "official_link": "https://muze.gov.tr/muze-detay?SectionId=SPD01&DistId=SPD",
      "price_range": "200",
      "currency": "TRY",
      "description_en": "One of the best-preserved Roman theatres—still used for performances.",
      "price_range_en": "₺200",
      "official_link_en": "https://muze.gov.tr/muze-detay?SectionId=SPD01&DistId=SPD"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "科尼扬蒂海滩",
      "attractions_name_en": "Konyaaltı Beach",
      "description": "安塔利亚著名的公共海滩，绵延数公里，背景是山脉。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Antalya's famous public beach—kilometres of sand with mountains behind.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "海港",
      "attractions_name_en": "Antalya Marina",
      "description": "卡雷奇老城旁的码头，有游艇、餐厅和游船。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Marina beside the old town—yachts, restaurants and boat trips.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "迷你城",
      "attractions_name_en": "MiniCity Antalya",
      "description": "展示土耳其各地著名建筑的微缩模型公园。",
      "official_link": "无官方购票链接",
      "price_range": "25",
      "currency": "TRY",
      "description_en": "Miniature park of famous Turkish buildings.",
      "price_range_en": "₺25",
      "official_link_en": "无官方购票链接"
    },
    {
      "id": "TR",
      "cityname": "安塔利亚",
      "cityname_en": "Antalya",
      "attractions_name": "奥林波斯国家公园",
      "attractions_name_en": "Olympos National Park",
      "description": "拥有古代遗址、海滩和火炬山（Chimaera）。",
      "official_link": "遗址和火炬山需门票",
      "price_range": "遗址约100，火炬山约50",
      "currency": "TRY",
      "description_en": "Ancient ruins, beaches and the eternal flames of Chimaera.",
      "price_range_en": "Ruins ~₺100, Chimaera ~₺50",
      "official_link_en": "遗址和火炬山需门票"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "死海滩 (厄吕代尼兹)",
      "attractions_name_en": "Oludeniz (Blue Lagoon)",
      "description": "世界著名的“蓝色泻湖”，以其平静如镜的海水和滑翔伞运动闻名。",
      "official_link": "无官方购票链接，海滩入场费约20",
      "price_range": "20 (蓝色泻湖入场费)",
      "currency": "TRY",
      "description_en": "World-famous Blue Lagoon—calm water and paragliding.",
      "price_range_en": "₺20 (Blue Lagoon entry)",
      "official_link_en": "无官方购票链接，海滩入场费约20"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "滑翔伞",
      "attractions_name_en": "Paragliding in Oludeniz",
      "description": "从巴巴达格山顶跳下，在空中俯瞰蓝色泻湖和海岸线，刺激又美妙。",
      "official_link": "各滑翔伞公司提供购票，无官方统一链接",
      "price_range": "120 - 200 欧元（取决于公司和季节）",
      "currency": "TRY",
      "description_en": "Paraglide from Babadağ—stunning views over the lagoon and coast.",
      "price_range_en": "€120–€200 (operator and season)",
      "official_link_en": "各滑翔伞公司提供购票，无官方统一链接"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "蝴蝶谷",
      "attractions_name_en": "Butterfly Valley",
      "description": "位于死海滩附近的海湾，以其独特的峡谷和夏季的蝴蝶群而闻名。",
      "official_link": "乘船前往，无官方购票链接",
      "price_range": "船费另计，通常免费入谷",
      "currency": "TRY",
      "description_en": "Bay near Ölüdeniz—dramatic canyon and butterflies in summer.",
      "price_range_en": "Boat fare separate; valley usually free",
      "official_link_en": "乘船前往，无官方购票链接"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "费特希耶鱼市",
      "attractions_name_en": "Fethiye Fish Market",
      "description": "独特的市场，你可以购买新鲜海鲜，然后在周边的餐厅加工享用。",
      "official_link": "无官方购票链接，为公共市集",
      "price_range": "免费（餐饮消费另计）",
      "currency": "TRY",
      "description_en": "Buy fresh fish at the market, then have it cooked at a nearby restaurant.",
      "price_range_en": "Free (meal extra)",
      "official_link_en": "无官方购票链接，为公共市集"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "巴巴达格山",
      "attractions_name_en": "Babadağ Mountain",
      "description": "滑翔伞的起跳点，也可以乘坐缆车登顶观景。",
      "official_link": "缆车公司提供购票：https://www.skysport.com.tr/babadag-teleferik",
      "price_range": "缆车约200 - 300",
      "currency": "TRY",
      "description_en": "Paragliding launch site—or take the cable car up for views.",
      "price_range_en": "Cable car ~₺200–₺300",
      "official_link_en": "缆车公司提供购票：https://www.skysport.com.tr/babadag-teleferik"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "利西亚之路",
      "attractions_name_en": "Lycian Way",
      "description": "徒步爱好者天堂，其中部分路段位于费特希耶附近，风景优美。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Long-distance trail—sections near Fethiye are especially scenic.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "阿明塔斯岩墓",
      "attractions_name_en": "Amyntas Rock Tombs",
      "description": "凿刻在悬崖上的古利西亚人墓葬，可徒步攀登近距离观看。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费（内部参观可能收费）",
      "currency": "TRY",
      "description_en": "Lycian rock-cut tomb in the cliff—climb up for a close look.",
      "price_range_en": "Free (interior may charge)",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "鬼城卡亚科伊",
      "attractions_name_en": "Kayaköy Ghost Town",
      "description": "废弃的希腊小镇，约有3500座房屋、两座教堂，历史感强烈。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Abandoned Greek village—thousands of empty houses and two churches.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "12岛游船之旅",
      "attractions_name_en": "12 Islands Boat Trip",
      "description": "乘坐游船游览费特希耶湾的多个小岛和海湾，浮潜和游泳。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "300 - 600 (全天游船含午餐)",
      "currency": "TRY",
      "description_en": "Boat trip around the bay—islands, coves, snorkelling and swimming.",
      "price_range_en": "₺300–₺600 (full day with lunch)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "TR",
      "cityname": "费特希耶",
      "cityname_en": "Fethiye",
      "attractions_name": "萨利肯特峡谷",
      "attractions_name_en": "Saklıkent Gorge",
      "description": "欧洲第二长的峡谷，可以徒步涉水探险。",
      "official_link": "无线上购买链接",
      "price_range": "约100",
      "currency": "TRY",
      "description_en": "Europe's second-longest canyon—hike and wade through the water.",
      "price_range_en": "~₺100",
      "official_link_en": "No online ticket link"
    },
    {
      "id": "TR",
      "cityname": "棉花堡 (代尼兹利)",
      "cityname_en": "Pamukkale (Denizli)",
      "attractions_name": "棉花堡钙化池",
      "attractions_name_en": "Pamukkale Travertines",
      "description": "独特的白色钙化池地貌，层层叠叠，状如棉花，可泡温泉。",
      "official_link": "https://visit-pamukkale.com/",
      "price_range": "700 (含希拉波利斯古城)",
      "currency": "TRY",
      "description_en": "Unique white travertine terraces—like cotton, with thermal pools.",
      "price_range_en": "₺700 (includes Hierapolis)",
      "official_link_en": "https://visit-pamukkale.com/"
    },
    {
      "id": "TR",
      "cityname": "棉花堡",
      "cityname_en": "Pamukkale",
      "attractions_name": "希拉波利斯古城",
      "attractions_name_en": "Hierapolis Ancient City",
      "description": "位于棉花堡顶部的古罗马城市遗址，包含剧场、浴场和墓地。",
      "official_link": "包含在棉花堡门票内",
      "price_range": "包含在棉花堡门票内",
      "currency": "TRY",
      "description_en": "Roman city on top of the travertines—theatre, baths and necropolis.",
      "price_range_en": "Included in Pamukkale ticket",
      "official_link_en": "包含在棉花堡门票内"
    },
    {
      "id": "TR",
      "cityname": "棉花堡",
      "cityname_en": "Pamukkale",
      "attractions_name": "希拉波利斯考古博物馆",
      "attractions_name_en": "Hierapolis Archaeology Museum",
      "description": "位于古罗马浴场内，展出希拉波利斯和周边地区的考古发现。",
      "official_link": "包含在棉花堡门票内",
      "price_range": "包含在棉花堡门票内",
      "currency": "TRY",
      "description_en": "In the Roman baths—finds from Hierapolis and the region.",
      "price_range_en": "Included in Pamukkale ticket",
      "official_link_en": "包含在棉花堡门票内"
    },
    {
      "id": "TR",
      "cityname": "棉花堡",
      "cityname_en": "Pamukkale",
      "attractions_name": "克利奥帕特拉温泉池",
      "attractions_name_en": "Cleopatra's Ancient Pool",
      "description": "传说中埃及艳后曾在此沐浴的古老温泉池，可以在罗马遗迹中游泳。",
      "official_link": "位于棉花堡景区内，单独收费",
      "price_range": "200 (单独入池)",
      "currency": "TRY",
      "description_en": "Ancient pool where Cleopatra is said to have bathed—swim among Roman ruins.",
      "price_range_en": "₺200 (pool only)",
      "official_link_en": "位于棉花堡景区内，单独收费"
    },
    {
      "id": "TR",
      "cityname": "棉花堡",
      "cityname_en": "Pamukkale",
      "attractions_name": "希拉波利斯大剧场",
      "attractions_name_en": "Hierapolis Theatre",
      "description": "保存完好的古罗马剧场，可容纳上万人。",
      "official_link": "包含在棉花堡门票内",
      "price_range": "包含在棉花堡门票内",
      "currency": "TRY",
      "description_en": "Well-preserved Roman theatre—seated thousands.",
      "price_range_en": "Included in Pamukkale ticket",
      "official_link_en": "包含在棉花堡门票内"
    },
    {
      "id": "TR",
      "cityname": "棉花堡",
      "cityname_en": "Pamukkale",
      "attractions_name": "帕穆克卡莱博物馆",
      "attractions_name_en": "Pamukkale Museum",
      "description": "展示当地的自然和历史遗产。",
      "official_link": "包含在棉花堡门票内",
      "price_range": "包含在棉花堡门票内",
      "currency": "TRY",
      "description_en": "Local natural and historical heritage.",
      "price_range_en": "Included in Pamukkale ticket",
      "official_link_en": "包含在棉花堡门票内"
    },
    {
      "id": "TR",
      "cityname": "棉花堡",
      "cityname_en": "Pamukkale",
      "attractions_name": "棉花堡村",
      "attractions_name_en": "Pamukkale Village",
      "description": "位于钙化池脚下的村庄，提供住宿和餐饮服务。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Village at the foot of the travertines—accommodation and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "棉花堡",
      "cityname_en": "Pamukkale",
      "attractions_name": "拉奥迪西亚古城",
      "attractions_name_en": "Laodicea Ancient City",
      "description": "圣经中的七教会之一，拥有大型剧场、教堂和街道遗址。",
      "official_link": "无线上购买链接",
      "price_range": "150",
      "currency": "TRY",
      "description_en": "One of the Seven Churches of Asia—theatre, churches and streets.",
      "price_range_en": "₺150",
      "official_link_en": "No online ticket link"
    },
    {
      "id": "TR",
      "cityname": "棉花堡",
      "cityname_en": "Pamukkale",
      "attractions_name": "代尼兹利市中心",
      "attractions_name_en": "Denizli City Center",
      "description": "代尼兹利省的首府，可体验当地生活，购物和品尝美食。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Provincial capital—local life, shopping and food.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "TR",
      "cityname": "棉花堡",
      "cityname_en": "Pamukkale",
      "attractions_name": "卡拉哈伊特红泉",
      "attractions_name_en": "Karahayit Red Springs",
      "description": "位于棉花堡附近，富含铁质的红色温泉，也有钙化地貌。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "TRY",
      "description_en": "Red thermal springs near Pamukkale—iron-rich water and travertine.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "杜布罗夫尼克城墙",
      "attractions_name_en": "Dubrovnik City Walls",
      "description": "保存完好的中世纪城墙，环绕着老城，提供壮丽的海景和城景。",
      "official_link": "https://www.wallsofdubrovnik.com/",
      "price_range": "35",
      "currency": "EUR",
      "description_en": "Well-preserved medieval walls—walk the ramparts for sea and city views.",
      "price_range_en": "€35",
      "official_link_en": "https://www.wallsofdubrovnik.com/"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "老城 (斯普利采街)",
      "attractions_name_en": "Old Town (Stradun)",
      "description": "杜布罗夫尼克的心脏，主要步行街，两旁是历史建筑、商店和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The heart of Dubrovnik—main pedestrian street, historic buildings, shops and cafés.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "圣劳伦斯要塞",
      "attractions_name_en": "Fort Lovrijenac",
      "description": "位于老城西侧的独立要塞，提供绝佳的城墙和大海景观。",
      "official_link": "https://www.wallsofdubrovnik.com/",
      "price_range": "包含在城墙门票内（或单独购票）",
      "currency": "EUR",
      "description_en": "Fort west of the old town—great views of the walls and the sea.",
      "price_range_en": "Included in walls ticket (or separate)",
      "official_link_en": "https://www.wallsofdubrovnik.com/"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "缆车 (Srđ山)",
      "attractions_name_en": "Dubrovnik Cable Car (Mount Srđ)",
      "description": "乘坐缆车登上Srđ山，俯瞰杜布罗夫尼克老城和亚得里亚海。",
      "official_link": "https://www.dubrovnikcablecar.com/",
      "price_range": "27 (往返)",
      "currency": "EUR",
      "description_en": "Cable car up Mt Srđ—panoramic views over the old town and Adriatic.",
      "price_range_en": "€27 (return)",
      "official_link_en": "https://www.dubrovnikcablecar.com/"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "杜布罗夫尼克大教堂",
      "attractions_name_en": "Dubrovnik Cathedral",
      "description": "位于老城中心，巴洛克式建筑，内有珍宝馆。",
      "official_link": "无门票，免费参观（珍宝馆收费）",
      "price_range": "免费（珍宝馆约3）",
      "currency": "EUR",
      "description_en": "Baroque cathedral in the old town—treasury extra.",
      "price_range_en": "Free (treasury ~€3)",
      "official_link_en": "无门票，免费参观（珍宝馆收费）"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "洛克鲁姆岛",
      "attractions_name_en": "Lokrum Island",
      "description": "离杜布罗夫尼克很近的小岛，有植物园、修道院遗址和孔雀。",
      "official_link": "船票另计，无官方购票链接",
      "price_range": "船票约27 (往返)",
      "currency": "EUR",
      "description_en": "Island near Dubrovnik—botanical garden, monastery ruins and peacocks.",
      "price_range_en": "Boat ~€27 (return)",
      "official_link_en": "船票另计，无官方购票链接"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "教区长宫殿",
      "attractions_name_en": "Rector's Palace",
      "description": "哥特式和文艺复兴风格的宫殿，曾是杜布罗夫尼克共和国的行政中心，现为文化历史博物馆。",
      "official_link": "https://www.dumus.hr/en/",
      "price_range": "15 (与弗朗西斯科修道院联票)",
      "currency": "EUR",
      "description_en": "Gothic-Renaissance palace—once the republic's seat, now a museum.",
      "price_range_en": "€15 (combo with Franciscan monastery)",
      "official_link_en": "https://www.dumus.hr/en/"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "弗朗西斯科修道院",
      "attractions_name_en": "Franciscan Monastery",
      "description": "老城内的修道院，拥有欧洲最古老的药房之一和博物馆。",
      "official_link": "https://www.dumus.hr/en/",
      "price_range": "15 (与教区长宫殿联票)",
      "currency": "EUR",
      "description_en": "Monastery in the old town—one of Europe's oldest pharmacies and a museum.",
      "price_range_en": "€15 (combo with Rector's Palace)",
      "official_link_en": "https://www.dumus.hr/en/"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "奥诺弗里奥喷泉",
      "attractions_name_en": "Onofrio's Large Fountain",
      "description": "老城入口处的大型喷泉，曾是城市供水系统的一部分。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Large fountain at the old town entrance—part of the historic water supply.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "杜布罗夫尼克",
      "cityname_en": "Dubrovnik",
      "attractions_name": "多米尼加修道院",
      "attractions_name_en": "Dominican Monastery",
      "description": "哥特式建筑，拥有美术馆，收藏了许多宗教艺术品。",
      "official_link": "无官方购票链接，入内参观收费",
      "price_range": "7",
      "currency": "EUR",
      "description_en": "Gothic monastery with an art gallery—religious art.",
      "price_range_en": "€7",
      "official_link_en": "无官方购票链接，入内参观收费"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "戴克里先宫",
      "attractions_name_en": "Diocletian's Palace",
      "description": "古罗马戴克里先皇帝的宫殿，现在是斯普利特老城的一部分，世界遗产。",
      "official_link": "无官方购票链接，为公共区域（部分景点收费）",
      "price_range": "免费（景点约10-20）",
      "currency": "EUR",
      "description_en": "Roman emperor Diocletian's palace—now the heart of Split, World Heritage.",
      "price_range_en": "Free (sights €10–€20)",
      "official_link_en": "无官方购票链接，为公共区域（部分景点收费）"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "圣杜预主座教堂和钟楼",
      "attractions_name_en": "Cathedral of Saint Domnius & Bell Tower",
      "description": "戴克里先宫内的主要建筑，曾是皇帝陵墓，可登钟楼俯瞰城市。",
      "official_link": "https://splitcurated.com/listings/saint-domnius-cathedral/",
      "price_range": "10 - 15 (根据包含区域)",
      "currency": "EUR",
      "description_en": "Main building inside the palace—once the emperor's mausoleum; climb the bell tower for views.",
      "price_range_en": "€10–€15 (by area)",
      "official_link_en": "https://splitcurated.com/listings/saint-domnius-cathedral/"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "马里扬山",
      "attractions_name_en": "Marjan Hill",
      "description": "斯普利特西侧的山丘，有步行道、观景台和教堂，提供城市全景。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Hill west of Split—walking paths, viewpoints and a church with city views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "里瓦海滨大道",
      "attractions_name_en": "Riva Promenade",
      "description": "斯普利特最受欢迎的海滨步道，两旁是棕榈树、咖啡馆和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Split's favourite waterfront promenade—palms, cafés and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "共和广场",
      "attractions_name_en": "Prokurative (Republic Square)",
      "description": "仿照威尼斯圣马可广场建造的广场，以其拱廊而闻名。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Square inspired by Venice's St Mark's—famous for its arcades.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "格雷戈里·宁斯基雕像",
      "attractions_name_en": "Statue of Gregory of Nin",
      "description": "斯普利特最著名的雕像之一，据说触摸其大脚趾会带来好运。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Split's best-known statues—rubbing the big toe is said to bring luck.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "费什市场",
      "attractions_name_en": "Fish Market (Peškarija)",
      "description": "斯普利特最大的鱼市，每天早晨有新鲜海产品出售。",
      "official_link": "无官方购票链接，为公共市集",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Split's main fish market—fresh catch every morning.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "无官方购票链接，为公共市集"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "贝尼海滩",
      "attractions_name_en": "Bene Beach",
      "description": "位于马里扬山脚下的海滩，设施齐全，适合家庭。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Beach at the foot of Marjan—well-equipped, family-friendly.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "民族志博物馆",
      "attractions_name_en": "Ethnographic Museum Split",
      "description": "位于戴克里先宫内，展示克罗地亚地区的传统服饰和生活用品。",
      "official_link": "https://splitcurated.com/listings/ethnographic-museum-of-split/",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "Inside the palace—traditional costume and everyday life.",
      "price_range_en": "€5",
      "official_link_en": "https://splitcurated.com/listings/ethnographic-museum-of-split/"
    },
    {
      "id": "HR",
      "cityname": "斯普利特",
      "cityname_en": "Split",
      "attractions_name": "罗马地下宫殿",
      "attractions_name_en": "Diocletian's Palace Cellars",
      "description": "戴克里先宫的地下部分，保存完好，可了解宫殿结构。",
      "official_link": "无官方购票链接，入内参观收费",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Underground halls of the palace—well preserved, revealing the structure.",
      "price_range_en": "€8",
      "official_link_en": "无官方购票链接，入内参观收费"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "圣马可教堂",
      "attractions_name_en": "St. Mark's Church",
      "description": "上城区的标志性建筑，以其多彩的屋顶瓷砖图案而闻名。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Upper Town landmark—famous for its colourful tile roof.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "萨格勒布大教堂",
      "attractions_name_en": "Zagreb Cathedral",
      "description": "哥特式建筑，拥有双塔，是克罗地亚最高的建筑之一。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Gothic cathedral with twin spires—among Croatia's tallest buildings.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "失恋博物馆",
      "attractions_name_en": "Museum of Broken Relationships",
      "description": "独特的主题博物馆，收藏了世界各地失恋者捐赠的物品和故事。",
      "official_link": "https://brokenships.com/",
      "price_range": "7.5",
      "currency": "EUR",
      "description_en": "Unique museum of break-up objects and stories from around the world.",
      "price_range_en": "€7.50",
      "official_link_en": "https://brokenships.com/"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "石门",
      "attractions_name_en": "Stone Gate",
      "description": "连接萨格勒布上城和下城的重要地标，内有圣母玛利亚的壁画。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Gate between Upper and Lower Town—with a Virgin Mary painting inside.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "杜卡诺瓦街市场 (Dolac Market)",
      "attractions_name_en": "Dolac Market",
      "description": "萨格勒布最著名的露天市场，提供新鲜农产品和当地美食。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Zagreb's most famous open-air market—fresh produce and local food.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "伊利卡街",
      "attractions_name_en": "Ilica Street",
      "description": "萨格勒布主要的购物街，两旁有商店、咖啡馆和历史建筑。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Zagreb's main shopping street—shops, cafés and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "萨格勒布缆车",
      "attractions_name_en": "Zagreb Funicular",
      "description": "连接上城和下城的最短公共交通工具，历史悠久。",
      "official_link": "无官方购票链接，为公共交通工具",
      "price_range": "0.66 (单程)",
      "currency": "EUR",
      "description_en": "Short funicular linking Upper and Lower Town—a historic ride.",
      "price_range_en": "€0.66 (single)",
      "official_link_en": "无官方购票链接，为公共交通工具"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "考古博物馆",
      "attractions_name_en": "Archaeological Museum Zagreb",
      "description": "收藏了从史前到中世纪的考古文物，包括著名的姆米亚。",
      "official_link": "https://www.amz.hr/en/",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "Archaeology from prehistory to the Middle Ages—including a famous mummy.",
      "price_range_en": "€5",
      "official_link_en": "https://www.amz.hr/en/"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "艺术和工艺博物馆",
      "attractions_name_en": "Museum of Arts and Crafts",
      "description": "收藏了从14世纪至今的艺术和工艺品，包括家具、陶瓷、纺织品等。",
      "official_link": "https://www.muo.hr/en/",
      "price_range": "6.5",
      "currency": "EUR",
      "description_en": "Arts and crafts from the 14th century—furniture, ceramics, textiles.",
      "price_range_en": "€6.50",
      "official_link_en": "https://www.muo.hr/en/"
    },
    {
      "id": "HR",
      "cityname": "萨格勒布",
      "cityname_en": "Zagreb",
      "attractions_name": "茨维特尼广场 (花广场)",
      "attractions_name_en": "Cvjetni trg (Flower Square)",
      "description": "萨格勒布市中心热闹的广场，有许多咖啡馆和花店。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Busy square in the centre—cafés and flower stalls.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "普拉竞技场",
      "attractions_name_en": "Pula Arena",
      "description": "保存完好的古罗马圆形竞技场，曾用于角斗士表演，现用于音乐会。",
      "official_link": "https://www.visitpula.hr/see-do/arena-pula/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Well-preserved Roman amphitheatre—gladiators then, concerts now.",
      "price_range_en": "€10",
      "official_link_en": "https://www.visitpula.hr/see-do/arena-pula/"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "奥古斯都神庙",
      "attractions_name_en": "Temple of Augustus",
      "description": "保存完好的古罗马神庙，供奉罗马皇帝奥古斯都。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Well-preserved Roman temple dedicated to Emperor Augustus.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "普拉凯旋门 (塞尔吉乌斯凯旋门)",
      "attractions_name_en": "Arch of the Sergii",
      "description": "古罗马时期的凯旋门，装饰精美。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Roman triumphal arch—finely decorated.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "普拉堡垒",
      "attractions_name_en": "Pula Castle (Kaštel)",
      "description": "位于山顶的威尼斯时期堡垒，现为伊斯特拉历史和海事博物馆。",
      "official_link": "https://ppmhp.hr/en/",
      "price_range": "4",
      "currency": "EUR",
      "description_en": "Venetian fort on the hill—now Istrian history and maritime museum.",
      "price_range_en": "€4",
      "official_link_en": "https://ppmhp.hr/en/"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "小罗马剧场",
      "attractions_name_en": "Small Roman Theatre",
      "description": "位于城堡附近的古罗马剧场遗址。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Roman theatre remains near the castle.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "圣弗朗西斯教堂和修道院",
      "attractions_name_en": "Church and Monastery of St. Francis",
      "description": "罗马式和哥特式建筑的修道院，有美丽的庭院。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Romanesque-Gothic monastery with a lovely cloister.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "普拉水族馆",
      "attractions_name_en": "Aquarium Pula",
      "description": "位于一座老要塞内，展示亚得里亚海的海洋生物。",
      "official_link": "https://www.aquarium.hr/",
      "price_range": "17",
      "currency": "EUR",
      "description_en": "In an old fort—Adriatic marine life.",
      "price_range_en": "€17",
      "official_link_en": "https://www.aquarium.hr/"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "涅斯廷格海滩",
      "attractions_name_en": "Histria Beach",
      "description": "普拉最受欢迎的海滩之一，有清澈的海水和鹅卵石。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Pula's most popular beaches—clear water and pebbles.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "普拉市场",
      "attractions_name_en": "Pula Market",
      "description": "当地人的生活中心，可以购买新鲜农产品和海鲜。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Local hub for fresh produce and seafood.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "HR",
      "cityname": "普拉",
      "cityname_en": "Pula",
      "attractions_name": "考古博物馆",
      "attractions_name_en": "Archaeological Museum of Istria",
      "description": "位于普拉竞技场附近，收藏了伊斯特拉地区从史前到中世纪的考古文物。",
      "official_link": "https://www.visitpula.hr/see-do/archaeological-museum/",
      "price_range": "4",
      "currency": "EUR",
      "description_en": "Near the arena—Istrian archaeology from prehistory to the Middle Ages.",
      "price_range_en": "€4",
      "official_link_en": "https://www.visitpula.hr/see-do/archaeological-museum/"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "海风琴",
      "attractions_name_en": "Sea Organ",
      "description": "独特的建筑装置，利用海浪产生音乐，是扎达尔的标志。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Unique installation—waves make music. Zadar's icon.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "太阳致敬",
      "attractions_name_en": "Greeting to the Sun",
      "description": "另一个独特的艺术装置，白天吸收太阳能，夜晚发出光芒。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Another unique installation—solar-powered, it glows at night.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "罗马广场",
      "attractions_name_en": "Roman Forum (Zadar)",
      "description": "古罗马时期的公共广场遗址，位于扎达尔老城中心。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Roman forum remains—at the heart of the old town.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "圣多纳图斯教堂",
      "attractions_name_en": "Church of St. Donatus",
      "description": "扎达尔最著名的地标，独特的圆形前罗马式教堂。",
      "official_link": "https://www.stdonatuschurch.org/",
      "price_range": "3",
      "currency": "EUR",
      "description_en": "Zadar's most famous landmark—unique circular pre-Romanesque church.",
      "price_range_en": "€3",
      "official_link_en": "https://www.stdonatuschurch.org/"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "扎达尔大教堂 (圣阿纳斯塔西亚教堂)",
      "attractions_name_en": "Zadar Cathedral (St. Anastasia's Cathedral)",
      "description": "罗曼式大教堂，可登钟楼俯瞰城市和海景。",
      "official_link": "无门票，免费参观（登钟楼收费）",
      "price_range": "免费（登钟楼约3）",
      "currency": "EUR",
      "description_en": "Romanesque cathedral—climb the bell tower for city and sea views.",
      "price_range_en": "Free (tower ~€3)",
      "official_link_en": "无门票，免费参观（登钟楼收费）"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "考古博物馆",
      "attractions_name_en": "Archaeological Museum Zadar",
      "description": "收藏了从史前到中世纪早期的考古发现。",
      "official_link": "https://www.amzd.hr/en/",
      "price_range": "4",
      "currency": "EUR",
      "description_en": "Archaeology from prehistory to the early Middle Ages.",
      "price_range_en": "€4",
      "official_link_en": "https://www.amzd.hr/en/"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "五井广场",
      "attractions_name_en": "Five Wells Square",
      "description": "扎达尔老城内的一个历史广场，曾是城市供水系统的一部分。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Historic square in the old town—once part of the water supply.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "陆门",
      "attractions_name_en": "Land Gate (Kopnena Vrata)",
      "description": "扎达尔的标志性城门，文艺复兴风格，装饰精美。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Zadar's landmark Renaissance gate—finely decorated.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "扎达尔老城墙",
      "attractions_name_en": "Zadar City Walls",
      "description": "联合国教科文组织世界遗产，环绕老城，可步行参观。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—walk the walls around the old town.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HR",
      "cityname": "扎达尔",
      "cityname_en": "Zadar",
      "attractions_name": "克尔卡国家公园一日游",
      "attractions_name_en": "Krka National Park Day Trip",
      "description": "距扎达尔不远的国家公园，以其多层瀑布和清澈的湖泊而闻名。",
      "official_link": "https://np-krka.hr/en/",
      "price_range": "10 - 40 (取决于季节)",
      "currency": "EUR",
      "description_en": "National park near Zadar—tiered waterfalls and clear lakes.",
      "price_range_en": "€10–€40 (season)",
      "official_link_en": "https://np-krka.hr/en/"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "阿姆斯特丹国立博物馆",
      "attractions_name_en": "Rijksmuseum",
      "description": "收藏了大量荷兰黄金时代艺术珍品，包括伦勃朗的《夜巡》。",
      "official_link": "https://www.rijksmuseum.nl/en",
      "price_range": "22.5",
      "currency": "EUR",
      "description_en": "Dutch Golden Age masterpieces—including Rembrandt's Night Watch.",
      "price_range_en": "€22.50",
      "official_link_en": "https://www.rijksmuseum.nl/en"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "安妮之家",
      "attractions_name_en": "Anne Frank House",
      "description": "安妮·弗兰克一家在二战期间躲藏并写下日记的地方。",
      "official_link": "https://www.annefrank.org/en/",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "Where Anne Frank and her family hid and she wrote her diary.",
      "price_range_en": "€16",
      "official_link_en": "https://www.annefrank.org/en/"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "梵高博物馆",
      "attractions_name_en": "Van Gogh Museum",
      "description": "收藏了梵高最多的画作，包括《向日葵》和《吃土豆的人》。",
      "official_link": "https://www.vangoghmuseum.nl/en",
      "price_range": "22",
      "currency": "EUR",
      "description_en": "The world's largest Van Gogh collection—Sunflowers, The Potato Eaters and more.",
      "price_range_en": "€22",
      "official_link_en": "https://www.vangoghmuseum.nl/en"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "运河游船",
      "attractions_name_en": "Canal Cruise",
      "description": "乘坐游船穿梭于阿姆斯特丹的运河，欣赏两岸独特的建筑。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "15 - 25",
      "currency": "EUR",
      "description_en": "Cruise Amsterdam's canals—unique architecture on both sides.",
      "price_range_en": "€15–€25",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "冯德尔公园",
      "attractions_name_en": "Vondelpark",
      "description": "阿姆斯特丹最大的公园，是当地人和游客休闲放松的好地方。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Amsterdam's largest park—popular with locals and visitors alike.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "皇家阿姆斯特丹皇宫",
      "attractions_name_en": "Royal Palace of Amsterdam",
      "description": "曾是市政厅，后改为皇宫，现在用于国事访问和重大活动。",
      "official_link": "https://www.paleisamsterdam.nl/en/",
      "price_range": "12.5",
      "currency": "EUR",
      "description_en": "Former town hall, now royal palace—used for state visits and events.",
      "price_range_en": "€12.50",
      "official_link_en": "https://www.paleisamsterdam.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "阿姆斯特丹运河带",
      "attractions_name_en": "Amsterdam Canal Ring",
      "description": "联合国教科文组织世界遗产，独特的运河系统和17世纪建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—canal ring and 17th-century buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "喜力体验馆",
      "attractions_name_en": "Heineken Experience",
      "description": "喜力啤酒厂的旧址，提供互动式啤酒酿造之旅和品尝。",
      "official_link": "https://www.heinekenexperience.com/",
      "price_range": "23 - 30",
      "currency": "EUR",
      "description_en": "Former Heineken brewery—interactive tour and tastings.",
      "price_range_en": "€23–€30",
      "official_link_en": "https://www.heinekenexperience.com/"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "伦勃朗故居博物馆",
      "attractions_name_en": "Rembrandt House Museum",
      "description": "伦勃朗曾经居住和工作的房子，展示了他的生活和艺术。",
      "official_link": "https://www.rembrandthuis.nl/en/",
      "price_range": "17.5",
      "currency": "EUR",
      "description_en": "Rembrandt's home and studio—his life and art.",
      "price_range_en": "€17.50",
      "official_link_en": "https://www.rembrandthuis.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "阿姆斯特丹",
      "cityname_en": "Amsterdam",
      "attractions_name": "绅士运河",
      "attractions_name_en": "Herengracht",
      "description": "阿姆斯特丹最古老、最著名的运河之一，两旁是豪华的运河屋。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Amsterdam's oldest and grandest canals—elegant canal houses.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "方块屋",
      "attractions_name_en": "Cube Houses",
      "description": "独特的倾斜方块形建筑群，是鹿特丹的标志性现代建筑。",
      "official_link": "参观内部体验房约3.50",
      "price_range": "3.50 (参观内部体验房)",
      "currency": "EUR",
      "description_en": "Distinctive tilted cube houses—Rotterdam's modern icon.",
      "price_range_en": "€3.50 (show cube)",
      "official_link_en": "参观内部体验房约3.50"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "市场大厅",
      "attractions_name_en": "Markthal",
      "description": "独特的马蹄形建筑，结合了住宅、市场和美食广场。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（消费另计）",
      "currency": "EUR",
      "description_en": "Unique horseshoe-shaped building—housing, market and food hall.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "伊拉斯谟桥",
      "attractions_name_en": "Erasmus Bridge",
      "description": "鹿特丹的标志性桥梁，连接马斯河两岸，形似天鹅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Rotterdam's iconic bridge over the Maas—swan-like shape.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "欧洲之桅",
      "attractions_name_en": "Euromast",
      "description": "鹿特丹最高的观景塔，提供城市和港口全景。",
      "official_link": "https://euromast.nl/en/",
      "price_range": "12.5",
      "currency": "EUR",
      "description_en": "Rotterdam's tallest viewing tower—city and port views.",
      "price_range_en": "€12.50",
      "official_link_en": "https://euromast.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "博物馆公园",
      "attractions_name_en": "Museum Park",
      "description": "汇集了鹿特丹最重要的博物馆，包括博伊曼斯·范伯宁恩美术馆。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Park with Rotterdam's main museums—including Boijmans.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "博伊曼斯·范伯宁恩美术馆",
      "attractions_name_en": "Museum Boijmans Van Beuningen",
      "description": "收藏了从中世纪到现代的艺术品，包括伦勃朗、莫奈等大师作品。",
      "official_link": "https://www.boijmans.nl/en/",
      "price_range": "15 (主馆目前关闭翻修，部分展品在Depot)",
      "currency": "EUR",
      "description_en": "Art from the Middle Ages to modern—Rembrandt, Monet and more. Main building closed for renovation; some works at Depot.",
      "price_range_en": "€15 (main building closed; Depot)",
      "official_link_en": "https://www.boijmans.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "鹿特丹港",
      "attractions_name_en": "Port of Rotterdam",
      "description": "欧洲最大的港口，可乘坐游船参观繁忙的港口活动。",
      "official_link": "游船公司提供购票，无官方统一链接",
      "price_range": "20 - 30 (游船)",
      "currency": "EUR",
      "description_en": "Europe's largest port—boat tours of the busy harbour.",
      "price_range_en": "€20–€30 (boat)",
      "official_link_en": "Tickets from boat operators; no single official link"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "小孩堤防风车村",
      "attractions_name_en": "Kinderdijk Windmills",
      "description": "联合国教科文组织世界遗产，拥有19座保存完好的传统风车。",
      "official_link": "https://www.kinderdijk.com/",
      "price_range": "19 (进入区域和参观风车)",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—19 preserved windmills.",
      "price_range_en": "€19 (area and windmills)",
      "official_link_en": "https://www.kinderdijk.com/"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "鹿特丹动物园",
      "attractions_name_en": "Diergaarde Blijdorp",
      "description": "欧洲最古老、最美丽的动物园之一，拥有多样化的动物和生态系统。",
      "official_link": "https://www.diergaardeblijdorp.nl/en/",
      "price_range": "28.5",
      "currency": "EUR",
      "description_en": "One of Europe's oldest and finest zoos—diverse animals and habitats.",
      "price_range_en": "€28.50",
      "official_link_en": "https://www.diergaardeblijdorp.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "鹿特丹",
      "cityname_en": "Rotterdam",
      "attractions_name": "鹿特丹中央车站",
      "attractions_name_en": "Rotterdam Centraal Station",
      "description": "现代化的建筑地标，是城市重建的象征。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Modern architectural landmark—symbol of the city's rebirth.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "和平宫",
      "attractions_name_en": "Peace Palace",
      "description": "国际法院和常设仲裁法院所在地，世界和平的象征。",
      "official_link": "https://www.vredespaleis.nl/en/",
      "price_range": "15 (参观中心)",
      "currency": "EUR",
      "description_en": "Home of the International Court of Justice—symbol of world peace.",
      "price_range_en": "€15 (visitor centre)",
      "official_link_en": "https://www.vredespaleis.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "莫里茨皇家美术馆",
      "attractions_name_en": "Mauritshuis",
      "description": "收藏了荷兰黄金时代大师的杰作，包括维米尔的《戴珍珠耳环的少女》。",
      "official_link": "https://www.mauritshuis.nl/en/",
      "price_range": "19.5",
      "currency": "EUR",
      "description_en": "Dutch Golden Age masterpieces—Vermeer's Girl with a Pearl Earring.",
      "price_range_en": "€19.50",
      "official_link_en": "https://www.mauritshuis.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "马德罗丹微缩城",
      "attractions_name_en": "Madurodam",
      "description": "微缩主题公园，展示了荷兰的著名地标、城市和风景的精美模型。",
      "official_link": "https://www.madurodam.nl/en/",
      "price_range": "24.5",
      "currency": "EUR",
      "description_en": "Miniature park—Dutch landmarks, cities and landscapes in scale.",
      "price_range_en": "€24.50",
      "official_link_en": "https://www.madurodam.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "席凡宁根海滩",
      "attractions_name_en": "Scheveningen Beach",
      "description": "海牙著名的海滨度假胜地，有码头、海滩和餐厅。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The Hague's famous seaside resort—pier, beach and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "荷兰国会大厦 (内庭)",
      "attractions_name_en": "Binnenhof & Ridderzaal",
      "description": "荷兰议会和政府所在地，哥特式建筑群，内庭可免费参观。",
      "official_link": "https://en.prodemos.nl/",
      "price_range": "免费（导览收费，目前有部分区域维修）",
      "currency": "EUR",
      "description_en": "Dutch parliament and government—Gothic complex; inner courtyard free.",
      "price_range_en": "Free (tours charge; some areas under repair)",
      "official_link_en": "https://en.prodemos.nl/"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "国际刑事法院",
      "attractions_name_en": "International Criminal Court (ICC)",
      "description": "联合国的一部分，可参观其公共画廊和展览。",
      "official_link": "https://www.icc-cpi.int/",
      "price_range": "免费（需预约）",
      "currency": "EUR",
      "description_en": "Part of the UN—public gallery and exhibitions. Book ahead.",
      "price_range_en": "Free (booking required)",
      "official_link_en": "https://www.icc-cpi.int/"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "埃舍尔在宫殿",
      "attractions_name_en": "Escher in Het Paleis",
      "description": "展览荷兰艺术家莫里茨·科内利斯·埃舍尔的错视艺术作品。",
      "official_link": "https://www.escherinhetpaleis.nl/en/",
      "price_range": "12.5",
      "currency": "EUR",
      "description_en": "Works by the Dutch artist M.C. Escher—optical illusions and more.",
      "price_range_en": "€12.50",
      "official_link_en": "https://www.escherinhetpaleis.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "市政厅",
      "attractions_name_en": "City Hall (The Hague)",
      "description": "现代建筑，由美国建筑师理查德·迈耶设计，被称为“冰宫”。",
      "official_link": "无官方购票链接，外部免费",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Modern building by Richard Meier—nicknamed the \"Ice Palace\".",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部免费"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "努尔德埃因德宫",
      "attractions_name_en": "Noordeinde Palace",
      "description": "荷兰国王的正式工作宫殿，不对公众开放，但可以参观其花园。",
      "official_link": "无官方购票链接，外部参观免费（花园特定日期开放）",
      "price_range": "免费（花园特定日期开放）",
      "currency": "EUR",
      "description_en": "The king's working palace—not open to the public; gardens on set dates.",
      "price_range_en": "Free (gardens on set dates)",
      "official_link_en": "无官方购票链接，外部参观免费（花园特定日期开放）"
    },
    {
      "id": "NL",
      "cityname": "海牙",
      "cityname_en": "The Hague",
      "attractions_name": "佳士得博物馆",
      "attractions_name_en": "Kunstmuseum Den Haag (formerly Gemeentemuseum)",
      "description": "收藏了蒙德里安最多的作品，以及其他现代艺术、时尚和设计。",
      "official_link": "https://www.kunstmuseum.nl/en",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "The world's largest Mondrian collection—plus modern art, fashion and design.",
      "price_range_en": "€16",
      "official_link_en": "https://www.kunstmuseum.nl/en"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "圆顶塔",
      "attractions_name_en": "Dom Tower",
      "description": "荷兰最高的教堂钟楼，可登顶俯瞰乌得勒支全景。",
      "official_link": "https://www.domtoren.nl/en/",
      "price_range": "12.5",
      "currency": "EUR",
      "description_en": "The Netherlands' tallest church tower—climb for city views.",
      "price_range_en": "€12.50",
      "official_link_en": "https://www.domtoren.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "圣马丁大教堂",
      "attractions_name_en": "Dom Church (St. Martin's Cathedral)",
      "description": "毗邻圆顶塔的教堂，其身受圆顶塔影响，内部结构独特。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Church next to the Dom Tower—unique interior linked to the tower.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "迪克·布鲁纳之家",
      "attractions_name_en": "Dick Bruna House (Miffy Museum)",
      "description": "纪念米菲兔的创作者迪克·布鲁纳，适合儿童。",
      "official_link": "https://www.nijntjemuseum.nl/",
      "price_range": "14 (与中央博物馆联票)",
      "currency": "EUR",
      "description_en": "Dedicated to Miffy's creator Dick Bruna—great for kids.",
      "price_range_en": "€14 (combo with Central Museum)",
      "official_link_en": "https://www.nijntjemuseum.nl/"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "中央博物馆",
      "attractions_name_en": "Centraal Museum Utrecht",
      "description": "乌得勒支最重要的博物馆，收藏了艺术、时尚和当地历史展品。",
      "official_link": "https://www.centraalmuseum.nl/en/",
      "price_range": "16.5",
      "currency": "EUR",
      "description_en": "Utrecht's main museum—art, fashion and local history.",
      "price_range_en": "€16.50",
      "official_link_en": "https://www.centraalmuseum.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "老运河",
      "attractions_name_en": "Oudegracht",
      "description": "乌得勒支独特的运河，两旁有下沉式的码头地窖，现在是商店和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Utrecht's unique canals—wharf cellars now shops and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "施罗德住宅",
      "attractions_name_en": "Rietveld Schröder House",
      "description": "荷兰风格派建筑的典范，联合国教科文组织世界遗产。",
      "official_link": "https://rietveldschroderhuis.nl/",
      "price_range": "17 (需提前预约)",
      "currency": "EUR",
      "description_en": "De Stijl masterpiece—UNESCO World Heritage. Book ahead.",
      "price_range_en": "€17 (booking required)",
      "official_link_en": "https://rietveldschroderhuis.nl/"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "德哈尔城堡",
      "attractions_name_en": "De Haar Castle",
      "description": "荷兰最大的城堡之一，充满童话色彩的哥特复兴式建筑。",
      "official_link": "https://www.kasteeldehaar.nl/en/",
      "price_range": "18.50 (花园+城堡)",
      "currency": "EUR",
      "description_en": "One of the Netherlands' largest castles—Gothic Revival, fairy-tale style.",
      "price_range_en": "€18.50 (gardens + castle)",
      "official_link_en": "https://www.kasteeldehaar.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "铁路博物馆",
      "attractions_name_en": "Railway Museum (Spoorwegmuseum)",
      "description": "位于一座老火车站内，展示了荷兰铁路历史。",
      "official_link": "https://www.spoorwegmuseum.nl/en/",
      "price_range": "19.5",
      "currency": "EUR",
      "description_en": "In a former station—Dutch railway history.",
      "price_range_en": "€19.50",
      "official_link_en": "https://www.spoorwegmuseum.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "乌得勒支大学植物园",
      "attractions_name_en": "Utrecht University Botanic Gardens",
      "description": "乌得勒支大学的植物园，拥有多样化的植物种类。",
      "official_link": "https://www.uu.nl/en/utrecht-university-botanic-gardens",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "University botanical garden—diverse plant collections.",
      "price_range_en": "€10",
      "official_link_en": "https://www.uu.nl/en/utrecht-university-botanic-gardens"
    },
    {
      "id": "NL",
      "cityname": "乌得勒支",
      "cityname_en": "Utrecht",
      "attractions_name": "圣凯瑟琳教堂博物馆",
      "attractions_name_en": "Catharijneconvent Museum",
      "description": "荷兰最全面的基督教艺术和历史博物馆。",
      "official_link": "https://www.catharijneconvent.nl/en/",
      "price_range": "17.5",
      "currency": "EUR",
      "description_en": "The Netherlands' most comprehensive museum of Christian art and history.",
      "price_range_en": "€17.50",
      "official_link_en": "https://www.catharijneconvent.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "地狱之门",
      "attractions_name_en": "Helpoort",
      "description": "荷兰最古老的城门，是马斯特里赫特历史悠久的标志。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The Netherlands' oldest surviving city gate—Maastricht's historic symbol.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "圣塞尔瓦斯教堂",
      "attractions_name_en": "Basilica of St. Servatius",
      "description": "荷兰最古老的教堂之一，罗曼式建筑，收藏有珍宝。",
      "official_link": "https://www.sintservaas.nl/en/",
      "price_range": "4.50 (参观珍宝)",
      "currency": "EUR",
      "description_en": "One of the Netherlands' oldest churches—Romanesque, with a treasury.",
      "price_range_en": "€4.50 (treasury)",
      "official_link_en": "https://www.sintservaas.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "博克里蒙山洞穴",
      "attractions_name_en": "Caves of Mount Saint Peter (Zonneberg Caves)",
      "description": "巨大的地下洞穴系统，曾是采石场和避难所。",
      "official_link": "https://www.exploremaastricht.nl/en/caves",
      "price_range": "10 - 15 (需导游带领)",
      "currency": "EUR",
      "description_en": "Vast underground cave system—former quarries and wartime refuge. Guided tours only.",
      "price_range_en": "€10–€15 (guided)",
      "official_link_en": "https://www.exploremaastricht.nl/en/caves"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "圣扬教堂",
      "attractions_name_en": "Sint Janskerk",
      "description": "哥特式教堂，以其红色的钟楼而闻名，可登顶俯瞰城市。",
      "official_link": "无门票，免费参观（登塔收费）",
      "price_range": "免费（登塔约3）",
      "currency": "EUR",
      "description_en": "Gothic church famous for its red tower—climb for city views.",
      "price_range_en": "Free (tower ~€3)",
      "official_link_en": "Free admission (tower paid)"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "瓦隆昆斯特公园",
      "attractions_name_en": "Vrijthof Square",
      "description": "马斯特里赫特最著名的广场，两旁是教堂、餐厅和酒吧。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Maastricht's most famous square—churches, restaurants and bars.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "马斯特里赫特地下城",
      "attractions_name_en": "Maastricht Underground",
      "description": "探索城市下方的隧道和防御工事，了解历史。",
      "official_link": "https://www.maastrichtunderground.nl/en/",
      "price_range": "10 - 15 (导览)",
      "currency": "EUR",
      "description_en": "Explore tunnels and fortifications beneath the city—guided tours.",
      "price_range_en": "€10–€15 (guided)",
      "official_link_en": "https://www.maastrichtunderground.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "自然史博物馆",
      "attractions_name_en": "Natural History Museum Maastricht",
      "description": "位于历史建筑内，展示林堡地区的自然历史。",
      "official_link": "https://www.nhmmaastricht.nl/",
      "price_range": "7.5",
      "currency": "EUR",
      "description_en": "In a historic building—natural history of Limburg.",
      "price_range_en": "€7.50",
      "official_link_en": "https://www.nhmmaastricht.nl/"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "博斯韦德修道院",
      "attractions_name_en": "Bookhandel Dominicanen (Dominicanen Bookstore)",
      "description": "位于一座古老的教堂内，被评为世界上最美丽的独立书店之一。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Bookshop in a former church—often called one of the world's most beautiful.",
      "price_range_en": "Free (books extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "圣彼得堡要塞",
      "attractions_name_en": "Fort St. Pieter",
      "description": "位于马斯特里赫特南部的历史要塞，提供城市全景。",
      "official_link": "https://www.maastrichtunderground.nl/en/",
      "price_range": "约10 (导览)",
      "currency": "EUR",
      "description_en": "Historic fort south of Maastricht—city views. Guided tours.",
      "price_range_en": "~€10 (guided)",
      "official_link_en": "https://www.maastrichtunderground.nl/en/"
    },
    {
      "id": "NL",
      "cityname": "马斯特里赫特",
      "cityname_en": "Maastricht",
      "attractions_name": "比嫩霍夫地区",
      "attractions_name_en": "Stokstraat Quarter",
      "description": "马斯特里赫特最古老的街区之一，狭窄的街道，独特的精品店。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Maastricht's oldest quarters—narrow streets and unique boutiques.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "班霍夫大街",
      "attractions_name_en": "Bahnhofstrasse",
      "description": "世界上最著名的购物街之一，两旁是高端商店、精品店和百货公司。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费（购物消费另计）",
      "currency": "CHF",
      "description_en": "One of the world's most famous shopping streets—luxury and department stores.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "苏黎世湖",
      "attractions_name_en": "Lake Zurich",
      "description": "景色优美的湖泊，可乘坐游船、在湖边散步或游泳。",
      "official_link": "游船公司提供购票，无官方统一链接",
      "price_range": "10 - 25 (游船)",
      "currency": "CHF",
      "description_en": "Beautiful lake—boat trips, lakeside walks or a swim.",
      "price_range_en": "CHF 10–25 (boat)",
      "official_link_en": "Tickets from boat operators; no single official link"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "弗劳明斯特教堂",
      "attractions_name_en": "Fraumünster Church",
      "description": "以马克·夏加尔的彩色玻璃窗而闻名，历史悠久。",
      "official_link": "https://www.fraumuenster.ch/en/",
      "price_range": "5",
      "currency": "CHF",
      "description_en": "Famous for Marc Chagall's stained-glass windows—historic church.",
      "price_range_en": "CHF 5",
      "official_link_en": "https://www.fraumuenster.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "苏黎世大教堂",
      "attractions_name_en": "Grossmünster",
      "description": "罗曼式教堂，苏黎世的标志性建筑，可登塔俯瞰城市。",
      "official_link": "https://www.grossmuenster.ch/en/",
      "price_range": "5",
      "currency": "CHF",
      "description_en": "Romanesque cathedral—Zurich's icon; climb the tower for views.",
      "price_range_en": "CHF 5",
      "official_link_en": "https://www.grossmuenster.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "瑞士国家博物馆",
      "attractions_name_en": "Swiss National Museum",
      "description": "位于一座城堡般的建筑内，展示瑞士从史前到现代的历史和文化。",
      "official_link": "https://www.nationalmuseum.ch/en/",
      "price_range": "10",
      "currency": "CHF",
      "description_en": "Castle-like building—Swiss history and culture from prehistory to today.",
      "price_range_en": "CHF 10",
      "official_link_en": "https://www.nationalmuseum.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "莉莉贝特动物园",
      "attractions_name_en": "Zoo Zürich",
      "description": "瑞士最大的动物园之一，拥有来自世界各地的动物，并注重自然栖息地模拟。",
      "official_link": "https://www.zoo.ch/en",
      "price_range": "29",
      "currency": "CHF",
      "description_en": "One of Switzerland's largest zoos—animals in naturalistic habitats.",
      "price_range_en": "CHF 29",
      "official_link_en": "https://www.zoo.ch/en"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "老城 (Altstadt)",
      "attractions_name_en": "Old Town (Altstadt)",
      "description": "苏黎世的历史中心，狭窄的鹅卵石街道，古老的建筑和广场。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Zurich's historic centre—narrow cobbled streets, old buildings and squares.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "林登霍夫山",
      "attractions_name_en": "Lindenhof Hill",
      "description": "位于老城中心的观景台，可俯瞰利马特河、老城和远处的山脉。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Viewpoint in the old town—over the Limmat, rooftops and distant Alps.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "FIFA世界足球博物馆",
      "attractions_name_en": "FIFA World Football Museum",
      "description": "全面展示足球历史和文化，包括世界杯奖杯等珍贵藏品。",
      "official_link": "https://www.fifamuseum.com/en/",
      "price_range": "24",
      "currency": "CHF",
      "description_en": "Football history and culture—including the World Cup trophy.",
      "price_range_en": "CHF 24",
      "official_link_en": "https://www.fifamuseum.com/en/"
    },
    {
      "id": "CH",
      "cityname": "苏黎世",
      "cityname_en": "Zürich",
      "attractions_name": "艺术之家",
      "attractions_name_en": "Kunsthaus Zürich",
      "description": "收藏了从中世纪到现代的艺术作品，包括莫奈、毕加索和贾科梅蒂等大师。",
      "official_link": "https://www.kunsthaus.ch/en/",
      "price_range": "25",
      "currency": "CHF",
      "description_en": "Art from the Middle Ages to modern—Monet, Picasso, Giacometti and more.",
      "price_range_en": "CHF 25",
      "official_link_en": "https://www.kunsthaus.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "日内瓦湖",
      "attractions_name_en": "Lake Geneva",
      "description": "欧洲最大的高山湖泊之一，可在湖畔散步、乘坐游船或享受水上活动。",
      "official_link": "游船公司提供购票，无官方统一链接",
      "price_range": "20 - 50 (游船)",
      "currency": "CHF",
      "description_en": "One of Europe's largest alpine lakes—walks, boat trips and water sports.",
      "price_range_en": "CHF 20–50 (boat)",
      "official_link_en": "Tickets from boat operators; no single official link"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "日内瓦大喷泉",
      "attractions_name_en": "Jet d'Eau",
      "description": "日内瓦的标志性景点，将水喷射到140米高空。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Geneva's icon—water jet shooting 140 m into the air.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "圣皮埃尔大教堂",
      "attractions_name_en": "St. Pierre Cathedral",
      "description": "哥特式大教堂，可登塔俯瞰日内瓦全景。",
      "official_link": "https://www.geneve.com/en/attractions/detail/cathedrale-saint-pierre",
      "price_range": "5 (登塔)",
      "currency": "CHF",
      "description_en": "Gothic cathedral—climb the tower for city views.",
      "price_range_en": "CHF 5 (tower)",
      "official_link_en": "https://www.geneve.com/en/attractions/detail/cathedrale-saint-pierre"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "万国宫",
      "attractions_name_en": "Palais des Nations",
      "description": "联合国欧洲总部所在地，可参观会议厅和展览。",
      "official_link": "https://www.ungeneva.org/",
      "price_range": "16",
      "currency": "CHF",
      "description_en": "UN European HQ—tour the halls and exhibitions.",
      "price_range_en": "CHF 16",
      "official_link_en": "https://www.ungeneva.org/"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "花钟",
      "attractions_name_en": "L'horloge Fleurie (Flower Clock)",
      "description": "位于英国花园内的巨大花钟，由数千朵鲜花组成，精确计时。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Giant flower clock in the English Garden—thousands of blooms, keeps time.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "英国花园",
      "attractions_name_en": "Jardin Anglais",
      "description": "位于日内瓦湖畔的公园，是休闲散步的好地方，有花钟。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Park by the lake—pleasant for a stroll; home to the flower clock.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "国际红十字与红新月博物馆",
      "attractions_name_en": "International Red Cross and Red Crescent Museum",
      "description": "独特的博物馆，通过互动展览讲述红十字运动的历史和人道主义行动。",
      "official_link": "https://www.redcrossmuseum.ch/en/",
      "price_range": "15",
      "currency": "CHF",
      "description_en": "Interactive exhibitions on the Red Cross and humanitarian action.",
      "price_range_en": "CHF 15",
      "official_link_en": "https://www.redcrossmuseum.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "宗教改革墙",
      "attractions_name_en": "Reformation Wall",
      "description": "纪念宗教改革领袖的巨大纪念碑，位于大学公园内。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Monument to Reformation leaders—in the university park.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "老城 (Vieille Ville)",
      "attractions_name_en": "Old Town (Vieille Ville)",
      "description": "日内瓦的历史中心，狭窄的街道，古老的建筑和隐蔽的广场。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Geneva's historic centre—narrow streets, old buildings and hidden squares.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "日内瓦",
      "cityname_en": "Geneva",
      "attractions_name": "艺术与历史博物馆",
      "attractions_name_en": "Museum of Art and History",
      "description": "收藏了从史前到现代的艺术品和考古文物。",
      "official_link": "https://www.mahmah.ch/",
      "price_range": "免费（特展收费）",
      "currency": "CHF",
      "description_en": "Art and archaeology from prehistory to the present.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.mahmah.ch/"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "琉森湖",
      "attractions_name_en": "Lake Lucerne",
      "description": "景色壮丽的湖泊，被阿尔卑斯山环绕，可乘坐游船。",
      "official_link": "https://www.lakelucerne.ch/en/",
      "price_range": "30 - 60 (游船，根据路线)",
      "currency": "CHF",
      "description_en": "Stunning lake surrounded by the Alps—boat trips on the water.",
      "price_range_en": "CHF 30–60 (boat, by route)",
      "official_link_en": "https://www.lakelucerne.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "卡佩尔廊桥和水塔",
      "attractions_name_en": "Chapel Bridge and Water Tower",
      "description": "欧洲最古老的木质廊桥，卢塞恩的标志性建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Europe's oldest wooden covered bridge—Lucerne's icon.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "狮子纪念碑",
      "attractions_name_en": "Lion Monument",
      "description": "纪念在法国大革命中牺牲的瑞士雇佣兵的雕塑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Memorial to Swiss guards who died in the French Revolution.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "皮拉图斯山",
      "attractions_name_en": "Mount Pilatus",
      "description": "卢塞恩的“家山”，可乘坐世界上最陡峭的齿轨铁路登顶，俯瞰湖景和山脉。",
      "official_link": "https://www.pilatus.ch/en/",
      "price_range": "78 (往返，根据季节和路线)",
      "currency": "CHF",
      "description_en": "Lucerne's \"home mountain\"—world's steepest cog railway, lake and Alpine views.",
      "price_range_en": "CHF 78 (return, season and route)",
      "official_link_en": "https://www.pilatus.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "瑞吉山",
      "attractions_name_en": "Mount Rigi",
      "description": "被誉为“山中皇后”，可乘坐齿轨铁路或缆车登顶，欣赏壮丽的日出日落。",
      "official_link": "https://www.rigi.ch/en/",
      "price_range": "78 (往返，根据季节和路线)",
      "currency": "CHF",
      "description_en": "\"Queen of the Mountains\"—cog railway or cable car, stunning sunrises and sunsets.",
      "price_range_en": "CHF 78 (return, season and route)",
      "official_link_en": "https://www.rigi.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "冰川公园",
      "attractions_name_en": "Glacier Garden",
      "description": "展示冰川侵蚀形成的冰洞和化石，旁边有镜子迷宫。",
      "official_link": "https://gletschergarten.ch/en/",
      "price_range": "18",
      "currency": "CHF",
      "description_en": "Glacial potholes and fossils—plus a mirror maze.",
      "price_range_en": "CHF 18",
      "official_link_en": "https://gletschergarten.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "穆塞格城墙",
      "attractions_name_en": "Musegg Wall",
      "description": "卢塞恩保存最好的中世纪城墙，可攀登部分塔楼。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Lucerne's best-preserved medieval walls—climb some of the towers.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "瑞士交通博物馆",
      "attractions_name_en": "Swiss Museum of Transport",
      "description": "瑞士最受欢迎的博物馆，展示交通工具的历史和技术，有互动展览。",
      "official_link": "https://www.verkehrshaus.ch/en/",
      "price_range": "33",
      "currency": "CHF",
      "description_en": "Switzerland's most popular museum—transport history and technology, hands-on.",
      "price_range_en": "CHF 33",
      "official_link_en": "https://www.verkehrshaus.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "豪斯布鲁克桥",
      "attractions_name_en": "Spreuer Bridge",
      "description": "卢塞恩的另一座历史悠久的木质廊桥，桥上有“死亡之舞”系列画作。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Another historic wooden bridge—painted with a \"Dance of Death\" cycle.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "卢塞恩",
      "cityname_en": "Lucerne",
      "attractions_name": "耶稣会教堂",
      "attractions_name_en": "Jesuit Church",
      "description": "卢塞恩最美的巴洛克式教堂之一，内部装饰华丽。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "One of Lucerne's finest Baroque churches—lavish interior.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "少女峰",
      "attractions_name_en": "Jungfraujoch - Top of Europe",
      "description": "欧洲最高的火车站，提供壮丽的冰川和阿尔卑斯山景色。",
      "official_link": "https://www.jungfrau.ch/en-gb/",
      "price_range": "200 - 250+ (往返火车票)",
      "currency": "CHF",
      "description_en": "Europe's highest railway station—glaciers and Alpine views.",
      "price_range_en": "CHF 200–250+ (return train)",
      "official_link_en": "https://www.jungfrau.ch/en-gb/"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "荷黑马特公园",
      "attractions_name_en": "Höhematte Park",
      "description": "因特拉肯市中心的广阔绿地，是滑翔伞降落区，可欣赏少女峰美景。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Large green space in the centre—paraglider landing zone, Jungfrau views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "布里恩茨湖",
      "attractions_name_en": "Lake Brienz",
      "description": "景色优美的碧绿湖泊，可乘坐游船，湖畔有许多小镇。",
      "official_link": "https://www.bls-schiff.ch/en/lake-cruise/tickets-vouchers/tickets",
      "price_range": "30 - 60 (游船公司提供购票，根据路线)",
      "currency": "CHF",
      "description_en": "Beautiful green lake—boat trips and lakeside villages.",
      "price_range_en": "CHF 30–60 (boat, by route)",
      "official_link_en": "https://www.bls-schiff.ch/en/lake-cruise/tickets-vouchers/tickets"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "图恩湖",
      "attractions_name_en": "Lake Thun",
      "description": "因特拉肯旁边的另一个大湖，有城堡和风景优美的村庄。",
      "official_link": "https://www.bls-schiff.ch/en/lake-cruise/tickets-vouchers/tickets",
      "price_range": "30 - 60 (游船公司提供购票，根据路线)",
      "currency": "CHF",
      "description_en": "Another large lake beside Interlaken—castles and pretty villages.",
      "price_range_en": "CHF 30–60 (boat, by route)",
      "official_link_en": "https://www.bls-schiff.ch/en/lake-cruise/tickets-vouchers/tickets"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "哈德昆观景台",
      "attractions_name_en": "Harder Kulm",
      "description": "乘坐缆车登上因特拉肯的“家山”，可俯瞰两湖和雪山全景。",
      "official_link": "https://www.jungfrau.ch/en-gb/harder-kulm/",
      "price_range": "40 (往返缆车)",
      "currency": "CHF",
      "description_en": "Cable car up Interlaken's \"home mountain\"—views over both lakes and the Alps.",
      "price_range_en": "CHF 40 (cable car return)",
      "official_link_en": "https://www.jungfrau.ch/en-gb/harder-kulm/"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "施皮茨小镇",
      "attractions_name_en": "Spiez",
      "description": "位于图恩湖畔的迷人小镇，有城堡和葡萄园，风景如画。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Charming village on Lake Thun—castle, vineyards and lake views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "劳特布伦嫩山谷",
      "attractions_name_en": "Lauterbrunnen Valley",
      "description": "拥有72道瀑布的“瀑布之谷”，包括施泰因巴赫瀑布。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分瀑布可能收费）",
      "currency": "CHF",
      "description_en": "\"Valley of 72 waterfalls\"—including Staubbach Falls.",
      "price_range_en": "Free (some falls may charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "文根和格林德瓦",
      "attractions_name_en": "Wengen & Grindelwald",
      "description": "阿尔卑斯山区的迷人村庄，是徒步和滑雪的绝佳基地。",
      "official_link": "无官方购票链接，为公共区域（交通费另计）",
      "price_range": "免费（交通费另计）",
      "currency": "CHF",
      "description_en": "Alpine villages—great base for hiking and skiing.",
      "price_range_en": "Free (transport extra)",
      "official_link_en": "无官方购票链接，为公共区域（交通费另计）"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "特鲁梅尔巴赫瀑布",
      "attractions_name_en": "Trümmelbach Falls",
      "description": "位于劳特布伦嫩山谷内，是欧洲最大的冰川瀑布，水流通过山体内部。",
      "official_link": "https://www.truemmelbachfaelle.ch/",
      "price_range": "14",
      "currency": "CHF",
      "description_en": "Europe's largest glacial waterfall—water flows inside the mountain.",
      "price_range_en": "CHF 14",
      "official_link_en": "https://www.truemmelbachfaelle.ch/"
    },
    {
      "id": "CH",
      "cityname": "因特拉肯",
      "cityname_en": "Interlaken",
      "attractions_name": "户外活动",
      "attractions_name_en": "Outdoor Activities",
      "description": "因特拉肯是户外运动的天堂，可体验滑翔伞、漂流、蹦极等。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "100 - 300+ (取决于活动)",
      "currency": "CHF",
      "description_en": "Outdoor paradise—paragliding, rafting, bungee and more.",
      "price_range_en": "CHF 100–300+ (by activity)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "伯尔尼老城",
      "attractions_name_en": "Bern Old Town",
      "description": "联合国教科文组织世界遗产，保存完好的中世纪老城，有拱廊和喷泉。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "UNESCO World Heritage—well-preserved medieval old town, arcades and fountains.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "伯尔尼钟楼 (Zytglogge)",
      "attractions_name_en": "Zytglogge (Clock Tower)",
      "description": "伯尔尼的标志性建筑，古老的钟楼，每天有报时表演。",
      "official_link": "https://bern.com/en/explore/tourist-attractions/attractions/zytglogge-clock-tower",
      "price_range": "20 (导览)",
      "currency": "CHF",
      "description_en": "Bern's icon—medieval clock tower with daily show. Guided tour.",
      "price_range_en": "CHF 20 (guided)",
      "official_link_en": "https://bern.com/en/explore/tourist-attractions/attractions/zytglogge-clock-tower"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "伯尔尼大教堂",
      "attractions_name_en": "Bern Minster",
      "description": "哥特式大教堂，瑞士最高的教堂，可登塔俯瞰城市。",
      "official_link": "https://www.bernermuenster.ch/",
      "price_range": "6 (登塔)",
      "currency": "CHF",
      "description_en": "Gothic cathedral—Switzerland's tallest; climb the tower for views.",
      "price_range_en": "CHF 6 (tower)",
      "official_link_en": "https://www.bernermuenster.ch/"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "熊公园",
      "attractions_name_en": "Bear Park",
      "description": "位于阿勒河畔的公园，是伯尔尼的象征——熊的家园。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Park by the Aare—Bern's symbol, home to bears.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "玫瑰园",
      "attractions_name_en": "Rose Garden (Rosengarten)",
      "description": "位于老城对面的山坡上，是欣赏伯尔尼老城和阿勒河全景的最佳地点。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Hill opposite the old town—best view of Bern and the Aare.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "联邦宫",
      "attractions_name_en": "Federal Palace of Switzerland",
      "description": "瑞士联邦政府和议会所在地，建筑宏伟，可参观部分区域。",
      "official_link": "https://www.parlament.ch/en/",
      "price_range": "免费（需预约导览）",
      "currency": "CHF",
      "description_en": "Swiss parliament and government—grand building; book a guided tour.",
      "price_range_en": "Free (guided tour, book ahead)",
      "official_link_en": "https://www.parlament.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "爱因斯坦故居",
      "attractions_name_en": "Einstein House",
      "description": "物理学家爱因斯坦在伯尔尼居住并发展相对论的故居，现为博物馆。",
      "official_link": "https://bern.com/en/explore/tourist-attractions/art-culture/einstein-house",
      "price_range": "6",
      "currency": "CHF",
      "description_en": "Where Einstein lived and developed the theory of relativity—now a museum.",
      "price_range_en": "CHF 6",
      "official_link_en": "https://bern.com/en/explore/tourist-attractions/art-culture/einstein-house"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "历史博物馆 / 爱因斯坦博物馆",
      "attractions_name_en": "Bern Historical Museum / Einstein Museum",
      "description": "瑞士第二大历史博物馆，其中包含一个专门的爱因斯坦博物馆。",
      "official_link": "https://www.bhm.ch/en/",
      "price_range": "18",
      "currency": "CHF",
      "description_en": "Switzerland's second-largest history museum—includes Einstein Museum.",
      "price_range_en": "CHF 18",
      "official_link_en": "https://www.bhm.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "艺术博物馆",
      "attractions_name_en": "Kunstmuseum Bern",
      "description": "瑞士最古老的艺术博物馆，收藏了从中世纪到现代的艺术作品。",
      "official_link": "https://www.kunstmuseumbern.ch/en/",
      "price_range": "18",
      "currency": "CHF",
      "description_en": "Switzerland's oldest art museum—from the Middle Ages to modern.",
      "price_range_en": "CHF 18",
      "official_link_en": "https://www.kunstmuseumbern.ch/en/"
    },
    {
      "id": "CH",
      "cityname": "伯尔尼",
      "cityname_en": "Bern",
      "attractions_name": "阿勒河",
      "attractions_name_en": "Aare River",
      "description": "环绕伯尔尼老城的河流，夏季可游泳或乘坐橡皮艇漂流。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（租赁设备另计）",
      "currency": "CHF",
      "description_en": "River around the old town—swim or float in summer.",
      "price_range_en": "Free (rental extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "美泉宫",
      "attractions_name_en": "Schönbrunn Palace",
      "description": "哈布斯堡王朝的夏宫，巴洛克式建筑，拥有华丽的宫殿、花园和动物园。",
      "official_link": "https://www.schoenbrunn.at/en/",
      "price_range": "22 - 28 (根据参观范围)",
      "currency": "EUR",
      "description_en": "Habsburg summer palace—Baroque splendour, gardens and zoo.",
      "price_range_en": "€22–€28 (by areas)",
      "official_link_en": "https://www.schoenbrunn.at/en/"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "霍夫堡宫",
      "attractions_name_en": "Hofburg Palace",
      "description": "哈布斯堡王朝的冬宫，曾是帝国中心，现为总统府、博物馆和西班牙骑术学校。",
      "official_link": "https://www.hofburg-wien.at/en/",
      "price_range": "19.50 (茜茜公主博物馆+皇家公寓+银器收藏)",
      "currency": "EUR",
      "description_en": "Habsburg winter palace—now museums, presidential offices and Spanish Riding School.",
      "price_range_en": "€19.50 (Sisi + apartments + silver)",
      "official_link_en": "https://www.hofburg-wien.at/en/"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "圣斯蒂芬大教堂",
      "attractions_name_en": "St. Stephen's Cathedral",
      "description": "维也纳的标志，哥特式大教堂，可登顶俯瞰城市全景。",
      "official_link": "https://www.stephanskirche.at/",
      "price_range": "6.50 (教堂内部，登塔另计)",
      "currency": "EUR",
      "description_en": "Vienna's icon—Gothic cathedral; climb the tower for city views.",
      "price_range_en": "€6.50 (church; tower extra)",
      "official_link_en": "https://www.stephanskirche.at/"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "美景宫",
      "attractions_name_en": "Belvedere Palace",
      "description": "巴洛克式宫殿建筑群，收藏了奥地利艺术品，包括克里姆特的《吻》。",
      "official_link": "https://www.belvedere.at/en/",
      "price_range": "24 (上美景宫)",
      "currency": "EUR",
      "description_en": "Baroque palace complex—Austrian art, including Klimt's The Kiss.",
      "price_range_en": "€24 (Upper Belvedere)",
      "official_link_en": "https://www.belvedere.at/en/"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "维也纳国家歌剧院",
      "attractions_name_en": "Vienna State Opera",
      "description": "世界顶级的歌剧院之一，可参加导览游或观看演出。",
      "official_link": "https://www.wiener-staatsoper.at/en/",
      "price_range": "15 (导览), 演出票价另计",
      "currency": "EUR",
      "description_en": "One of the world's top opera houses—guided tour or attend a performance.",
      "price_range_en": "€15 (tour); performance tickets extra",
      "official_link_en": "https://www.wiener-staatsoper.at/en/"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "环城大道",
      "attractions_name_en": "Ringstrasse",
      "description": "维也纳市中心一条环形大道，两旁是宏伟的公共建筑、博物馆和公园。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Ring road around the centre—grand buildings, museums and parks.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "普拉特公园与摩天轮",
      "attractions_name_en": "Prater Park & Giant Ferris Wheel",
      "description": "维也纳大型游乐园和公园，有标志性摩天轮，可俯瞰城市。",
      "official_link": "摩天轮约13.50，公园免费",
      "price_range": "13.50 (摩天轮)",
      "currency": "EUR",
      "description_en": "Vienna's big park and fairground—iconic Ferris wheel with city views.",
      "price_range_en": "€13.50 (Ferris wheel)",
      "official_link_en": "摩天轮约13.50，公园免费"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "艺术史博物馆",
      "attractions_name_en": "Kunsthistorisches Museum Vienna",
      "description": "收藏了哈布斯堡家族的艺术珍品，包括拉斐尔、提香等大师作品。",
      "official_link": "https://www.khm.at/en/",
      "price_range": "21",
      "currency": "EUR",
      "description_en": "Habsburg art treasures—Raphael, Titian and more.",
      "price_range_en": "€21",
      "official_link_en": "https://www.khm.at/en/"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "百水公寓",
      "attractions_name_en": "Hundertwasser House",
      "description": "独特而色彩斑斓的公寓楼，由艺术家百水设计，非对称和自然元素。",
      "official_link": "无官方购票链接，外部参观免费（不可入内）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Colourful apartment block by artist Hundertwasser—asymmetric and organic.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费（不可入内）"
    },
    {
      "id": "AT",
      "cityname": "维也纳",
      "cityname_en": "Vienna",
      "attractions_name": "中央咖啡馆",
      "attractions_name_en": "Café Central",
      "description": "维也纳最著名的咖啡馆之一，历史悠久，曾是知识分子聚集地。",
      "official_link": "无官方购票链接，为餐饮场所",
      "price_range": "免费（餐饮消费另计）",
      "currency": "EUR",
      "description_en": "One of Vienna's most famous cafés—historic haunt of intellectuals.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "No official ticket link; dining venue"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "萨尔茨堡要塞",
      "attractions_name_en": "Hohensalzburg Fortress",
      "description": "欧洲最大、保存最好的中世纪城堡之一，可俯瞰萨尔茨堡全景。",
      "official_link": "https://www.festung-hohensalzburg.at/en/",
      "price_range": "16.60 (含缆车)",
      "currency": "EUR",
      "description_en": "One of Europe's largest and best-preserved medieval fortresses—city views.",
      "price_range_en": "€16.60 (incl. funicular)",
      "official_link_en": "https://www.festung-hohensalzburg.at/en/"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "莫扎特故居",
      "attractions_name_en": "Mozart's Birthplace",
      "description": "音乐家莫扎特的出生地，现为博物馆，展示其生活和乐器。",
      "official_link": "https://mozarteum.at/museums/mozarts-geburtshaus/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "Mozart's birthplace—museum of his life and instruments.",
      "price_range_en": "€15",
      "official_link_en": "https://mozarteum.at/museums/mozarts-geburtshaus/"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "米拉贝尔宫及花园",
      "attractions_name_en": "Mirabell Palace and Gardens",
      "description": "巴洛克式宫殿和花园，以《音乐之声》的拍摄地而闻名。",
      "official_link": "无门票，花园免费参观（宫殿部分区域开放）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Baroque palace and gardens—Sound of Music filming location.",
      "price_range_en": "Free",
      "official_link_en": "无门票，花园免费参观（宫殿部分区域开放）"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "萨尔茨堡大教堂",
      "attractions_name_en": "Salzburg Cathedral",
      "description": "巴洛克式大教堂，拥有宏伟的穹顶和管风琴。",
      "official_link": "无门票，免费参观（珍宝馆收费）",
      "price_range": "免费（珍宝馆约3）",
      "currency": "EUR",
      "description_en": "Baroque cathedral—grand dome and organ.",
      "price_range_en": "Free (treasury ~€3)",
      "official_link_en": "无门票，免费参观（珍宝馆收费）"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "粮食胡同",
      "attractions_name_en": "Getreidegasse",
      "description": "萨尔茨堡老城最著名的购物街，有许多历史悠久的招牌。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Salzburg's most famous shopping street—historic signs and shops.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "僧侣山",
      "attractions_name_en": "Mönchsberg",
      "description": "萨尔茨堡老城旁的森林山丘，有步行道、博物馆和观景台。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（升降梯另计）",
      "currency": "EUR",
      "description_en": "Wooded hill beside the old town—paths, museum and viewpoints.",
      "price_range_en": "Free (elevator extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "萨尔茨堡博物馆",
      "attractions_name_en": "Salzburg Museum",
      "description": "位于新官邸内，展示萨尔茨堡的历史、艺术和文化。",
      "official_link": "https://www.salzburgmuseum.at/en/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "In the Neue Residenz—Salzburg's history, art and culture.",
      "price_range_en": "€10",
      "official_link_en": "https://www.salzburgmuseum.at/en/"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "海尔布伦宫及戏水园",
      "attractions_name_en": "Hellbrunn Palace and Trick Fountains",
      "description": "独具匠心的夏宫，以其隐秘的戏水喷泉和机械剧场而闻名。",
      "official_link": "https://www.hellbrunn.at/en/",
      "price_range": "14.5",
      "currency": "EUR",
      "description_en": "Whimsical summer palace—hidden water jets and mechanical theatre.",
      "price_range_en": "€14.50",
      "official_link_en": "https://www.hellbrunn.at/en/"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "《音乐之声》之旅",
      "attractions_name_en": "The Sound of Music Tour",
      "description": "乘坐巴士游览电影《音乐之声》的多个取景地。",
      "official_link": "各旅行社提供购票，无官方统一链接",
      "price_range": "50 - 60 (根据公司)",
      "currency": "EUR",
      "description_en": "Bus tour to Sound of Music filming locations.",
      "price_range_en": "€50–€60 (operator)",
      "official_link_en": "各旅行社提供购票，无官方统一链接"
    },
    {
      "id": "AT",
      "cityname": "萨尔茨堡",
      "cityname_en": "Salzburg",
      "attractions_name": "圣彼得公墓",
      "attractions_name_en": "St. Peter's Cemetery",
      "description": "欧洲最古老、最美丽的公墓之一，风景如画，有教堂和地下墓穴。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Europe's oldest and most beautiful cemeteries—church and catacombs.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "黄金屋顶",
      "attractions_name_en": "Goldenes Dachl (Golden Roof)",
      "description": "因斯布鲁克的标志性建筑，以其2657块镀金铜瓦屋顶而闻名。",
      "official_link": "无官方购票链接，外部参观免费（博物馆收费）",
      "price_range": "免费（博物馆约5）",
      "currency": "EUR",
      "description_en": "Innsbruck's icon—2,657 gilded copper tiles. Museum extra.",
      "price_range_en": "Free (museum ~€5)",
      "official_link_en": "无官方购票链接，外部参观免费（博物馆收费）"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "霍夫堡皇宫",
      "attractions_name_en": "Hofburg Innsbruck",
      "description": "维也纳霍夫堡宫的姐妹宫殿，曾是哈布斯堡家族的住所。",
      "official_link": "https://www.burghauptmannschaft.at/Themen/Hofburg-Wien.html",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Sister to Vienna's Hofburg—Habsburg residence.",
      "price_range_en": "€12",
      "official_link_en": "https://www.burghauptmannschaft.at/Themen/Hofburg-Wien.html"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "施华洛世奇水晶世界",
      "attractions_name_en": "Swarovski Kristallwelten",
      "description": "独特的艺术装置和展览，展示施华洛世奇水晶的魅力。",
      "official_link": "https://kristallwelten.swarovski.com/",
      "price_range": "25",
      "currency": "EUR",
      "description_en": "Unique art installations and exhibitions—Swarovski crystal.",
      "price_range_en": "€25",
      "official_link_en": "https://kristallwelten.swarovski.com/"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "城市塔楼",
      "attractions_name_en": "Stadtturm",
      "description": "因斯布鲁克老城中心的钟楼，可登顶俯瞰城市和山脉。",
      "official_link": "无官方购票链接，登塔收费",
      "price_range": "4.5",
      "currency": "EUR",
      "description_en": "Clock tower in the old town—climb for city and mountain views.",
      "price_range_en": "€4.50",
      "official_link_en": "无官方购票链接，登塔收费"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "玛丽亚·特蕾莎大街",
      "attractions_name_en": "Maria-Theresien-Strasse",
      "description": "因斯布鲁克最主要的购物街，两旁是历史建筑和商店。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Innsbruck's main shopping street—historic buildings and shops.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "阿尔卑斯动物园",
      "attractions_name_en": "Alpenzoo Innsbruck",
      "description": "欧洲海拔最高的动物园，专门饲养阿尔卑斯地区的动物。",
      "official_link": "https://www.alpenzoo.at/en/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "Europe's highest zoo—Alpine animals.",
      "price_range_en": "€15",
      "official_link_en": "https://www.alpenzoo.at/en/"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "北链山",
      "attractions_name_en": "Nordkette",
      "description": "可乘坐缆车和索道轻松抵达的高山区域，提供壮丽的阿尔卑斯景色。",
      "official_link": "https://www.nordkette.com/en/",
      "price_range": "49 (往返缆车)",
      "currency": "EUR",
      "description_en": "Cable car and gondola to the mountains—stunning Alpine views.",
      "price_range_en": "€49 (cable car return)",
      "official_link_en": "https://www.nordkette.com/en/"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "宫廷教堂",
      "attractions_name_en": "Court Church (Hofkirche)",
      "description": "以其“黑人纪念碑”和皇帝马克西米利安一世的空墓而闻名。",
      "official_link": "https://www.tiroler-landesmuseen.at/de/hofkirche",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Famous for the \"Black Men\" monuments and Emperor Maximilian's empty tomb.",
      "price_range_en": "€12",
      "official_link_en": "https://www.tiroler-landesmuseen.at/de/hofkirche"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "安布拉斯城堡",
      "attractions_name_en": "Ambras Castle",
      "description": "文艺复兴时期的城堡，曾是斐迪南二世大公的住所，有珍奇室和艺术收藏。",
      "official_link": "https://www.schlossambras-innsbruck.at/en/",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "Renaissance castle—Archduke Ferdinand II's residence, cabinet of curiosities and art.",
      "price_range_en": "€16",
      "official_link_en": "https://www.schlossambras-innsbruck.at/en/"
    },
    {
      "id": "AT",
      "cityname": "因斯布鲁克",
      "cityname_en": "Innsbruck",
      "attractions_name": "伯吉塞尔山滑雪跳台",
      "attractions_name_en": "Bergisel Ski Jump",
      "description": "独特的现代滑雪跳台，由扎哈·哈迪德设计，可登顶观景。",
      "official_link": "https://www.bergisel.info/en/",
      "price_range": "11",
      "currency": "EUR",
      "description_en": "Striking modern ski jump by Zaha Hadid—climb for views.",
      "price_range_en": "€11",
      "official_link_en": "https://www.bergisel.info/en/"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "施洛斯伯格山和钟楼",
      "attractions_name_en": "Schlossberg & Clock Tower",
      "description": "格拉茨的标志，位于市中心的小山，有钟楼和城堡遗迹，可缆车或步行登顶。",
      "official_link": "缆车约3.50，电梯约2.50，钟楼外部免费",
      "price_range": "免费（缆车或电梯另计）",
      "currency": "EUR",
      "description_en": "Graz's icon—hill in the centre with clock tower and castle remains.",
      "price_range_en": "Free (funicular/elevator extra)",
      "official_link_en": "缆车约3.50，电梯约2.50，钟楼外部免费"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "格拉茨老城",
      "attractions_name_en": "Graz Old Town",
      "description": "联合国教科文组织世界遗产，保存完好的中世纪和文艺复兴风格老城。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—well-preserved medieval and Renaissance old town.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "格拉茨大教堂",
      "attractions_name_en": "Graz Cathedral",
      "description": "哥特式教堂，曾是哈布斯堡家族的皇家教堂。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Gothic cathedral—once the Habsburgs' court church.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "岛屿",
      "attractions_name_en": "Murinsel",
      "description": "穆尔河上漂浮的独特人工岛屿，兼作咖啡馆和连接两岸的桥梁。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Unique floating island on the Mur—café and bridge.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "格拉茨美术馆 (友善外星人)",
      "attractions_name_en": "Kunsthaus Graz (Friendly Alien)",
      "description": "独特的现代艺术博物馆，其蓝色泡泡状外观被称为“友善外星人”。",
      "official_link": "https://www.museum-joanneum.at/kunsthaus-graz/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Unique modern art museum—blue bubble building nicknamed \"Friendly Alien\".",
      "price_range_en": "€12",
      "official_link_en": "https://www.museum-joanneum.at/kunsthaus-graz/"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "武器库博物馆",
      "attractions_name_en": "Styrian Armory (Landeszeughaus)",
      "description": "世界上保存最完好的历史武器库之一，收藏了大量中世纪武器和盔甲。",
      "official_link": "https://www.museum-joanneum.at/landeszeughaus/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "One of the world's best-preserved historic armouries—medieval weapons and armour.",
      "price_range_en": "€15",
      "official_link_en": "https://www.museum-joanneum.at/landeszeughaus/"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "埃根贝格宫",
      "attractions_name_en": "Eggenberg Palace",
      "description": "巴洛克式宫殿，联合国教科文组织世界遗产，有独特的行星大厅和花园。",
      "official_link": "https://www.museum-joanneum.at/schloss-eggenberg/",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "Baroque palace, UNESCO site—Planet Hall and gardens.",
      "price_range_en": "€16",
      "official_link_en": "https://www.museum-joanneum.at/schloss-eggenberg/"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "赫伯特·冯·卡拉扬广场",
      "attractions_name_en": "Hauptplatz (Main Square)",
      "description": "格拉茨老城的主广场，有市政厅和历史建筑。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Main square in the old town—town hall and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "大公宫",
      "attractions_name_en": "Landhaus",
      "description": "文艺复兴风格的宫殿，是施泰尔马克州议会的所在地，有精美庭院。",
      "official_link": "无官方购票链接，外部免费",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Renaissance palace—Styrian parliament, fine courtyards.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部免费"
    },
    {
      "id": "AT",
      "cityname": "格拉茨",
      "cityname_en": "Graz",
      "attractions_name": "穆尔河畔",
      "attractions_name_en": "Mur River",
      "description": "穆尔河穿城而过，可在河畔散步或享受咖啡馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "The Mur runs through the city—stroll the banks or relax at a café.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AT",
      "cityname": "林茨",
      "cityname_en": "Linz",
      "attractions_name": "主广场",
      "attractions_name_en": "Hauptplatz",
      "description": "林茨的中心广场，有三位一体柱和历史建筑。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Linz's central square—Trinity Column and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "AT",
      "cityname": "林茨",
      "cityname_en": "Linz",
      "attractions_name": "林茨城堡博物馆",
      "attractions_name_en": "Lentos Art Museum",
      "description": "现代艺术博物馆，位于多瑙河畔，夜间会发光。",
      "official_link": "https://www.lentos.at/en/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Modern art museum by the Danube—lit up at night.",
      "price_range_en": "€10",
      "official_link_en": "https://www.lentos.at/en/"
    },
    {
      "id": "AT",
      "cityname": "林茨",
      "cityname_en": "Linz",
      "attractions_name": "Ars Electronica 中心",
      "attractions_name_en": "Ars Electronica Center",
      "description": "未来科技博物馆，展示数字艺术、虚拟现实和人工智能。",
      "official_link": "https://ars.electronica.art/center/en/",
      "price_range": "14",
      "currency": "EUR",
      "description_en": "Museum of the future—digital art, VR and AI.",
      "price_range_en": "€14",
      "official_link_en": "https://ars.electronica.art/center/en/"
    },
    {
      "id": "AT",
      "cityname": "林茨",
      "cityname_en": "Linz",
      "attractions_name": "林茨新大教堂",
      "attractions_name_en": "New Cathedral (Mariendom)",
      "description": "奥地利最大的教堂，哥特式风格，拥有精美的彩色玻璃窗。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Austria's largest church—Gothic, with fine stained glass.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "AT",
      "cityname": "林茨",
      "cityname_en": "Linz",
      "attractions_name": "林茨植物园",
      "attractions_name_en": "Linz Botanical Garden",
      "description": "城市中心的植物园，拥有来自世界各地的植物。",
      "official_link": "https://www.linz.at/botanischergarten/",
      "price_range": "4.5",
      "currency": "EUR",
      "description_en": "Botanical garden in the centre—plants from around the world.",
      "price_range_en": "€4.50",
      "official_link_en": "https://www.linz.at/botanischergarten/"
    },
    {
      "id": "AT",
      "cityname": "林茨",
      "cityname_en": "Linz",
      "attractions_name": "林茨老城",
      "attractions_name_en": "Linz Old Town",
      "description": "探索历史悠久的街道，有巴洛克式建筑和咖啡馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Explore historic streets—Baroque buildings and cafés.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AT",
      "cityname": "林茨",
      "cityname_en": "Linz",
      "attractions_name": "钢城之旅",
      "attractions_name_en": "Voestalpine Stahlwelt",
      "description": "参观奥地利最大的工业公司之一，了解钢铁生产过程。",
      "official_link": "https://www.voestalpine.com/stahlwelt/en/",
      "price_range": "14",
      "currency": "EUR",
      "description_en": "Tour one of Austria's largest industrial sites—see how steel is made.",
      "price_range_en": "€14",
      "official_link_en": "https://www.voestalpine.com/stahlwelt/en/"
    },
    {
      "id": "AT",
      "cityname": "林茨",
      "cityname_en": "Linz",
      "attractions_name": "波斯特林山铁路",
      "attractions_name_en": "Pöstlingbergbahn",
      "description": "欧洲最陡峭的粘着式铁路，可登上波斯特林山，俯瞰林茨。",
      "official_link": "https://www.linzag.at/portal/de/privatkunden/freizeit/poestlingbergbahn",
      "price_range": "7.60 (往返)",
      "currency": "EUR",
      "description_en": "Europe's steepest adhesion railway—up Pöstlingberg for views over Linz.",
      "price_range_en": "€7.60 (return)",
      "official_link_en": "https://www.linzag.at/portal/de/privatkunden/freizeit/poestlingbergbahn"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "哈尔格林姆大教堂",
      "attractions_name_en": "Hallgrímskirkja",
      "description": "雷克雅未克的标志性建筑，独特的外观，可登塔俯瞰城市全景。",
      "official_link": "https://www.hallgrimskirkja.is/en/",
      "price_range": "1600 (登塔)",
      "currency": "ISK",
      "description_en": "Reykjavik's icon—distinctive design; climb the tower for city views.",
      "price_range_en": "ISK 1600 (tower)",
      "official_link_en": "https://www.hallgrimskirkja.is/en/"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "太阳航海者",
      "attractions_name_en": "Sólfarið (Sun Voyager)",
      "description": "位于海边的雕塑，形似维京船，是和平与希望的象征，日落时分尤为美丽。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Sculpture by the sea—Viking ship shape, symbol of peace and hope; beautiful at sunset.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "珍珠楼",
      "attractions_name_en": "Perlan",
      "description": "独特的穹顶建筑，内有冰川博物馆、观景台和餐厅，可了解冰岛自然。",
      "official_link": "https://www.perlan.is/en",
      "price_range": "4990 (展览+观景台)",
      "currency": "ISK",
      "description_en": "Unique dome building—glacier exhibition, viewing deck and restaurant.",
      "price_range_en": "ISK 4990 (exhibition + viewing deck)",
      "official_link_en": "https://www.perlan.is/en"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "老港口",
      "attractions_name_en": "Old Harbour",
      "description": "雷克雅未克的老港区，有许多餐厅、咖啡馆，是观鲸和出海游船的出发点。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（出海游船另计）",
      "currency": "ISK",
      "description_en": "Old harbour—restaurants, cafés and departure point for whale watching and boat trips.",
      "price_range_en": "Free (boat trips extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "维京海事博物馆",
      "attractions_name_en": "Vikin Maritime Museum",
      "description": "位于老港口，展示冰岛的渔业和海事历史。",
      "official_link": "https://visitreykjavik.is/service/maritime-museum",
      "price_range": "2200",
      "currency": "ISK",
      "description_en": "At the old harbour—Iceland's fishing and maritime history.",
      "price_range_en": "ISK 2200",
      "official_link_en": "https://visitreykjavik.is/service/maritime-museum"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "劳格维格购物街",
      "attractions_name_en": "Laugavegur",
      "description": "雷克雅未克主要的购物街，两旁是商店、餐厅和酒吧，充满活力。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费（购物消费另计）",
      "currency": "ISK",
      "description_en": "Reykjavik's main shopping street—shops, restaurants and bars.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "冰岛国家博物馆",
      "attractions_name_en": "National Museum of Iceland",
      "description": "全面展示冰岛从定居到现代的历史和文化。",
      "official_link": "https://www.thjodminjasafn.is/english/",
      "price_range": "2500",
      "currency": "ISK",
      "description_en": "Iceland's history and culture from settlement to the present.",
      "price_range_en": "ISK 2500",
      "official_link_en": "https://www.thjodminjasafn.is/english/"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "雷克雅未克艺术博物馆",
      "attractions_name_en": "Reykjavík Art Museum",
      "description": "分为三个展馆，收藏了冰岛当代艺术。",
      "official_link": "https://www.listasafnreykjavikur.is/en",
      "price_range": "2200 (三馆联票)",
      "currency": "ISK",
      "description_en": "Three venues—Icelandic contemporary art.",
      "price_range_en": "ISK 2200 (three venues)",
      "official_link_en": "https://www.listasafnreykjavikur.is/en"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "蓝色泻湖 (附近)",
      "attractions_name_en": "Blue Lagoon (nearby)",
      "description": "世界著名的地热温泉，富含矿物质，以其独特的蓝色水体和疗效而闻名。",
      "official_link": "https://www.bluelagoon.com/",
      "price_range": "9990 - 15990 (成人标准票，需提前预订)",
      "currency": "ISK",
      "description_en": "World-famous geothermal spa—mineral-rich blue water. Book ahead.",
      "price_range_en": "ISK 9990–15990 (adult standard; book ahead)",
      "official_link_en": "https://www.bluelagoon.com/"
    },
    {
      "id": "IS",
      "cityname": "雷克雅未克",
      "cityname_en": "Reykjavík",
      "attractions_name": "音乐厅和会议中心 (哈尔帕)",
      "attractions_name_en": "Harpa Concert Hall and Conference Centre",
      "description": "独特的几何玻璃外墙建筑，是雷克雅未克的文化地标。",
      "official_link": "无官方购票链接，外部参观免费（演出票另计）",
      "price_range": "免费（演出票另计）",
      "currency": "ISK",
      "description_en": "Striking geometric glass building—Reykjavik's cultural landmark.",
      "price_range_en": "Free (concert tickets extra)",
      "official_link_en": "无官方购票链接，外部参观免费（演出票另计）"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "辛格维利尔国家公园",
      "attractions_name_en": "Þingvellir National Park",
      "description": "联合国教科文组织世界遗产，冰岛议会的发源地，欧亚板块和北美板块的交界处。",
      "official_link": "https://www.thingvellir.is/en/",
      "price_range": "免费（停车费约750）",
      "currency": "ISK",
      "description_en": "UNESCO World Heritage—birthplace of the Althing; rift between Eurasian and North American plates.",
      "price_range_en": "Free (parking ~ISK 750)",
      "official_link_en": "https://www.thingvellir.is/en/"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "盖歇尔间歇泉区",
      "attractions_name_en": "Geysir Geothermal Area",
      "description": "冰岛最活跃的间歇泉之一，史托克间歇泉每隔几分钟喷发一次。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "One of Iceland's most active geyser areas—Strokkur erupts every few minutes.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "黄金瀑布",
      "attractions_name_en": "Gullfoss Waterfall",
      "description": "冰岛最壮观的瀑布之一，气势磅礴，水流分两级跌落。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "One of Iceland's most spectacular waterfalls—two tiers, powerful flow.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "秘密泻湖",
      "attractions_name_en": "Secret Lagoon (Gamla Laugin)",
      "description": "冰岛最古老的地热温泉泳池之一，更具原始自然风光。",
      "official_link": "https://secretlagoon.is/",
      "price_range": "3300",
      "currency": "ISK",
      "description_en": "One of Iceland's oldest geothermal pools—more natural and low-key.",
      "price_range_en": "ISK 3300",
      "official_link_en": "https://secretlagoon.is/"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "凯利德火山口湖",
      "attractions_name_en": "Kerið Volcanic Crater Lake",
      "description": "独特的红色火山岩火山口，内部是美丽的蓝色湖水。",
      "official_link": "https://www.kerid.is/",
      "price_range": "400",
      "currency": "ISK",
      "description_en": "Distinctive red volcanic crater—beautiful blue lake inside.",
      "price_range_en": "ISK 400",
      "official_link_en": "https://www.kerid.is/"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "冰岛马农场",
      "attractions_name_en": "Icelandic Horse Farm Visit",
      "description": "体验冰岛特有的矮脚马，有些农场提供骑行或参观。",
      "official_link": "各农场有独立购票，无官方统一链接",
      "price_range": "3000 - 8000+ (参观或骑行)",
      "currency": "ISK",
      "description_en": "Meet Iceland's unique horses—some farms offer rides or visits.",
      "price_range_en": "ISK 3000–8000+ (visit or ride)",
      "official_link_en": "各农场有独立购票，无官方统一链接"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "弗里德海马斯番茄农场",
      "attractions_name_en": "Friðheimar Tomato Farm",
      "description": "独特的番茄农场，在温室中种植，提供以番茄为主题的餐饮体验。",
      "official_link": "https://www.fridheimar.is/",
      "price_range": "免费（餐饮消费另计）",
      "currency": "ISK",
      "description_en": "Unique tomato farm in greenhouses—tomato-themed dining.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "https://www.fridheimar.is/"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "劳加瓦特温泉面包",
      "attractions_name_en": "Laugarvatn Fontana Geothermal Baths",
      "description": "位于湖畔的地热温泉，可以在蒸汽房和户外浴池放松，尝试地热烤面包。",
      "official_link": "https://www.fontana.is/en/",
      "price_range": "4800",
      "currency": "ISK",
      "description_en": "Geothermal baths by the lake—steam rooms, outdoor pools and geothermal rye bread.",
      "price_range_en": "ISK 4800",
      "official_link_en": "https://www.fontana.is/en/"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "雷克霍尔特",
      "attractions_name_en": "Reykholt",
      "description": "冰岛历史上的重要地点，曾是中世纪文学家斯诺里·斯图鲁松的故居。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分博物馆收费）",
      "currency": "ISK",
      "description_en": "Historic site—home of medieval writer Snorri Sturluson.",
      "price_range_en": "Free (some museums charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "黄金圈",
      "cityname_en": "Golden Circle",
      "attractions_name": "朗格冰川雪地摩托",
      "attractions_name_en": "Langjökull Glacier Snowmobiling",
      "description": "在冰岛第二大冰川上体验刺激的雪地摩托。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "20000 - 30000+ (取决于时长和公司)",
      "currency": "ISK",
      "description_en": "Snowmobile on Iceland's second-largest glacier.",
      "price_range_en": "ISK 20000–30000+ (duration and operator)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "塞里雅兰瀑布",
      "attractions_name_en": "Seljalandsfoss Waterfall",
      "description": "独特的瀑布，游客可以走到瀑布后面感受水帘。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（停车费约700）",
      "currency": "ISK",
      "description_en": "Unique waterfall—walk behind the curtain of water.",
      "price_range_en": "Free (parking ~ISK 700)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "斯科加瀑布",
      "attractions_name_en": "Skógafoss Waterfall",
      "description": "冰岛最大最美丽的瀑布之一，常有彩虹出现，可爬到瀑布顶端。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（停车费约700）",
      "currency": "ISK",
      "description_en": "One of Iceland's largest and most beautiful waterfalls—often rainbows; climb to the top.",
      "price_range_en": "Free (parking ~ISK 700)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "维克黑沙滩",
      "attractions_name_en": "Reynisfjara Black Sand Beach",
      "description": "世界十大最美沙滩之一，独特的黑色沙滩、玄武岩柱和海蚀柱。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "One of the world's most striking beaches—black sand, basalt columns and sea stacks.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "飞机残骸",
      "attractions_name_en": "Sólheimasandur Plane Wreck",
      "description": "一架美国海军飞机在沙滩上的残骸，是独特的摄影地。",
      "official_link": "无官方购票链接，需步行或乘坐接驳车",
      "price_range": "免费（接驳车另计）",
      "currency": "ISK",
      "description_en": "Wreck of a US Navy plane on the beach—unique photo spot.",
      "price_range_en": "Free (shuttle extra)",
      "official_link_en": "无官方购票链接，需步行或乘坐接驳车"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "杰古沙龙冰河湖",
      "attractions_name_en": "Jökulsárlón Glacier Lagoon",
      "description": "冰岛最大的冰川湖，漂浮着巨大的冰山，可乘船游览。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（船游另计：6500+）",
      "currency": "ISK",
      "description_en": "Iceland's largest glacial lagoon—floating icebergs; boat tours available.",
      "price_range_en": "Free (boat tour ISK 6500+)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "钻石沙滩",
      "attractions_name_en": "Diamond Beach",
      "description": "位于杰古沙龙冰河湖对面，黑色沙滩上散落着晶莹剔透的冰块，形似钻石。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Across from the lagoon—black sand dotted with ice chunks like diamonds.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "瓦特纳冰川国家公园",
      "attractions_name_en": "Vatnajökull National Park",
      "description": "欧洲最大的国家公园之一，涵盖冰川、火山、瀑布和峡谷。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分区域或活动收费）",
      "currency": "ISK",
      "description_en": "One of Europe's largest national parks—glaciers, volcanoes, waterfalls and canyons.",
      "price_range_en": "Free (some areas/activities charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "冰川徒步 (索尔黑马冰川)",
      "attractions_name_en": "Glacier Hiking (Sólheimajökull)",
      "description": "在冰川向导带领下，体验在冰川上徒步的乐趣。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "10000 - 20000+ (取决于时长和公司)",
      "currency": "ISK",
      "description_en": "Guided glacier walk on Sólheimajökull.",
      "price_range_en": "ISK 10000–20000+ (duration and operator)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "迪霍拉里角",
      "attractions_name_en": "Dyrhólaey",
      "description": "巨大的海蚀拱门，是观鸟和欣赏南岸海岸线的绝佳地点。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Huge sea arch—great for birdwatching and south coast views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "冰岛南岸",
      "cityname_en": "South Coast",
      "attractions_name": "秘密瀑布 (Kvernufoss)",
      "attractions_name_en": "Kvernufoss Waterfall",
      "description": "隐藏在斯科加瀑布附近的一个小瀑布，可以走到后面。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Hidden waterfall near Skógafoss—walk behind the water.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛 (阿库雷里)",
      "cityname_en": "North Iceland (Akureyri)",
      "attractions_name": "阿库雷里大教堂",
      "attractions_name_en": "Akureyrarkirkja",
      "description": "阿库雷里的标志性教堂，位于高处，可俯瞰小镇和峡湾。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Akureyri's landmark church on the hill—views over town and fjord.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛",
      "cityname_en": "North Iceland",
      "attractions_name": "米湖",
      "attractions_name_en": "Lake Mývatn",
      "description": "独特的火山湖泊，周边有许多地热奇观、熔岩地貌和鸟类。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分景点可能收费）",
      "currency": "ISK",
      "description_en": "Volcanic lake—geothermal wonders, lava formations and birdlife.",
      "price_range_en": "Free (some sites charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛",
      "cityname_en": "North Iceland",
      "attractions_name": "众神瀑布",
      "attractions_name_en": "Goðafoss Waterfall",
      "description": "冰岛最著名的瀑布之一，与冰岛早期基督教化历史有关。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "One of Iceland's most famous waterfalls—tied to early Christian history.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛",
      "cityname_en": "North Iceland",
      "attractions_name": "地狱厨房 (Námafjall Hverir)",
      "attractions_name_en": "Námafjall Hverir Geothermal Area",
      "description": "米湖附近的地热区，有沸腾的泥浆池和冒烟的 fumaroles。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Geothermal area near Mývatn—boiling mud pools and fumaroles.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛",
      "cityname_en": "North Iceland",
      "attractions_name": "黛提瀑布",
      "attractions_name_en": "Dettifoss Waterfall",
      "description": "欧洲水流量最大的瀑布，气势雄伟，位于瓦特纳冰川国家公园东北部。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Europe's most powerful waterfall—northeast of Vatnajökull National Park.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛",
      "cityname_en": "North Iceland",
      "attractions_name": "米湖自然浴场",
      "attractions_name_en": "Mývatn Nature Baths",
      "description": "米湖附近的地热温泉，是蓝色泻湖的北部版本，更安静。",
      "official_link": "https://www.myvatnnaturebaths.is/",
      "price_range": "6500 - 7500 (成人标准票)",
      "currency": "ISK",
      "description_en": "Geothermal baths near Mývatn—quieter northern counterpart to the Blue Lagoon.",
      "price_range_en": "ISK 6500–7500 (adult standard)",
      "official_link_en": "https://www.myvatnnaturebaths.is/"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛",
      "cityname_en": "North Iceland",
      "attractions_name": "胡萨维克观鲸",
      "attractions_name_en": "Húsavík Whale Watching",
      "description": "被誉为欧洲的观鲸之都，高成功率看到各种鲸鱼。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "10000 - 15000+ (取决于公司和时长)",
      "currency": "ISK",
      "description_en": "Europe's whale-watching capital—high chance of seeing whales.",
      "price_range_en": "ISK 10000–15000+ (operator and duration)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛",
      "cityname_en": "North Iceland",
      "attractions_name": "火山地带 (Dimmuborgir)",
      "attractions_name_en": "Dimmuborgir Lava Fields",
      "description": "米湖附近独特的熔岩地貌，形成各种奇特的岩石结构。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Unique lava formations near Mývatn—weird rock shapes.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛",
      "cityname_en": "North Iceland",
      "attractions_name": "阿斯比尔吉峡谷",
      "attractions_name_en": "Ásbyrgi Canyon",
      "description": "马蹄形峡谷，传说由奥丁八足马斯莱普尼尔的蹄印形成。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Horseshoe canyon—legend says Odin's horse left its hoofprint.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "北部冰岛",
      "cityname_en": "North Iceland",
      "attractions_name": "格里姆塞岛",
      "attractions_name_en": "Grímsey Island",
      "description": "位于北极圈内的小岛，是观鸟和体验北极圈的好地方。",
      "official_link": "飞机或渡轮前往，无官方购票链接",
      "price_range": "交通费另计",
      "currency": "ISK",
      "description_en": "Island inside the Arctic Circle—birdwatching and Arctic experience.",
      "price_range_en": "Transport extra",
      "official_link_en": "飞机或渡轮前往，无官方购票链接"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛 (斯奈山半岛)",
      "cityname_en": "West Iceland (Snæfellsnes Peninsula)",
      "attractions_name": "教会山 (草帽山)",
      "attractions_name_en": "Kirkjufell",
      "description": "冰岛最著名的地标之一，独特的山形和旁边的瀑布，是摄影圣地。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "One of Iceland's most iconic landmarks—distinctive mountain and waterfall.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛",
      "cityname_en": "West Iceland",
      "attractions_name": "布迪尔黑教堂",
      "attractions_name_en": "Búðakirkja (Black Church)",
      "description": "斯奈山半岛上一座独特的黑色木制教堂，背景是火山和海岸。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Unique black wooden church on Snæfellsnes—volcano and coast backdrop.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛",
      "cityname_en": "West Iceland",
      "attractions_name": "斯奈山冰川国家公园",
      "attractions_name_en": "Snæfellsjökull National Park",
      "description": "覆盖了斯奈山冰川和周边区域，有独特的熔岩地貌和海岸线。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Covers Snæfellsjökull glacier and surrounds—lava and coastline.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛",
      "cityname_en": "West Iceland",
      "attractions_name": "阿尔纳斯塔皮渔村",
      "attractions_name_en": "Arnarstapi Village",
      "description": "迷人的小渔村，有独特的玄武岩海岸线和拱门。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Charming fishing village—basalt coastline and arches.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛",
      "cityname_en": "West Iceland",
      "attractions_name": "德里霍拉尔海蚀洞",
      "attractions_name_en": "Djúpalónssandur Black Sand Beach",
      "description": "斯奈山半岛的黑沙滩，有独特的鹅卵石和船只残骸。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Black sand beach on Snæfellsnes—pebbles and shipwreck.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛",
      "cityname_en": "West Iceland",
      "attractions_name": "斯托克海雀悬崖",
      "attractions_name_en": "Lóndrangar Basalt Cliffs",
      "description": "壮观的玄武岩柱和海蚀柱，是观鸟的好地方。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Spectacular basalt columns and sea stacks—great for birdwatching.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛",
      "cityname_en": "West Iceland",
      "attractions_name": "赫尔纳尔渔村",
      "attractions_name_en": "Hellnar Village",
      "description": "另一个迷人的小渔村，有玄武岩洞穴和海边咖啡馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Another charming fishing village—basalt caves and seaside cafés.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛",
      "cityname_en": "West Iceland",
      "attractions_name": "塞特贝格玄武岩柱",
      "attractions_name_en": "Gerðuberg Basalt Columns",
      "description": "巨大的六边形玄武岩柱墙，非常壮观。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Massive wall of hexagonal basalt columns.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛",
      "cityname_en": "West Iceland",
      "attractions_name": "瓦斯山温泉",
      "attractions_name_en": "Lýsuhólslaug Geothermal Pool",
      "description": "斯奈山半岛上的地热温泉，富含矿物质。",
      "official_link": "https://adventures.is/iceland/attractions/lysuholslaug-geothermal-pool/",
      "price_range": "约1500 - 2000",
      "currency": "ISK",
      "description_en": "Geothermal pool on Snæfellsnes—mineral-rich.",
      "price_range_en": "~ISK 1500–2000",
      "official_link_en": "https://adventures.is/iceland/attractions/lysuholslaug-geothermal-pool/"
    },
    {
      "id": "IS",
      "cityname": "西部冰岛",
      "cityname_en": "West Iceland",
      "attractions_name": "斯蒂基斯霍尔米小镇",
      "attractions_name_en": "Stykkishólmur",
      "description": "斯奈山半岛北部的小镇，是韦斯特峡湾的门户，有色彩斑斓的房屋和港口。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ISK",
      "description_en": "Town in northern Snæfellsnes—gateway to Westfjords; colourful houses and harbour.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "布拉格城堡",
      "attractions_name_en": "Prague Castle",
      "description": "世界上最大的古城堡群之一，包括圣维特大教堂、旧皇宫等，捷克历史的象征。",
      "official_link": "https://www.hrad.cz/en/prague-castle-for-visitors",
      "price_range": "250 - 450 (根据参观路线)",
      "currency": "CZK",
      "description_en": "One of the world's largest castle complexes—St Vitus, Old Palace and more.",
      "price_range_en": "CZK 250–450 (by circuit)",
      "official_link_en": "https://www.hrad.cz/en/prague-castle-for-visitors"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "查理大桥",
      "attractions_name_en": "Charles Bridge",
      "description": "历史悠久的石桥，连接布拉格老城和城堡区，桥上有许多雕塑和街头艺人。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Historic stone bridge linking Old Town and Castle—statues and street performers.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "老城广场",
      "attractions_name_en": "Old Town Square",
      "description": "布拉格的心脏，有天文钟、泰恩教堂和胡斯纪念碑，节日气氛浓厚。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Prague's heart—Astronomical Clock, Týn Church and Hus Monument.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "布拉格天文钟",
      "attractions_name_en": "Prague Astronomical Clock",
      "description": "位于老城市政厅，每小时整点有木偶报时表演，是世界最古老且仍能运作的天文钟。",
      "official_link": "https://www.astronomical-clock-prague.com/",
      "price_range": "250 (登市政厅塔楼)",
      "currency": "CZK",
      "description_en": "On the Old Town Hall—hourly puppet show; world's oldest working astronomical clock.",
      "price_range_en": "CZK 250 (town hall tower)",
      "official_link_en": "https://www.astronomical-clock-prague.com/"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "圣维特大教堂",
      "attractions_name_en": "St. Vitus Cathedral",
      "description": "布拉格城堡内最重要的建筑，哥特式大教堂，拥有精美的彩色玻璃窗。",
      "official_link": "包含在布拉格城堡门票内",
      "price_range": "包含在布拉格城堡门票内",
      "currency": "CZK",
      "description_en": "Castle's centrepiece—Gothic cathedral with fine stained glass.",
      "price_range_en": "Included in castle ticket",
      "official_link_en": "包含在布拉格城堡门票内"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "犹太区",
      "attractions_name_en": "Jewish Quarter (Josefov)",
      "description": "布拉格历史悠久的犹太社区，有犹太博物馆、会堂和老犹太公墓。",
      "official_link": "https://www.jewishmuseum.cz/en/",
      "price_range": "350 - 550 (联票，根据包含景点)",
      "currency": "CZK",
      "description_en": "Historic Jewish quarter—museum, synagogues and Old Jewish Cemetery.",
      "price_range_en": "CZK 350–550 (combined, by sites)",
      "official_link_en": "https://www.jewishmuseum.cz/en/"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "瓦茨拉夫广场",
      "attractions_name_en": "Wenceslas Square",
      "description": "新城区的中心，历史事件发生地，两旁是商店、酒店和餐厅。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "New Town's main boulevard—shops, hotels and restaurants; historic events.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "高堡",
      "attractions_name_en": "Vyšehrad",
      "description": "布拉格另一座历史悠久的城堡，位于伏尔塔瓦河畔高处，有教堂和墓地，景色优美。",
      "official_link": "https://www.praha-vysehrad.cz/en/",
      "price_range": "免费（部分景点收费）",
      "currency": "CZK",
      "description_en": "Another historic fortress above the Vltava—church, cemetery and views.",
      "price_range_en": "Free (some sites charge)",
      "official_link_en": "https://www.praha-vysehrad.cz/en/"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "莱特纳公园",
      "attractions_name_en": "Letná Park",
      "description": "位于伏尔塔瓦河畔高处的公园，提供布拉格老城和多座桥梁的全景。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Park above the Vltava—panoramic view of Old Town and bridges.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "CZ",
      "cityname": "布拉格",
      "cityname_en": "Prague",
      "attractions_name": "跳舞的房子",
      "attractions_name_en": "Dancing House",
      "description": "独特的现代建筑，由弗兰克·盖里设计，形似一对跳舞的舞者。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Distinctive modern building by Frank Gehry—looks like two dancers.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "捷克克鲁姆洛夫城堡",
      "attractions_name_en": "Český Krumlov Castle",
      "description": "联合国教科文组织世界遗产，巨大的城堡建筑群，俯瞰蜿蜒的伏尔塔瓦河。",
      "official_link": "https://www.zamek-ceskykrumlov.cz/en",
      "price_range": "180 - 400 (根据参观路线)",
      "currency": "CZK",
      "description_en": "UNESCO World Heritage—huge castle above the winding Vltava.",
      "price_range_en": "CZK 180–400 (by circuit)",
      "official_link_en": "https://www.zamek-ceskykrumlov.cz/en"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "圣维特教堂",
      "attractions_name_en": "St. Vitus Church",
      "description": "捷克克鲁姆洛夫老城区的地标，哥特式教堂，内部装饰精美。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Landmark in the old town—Gothic church, fine interior.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "老城广场",
      "attractions_name_en": "Old Town Square",
      "description": "捷克克鲁姆洛夫的心脏，周围是色彩斑斓的房屋和市政厅。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Heart of Český Krumlov—colourful houses and town hall.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "埃贡·席勒艺术中心",
      "attractions_name_en": "Egon Schiele Art Centrum",
      "description": "展览奥地利表现主义画家埃贡·席勒的作品，以及其他20世纪艺术。",
      "official_link": "https://www.esac.cz/en/egon-schiele-art-centrum/",
      "price_range": "150 - 200",
      "currency": "CZK",
      "description_en": "Works by Egon Schiele and other 20th-century art.",
      "price_range_en": "CZK 150–200",
      "official_link_en": "https://www.esac.cz/en/egon-schiele-art-centrum/"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "登城堡塔楼",
      "attractions_name_en": "Castle Tower Climb",
      "description": "攀登城堡高塔，可俯瞰整个捷克克鲁姆洛夫小镇的全景。",
      "official_link": "包含在城堡门票内（或单独购买）",
      "price_range": "包含在城堡门票内",
      "currency": "CZK",
      "description_en": "Climb the castle tower for a full view of the town.",
      "price_range_en": "Included in castle ticket",
      "official_link_en": "包含在城堡门票内（或单独购买）"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "酷刑博物馆",
      "attractions_name_en": "Museum of Torture",
      "description": "位于城堡下方的地下室，展示中世纪的酷刑工具和历史。",
      "official_link": "https://medievaltorturemuseum.com/la/",
      "price_range": "180",
      "currency": "CZK",
      "description_en": "Cellars under the castle—medieval torture tools and history.",
      "price_range_en": "CZK 180",
      "official_link_en": "https://medievaltorturemuseum.com/la/"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "伏尔塔瓦河漂流",
      "attractions_name_en": "Vltava River Rafting/Canoeing",
      "description": "在伏尔塔瓦河上进行皮划艇或漂流，从水上欣赏小镇风光。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "300 - 800 (根据时长和船只)",
      "currency": "CZK",
      "description_en": "Kayak or raft on the Vltava—see the town from the water.",
      "price_range_en": "CZK 300–800 (duration and craft)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "蜡像馆",
      "attractions_name_en": "Wax Museum",
      "description": "展出历史人物和名人蜡像。",
      "official_link": "无官方购票链接",
      "price_range": "120 - 150",
      "currency": "CZK",
      "description_en": "Wax figures of historical and famous figures.",
      "price_range_en": "CZK 120–150",
      "official_link_en": "无官方购票链接"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "摄影博物馆",
      "attractions_name_en": "Museum Fotoatelier Seidel",
      "description": "独特的博物馆，展示19世纪末20世纪初的摄影艺术和技术。",
      "official_link": "https://www.seidel.cz/en/",
      "price_range": "180",
      "currency": "CZK",
      "description_en": "Museum of photography—late 19th and early 20th century.",
      "price_range_en": "CZK 180",
      "official_link_en": "https://www.seidel.cz/en/"
    },
    {
      "id": "CZ",
      "cityname": "捷克克鲁姆洛夫",
      "cityname_en": "Český Krumlov",
      "attractions_name": "城堡花园",
      "attractions_name_en": "Castle Garden",
      "description": "位于城堡后方的巴洛克式花园，是散步和放松的好地方。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Baroque gardens behind the castle—stroll and relax.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "磨坊温泉长廊",
      "attractions_name_en": "Mill Colonnade",
      "description": "卡罗维发利最长的温泉长廊，内有多个温泉出口，可品尝矿泉水。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Karlovy Vary's longest colonnade—several springs; taste the mineral water.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "市场温泉长廊",
      "attractions_name_en": "Market Colonnade",
      "description": "精美的木制温泉长廊，位于老城中心。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Elegant wooden colonnade in the old town.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "温泉长廊 (Vřídelní kolonáda)",
      "attractions_name_en": "Hot Spring Colonnade (Vřídelní kolonáda)",
      "description": "现代化的温泉长廊，内有卡罗维发利最著名的间歇泉，喷发高度可达12米。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Modern colonnade—Karlovy Vary's famous geyser, up to 12 m high.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "黛安娜观景塔",
      "attractions_name_en": "Diana Observation Tower",
      "description": "乘坐缆车或步行登上山顶，可俯瞰卡罗维发利全景。",
      "official_link": "缆车往返约100",
      "price_range": "免费（缆车另计）",
      "currency": "CZK",
      "description_en": "Funicular or walk to the top—view over Karlovy Vary.",
      "price_range_en": "Free (funicular extra)",
      "official_link_en": "缆车往返约100"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "莫泽玻璃博物馆",
      "attractions_name_en": "Moser Glassworks",
      "description": "参观玻璃厂，了解传统玻璃制作工艺，并购买水晶制品。",
      "official_link": "https://www.moser-glass.com/en/",
      "price_range": "200 (参观)",
      "currency": "CZK",
      "description_en": "Glassworks tour—traditional craft and crystal for sale.",
      "price_range_en": "CZK 200 (tour)",
      "official_link_en": "https://www.moser-glass.com/en/"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "贝赫尔利口酒博物馆",
      "attractions_name_en": "Jan Becher Museum (Becherovka Museum)",
      "description": "了解捷克著名草药利口酒Becherovka的历史和制作过程，可品尝。",
      "official_link": "https://www.becherovka.com/en/visit-us/",
      "price_range": "140",
      "currency": "CZK",
      "description_en": "History and making of Becherovka—tastings available.",
      "price_range_en": "CZK 140",
      "official_link_en": "https://www.becherovka.com/en/visit-us/"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "普普大饭店",
      "attractions_name_en": "Grandhotel Pupp",
      "description": "历史悠久、奢华的酒店，曾是《007：大战皇家赌场》的取景地。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费（住宿/餐饮另计）",
      "currency": "CZK",
      "description_en": "Historic luxury hotel—filming location for Casino Royale.",
      "price_range_en": "Free (stay/dining extra)",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "俄罗斯东正教堂",
      "attractions_name_en": "Orthodox Church of Saints Peter and Paul",
      "description": "精美的东正教堂，拥有金色的洋葱头圆顶。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Fine Orthodox church with golden onion domes.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "城市剧院",
      "attractions_name_en": "Municipal Theatre of Karlovy Vary",
      "description": "漂亮的剧院建筑，可观看演出或欣赏外部建筑。",
      "official_link": "无官方购票链接，外部参观免费（演出票另计）",
      "price_range": "免费（演出票另计）",
      "currency": "CZK",
      "description_en": "Beautiful theatre—catch a show or admire the building.",
      "price_range_en": "Free (performance tickets extra)",
      "official_link_en": "无官方购票链接，外部参观免费（演出票另计）"
    },
    {
      "id": "CZ",
      "cityname": "卡罗维发利",
      "cityname_en": "Karlovy Vary",
      "attractions_name": "特普拉河",
      "attractions_name_en": "Teplá River",
      "description": "穿城而过的河流，两岸是历史建筑和温泉长廊。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "River through town—historic buildings and colonnades along the banks.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "斯皮尔伯克城堡",
      "attractions_name_en": "Špilberk Castle",
      "description": "曾是监狱，现为博物馆，可俯瞰布尔诺市景。",
      "official_link": "https://www.spilberk.cz/en/",
      "price_range": "150 - 250 (根据参观区域)",
      "currency": "CZK",
      "description_en": "Former prison, now a museum—views over Brno.",
      "price_range_en": "CZK 150–250 (by areas)",
      "official_link_en": "https://www.spilberk.cz/en/"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "圣彼得与圣保罗大教堂",
      "attractions_name_en": "Cathedral of St. Peter and Paul",
      "description": "布尔诺的标志，哥特式大教堂，位于城市高处。",
      "official_link": "无门票，免费参观（登塔收费）",
      "price_range": "免费（登塔约50）",
      "currency": "CZK",
      "description_en": "Brno's icon—Gothic cathedral on the hill.",
      "price_range_en": "Free (tower ~CZK 50)",
      "official_link_en": "Free admission (tower paid)"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "自由广场",
      "attractions_name_en": "Freedom Square (Náměstí Svobody)",
      "description": "布尔诺的主广场，有现代化的“钟楼”和历史建筑。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Brno's main square—modern \"clock\" and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "圣雅各布教堂地下墓穴",
      "attractions_name_en": "Ossuary at the Church of St. James",
      "description": "欧洲第二大地下墓穴，内有数万具人类遗骸。",
      "official_link": "https://ticbrno.cz/en/ossuary-of-st-james-church",
      "price_range": "140",
      "currency": "CZK",
      "description_en": "Europe's second-largest ossuary—tens of thousands of remains.",
      "price_range_en": "CZK 140",
      "official_link_en": "https://ticbrno.cz/en/ossuary-of-st-james-church"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "明登之家",
      "attractions_name_en": "Tugendhat Villa",
      "description": "联合国教科文组织世界遗产，现代主义建筑杰作，由密斯·凡德罗设计。",
      "official_link": "https://www.tugendhat.eu/en/",
      "price_range": "500 (需提前预约)",
      "currency": "CZK",
      "description_en": "UNESCO World Heritage—modernist masterpiece by Mies van der Rohe.",
      "price_range_en": "CZK 500 (book ahead)",
      "official_link_en": "https://www.tugendhat.eu/en/"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "孟德尔博物馆",
      "attractions_name_en": "Mendel Museum",
      "description": "纪念遗传学创始人格雷戈尔·孟德尔的博物馆，位于他曾经工作的修道院内。",
      "official_link": "https://www.mendelmuseum.muni.cz/en/",
      "price_range": "150",
      "currency": "CZK",
      "description_en": "Museum dedicated to Gregor Mendel—in the monastery where he worked.",
      "price_range_en": "CZK 150",
      "official_link_en": "https://www.mendelmuseum.muni.cz/en/"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "老市政厅",
      "attractions_name_en": "Old Town Hall",
      "description": "布尔诺最古老的世俗建筑，有著名的“布尔诺龙”和“布尔诺车轮”。",
      "official_link": "无官方购票链接，外部参观免费（登塔收费）",
      "price_range": "免费（登塔约70）",
      "currency": "CZK",
      "description_en": "Brno's oldest secular building—famous \"Brno dragon\" and \"Brno wheel\".",
      "price_range_en": "Free (tower ~CZK 70)",
      "official_link_en": "无官方购票链接，外部参观免费（登塔收费）"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "卡普钦修士墓穴",
      "attractions_name_en": "Capuchin Crypt",
      "description": "收藏了18世纪木乃伊化修道士遗骸的地下墓穴。",
      "official_link": "https://museoecriptacappuccini.it/en/the-crypt/",
      "price_range": "90",
      "currency": "CZK",
      "description_en": "Underground crypt with mummified 18th-century Capuchin monks.",
      "price_range_en": "CZK 90",
      "official_link_en": "https://museoecriptacappuccini.it/en/the-crypt/"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "维拉内茨城堡",
      "attractions_name_en": "Veveří Castle",
      "description": "位于布尔诺水库旁边的中世纪城堡，可乘船前往。",
      "official_link": "https://www.hrad-veveri.cz/en",
      "price_range": "100 - 200 (根据参观路线)",
      "currency": "CZK",
      "description_en": "Medieval castle by Brno reservoir—reachable by boat.",
      "price_range_en": "CZK 100–200 (by circuit)",
      "official_link_en": "https://www.hrad-veveri.cz/en"
    },
    {
      "id": "CZ",
      "cityname": "布尔诺",
      "cityname_en": "Brno",
      "attractions_name": "兹维尔科夫公园",
      "attractions_name_en": "Lužánky Park",
      "description": "布尔诺最古老的公园，是放松和休闲的好地方。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Brno's oldest park—relax and unwind.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "皮尔森乌尔昆啤酒厂",
      "attractions_name_en": "Pilsner Urquell Brewery",
      "description": "皮尔森啤酒的发源地，可参观啤酒厂，了解酿造过程并品尝啤酒。",
      "official_link": "https://www.pilsnerurquell.com/",
      "price_range": "290",
      "currency": "CZK",
      "description_en": "Birthplace of Pilsner—brewery tour, brewing process and beer tasting.",
      "price_range_en": "CZK 290",
      "official_link_en": "https://www.pilsnerurquell.com/"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "皮尔森地下通道",
      "attractions_name_en": "Pilsen Historical Underground",
      "description": "探索皮尔森老城下方的中世纪隧道和酒窖。",
      "official_link": "https://www.prazdrojvisit.cz/en/tours/pilsen-historical-underground-tour",
      "price_range": "140",
      "currency": "CZK",
      "description_en": "Medieval tunnels and cellars under the old town.",
      "price_range_en": "CZK 140",
      "official_link_en": "https://www.prazdrojvisit.cz/en/tours/pilsen-historical-underground-tour"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "圣巴尔多禄茂大教堂",
      "attractions_name_en": "St. Bartholomew's Cathedral",
      "description": "哥特式大教堂，拥有捷克最高的教堂尖塔，可登塔俯瞰城市。",
      "official_link": "无门票，免费参观（登塔收费）",
      "price_range": "免费（登塔约60）",
      "currency": "CZK",
      "description_en": "Gothic cathedral—Czech Republic's tallest spire; climb for city views.",
      "price_range_en": "Free (tower ~CZK 60)",
      "official_link_en": "Free admission (tower paid)"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "大犹太会堂",
      "attractions_name_en": "Great Synagogue",
      "description": "欧洲第二大犹太会堂，独特的摩尔复兴式建筑。",
      "official_link": "https://www.zmo.cz/en/great-synagogue.html",
      "price_range": "100",
      "currency": "CZK",
      "description_en": "Europe's second-largest synagogue—Moorish Revival style.",
      "price_range_en": "CZK 100",
      "official_link_en": "https://www.zmo.cz/en/great-synagogue.html"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "西波西米亚博物馆",
      "attractions_name_en": "Museum of West Bohemia in Pilsen",
      "description": "收藏了皮尔森地区从史前到现代的历史、考古和艺术品。",
      "official_link": "https://www.visitplzen.eu/en/visit-pilsen/pilsen-old-town/museum-of-west-bohemia/",
      "price_range": "100",
      "currency": "CZK",
      "description_en": "Pilsen region—prehistory to modern; history, archaeology and art.",
      "price_range_en": "CZK 100",
      "official_link_en": "https://www.visitplzen.eu/en/visit-pilsen/pilsen-old-town/museum-of-west-bohemia/"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "解放纪念碑",
      "attractions_name_en": "Monument to the Liberation of Pilsen",
      "description": "纪念二战末期美国军队解放皮尔森的纪念碑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Monument to the US Army's liberation of Pilsen at the end of WWII.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "比利时的皮尔森动物园",
      "attractions_name_en": "Pilsen Zoo and Dinopark",
      "description": "动物园内有各种动物，旁边是恐龙主题公园，适合家庭。",
      "official_link": "https://www.zooplzen.cz/en/",
      "price_range": "200 - 300 (根据是否包含恐龙公园)",
      "currency": "CZK",
      "description_en": "Zoo with many animals—dinosaur theme park next door; family-friendly.",
      "price_range_en": "CZK 200–300 (with/without dinosaur park)",
      "official_link_en": "https://www.zooplzen.cz/en/"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "共和国广场",
      "attractions_name_en": "Republic Square (Náměstí Republiky)",
      "description": "皮尔森的主广场，有大教堂、市政厅和喷泉。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "CZK",
      "description_en": "Pilsen's main square—cathedral, town hall and fountain.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "木偶博物馆",
      "attractions_name_en": "Museum of Puppets",
      "description": "展示捷克丰富的木偶制作和表演历史。",
      "official_link": "https://www.muzeum-loutek.cz/en/",
      "price_range": "100",
      "currency": "CZK",
      "description_en": "Czech puppetry—making and performance history.",
      "price_range_en": "CZK 100",
      "official_link_en": "https://www.muzeum-loutek.cz/en/"
    },
    {
      "id": "CZ",
      "cityname": "皮尔森",
      "cityname_en": "Pilsen",
      "attractions_name": "科技园",
      "attractions_name_en": "Techmania Science Center",
      "description": "互动式科学中心，适合所有年龄段的游客，探索科学原理。",
      "official_link": "https://www.techmania.cz/en/",
      "price_range": "200 - 300",
      "currency": "CZK",
      "description_en": "Interactive science centre—all ages, hands-on experiments.",
      "price_range_en": "CZK 200–300",
      "official_link_en": "https://www.techmania.cz/en/"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "圣三一学院与凯尔斯书",
      "attractions_name_en": "Trinity College Dublin & Book of Kells",
      "description": "爱尔兰最古老的大学，其图书馆收藏了著名的《凯尔斯书》，一本精美的手抄本福音书。",
      "official_link": "https://www.tcd.ie/visitors/book-of-kells/",
      "price_range": "18.50 - 25 (在线预订可能更便宜)",
      "currency": "EUR",
      "description_en": "Ireland's oldest university—library holds the famous Book of Kells.",
      "price_range_en": "€18.50–€25 (cheaper online)",
      "official_link_en": "https://www.tcd.ie/visitors/book-of-kells/"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "健力士啤酒厂",
      "attractions_name_en": "Guinness Storehouse",
      "description": "探索健力士啤酒的历史、酿造过程，并在顶楼的重力酒吧享用一杯免费啤酒，俯瞰都柏林全景。",
      "official_link": "https://www.guinness-storehouse.com/en",
      "price_range": "26 - 36 (根据时间段)",
      "currency": "EUR",
      "description_en": "Guinness history and brewing—free pint in the Gravity Bar with city views.",
      "price_range_en": "€26–€36 (by time)",
      "official_link_en": "https://www.guinness-storehouse.com/en"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "都柏林城堡",
      "attractions_name_en": "Dublin Castle",
      "description": "爱尔兰历史的中心，曾是英国在爱尔兰的行政中心，有博物馆、礼拜堂和花园。",
      "official_link": "https://www.dublincastle.ie/",
      "price_range": "8 (仅参观地面), 12 (导览)",
      "currency": "EUR",
      "description_en": "Centre of Irish history—former British admin; museums, chapel and gardens.",
      "price_range_en": "€8 (grounds only), €12 (guided)",
      "official_link_en": "https://www.dublincastle.ie/"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "圣帕特里克大教堂",
      "attractions_name_en": "St. Patrick's Cathedral",
      "description": "爱尔兰最大的教堂，历史悠久，与爱尔兰守护神圣帕特里克有关。",
      "official_link": "https://www.stpatrickscathedral.ie/",
      "price_range": "9",
      "currency": "EUR",
      "description_en": "Ireland's largest church—linked to St Patrick.",
      "price_range_en": "€9",
      "official_link_en": "https://www.stpatrickscathedral.ie/"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "凤凰公园",
      "attractions_name_en": "Phoenix Park",
      "description": "欧洲最大的城市公园之一，有野生鹿群、爱尔兰总统府和美国大使馆。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Europe's largest city parks—wild deer, Áras an Uachtaráin and US Embassy.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "都柏林国家博物馆",
      "attractions_name_en": "National Museum of Ireland - Archaeology",
      "description": "免费参观，收藏了爱尔兰从史前到中世纪的考古文物，包括金器和“沼泽人”。",
      "official_link": "https://www.museum.ie/en-US/Museums/Archaeology",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Free—Irish archaeology from prehistory to medieval; gold and bog bodies.",
      "price_range_en": "Free",
      "official_link_en": "https://www.museum.ie/en-US/Museums/Archaeology"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "格拉夫顿街",
      "attractions_name_en": "Grafton Street",
      "description": "都柏林最繁华的购物街之一，两旁是商店、咖啡馆和街头艺人。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Dublin's busiest shopping street—shops, cafés and buskers.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "坦普尔酒吧区",
      "attractions_name_en": "Temple Bar",
      "description": "都柏林著名的文化和娱乐区，有许多酒吧、餐厅和画廊，夜晚尤其热闹。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮消费另计）",
      "currency": "EUR",
      "description_en": "Dublin's famous cultural quarter—pubs, restaurants and galleries; lively at night.",
      "price_range_en": "Free (food/drink extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "圣史蒂芬绿地",
      "attractions_name_en": "St Stephen's Green",
      "description": "都柏林市中心维多利亚时代的公园，是休憩放松的好地方。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Victorian park in the centre—rest and relax.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "IE",
      "cityname": "都柏林",
      "cityname_en": "Dublin",
      "attractions_name": "都柏林动物园",
      "attractions_name_en": "Dublin Zoo",
      "description": "位于凤凰公园内，是世界上最古老且最受欢迎的动物园之一。",
      "official_link": "https://www.dublinzoo.ie/",
      "price_range": "23.50 (成人)",
      "currency": "EUR",
      "description_en": "In Phoenix Park—one of the world's oldest and most popular zoos.",
      "price_range_en": "€23.50 (adult)",
      "official_link_en": "https://www.dublinzoo.ie/"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "高威市中心 (拉丁区)",
      "attractions_name_en": "Galway City Centre (Latin Quarter)",
      "description": "高威的心脏地带，鹅卵石街道，充满活力的酒吧、餐厅和街头表演。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Galway's heart—cobbled streets, lively pubs, restaurants and buskers.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "高威大教堂",
      "attractions_name_en": "Galway Cathedral",
      "description": "独特且宏伟的罗马天主教大教堂，是爱尔兰最新的大型石制建筑之一。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Striking Roman Catholic cathedral—one of Ireland's newest large stone buildings.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "斯潘尼什拱门",
      "attractions_name_en": "Spanish Arch",
      "description": "高威历史悠久的城墙遗迹，位于科里布河入海口附近。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Historic remnant of the city walls—near the Corrib estuary.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "艾尔广场",
      "attractions_name_en": "Eyre Square",
      "description": "高威市中心的主要广场，绿地和纪念碑，是市民休闲的场所。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Main square in the centre—green space and monuments.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "高威市博物馆",
      "attractions_name_en": "Galway City Museum",
      "description": "位于斯潘尼什拱门附近，展示高威的历史和考古。",
      "official_link": "https://galwaycitymuseum.ie/",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Near Spanish Arch—Galway's history and archaeology.",
      "price_range_en": "Free",
      "official_link_en": "https://galwaycitymuseum.ie/"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "克拉达戒指博物馆",
      "attractions_name_en": "Claddagh Ring Museum",
      "description": "了解爱尔兰传统克拉达戒指（代表爱情、忠诚和友谊）的历史和文化。",
      "official_link": "无官方购票链接，通常免费参观（购买另计）",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "History of the Claddagh ring—love, loyalty and friendship.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "无官方购票链接，通常免费参观（购买另计）"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "邓盖尔城堡 (邓圭尔城堡)",
      "attractions_name_en": "Dunguaire Castle",
      "description": "位于高威湾畔的16世纪塔楼，夏季常有中世纪晚宴表演。",
      "official_link": "hhttps://www.dunguairecastle.com/",
      "price_range": "6 (仅参观), 60+ (晚宴)",
      "currency": "EUR",
      "description_en": "16th-century tower on Galway Bay—medieval banquets in summer.",
      "price_range_en": "€6 (visit only), €60+ (banquet)",
      "official_link_en": "hhttps://www.dunguairecastle.com/"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "康尼马拉国家公园",
      "attractions_name_en": "Connemara National Park",
      "description": "崎岖美丽的国家公园，有山脉、沼泽、石楠地和丰富的野生动物。",
      "official_link": "https://www.nationalparks.ie/connemara/",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Rugged national park—mountains, bogs, heath and wildlife.",
      "price_range_en": "Free",
      "official_link_en": "https://www.nationalparks.ie/connemara/"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "凯尔莫尔修道院",
      "attractions_name_en": "Kylemore Abbey",
      "description": "位于康尼马拉国家公园内的宏伟哥特式修道院，有维多利亚式围墙花园。",
      "official_link": "https://www.kylemoreabbey.com/",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "Grand Gothic abbey in Connemara—Victorian walled garden.",
      "price_range_en": "€16",
      "official_link_en": "https://www.kylemoreabbey.com/"
    },
    {
      "id": "IE",
      "cityname": "高威",
      "cityname_en": "Galway",
      "attractions_name": "戈尔韦湾",
      "attractions_name_en": "Galway Bay",
      "description": "美丽的海湾，可沿着海岸线散步，欣赏大西洋风光。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Beautiful bay—walk the coast and enjoy Atlantic views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "布拉尼城堡与巧言石",
      "attractions_name_en": "Blarney Castle & Blarney Stone",
      "description": "著名的城堡，游客可倒挂亲吻“巧言石”，据说可获得雄辩之才。",
      "official_link": "https://www.blarneycastle.ie/",
      "price_range": "20 (成人)",
      "currency": "EUR",
      "description_en": "Famous castle—kiss the Blarney Stone (upside down) for the gift of the gab.",
      "price_range_en": "€20 (adult)",
      "official_link_en": "https://www.blarneycastle.ie/"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "圣芬巴尔大教堂",
      "attractions_name_en": "St. Fin Barre's Cathedral",
      "description": "宏伟的哥特式大教堂，由著名建筑师威廉·伯吉斯设计。",
      "official_link": "https://corkcathedral.ie/",
      "price_range": "7",
      "currency": "EUR",
      "description_en": "Grand Gothic cathedral—designed by William Burges.",
      "price_range_en": "€7",
      "official_link_en": "https://corkcathedral.ie/"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "英国市场",
      "attractions_name_en": "English Market",
      "description": "历史悠久的室内食品市场，有各种当地和国际美食。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Historic covered food market—local and international produce.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "科克城市高尔博物馆",
      "attractions_name_en": "Cork Public Museum",
      "description": "位于菲茨杰拉德公园内，展示科克的历史和文化。",
      "official_link": "https://www.corkcity.ie/en/cork-public-museum/",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "In Fitzgerald Park—Cork's history and culture.",
      "price_range_en": "Free",
      "official_link_en": "https://www.corkcity.ie/en/cork-public-museum/"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "墨菲斯啤酒体验",
      "attractions_name_en": "Murphy's Brewery Experience",
      "description": "探索科克当地特色墨菲斯啤酒的历史和酿造过程。",
      "official_link": "无官方购票链接，通常酒吧提供",
      "price_range": "免费（餐饮消费另计）",
      "currency": "EUR",
      "description_en": "Cork's Murphy's beer—history and brewing.",
      "price_range_en": "Free (food/drink extra)",
      "official_link_en": "无官方购票链接，通常酒吧提供"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "科克大学",
      "attractions_name_en": "University College Cork (UCC)",
      "description": "美丽的大学校园，有哥特式建筑和博物馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Beautiful campus—Gothic buildings and museum.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "科克监狱",
      "attractions_name_en": "Cork City Gaol",
      "description": "维多利亚时代的监狱，现为博物馆，展示囚犯的生活。",
      "official_link": "https://www.corkcitygaol.com/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Victorian prison, now a museum—prison life.",
      "price_range_en": "€12",
      "official_link_en": "https://www.corkcitygaol.com/"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "圣安妮教堂与肖登大钟",
      "attractions_name_en": "St Anne's Church & Shandon Bells",
      "description": "教堂的钟楼是科克的地标，游客可以爬上钟楼敲响钟声。",
      "official_link": "https://www.stanneshandon.ie/",
      "price_range": "8 (登塔敲钟)",
      "currency": "EUR",
      "description_en": "Church tower is a Cork landmark—climb up and ring the bells.",
      "price_range_en": "€8 (tower and bells)",
      "official_link_en": "https://www.stanneshandon.ie/"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "科克海事酒店",
      "attractions_name_en": "The Metropole Hotel Cork",
      "description": "科克历史悠久的酒店，位于市中心，可感受历史氛围。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费（住宿/餐饮另计）",
      "currency": "EUR",
      "description_en": "Historic hotel in the centre—step back in time.",
      "price_range_en": "Free (stay/dining extra)",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "IE",
      "cityname": "科克",
      "cityname_en": "Cork",
      "attractions_name": "科克歌剧院",
      "attractions_name_en": "Cork Opera House",
      "description": "重要的文化场所，可观看音乐剧、歌剧和音乐会。",
      "official_link": "https://www.corkoperahouse.ie/",
      "price_range": "演出票价另计",
      "currency": "EUR",
      "description_en": "Key venue—musicals, opera and concerts.",
      "price_range_en": "Performance tickets extra",
      "official_link_en": "https://www.corkoperahouse.ie/"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "约翰国王城堡",
      "attractions_name_en": "King John's Castle",
      "description": "位于香农河畔，历史悠久的13世纪城堡，有互动展览。",
      "official_link": "https://www.kingjohnscastle.ie/",
      "price_range": "14.5",
      "currency": "EUR",
      "description_en": "13th-century castle on the Shannon—interactive exhibitions.",
      "price_range_en": "€14.50",
      "official_link_en": "https://www.kingjohnscastle.ie/"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "圣玛丽大教堂",
      "attractions_name_en": "St. Mary's Cathedral",
      "description": "爱尔兰现存最古老的建筑之一，历史悠久，建筑精美。",
      "official_link": "https://www.stmaryscathedral.ie/",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "One of Ireland's oldest surviving buildings—fine architecture.",
      "price_range_en": "€5",
      "official_link_en": "https://www.stmaryscathedral.ie/"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "利默里克博物馆",
      "attractions_name_en": "Limerick Museum",
      "description": "展示利默里克的历史、文化和遗产。",
      "official_link": "无需购票",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Limerick's history, culture and heritage.",
      "price_range_en": "Free",
      "official_link_en": "No ticket required"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "香农河",
      "attractions_name_en": "River Shannon",
      "description": "爱尔兰最长的河流，可沿着河畔散步或参加游船活动。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（游船另计）",
      "currency": "EUR",
      "description_en": "Ireland's longest river—walk the banks or take a boat trip.",
      "price_range_en": "Free (boat extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "利默里克艺术画廊",
      "attractions_name_en": "Limerick City Gallery of Art",
      "description": "收藏了爱尔兰和国际艺术家的作品，以20世纪艺术为主。",
      "official_link": "https://www.limerick.ie/discover/attractions/limerick-city-gallery-art",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Irish and international art—strong on 20th century.",
      "price_range_en": "Free",
      "official_link_en": "https://www.limerick.ie/discover/attractions/limerick-city-gallery-art"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "福伊恩斯飞行船博物馆",
      "attractions_name_en": "Foynes Flying Boat & Maritime Museum",
      "description": "位于利默里克附近，展示泛美航空跨大西洋飞行船的历史，以及爱尔兰咖啡的发源地。",
      "official_link": "https://flyingboatmuseum.com/",
      "price_range": "14",
      "currency": "EUR",
      "description_en": "Near Limerick—Pan Am flying boat history; birthplace of Irish coffee.",
      "price_range_en": "€14",
      "official_link_en": "https://flyingboatmuseum.com/"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "阿代尔村",
      "attractions_name_en": "Adare Village",
      "description": "利默里克附近的“茅草屋村”，被认为是爱尔兰最美丽的村庄之一。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Thatched village near Limerick—one of Ireland's prettiest.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "圣乔治教堂",
      "attractions_name_en": "St. George's Church",
      "description": "历史悠久的教堂，位于市中心。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Historic church in the centre.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "格里菲斯学院",
      "attractions_name_en": "Griffith College Limerick",
      "description": "位于一座历史建筑内，美丽且值得参观。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "In a historic building—worth a look.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "IE",
      "cityname": "利默里克",
      "cityname_en": "Limerick",
      "attractions_name": "橄榄球博物馆",
      "attractions_name_en": "International Rugby Experience",
      "description": "互动式博物馆，庆祝爱尔兰和世界橄榄球的历史和文化。",
      "official_link": "https://www.internationalrugbyexperience.com/",
      "price_range": "17",
      "currency": "EUR",
      "description_en": "Interactive museum—Irish and world rugby history and culture.",
      "price_range_en": "€17",
      "official_link_en": "https://www.internationalrugbyexperience.com/"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡 (莫赫悬崖)",
      "cityname_en": "County Clare (Cliffs of Moher)",
      "attractions_name": "莫赫悬崖",
      "attractions_name_en": "Cliffs of Moher",
      "description": "欧洲最高的悬崖之一，大西洋的壮丽景色，是爱尔兰最著名的自然景观。",
      "official_link": "https://www.cliffsofmoher.ie/",
      "price_range": "7 - 12 (在线预订可能更便宜)",
      "currency": "EUR",
      "description_en": "Among Europe's highest cliffs—dramatic Atlantic views; Ireland's top natural sight.",
      "price_range_en": "€7–€12 (cheaper online)",
      "official_link_en": "https://www.cliffsofmoher.ie/"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡",
      "cityname_en": "County Clare",
      "attractions_name": "布伦国家公园",
      "attractions_name_en": "Burren National Park",
      "description": "独特的喀斯特地貌，石灰岩地表，有丰富的植物和考古遗址。",
      "official_link": "https://www.nationalparks.ie/burren/",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Unique karst landscape—limestone pavements, plants and archaeology.",
      "price_range_en": "Free",
      "official_link_en": "https://www.nationalparks.ie/burren/"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡",
      "cityname_en": "County Clare",
      "attractions_name": "杜林村",
      "attractions_name_en": "Doolin Village",
      "description": "位于莫赫悬崖附近的海边小村庄，以其传统音乐和前往阿兰群岛的渡轮而闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Village by the sea near the Cliffs—traditional music and ferry to the Aran Islands.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡",
      "cityname_en": "County Clare",
      "attractions_name": "阿兰群岛",
      "attractions_name_en": "Aran Islands",
      "description": "位于高威湾外，以其独特的盖尔语文化、古老的石墙和崎岖的风景而闻名。",
      "official_link": "渡轮公司提供购票，无官方统一链接",
      "price_range": "往返渡轮约30 - 40",
      "currency": "EUR",
      "description_en": "Islands off Galway Bay—Gaelic culture, ancient stone walls and rugged scenery.",
      "price_range_en": "Return ferry ~€30–€40",
      "official_link_en": "渡轮公司提供购票，无官方统一链接"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡",
      "cityname_en": "County Clare",
      "attractions_name": "班拉蒂城堡与民俗公园",
      "attractions_name_en": "Bunratty Castle & Folk Park",
      "description": "保存完好的15世纪城堡和民俗公园，展示19世纪爱尔兰乡村生活。",
      "official_link": "https://www.bunrattycastle.ie/",
      "price_range": "19.50 (成人)",
      "currency": "EUR",
      "description_en": "Well-preserved 15th-century castle and folk park—19th-century Irish rural life.",
      "price_range_en": "€19.50 (adult)",
      "official_link_en": "https://www.bunrattycastle.ie/"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡",
      "cityname_en": "County Clare",
      "attractions_name": "艾尔森林公园",
      "attractions_name_en": "Aillwee Cave & Birds of Prey Centre",
      "description": "布伦地区的著名洞穴，旁边有猛禽中心，可观看鸟类表演。",
      "official_link": "https://aillweeburrenexperience.ie/",
      "price_range": "19.50 (套票)",
      "currency": "EUR",
      "description_en": "Famous caves in the Burren—raptor centre and bird shows next door.",
      "price_range_en": "€19.50 (combined)",
      "official_link_en": "https://aillweeburrenexperience.ie/"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡",
      "cityname_en": "County Clare",
      "attractions_name": "多尔曼古墓",
      "attractions_name_en": "Poulnabrone Dolmen",
      "description": "布伦地区一个著名的史前石墓，历史可追溯到新石器时代。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Famous prehistoric dolmen in the Burren—Neolithic.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡",
      "cityname_en": "County Clare",
      "attractions_name": "莫赫悬崖游客中心",
      "attractions_name_en": "Cliffs of Moher Visitor Centre",
      "description": "位于悬崖顶部，提供关于悬崖形成、地质和生态的信息。",
      "official_link": "包含在莫赫悬崖门票内",
      "price_range": "包含在莫赫悬崖门票内",
      "currency": "EUR",
      "description_en": "At the cliff top—geology, formation and ecology of the cliffs.",
      "price_range_en": "Included in Cliffs of Moher ticket",
      "official_link_en": "包含在莫赫悬崖门票内"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡",
      "cityname_en": "County Clare",
      "attractions_name": "肖尼·奥布莱恩酒吧",
      "attractions_name_en": "Gus O'Connor's Pub (Doolin)",
      "description": "杜林村著名的传统爱尔兰酒吧，每晚有现场音乐表演。",
      "official_link": "无官方购票链接，为餐饮场所",
      "price_range": "免费（餐饮消费另计）",
      "currency": "EUR",
      "description_en": "Famous traditional pub in Doolin—live music every night.",
      "price_range_en": "Free (food/drink extra)",
      "official_link_en": "No official ticket link; dining venue"
    },
    {
      "id": "IE",
      "cityname": "克莱尔郡",
      "cityname_en": "County Clare",
      "attractions_name": "大西洋之路 (沿海风景)",
      "attractions_name_en": "Wild Atlantic Way (Coastal Scenery)",
      "description": "爱尔兰西海岸壮丽的沿海驾驶路线，莫赫悬崖是其中一部分。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Stunning coastal drive on Ireland's west coast—Cliffs of Moher on the route.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "小美人鱼雕像",
      "attractions_name_en": "The Little Mermaid Statue",
      "description": "哥本哈根的标志性雕塑，灵感来自安徒生童话。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Copenhagen's icon—inspired by Hans Christian Andersen's fairy tale.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "新港",
      "attractions_name_en": "Nyhavn",
      "description": "色彩斑斓的联排别墅、历史悠久的船只和海滨餐厅，是哥本哈根最上镜的地方。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮消费另计）",
      "currency": "DKK",
      "description_en": "Colourful townhouses, historic ships and harbour cafés—Copenhagen's most photogenic spot.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "趣伏里公园",
      "attractions_name_en": "Tivoli Gardens",
      "description": "世界上最古老的游乐园之一，结合了游乐设施、花园和娱乐表演。",
      "official_link": "https://www.tivoli.dk/en",
      "price_range": "169 - 229 (仅入场，游乐设施另计)",
      "currency": "DKK",
      "description_en": "One of the world's oldest amusement parks—rides, gardens and shows.",
      "price_range_en": "DKK 169–229 (entry; rides extra)",
      "official_link_en": "https://www.tivoli.dk/en"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "阿美琳堡宫",
      "attractions_name_en": "Amalienborg Palace",
      "description": "丹麦皇室的冬宫，卫兵换岗仪式是亮点。",
      "official_link": "https://www.visitcopenhagen.com/copenhagen/planning/amalienborg-palace-gdk492887",
      "price_range": "125",
      "currency": "DKK",
      "description_en": "Danish royal winter residence—changing of the guard is the highlight.",
      "price_range_en": "DKK 125",
      "official_link_en": "https://www.visitcopenhagen.com/copenhagen/planning/amalienborg-palace-gdk492887"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "罗森堡城堡",
      "attractions_name_en": "Rosenborg Castle",
      "description": "文艺复兴风格的城堡，收藏有丹麦皇冠珠宝和其他皇家藏品。",
      "official_link": "https://denkongeligesamling.dk/en/rosenborg-castle/tickets/",
      "price_range": "130",
      "currency": "DKK",
      "description_en": "Renaissance castle—Danish crown jewels and royal collections.",
      "price_range_en": "DKK 130",
      "official_link_en": "https://denkongeligesamling.dk/en/rosenborg-castle/tickets/"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "圆塔",
      "attractions_name_en": "The Round Tower (Rundetårn)",
      "description": "欧洲最古老仍在使用的天文台，可沿着螺旋坡道登顶俯瞰城市。",
      "official_link": "https://rundetaarn.dk/en/",
      "price_range": "40",
      "currency": "DKK",
      "description_en": "Europe's oldest working observatory—spiral ramp to the top for city views.",
      "price_range_en": "DKK 40",
      "official_link_en": "https://rundetaarn.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "克里斯蒂安堡宫",
      "attractions_name_en": "Christiansborg Palace",
      "description": "丹麦议会、最高法院和首相办公室所在地，可参观皇家接待室和地下遗迹。",
      "official_link": "https://kongeligeslotte.dk/en/palaces-and-gardens/christiansborg-palace/",
      "price_range": "160 (皇家接待室+厨房)",
      "currency": "DKK",
      "description_en": "Houses parliament, Supreme Court and PM's office—royal reception rooms and ruins.",
      "price_range_en": "DKK 160 (reception rooms + kitchen)",
      "official_link_en": "https://kongeligeslotte.dk/en/palaces-and-gardens/christiansborg-palace/"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "国家博物馆",
      "attractions_name_en": "National Museum of Denmark",
      "description": "免费参观，展示丹麦从史前到现代的历史和文化。",
      "official_link": "https://natmus.dk/en/",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Free—Danish history and culture from prehistory to the present.",
      "price_range_en": "Free",
      "official_link_en": "https://natmus.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "购物街 (Stroget)",
      "attractions_name_en": "Strøget",
      "description": "欧洲最长的步行街之一，两旁是商店、咖啡馆和街头艺人。",
      "official_link": "无官方购票链接，为公共街道",
      "price_range": "免费（购物消费另计）",
      "currency": "DKK",
      "description_en": "One of Europe's longest pedestrian streets—shops, cafés and buskers.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public street"
    },
    {
      "id": "DK",
      "cityname": "哥本哈根",
      "cityname_en": "Copenhagen",
      "attractions_name": "救主堂",
      "attractions_name_en": "Church of Our Saviour",
      "description": "巴洛克式教堂，独特的外部螺旋形尖顶，可攀登欣赏哥本哈根全景。",
      "official_link": "https://www.vorfrelserskirke.dk/",
      "price_range": "65",
      "currency": "DKK",
      "description_en": "Baroque church—climb the external spiral spire for city views.",
      "price_range_en": "DKK 65",
      "official_link_en": "https://www.vorfrelserskirke.dk/"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "丹麦老城",
      "attractions_name_en": "Den Gamle By (The Old Town)",
      "description": "露天博物馆，展示丹麦不同历史时期的城市生活。",
      "official_link": "https://www.dengamleby.dk/en/",
      "price_range": "170 (成人)",
      "currency": "DKK",
      "description_en": "Open-air museum—Danish town life across the centuries.",
      "price_range_en": "DKK 170 (adult)",
      "official_link_en": "https://www.dengamleby.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "奥胡斯大教堂",
      "attractions_name_en": "Aarhus Cathedral",
      "description": "哥特式大教堂，丹麦最长的教堂，拥有精美的壁画和祭坛。",
      "official_link": "无门票，免费参观（部分区域可能收费）",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Gothic cathedral—Denmark's longest; fine frescoes and altars.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（部分区域可能收费）"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "ARoS 奥胡斯艺术博物馆",
      "attractions_name_en": "ARoS Aarhus Art Museum",
      "description": "重要的艺术博物馆，顶部的“你的彩虹全景”是标志性装置。",
      "official_link": "https://www.aros.dk/en/",
      "price_range": "170",
      "currency": "DKK",
      "description_en": "Major art museum—\"Your Rainbow Panorama\" on the roof is iconic.",
      "price_range_en": "DKK 170",
      "official_link_en": "https://www.aros.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "莫斯高史前博物馆",
      "attractions_name_en": "Moesgaard Museum",
      "description": "位于奥胡斯郊外的现代化博物馆，展示史前和维京时期的历史。",
      "official_link": "https://www.moesgaardmuseum.dk/en/",
      "price_range": "180",
      "currency": "DKK",
      "description_en": "Modern museum outside Aarhus—prehistory and Viking age.",
      "price_range_en": "DKK 180",
      "official_link_en": "https://www.moesgaardmuseum.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "奥胡斯市政厅",
      "attractions_name_en": "Aarhus City Hall",
      "description": "由阿尔瓦·阿尔托设计，具有独特现代风格的市政厅。",
      "official_link": "无官方购票链接，外部参观免费（内部可能需预约）",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Town hall by Alvar Aalto—distinctive modern design.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费（内部可能需预约）"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "植物园",
      "attractions_name_en": "Botanical Garden Aarhus",
      "description": "大型植物园，有温室、热带区和各种植物。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Large botanical garden—greenhouses, tropical zone and plants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "奥胡斯滨水区",
      "attractions_name_en": "Aarhus Ø (Aarhus East)",
      "description": "新兴的滨水区，有现代建筑、港口浴场和咖啡馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Emerging waterfront—modern buildings, harbour baths and cafés.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "奥胡斯大学公园",
      "attractions_name_en": "Aarhus University Park",
      "description": "美丽的公园，是奥胡斯大学校园的一部分，适合散步和放松。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Lovely park—part of Aarhus University; stroll and relax.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "莱姆比克城堡",
      "attractions_name_en": "Kalø Castle Ruin",
      "description": "位于奥胡斯附近，一座历史悠久的城堡遗址，风景优美。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Historic castle ruins near Aarhus—scenic.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "奥胡斯",
      "cityname_en": "Aarhus",
      "attractions_name": "沃克斯克莱德教堂",
      "attractions_name_en": "Vor Frue Kirke (Church of Our Lady)",
      "description": "奥胡斯最古老的教堂之一，有地下墓穴和中世纪修道院遗址。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "One of Aarhus's oldest churches—crypt and medieval monastery remains.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "安徒生博物馆",
      "attractions_name_en": "H.C. Andersen Museum",
      "description": "纪念丹麦著名童话作家汉斯·克里斯蒂安·安徒生的现代化博物馆。",
      "official_link": "https://hcandersenshus.dk/en/",
      "price_range": "165",
      "currency": "DKK",
      "description_en": "Modern museum dedicated to Hans Christian Andersen.",
      "price_range_en": "DKK 165",
      "official_link_en": "https://hcandersenshus.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "安徒生童年故居",
      "attractions_name_en": "H.C. Andersen's Childhood Home",
      "description": "安徒生出生和度过童年的小房子，还原其生活场景。",
      "official_link": "https://hcandersenshus.dk/en/",
      "price_range": "95 (通常与博物馆联票)",
      "currency": "DKK",
      "description_en": "Small house where Andersen was born and grew up—recreated scenes.",
      "price_range_en": "DKK 95 (often combined with museum)",
      "official_link_en": "https://hcandersenshus.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "芬岛村",
      "attractions_name_en": "Funen Village (Den Fynske Landsby)",
      "description": "露天博物馆，展示19世纪芬岛的乡村生活。",
      "official_link": "https://www.denfynskelandsby.dk/en/",
      "price_range": "120",
      "currency": "DKK",
      "description_en": "Open-air museum—19th-century Funen village life.",
      "price_range_en": "DKK 120",
      "official_link_en": "https://www.denfynskelandsby.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "圣克努特大教堂",
      "attractions_name_en": "St. Canute's Cathedral (Odense Cathedral)",
      "description": "宏伟的哥特式大教堂，是丹麦最重要的教堂之一，埋葬着丹麦国王圣克努特。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Grand Gothic cathedral—one of Denmark's most important; burial place of King Canute.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "奥登塞动物园",
      "attractions_name_en": "Odense Zoo",
      "description": "拥有来自世界各地的动物，被认为是欧洲最好的动物园之一。",
      "official_link": "https://www.odensezoo.dk/en/",
      "price_range": "210",
      "currency": "DKK",
      "description_en": "Animals from around the world—one of Europe's best zoos.",
      "price_range_en": "DKK 210",
      "official_link_en": "https://www.odensezoo.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "欧登塞城堡",
      "attractions_name_en": "Odense Castle",
      "description": "奥登塞市中心的一座历史悠久的城堡。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Historic castle in the centre of Odense.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "铁路博物馆",
      "attractions_name_en": "Danish Railway Museum",
      "description": "丹麦最大的铁路博物馆，收藏了各种火车和铁路设备。",
      "official_link": "https://www.jernbanemuseet.dk/en/",
      "price_range": "120",
      "currency": "DKK",
      "description_en": "Denmark's largest railway museum—trains and railway heritage.",
      "price_range_en": "DKK 120",
      "official_link_en": "https://www.jernbanemuseet.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "蒙克莫斯公园",
      "attractions_name_en": "Munke Mose Park",
      "description": "位于奥登塞市中心的绿色公园，有河道和休闲区。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Green park in the centre—river and leisure areas.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "圣奥本教堂",
      "attractions_name_en": "Saint Albani Church",
      "description": "新哥特式教堂，是奥登塞的另一个重要教堂。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Neo-Gothic church—another key church in Odense.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "DK",
      "cityname": "奥登塞",
      "cityname_en": "Odense",
      "attractions_name": "奥登塞港口浴场",
      "attractions_name_en": "Odense Harbour Bath",
      "description": "位于奥登塞港口，夏季开放的公共游泳区。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Public harbour baths—open in summer.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "奥尔堡城堡",
      "attractions_name_en": "Aalborghus Castle",
      "description": "丹麦保存最完好的文艺复兴时期城堡之一，曾是皇家住所。",
      "official_link": "无官方购票链接，外部参观免费（部分区域可入内）",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "One of Denmark's best-preserved Renaissance castles—former royal residence.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费（部分区域可入内）"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "林德霍姆霍耶",
      "attractions_name_en": "Lindholm Høje",
      "description": "重要的维京遗址，有数百座石制墓碑，可追溯到维京时代。",
      "official_link": "https://www.nordjyskemuseer.dk/museum/lindholm-hoeje/",
      "price_range": "80 (博物馆)",
      "currency": "DKK",
      "description_en": "Important Viking site—hundreds of stone-set graves from the Viking age.",
      "price_range_en": "DKK 80 (museum)",
      "official_link_en": "https://www.nordjyskemuseer.dk/museum/lindholm-hoeje/"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "库恩斯博物馆",
      "attractions_name_en": "Kunsten Museum of Modern Art Aalborg",
      "description": "由阿尔瓦·阿尔托设计的现代艺术博物馆，收藏20世纪至今的丹麦和国际艺术。",
      "official_link": "https://kunsten.dk/en",
      "price_range": "120",
      "currency": "DKK",
      "description_en": "Modern art museum by Alvar Aalto—Danish and international art from the 20th century.",
      "price_range_en": "DKK 120",
      "official_link_en": "https://kunsten.dk/en"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "奥尔堡大教堂",
      "attractions_name_en": "Budolfi Church (Aalborg Cathedral)",
      "description": "哥特式大教堂，奥尔堡的主要教堂。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Gothic cathedral—Aalborg's main church.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "奥尔堡动物园",
      "attractions_name_en": "Aalborg Zoo",
      "description": "拥有来自世界各地的动物，并积极参与动物保护项目。",
      "official_link": "https://www.aalborgzoo.dk/en/",
      "price_range": "195",
      "currency": "DKK",
      "description_en": "Animals from around the world—active in conservation.",
      "price_range_en": "DKK 195",
      "official_link_en": "https://www.aalborgzoo.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "延森之屋",
      "attractions_name_en": "Jens Bang's House",
      "description": "宏伟的文艺复兴时期豪宅，是奥尔堡最著名的建筑之一。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Grand Renaissance mansion—one of Aalborg's most famous buildings.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "奥尔堡历史博物馆",
      "attractions_name_en": "Aalborg Historical Museum",
      "description": "展示奥尔堡从维京时代到现代的历史。",
      "official_link": "https://www.nordjyskemuseer.dk/museum/aalborg-historiske-museum/",
      "price_range": "80",
      "currency": "DKK",
      "description_en": "Aalborg's history from the Viking age to the present.",
      "price_range_en": "DKK 80",
      "official_link_en": "https://www.nordjyskemuseer.dk/museum/aalborg-historiske-museum/"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "弗斯特鲁普堡",
      "attractions_name_en": "Fårup Sommerland",
      "description": "位于奥尔堡附近的大型游乐园和水上乐园，适合家庭。",
      "official_link": "https://www.faarupsommerland.dk/en/",
      "price_range": "299 - 369 (根据季节)",
      "currency": "DKK",
      "description_en": "Large amusement and water park near Aalborg—family-friendly.",
      "price_range_en": "DKK 299–369 (by season)",
      "official_link_en": "https://www.faarupsommerland.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "乌特宗中心",
      "attractions_name_en": "Utzon Center",
      "description": "位于奥尔堡港口，由丹麦著名建筑师约恩·乌特宗（悉尼歌剧院设计者）设计，展示建筑和设计。",
      "official_link": "https://utzoncenter.dk/en/",
      "price_range": "100",
      "currency": "DKK",
      "description_en": "At Aalborg harbour—by Jørn Utzon (Sydney Opera House); architecture and design.",
      "price_range_en": "DKK 100",
      "official_link_en": "https://utzoncenter.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "奥尔堡",
      "cityname_en": "Aalborg",
      "attractions_name": "奥尔堡港口",
      "attractions_name_en": "Aalborg Havnefront (Waterfront)",
      "description": "现代化的港口区，有艺术、建筑和休闲空间。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Modern harbour area—art, architecture and leisure.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "罗斯基勒大教堂",
      "attractions_name_en": "Roskilde Cathedral",
      "description": "联合国教科文组织世界遗产，丹麦王室的陵寝，哥特式建筑。",
      "official_link": "https://roskildedomkirke.dk/",
      "price_range": "70",
      "currency": "DKK",
      "description_en": "UNESCO World Heritage—Danish royal burial church; Gothic.",
      "price_range_en": "DKK 70",
      "official_link_en": "https://roskildedomkirke.dk/"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "维京船博物馆",
      "attractions_name_en": "Viking Ship Museum",
      "description": "展示五艘保存完好的维京船遗骸，可了解维京历史和造船技术。",
      "official_link": "https://www.vikingeskibsmuseet.dk/en",
      "price_range": "160",
      "currency": "DKK",
      "description_en": "Five preserved Viking ship wrecks—Viking history and shipbuilding.",
      "price_range_en": "DKK 160",
      "official_link_en": "https://www.vikingeskibsmuseet.dk/en"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "罗斯基勒节日 (夏季)",
      "attractions_name_en": "Roskilde Festival",
      "description": "欧洲最大的音乐节之一，每年夏季在罗斯基勒举行。",
      "official_link": "https://www.roskilde-festival.dk/en/",
      "price_range": "2000 - 2500+ (全票)",
      "currency": "DKK",
      "description_en": "One of Europe's largest music festivals—every summer in Roskilde.",
      "price_range_en": "DKK 2000–2500+ (full ticket)",
      "official_link_en": "https://www.roskilde-festival.dk/en/"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "罗斯基勒宫",
      "attractions_name_en": "Roskilde Palace",
      "description": "曾是罗斯基勒主教的住所，现在是艺术展览和文化活动场所。",
      "official_link": "无官方购票链接，外部参观免费（部分展览收费）",
      "price_range": "免费（展览另计）",
      "currency": "DKK",
      "description_en": "Former bishop's residence—now art exhibitions and culture.",
      "price_range_en": "Free (exhibitions extra)",
      "official_link_en": "无官方购票链接，外部参观免费（部分展览收费）"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "丹麦体验中心",
      "attractions_name_en": "Ragnarock - Museum of Pop, Rock and Youth Culture",
      "description": "现代化的博物馆，以互动方式展示丹麦流行、摇滚和青年文化。",
      "official_link": "https://www.visitdenmark.com/denmark/plan-your-trip/denmarks-rock-museum-ragnarock-gdk912482",
      "price_range": "120",
      "currency": "DKK",
      "description_en": "Modern museum—Danish pop, rock and youth culture, interactive.",
      "price_range_en": "DKK 120",
      "official_link_en": "https://www.visitdenmark.com/denmark/plan-your-trip/denmarks-rock-museum-ragnarock-gdk912482"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "罗斯基勒市中心",
      "attractions_name_en": "Roskilde City Centre",
      "description": "历史悠久的市中心，有步行街、商店和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Historic centre—pedestrian streets, shops and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "罗斯基勒峡湾",
      "attractions_name_en": "Roskilde Fjord",
      "description": "美丽的峡湾，可进行划船、帆船等水上活动，或在岸边散步。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Beautiful fjord—boating, sailing or a stroll along the shore.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "圣劳伦斯教堂遗址",
      "attractions_name_en": "St. Laurentius Church Ruins",
      "description": "位于罗斯基勒市中心，是中世纪教堂的遗址。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "DKK",
      "description_en": "Medieval church ruins in the centre.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "利勒·维拉莫斯博物馆",
      "attractions_name_en": "Lützhøfts Købmandsgård (General Store)",
      "description": "罗斯基勒的一个历史商店，还原了1920年代的商店风貌。",
      "official_link": "https://xn--ltzhftskbmandsgrd-nrb36ae9e.dk/",
      "price_range": "免费（部分体验收费）",
      "currency": "DKK",
      "description_en": "Historic shop—recreated 1920s atmosphere.",
      "price_range_en": "Free (some experiences charge)",
      "official_link_en": "https://xn--ltzhftskbmandsgrd-nrb36ae9e.dk/"
    },
    {
      "id": "DK",
      "cityname": "罗斯基勒",
      "cityname_en": "Roskilde",
      "attractions_name": "罗斯基勒博物馆",
      "attractions_name_en": "Roskilde Museum",
      "description": "展示罗斯基勒地区的历史和考古发现。",
      "official_link": "https://www.vikingeskibsmuseet.dk/",
      "price_range": "60",
      "currency": "DKK",
      "description_en": "Roskilde's history and archaeology.",
      "price_range_en": "DKK 60",
      "official_link_en": "https://www.vikingeskibsmuseet.dk/"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "瓦萨沉船博物馆",
      "attractions_name_en": "Vasa Museum",
      "description": "世界上保存最完好的17世纪船只，从海底打捞上来并进行修复，令人惊叹。",
      "official_link": "https://www.vasamuseet.se/en",
      "price_range": "170",
      "currency": "SEK",
      "description_en": "World's best-preserved 17th-century ship—raised and restored; stunning.",
      "price_range_en": "SEK 170",
      "official_link_en": "https://www.vasamuseet.se/en"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "斯德哥尔摩老城 (Gamla Stan)",
      "attractions_name_en": "Gamla Stan (Old Town)",
      "description": "斯德哥尔摩的历史中心，狭窄的鹅卵石街道，色彩斑斓的房屋和皇家宫殿。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Stockholm's historic heart—narrow cobbled streets, colourful houses and the Royal Palace.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "斯德哥尔摩市政厅",
      "attractions_name_en": "Stockholm City Hall",
      "description": "每年诺贝尔奖晚宴的举办地，可参观金色大厅和蓝色大厅，并登塔俯瞰城市。",
      "official_link": "https://international.stockholm.se/city-hall/",
      "price_range": "140 (导览), 90 (登塔)",
      "currency": "SEK",
      "description_en": "Where the Nobel banquet is held—Golden Hall, Blue Hall and tower views.",
      "price_range_en": "SEK 140 (tour), SEK 90 (tower)",
      "official_link_en": "https://international.stockholm.se/city-hall/"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "皇家宫殿",
      "attractions_name_en": "Royal Palace",
      "description": "瑞典国王的官方住所，欧洲最大的宫殿之一，可观看卫兵换岗仪式。",
      "official_link": "https://www.kungligaslotten.se/english/royal-palaces-and-sites/the-royal-palace.html",
      "price_range": "180 (入内参观)",
      "currency": "SEK",
      "description_en": "Swedish King's official residence—one of Europe's largest palaces; changing of the guard.",
      "price_range_en": "SEK 180 (interior)",
      "official_link_en": "https://www.kungligaslotten.se/english/royal-palaces-and-sites/the-royal-palace.html"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "斯堪森博物馆",
      "attractions_name_en": "Skansen Open-Air Museum",
      "description": "世界上第一个露天博物馆，展示瑞典各地的传统建筑、动物和文化。",
      "official_link": "https://skansen.se/en/",
      "price_range": "160 - 240 (根据季节)",
      "currency": "SEK",
      "description_en": "World's first open-air museum—traditional buildings, animals and Swedish culture.",
      "price_range_en": "SEK 160–240 (by season)",
      "official_link_en": "https://skansen.se/en/"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "沉船博物馆 (阿巴博物馆)",
      "attractions_name_en": "ABBA The Museum",
      "description": "互动式博物馆，专门纪念瑞典著名流行乐队ABBA。",
      "official_link": "https://abbathemuseum.com/",
      "price_range": "295",
      "currency": "SEK",
      "description_en": "Interactive museum dedicated to ABBA.",
      "price_range_en": "SEK 295",
      "official_link_en": "https://abbathemuseum.com/"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "斯德哥尔摩大教堂",
      "attractions_name_en": "Stortorget (Old Town Square)",
      "description": "斯德哥尔摩老城的主广场，周围是历史建筑和著名的老城咖啡馆。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Main church in the old town—historic buildings and famous cafés nearby.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "皇后岛宫",
      "attractions_name_en": "Drottningholm Palace",
      "description": "联合国教科文组织世界遗产，瑞典皇室的私人住所，有中国宫殿和剧院。",
      "official_link": "https://www.kungligaslotten.se/english/royal-palaces-and-sites/drottningholm-palace.html",
      "price_range": "140 (宫殿), 140 (中国宫殿)",
      "currency": "SEK",
      "description_en": "UNESCO World Heritage—royal private residence; Chinese Pavilion and theatre.",
      "price_range_en": "SEK 140 (palace), SEK 140 (Chinese Pavilion)",
      "official_link_en": "https://www.kungligaslotten.se/english/royal-palaces-and-sites/drottningholm-palace.html"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "诺贝尔博物馆",
      "attractions_name_en": "Nobel Museum",
      "description": "位于老城，展示诺贝尔奖的历史、获奖者及其成就。",
      "official_link": "https://www.nobelprizemuseum.se/",
      "price_range": "140",
      "currency": "SEK",
      "description_en": "In the old town—Nobel Prize history, laureates and achievements.",
      "price_range_en": "SEK 140",
      "official_link_en": "https://www.nobelprizemuseum.se/"
    },
    {
      "id": "SE",
      "cityname": "斯德哥尔摩",
      "cityname_en": "Stockholm",
      "attractions_name": "地铁站艺术",
      "attractions_name_en": "Stockholm Metro Art",
      "description": "斯德哥尔摩地铁被称为“世界上最长的艺术画廊”，许多地铁站都有独特的艺术装置。",
      "official_link": "无官方购票链接，使用交通卡可免费参观",
      "price_range": "交通费另计",
      "currency": "SEK",
      "description_en": "\"World's longest art gallery\"—many stations have unique art.",
      "price_range_en": "Transport fare extra",
      "official_link_en": "无官方购票链接，使用交通卡可免费参观"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "里瑟本游乐园",
      "attractions_name_en": "Liseberg Amusement Park",
      "description": "斯堪的纳维亚最大的游乐园，有各种游乐设施、花园和音乐会。",
      "official_link": "https://www.liseberg.se/en/",
      "price_range": "125 - 195 (仅入场，游乐设施另计)",
      "currency": "SEK",
      "description_en": "Scandinavia's largest amusement park—rides, gardens and concerts.",
      "price_range_en": "SEK 125–195 (entry; rides extra)",
      "official_link_en": "https://www.liseberg.se/en/"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "哥德堡歌剧院",
      "attractions_name_en": "Gothenburg Opera",
      "description": "哥德堡的标志性现代建筑，位于港口，可观看演出。",
      "official_link": "https://opera.se/en/",
      "price_range": "演出票价另计",
      "currency": "SEK",
      "description_en": "Göteborg's iconic modern building by the harbour—catch a performance.",
      "price_range_en": "Performance tickets extra",
      "official_link_en": "https://opera.se/en/"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "鱼教堂",
      "attractions_name_en": "Feskekôrka (Fish Church)",
      "description": "独特的室内鱼市场，建筑外形像一座教堂。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "SEK",
      "description_en": "Unique indoor fish market—building shaped like a church.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "哥德堡艺术博物馆",
      "attractions_name_en": "Gothenburg Museum of Art",
      "description": "收藏了北欧和国际艺术作品，包括伦勃朗、莫奈和毕加索。",
      "official_link": "https://goteborgskonstmuseum.se/en/",
      "price_range": "60",
      "currency": "SEK",
      "description_en": "Nordic and international art—Rembrandt, Monet, Picasso and more.",
      "price_range_en": "SEK 60",
      "official_link_en": "https://goteborgskonstmuseum.se/en/"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "宇航中心",
      "attractions_name_en": "Universeum",
      "description": "大型科学中心，有热带雨林、水族馆和各种互动展览。",
      "official_link": "https://www.universeum.se/en/",
      "price_range": "295 - 345",
      "currency": "SEK",
      "description_en": "Large science centre—rainforest, aquarium and interactive exhibits.",
      "price_range_en": "SEK 295–345",
      "official_link_en": "https://www.universeum.se/en/"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "哈加区",
      "attractions_name_en": "Haga District",
      "description": "哥德堡最古老的工人区之一，有独特的木制房屋、咖啡馆和精品店。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮消费另计）",
      "currency": "SEK",
      "description_en": "One of Göteborg's oldest working-class districts—wooden houses, cafés and boutiques.",
      "price_range_en": "Free (food/drink extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "哥德堡植物园",
      "attractions_name_en": "Gothenburg Botanical Garden",
      "description": "瑞典最大的植物园之一，有各种植物收藏和美丽的景观。",
      "official_link": "无需购票",
      "price_range": "免费（部分区域收费）",
      "currency": "SEK",
      "description_en": "One of Sweden's largest botanical gardens—plant collections and lovely grounds.",
      "price_range_en": "Free (some areas charge)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "哥德堡市政厅",
      "attractions_name_en": "Gothenburg City Hall",
      "description": "由埃里克·贡纳尔·阿斯普朗德设计的现代主义建筑杰作。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Modernist masterpiece by Erik Gunnar Asplund.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "哥德堡群岛",
      "attractions_name_en": "Gothenburg Archipelago",
      "description": "沿着哥德堡海岸线分布的风景优美的群岛，可乘坐渡轮游览。",
      "official_link": "渡轮公司提供购票，无官方统一链接",
      "price_range": "渡轮票价另计",
      "currency": "SEK",
      "description_en": "Scenic archipelago along the coast—explore by ferry.",
      "price_range_en": "Ferry fare extra",
      "official_link_en": "渡轮公司提供购票，无官方统一链接"
    },
    {
      "id": "SE",
      "cityname": "哥德堡",
      "cityname_en": "Gothenburg",
      "attractions_name": "海事博物馆和水族馆",
      "attractions_name_en": "Maritiman (Maritime Museum)",
      "description": "世界上最大的浮动船舶博物馆，有潜艇、驱逐舰等真实船只。",
      "official_link": "https://maritiman.se/en/",
      "price_range": "145",
      "currency": "SEK",
      "description_en": "World's largest floating ship museum—submarine, destroyer and more.",
      "price_range_en": "SEK 145",
      "official_link_en": "https://maritiman.se/en/"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "马尔默城堡",
      "attractions_name_en": "Malmö Castle (Malmöhus Castle)",
      "description": "斯堪的纳维亚最古老的文艺复兴城堡之一，内有博物馆。",
      "official_link": "不支持线上购票",
      "price_range": "80",
      "currency": "SEK",
      "description_en": "One of Scandinavia's oldest Renaissance castles—museums inside.",
      "price_range_en": "SEK 80",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "特纳里索旋转中心",
      "attractions_name_en": "Turning Torso",
      "description": "瑞典最高的建筑，独特的扭曲形状，由圣地亚哥·卡拉特拉瓦设计。",
      "official_link": "无官方购票链接，外部参观免费（住宅楼不可入内）",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Sweden's tallest building—twisted shape by Santiago Calatrava.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费（住宅楼不可入内）"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "老城广场",
      "attractions_name_en": "Stortorget (Main Square)",
      "description": "马尔默的老城主广场，周围是历史建筑和市政厅。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Main square in the old town—historic buildings and town hall.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "小广场",
      "attractions_name_en": "Lilla Torg",
      "description": "马尔默最美丽的广场之一，有色彩斑斓的半木结构房屋和户外餐厅。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费（餐饮消费另计）",
      "currency": "SEK",
      "description_en": "One of Malmö's prettiest squares—colourful half-timbered houses and outdoor dining.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "圣彼得教堂",
      "attractions_name_en": "St. Peter's Church (Sankt Petri Kyrka)",
      "description": "马尔默最古老的建筑，哥特式教堂，内部有精美的壁画。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Malmö's oldest building—Gothic church with fine frescoes.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "科技与海事博物馆",
      "attractions_name_en": "Technology and Maritime Museum",
      "description": "位于马尔默城堡内，展示科技、自然历史和海事发展。",
      "official_link": "包含在马尔默城堡门票内",
      "price_range": "包含在马尔默城堡门票内",
      "currency": "SEK",
      "description_en": "Inside Malmö Castle—technology, natural history and maritime.",
      "price_range_en": "Included in castle ticket",
      "official_link_en": "包含在马尔默城堡门票内"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "库努比公园",
      "attractions_name_en": "Kungsparken",
      "description": "马尔默最古老的公园，有河流、桥梁和植物。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Malmö's oldest park—river, bridges and plants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "马尔默歌剧院",
      "attractions_name_en": "Malmö Opera",
      "description": "重要的文化场所，可观看歌剧、音乐剧和音乐会。",
      "official_link": "https://www.malmoopera.se/",
      "price_range": "演出票价另计",
      "currency": "SEK",
      "description_en": "Key venue—opera, musicals and concerts.",
      "price_range_en": "Performance tickets extra",
      "official_link_en": "https://www.malmoopera.se/"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "马尔默现代艺术博物馆",
      "attractions_name_en": "Moderna Museet Malmö",
      "description": "斯德哥尔摩现代艺术博物馆的分馆，展示当代艺术。",
      "official_link": "https://www.modernamuseet.se/malmo/en/",
      "price_range": "免费（特展收费）",
      "currency": "SEK",
      "description_en": "Branch of Stockholm's Moderna—contemporary art.",
      "price_range_en": "Free (special exhibitions charge)",
      "official_link_en": "https://www.modernamuseet.se/malmo/en/"
    },
    {
      "id": "SE",
      "cityname": "马尔默",
      "cityname_en": "Malmö",
      "attractions_name": "厄勒松大桥",
      "attractions_name_en": "Øresund Bridge",
      "description": "连接瑞典马尔默和丹麦哥本哈根的跨海大桥，是工程奇迹。",
      "official_link": "无官方购票链接，可驾车或乘坐火车通过",
      "price_range": "过桥费另计",
      "currency": "SEK",
      "description_en": "Bridge linking Malmö and Copenhagen—engineering marvel.",
      "price_range_en": "Bridge toll extra",
      "official_link_en": "无官方购票链接，可驾车或乘坐火车通过"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "乌普萨拉大教堂",
      "attractions_name_en": "Uppsala Cathedral",
      "description": "斯堪的纳维亚最大的大教堂，哥特式建筑，埋葬着许多瑞典国王。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Scandinavia's largest cathedral—Gothic; many Swedish kings buried here.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "乌普萨拉城堡",
      "attractions_name_en": "Uppsala Castle",
      "description": "历史悠久的城堡，曾是瑞典皇室住所，现在是省长官邸和博物馆。",
      "official_link": "https://www.visituppsalaslott.se/",
      "price_range": "60 (部分区域)",
      "currency": "SEK",
      "description_en": "Historic castle—former royal residence; now governor's residence and museum.",
      "price_range_en": "SEK 60 (some areas)",
      "official_link_en": "https://www.visituppsalaslott.se/"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "乌普萨拉大学主楼",
      "attractions_name_en": "Uppsala University Main Building",
      "description": "瑞典最古老的大学的主楼，建筑宏伟，可参观。",
      "official_link": "无官方购票链接，外部参观免费（内部可能需预约）",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Main building of Sweden's oldest university—grand architecture.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费（内部可能需预约）"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "林奈花园",
      "attractions_name_en": "Linnaeus Garden",
      "description": "植物学家卡尔·林奈的故居和植物园，展示他的研究成果。",
      "official_link": "hhttps://linnaeusuppsala.com/",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Botanist Carl Linnaeus's house and garden—his work on display.",
      "price_range_en": "Free",
      "official_link_en": "hhttps://linnaeusuppsala.com/"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "老乌普萨拉",
      "attractions_name_en": "Gamla Uppsala",
      "description": "重要的维京时代遗址，有巨大的皇家墓葬土丘和博物馆。",
      "official_link": "https://raa.se/english/cultural-heritage/archaeology/gamla-uppsala/",
      "price_range": "100 (博物馆)",
      "currency": "SEK",
      "description_en": "Important Viking-age site—huge royal burial mounds and museum.",
      "price_range_en": "SEK 100 (museum)",
      "official_link_en": "https://raa.se/english/cultural-heritage/archaeology/gamla-uppsala/"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "乌普萨拉大学图书馆 (卡罗琳娜)",
      "attractions_name_en": "Carolina Rediviva (Uppsala University Library)",
      "description": "瑞典最大的图书馆，收藏有珍贵的手稿和书籍。",
      "official_link": "无官方购票链接，免费参观",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Sweden's largest library—precious manuscripts and books.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，免费参观"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "乌普萨拉历史博物馆",
      "attractions_name_en": "Uppsala University Museum Gustavianum",
      "description": "位于大学老楼内，收藏了大学历史、艺术和自然科学藏品。",
      "official_link": "https://www.uu.se/en/gustavianum",
      "price_range": "80",
      "currency": "SEK",
      "description_en": "In the old university building—university history, art and natural history.",
      "price_range_en": "SEK 80",
      "official_link_en": "https://www.uu.se/en/gustavianum"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "维丁加公园",
      "attractions_name_en": "Fyrishov Water Park",
      "description": "乌普萨拉的大型水上乐园和休闲中心，适合家庭。",
      "official_link": "https://fyrishov.se/en/",
      "price_range": "125 (成人，水上乐园)",
      "currency": "SEK",
      "description_en": "Large water park and leisure centre—family-friendly.",
      "price_range_en": "SEK 125 (adult, water park)",
      "official_link_en": "https://fyrishov.se/en/"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "乌普萨拉市公园",
      "attractions_name_en": "City Park (Stadsparken)",
      "description": "乌普萨拉市中心的公园，有儿童游乐区和休闲空间。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Park in the centre—playground and leisure.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "SE",
      "cityname": "乌普萨拉",
      "cityname_en": "Uppsala",
      "attractions_name": "乌普萨拉艺术博物馆",
      "attractions_name_en": "Uppsala Art Museum",
      "description": "位于乌普萨拉城堡内，展示瑞典和国际艺术。",
      "official_link": "包含在城堡门票内",
      "price_range": "包含在城堡门票内",
      "currency": "SEK",
      "description_en": "Inside Uppsala Castle—Swedish and international art.",
      "price_range_en": "Included in castle ticket",
      "official_link_en": "包含在城堡门票内"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛 (维斯比)",
      "cityname_en": "Gotland (Visby)",
      "attractions_name": "维斯比城墙",
      "attractions_name_en": "Visby City Wall",
      "description": "联合国教科文组织世界遗产，保存完好的中世纪城墙，环绕维斯比老城。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "UNESCO World Heritage—well-preserved medieval town wall around Visby.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛",
      "cityname_en": "Gotland",
      "attractions_name": "维斯比老城",
      "attractions_name_en": "Visby Old Town",
      "description": "联合国教科文组织世界遗产，狭窄的鹅卵石街道，玫瑰盛开的季节尤为美丽。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "UNESCO World Heritage—cobbled streets; especially beautiful when the roses bloom.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛",
      "cityname_en": "Gotland",
      "attractions_name": "维斯比大教堂",
      "attractions_name_en": "Visby Cathedral (St. Mary's Church)",
      "description": "维斯比的地标，曾是德国教堂，现在是教区教堂。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Visby's landmark—former German church, now parish church.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛",
      "cityname_en": "Gotland",
      "attractions_name": "哥特兰博物馆",
      "attractions_name_en": "Gotland Museum",
      "description": "深入了解哥特兰岛的历史、考古和艺术，包括维京宝藏。",
      "official_link": "https://gotlandsmuseum.se/en/",
      "price_range": "150",
      "currency": "SEK",
      "description_en": "Gotland's history, archaeology and art—including Viking treasure.",
      "price_range_en": "SEK 150",
      "official_link_en": "https://gotlandsmuseum.se/en/"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛",
      "cityname_en": "Gotland",
      "attractions_name": "圣卡琳教堂遗址",
      "attractions_name_en": "St. Karin's Ruin",
      "description": "维斯比老城内保存较好的中世纪教堂遗址，具有独特的美感。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Well-preserved medieval church ruins in Visby—striking.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛",
      "cityname_en": "Gotland",
      "attractions_name": "弗洛尔霍姆自然保护区",
      "attractions_name_en": "Fårö Island & Nature Reserve",
      "description": "位于哥特兰岛北部的小岛，以其独特的“裸石”（Raukar）和自然风光闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（渡轮费另计）",
      "currency": "SEK",
      "description_en": "Island north of Gotland—famous for \"raukar\" limestone stacks and nature.",
      "price_range_en": "Free (ferry extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛",
      "cityname_en": "Gotland",
      "attractions_name": "尼斯的维京村",
      "attractions_name_en": "Viking Village in Tofta",
      "description": "重建的维京村庄，展示维京时代的生活方式和手工艺。",
      "official_link": "https://www.visitnordic.com/en/nordic-vikings",
      "price_range": "100 - 120",
      "currency": "SEK",
      "description_en": "Reconstructed Viking village—Viking-era life and crafts.",
      "price_range_en": "SEK 100–120",
      "official_link_en": "https://www.visitnordic.com/en/nordic-vikings"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛",
      "cityname_en": "Gotland",
      "attractions_name": "博格维克渔村",
      "attractions_name_en": "Blå Lagunen (Blue Lagoon)",
      "description": "哥特兰岛的一个美丽湖泊，夏季可游泳，被称为“蓝泻湖”。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Beautiful lake on Gotland—swimming in summer; nicknamed \"Blue Lagoon\".",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛",
      "cityname_en": "Gotland",
      "attractions_name": "科斯特霍尔姆城堡遗址",
      "attractions_name_en": "Korsbetningen & Castle Ruins",
      "description": "维斯比外围的古战场遗址和城堡废墟。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "Historic battlefield and castle ruins near Visby.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SE",
      "cityname": "哥特兰岛",
      "cityname_en": "Gotland",
      "attractions_name": "戈鲁登海滩",
      "attractions_name_en": "Tofta Beach / Sudersand Beach",
      "description": "哥特兰岛上最受欢迎的海滩之一，夏季是日光浴和游泳的好去处。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "SEK",
      "description_en": "One of Gotland's most popular beaches—sunbathing and swimming in summer.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "赫尔辛基大教堂",
      "attractions_name_en": "Helsinki Cathedral",
      "description": "赫尔辛基的标志性建筑，新古典主义风格的白色教堂，位于参议院广场。",
      "official_link": "https://helsingintuomiokirkko.fi/en/",
      "price_range": "免费（登塔/导览可能收费）",
      "currency": "EUR",
      "description_en": "Helsinki's icon—neoclassical white church on Senate Square.",
      "price_range_en": "Free (tower/tour may charge)",
      "official_link_en": "https://helsingintuomiokirkko.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "芬兰堡",
      "attractions_name_en": "Suomenlinna Sea Fortress",
      "description": "联合国教科文组织世界遗产，由岛屿组成的海上要塞，有博物馆、隧道和美丽的海景。",
      "official_link": "https://www.suomenlinna.fi/en/",
      "price_range": "免费（渡轮费另计，博物馆收费）",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—island fortress; museums, tunnels and sea views.",
      "price_range_en": "Free (ferry extra; museums charge)",
      "official_link_en": "https://www.suomenlinna.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "岩石教堂",
      "attractions_name_en": "Temppeliaukio Church (Rock Church)",
      "description": "独特的教堂，直接在岩石中建造，内部有极佳的声学效果。",
      "official_link": "https://www.temppeliaukionkirkko.fi/en/index/nimi.html",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "Unique church built into the rock—excellent acoustics.",
      "price_range_en": "€5",
      "official_link_en": "https://www.temppeliaukionkirkko.fi/en/index/nimi.html"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "市集广场",
      "attractions_name_en": "Market Square (Kauppatori)",
      "description": "位于赫尔辛基港口，有露天市场，出售新鲜食物、纪念品和手工艺品。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "At the harbour—open-air market for food, souvenirs and crafts.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "乌斯佩斯基大教堂",
      "attractions_name_en": "Uspenski Cathedral",
      "description": "东正教大教堂，红砖建筑，位于卡塔亚诺卡半岛，俯瞰城市。",
      "official_link": "无需购票",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Orthodox cathedral—red brick on Katajanokka; overlooks the city.",
      "price_range_en": "Free",
      "official_link_en": "No ticket required"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "阿黛浓艺术博物馆",
      "attractions_name_en": "Ateneum Art Museum",
      "description": "芬兰国家美术馆的一部分，收藏了芬兰艺术的经典之作。",
      "official_link": "https://ateneum.fi/en/",
      "price_range": "19 - 22 (根据展览)",
      "currency": "EUR",
      "description_en": "Part of the Finnish National Gallery—classic Finnish art.",
      "price_range_en": "€19–€22 (by exhibition)",
      "official_link_en": "https://ateneum.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "芬兰国家博物馆",
      "attractions_name_en": "National Museum of Finland",
      "description": "展示芬兰从石器时代至今的历史和文化。",
      "official_link": "https://www.kansallismuseo.fi/en/",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "Finnish history and culture from the Stone Age to the present.",
      "price_range_en": "€16",
      "official_link_en": "https://www.kansallismuseo.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "赫尔辛基中央车站",
      "attractions_name_en": "Helsinki Central Railway Station",
      "description": "著名的火车站建筑，由埃列尔·萨里宁设计，是赫尔辛基的地标。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Famous station by Eliel Saarinen—Helsinki landmark.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "西贝柳斯公园与纪念碑",
      "attractions_name_en": "Sibelius Park & Monument",
      "description": "纪念芬兰著名作曲家让·西贝柳斯的公园和独特雕塑。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Park and striking sculpture honouring Jean Sibelius.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "FI",
      "cityname": "赫尔辛基",
      "cityname_en": "Helsinki",
      "attractions_name": "伴侣岛",
      "attractions_name_en": "Seurasaari Open-Air Museum",
      "description": "露天博物馆，展示芬兰各地的传统木屋和生活方式，夏季有表演。",
      "official_link": "https://www.kansallismuseo.fi/en/seurasaarenulkomuseo",
      "price_range": "10 (博物馆)",
      "currency": "EUR",
      "description_en": "Open-air museum—traditional Finnish log buildings and life; summer performances.",
      "price_range_en": "€10 (museum)",
      "official_link_en": "https://www.kansallismuseo.fi/en/seurasaarenulkomuseo"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米 (拉普兰)",
      "cityname_en": "Rovaniemi (Lapland)",
      "attractions_name": "圣诞老人村",
      "attractions_name_en": "Santa Claus Village",
      "description": "圣诞老人的官方居所，可与圣诞老人见面、寄信，并跨越北极圈。",
      "official_link": "https://santaclausvillage.info/",
      "price_range": "免费（与圣诞老人合影/购物另计）",
      "currency": "EUR",
      "description_en": "Santa's official home—meet Santa, post letters, cross the Arctic Circle.",
      "price_range_en": "Free (photo/shopping extra)",
      "official_link_en": "https://santaclausvillage.info/"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米",
      "cityname_en": "Rovaniemi",
      "attractions_name": "北极中心",
      "attractions_name_en": "Arktikum Science Centre and Museum",
      "description": "了解北极地区自然、文化和历史的科学中心和博物馆。",
      "official_link": "https://www.arktikum.fi/en/",
      "price_range": "18",
      "currency": "EUR",
      "description_en": "Science centre and museum—Arctic nature, culture and history.",
      "price_range_en": "€18",
      "official_link_en": "https://www.arktikum.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米",
      "cityname_en": "Rovaniemi",
      "attractions_name": "圣诞老人公园",
      "attractions_name_en": "SantaPark",
      "description": "地下洞穴内的圣诞主题乐园，有精灵学校、姜饼厨房等。",
      "official_link": "https://santapark.com/",
      "price_range": "39 - 42 (根据季节)",
      "currency": "EUR",
      "description_en": "Underground Christmas theme park—elf school, gingerbread kitchen and more.",
      "price_range_en": "€39–€42 (by season)",
      "official_link_en": "https://santapark.com/"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米",
      "cityname_en": "Rovaniemi",
      "attractions_name": "驯鹿农场",
      "attractions_name_en": "Reindeer Farm Visit",
      "description": "体验拉普兰的传统驯鹿文化，可喂食驯鹿或乘坐驯鹿雪橇。",
      "official_link": "各农场有独立购票，无官方统一链接",
      "price_range": "50 - 100+ (根据活动)",
      "currency": "EUR",
      "description_en": "Traditional reindeer culture—feed reindeer or take a sleigh ride.",
      "price_range_en": "€50–€100+ (by activity)",
      "official_link_en": "各农场有独立购票，无官方统一链接"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米",
      "cityname_en": "Rovaniemi",
      "attractions_name": "哈士奇公园",
      "attractions_name_en": "Husky Park/Safari",
      "description": "体验雪橇犬的乐趣，可参观哈士奇犬舍或乘坐哈士奇雪橇。",
      "official_link": "各农场/公司有独立购票，无官方统一链接",
      "price_range": "80 - 200+ (根据活动)",
      "currency": "EUR",
      "description_en": "Husky experience—visit the kennels or take a husky sled ride.",
      "price_range_en": "€80–€200+ (by activity)",
      "official_link_en": "各农场/公司有独立购票，无官方统一链接"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米",
      "cityname_en": "Rovaniemi",
      "attractions_name": "罗瓦涅米教堂",
      "attractions_name_en": "Rovaniemi Church",
      "description": "罗瓦涅米的主要教堂，由阿尔瓦·阿尔托设计。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Rovaniemi's main church—designed by Alvar Aalto.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米",
      "cityname_en": "Rovaniemi",
      "attractions_name": "极光狩猎",
      "attractions_name_en": "Aurora Hunting Tour",
      "description": "乘坐巴士或雪地摩托前往远离光污染的地区，追寻北极光。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "80 - 150+ (根据时长和交通工具)",
      "currency": "EUR",
      "description_en": "Bus or snowmobile to dark skies—hunt the Northern Lights.",
      "price_range_en": "€80–€150+ (duration and transport)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米",
      "cityname_en": "Rovaniemi",
      "attractions_name": "兰努阿野生动物园",
      "attractions_name_en": "Ranua Wildlife Park",
      "description": "芬兰最北的动物园，居住着北极动物，如北极熊、驼鹿等。",
      "official_link": "https://www.ranuazoo.com/english/",
      "price_range": "25",
      "currency": "EUR",
      "description_en": "Finland's northernmost zoo—polar bears, moose and other Arctic animals.",
      "price_range_en": "€25",
      "official_link_en": "https://www.ranuazoo.com/english/"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米",
      "cityname_en": "Rovaniemi",
      "attractions_name": "奥纳斯瓦拉滑雪度假村",
      "attractions_name_en": "Ounasvaara Ski Resort",
      "description": "位于罗瓦涅米市中心附近，冬季可滑雪，夏季可进行户外活动。",
      "official_link": "https://ounasvaara.fi/en/",
      "price_range": "滑雪票价另计",
      "currency": "EUR",
      "description_en": "Near the centre—skiing in winter, outdoor activities in summer.",
      "price_range_en": "Ski pass extra",
      "official_link_en": "https://ounasvaara.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "罗瓦涅米",
      "cityname_en": "Rovaniemi",
      "attractions_name": "愤怒的小鸟公园",
      "attractions_name_en": "Angry Birds Park (Valtatie)",
      "description": "户外游乐场，以流行的愤怒的小鸟为主题，适合儿童。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Outdoor playground themed on Angry Birds—for kids.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "姆明博物馆",
      "attractions_name_en": "Moomin Museum",
      "description": "世界上唯一的姆明主题博物馆，展示朵贝·扬松的姆明故事和艺术。",
      "official_link": "https://muumimuseo.fi/en/",
      "price_range": "14",
      "currency": "EUR",
      "description_en": "World's only Moomin museum—Tove Jansson's Moomin stories and art.",
      "price_range_en": "€14",
      "official_link_en": "https://muumimuseo.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "坦佩雷大教堂",
      "attractions_name_en": "Tampere Cathedral",
      "description": "坦佩雷的主要教堂，国家浪漫主义风格，以其独特的壁画而闻名。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Tampere's main church—National Romantic style; famous frescoes.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "萨尔坎涅米游乐园",
      "attractions_name_en": "Särkänniemi Adventure Park",
      "description": "大型游乐园，包括游乐设施、水族馆、海豚馆和观景塔。",
      "official_link": "https://sarkanniemi.fi/en/",
      "price_range": "40 - 50 (全票)",
      "currency": "EUR",
      "description_en": "Large amusement park—rides, aquarium, dolphinarium and observation tower.",
      "price_range_en": "€40–€50 (full pass)",
      "official_link_en": "https://sarkanniemi.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "坦佩雷市场大厅",
      "attractions_name_en": "Tampere Market Hall",
      "description": "北欧美最大的室内市场大厅，有各种食物摊位和咖啡馆。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Nordic Europe's largest indoor market hall—food stalls and cafés.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "纳辛内乌拉观景塔",
      "attractions_name_en": "Näsinneula Observation Tower",
      "description": "萨尔坎涅米游乐园内的观景塔，可俯瞰坦佩雷和周边湖景。",
      "official_link": "包含在萨尔坎涅米门票内（或单独购买）",
      "price_range": "包含在萨尔坎涅米门票内",
      "currency": "EUR",
      "description_en": "Observation tower in Särkänniemi—views over Tampere and the lakes.",
      "price_range_en": "Included in Särkänniemi ticket",
      "official_link_en": "包含在萨尔坎涅米门票内（或单独购买）"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "坦佩雷艺术博物馆",
      "attractions_name_en": "Tampere Art Museum",
      "description": "收藏了芬兰和国际艺术品。",
      "official_link": "https://tampereentaidemuseo.fi/en/",
      "price_range": "上午/下午 00時00分00秒 ",
      "currency": "EUR",
      "description_en": "Finnish and international art.",
      "price_range_en": "Varies (check website)",
      "official_link_en": "https://tampereentaidemuseo.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "瓦普里基博物馆中心",
      "attractions_name_en": "Vapriikki Museum Centre",
      "description": "大型博物馆中心，包含多个博物馆，如芬兰冰球博物馆、自然历史博物馆等。",
      "official_link": "https://vapriikki.fi/en/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "Large museum centre—ice hockey museum, natural history and more.",
      "price_range_en": "€15",
      "official_link_en": "https://vapriikki.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "坦佩雷旧工厂区 (Finlayson Area)",
      "attractions_name_en": "Finlayson Area",
      "description": "历史悠久的工业区，现已改造为商店、餐厅、博物馆和电影院。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Historic factory area—now shops, restaurants, museums and cinema.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "琴卡萨里",
      "attractions_name_en": "Pyynikki Ridge & Observation Tower",
      "description": "坦佩雷市中心附近的自然高地，有观景塔，可俯瞰湖景，并品尝甜甜圈。",
      "official_link": "登塔约2 (或免费)",
      "price_range": "免费（登塔/甜甜圈另计）",
      "currency": "EUR",
      "description_en": "Natural ridge near the centre—observation tower, lake views and doughnuts.",
      "price_range_en": "Free (tower/doughnuts extra)",
      "official_link_en": "登塔约2 (或免费)"
    },
    {
      "id": "FI",
      "cityname": "坦佩雷",
      "cityname_en": "Tampere",
      "attractions_name": "坦佩雷市中心",
      "attractions_name_en": "Tampere City Centre",
      "description": "探索坦佩雷的购物街、咖啡馆和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Explore Tampere's shopping streets, cafés and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "图尔库城堡",
      "attractions_name_en": "Turku Castle",
      "description": "芬兰最古老的建筑之一，历史悠久的城堡，内有博物馆。",
      "official_link": "https://www.turunmuseokeskus.fi/en/turku-castle",
      "price_range": "16",
      "currency": "EUR",
      "description_en": "One of Finland's oldest buildings—historic castle with museum.",
      "price_range_en": "€16",
      "official_link_en": "https://www.turunmuseokeskus.fi/en/turku-castle"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "图尔库大教堂",
      "attractions_name_en": "Turku Cathedral",
      "description": "芬兰最重要的宗教建筑，历史悠久，是芬兰的国宝级教堂。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Finland's most important religious building—national treasure.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "奥拉河畔",
      "attractions_name_en": "Aura Riverfront",
      "description": "沿着奥拉河畔散步，欣赏历史建筑、船只和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Stroll along the Aura River—historic buildings, boats and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "瓦里奥纳河口博物馆",
      "attractions_name_en": "Aboa Vetus & Ars Nova",
      "description": "独特的博物馆，结合了考古遗址和现代艺术展览。",
      "official_link": "https://avan.fi/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "Unique museum—archaeological site and modern art.",
      "price_range_en": "€15",
      "official_link_en": "https://avan.fi/"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "图尔库露天博物馆 (卢奥斯塔尔迈基)",
      "attractions_name_en": "Luostarinmäki Handicrafts Museum",
      "description": "露天博物馆，展示19世纪图尔库的手工业和生活方式。",
      "official_link": "https://luostarinmaki.fi/en/the-museum/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Open-air museum—19th-century Turku crafts and life.",
      "price_range_en": "€10",
      "official_link_en": "https://luostarinmaki.fi/en/the-museum/"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "芬兰手工艺术博物馆",
      "attractions_name_en": "Craft Museum of Finland",
      "description": "展示芬兰手工艺和纺织品的历史和发展。",
      "official_link": "https://www.craftmuseum.fi/en/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Finnish handicrafts and textiles—history and development.",
      "price_range_en": "€10",
      "official_link_en": "https://www.craftmuseum.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "图尔库市场大厅",
      "attractions_name_en": "Turku Market Hall",
      "description": "历史悠久的室内市场大厅，有各种当地美食和特产。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Historic indoor market hall—local food and produce.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "药学博物馆和吉尔之家",
      "attractions_name_en": "Pharmacy Museum and Qwensel House",
      "description": "芬兰最古老的木制房屋之一，展示18世纪的药房和生活。",
      "official_link": "https://www.visitfinland.com/en/product/643a31ad-8d6c-4a7d-9e5d-ba81f989fe94/pharmacy-museum-the-qwensel-house/",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "One of Finland's oldest wooden houses—18th-century pharmacy and life.",
      "price_range_en": "€8",
      "official_link_en": "https://www.visitfinland.com/en/product/643a31ad-8d6c-4a7d-9e5d-ba81f989fe94/pharmacy-museum-the-qwensel-house/"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "图尔库艺术博物馆",
      "attractions_name_en": "Turku Art Museum",
      "description": "收藏了芬兰和国际艺术品，以芬兰黄金时代艺术为主。",
      "official_link": "https://turuntaidemuseo.fi/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Finnish and international art—strong on Finnish Golden Age.",
      "price_range_en": "€12",
      "official_link_en": "https://turuntaidemuseo.fi/en/"
    },
    {
      "id": "FI",
      "cityname": "图尔库",
      "cityname_en": "Turku",
      "attractions_name": "大广场",
      "attractions_name_en": "Old Great Square (Vanha Suurtori)",
      "description": "图尔库的历史中心，有老市政厅和各种文化活动。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Turku's historic centre—old town hall and cultural events.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛 (玛丽港)",
      "cityname_en": "Åland Islands (Mariehamn)",
      "attractions_name": "庞培三桅帆船",
      "attractions_name_en": "Pommern",
      "description": "停泊在玛丽港的四桅帆船，是世界上仅存的帆船之一，现为博物馆。",
      "official_link": "https://sjofartsmuseum.ax/en/pommern/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Four-masted ship in Mariehamn—one of the world's last; now a museum.",
      "price_range_en": "€12",
      "official_link_en": "https://sjofartsmuseum.ax/en/pommern/"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛",
      "cityname_en": "Åland Islands",
      "attractions_name": "斯蒂哥斯堡城堡遗址",
      "attractions_name_en": "Kastelholm Castle",
      "description": "历史悠久的城堡遗址，曾是瑞典王室的住所，位于奥兰群岛。",
      "official_link": "https://www.aland.travel/kastelholm-en",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Historic castle ruins—former Swedish royal residence; in the Åland Islands.",
      "price_range_en": "€8",
      "official_link_en": "https://www.aland.travel/kastelholm-en"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛",
      "cityname_en": "Åland Islands",
      "attractions_name": "奥兰海事博物馆",
      "attractions_name_en": "Åland Maritime Museum",
      "description": "展示奥兰群岛的海事历史和文化，被认为是世界上最好的海事博物馆之一。",
      "official_link": "https://sjofartsmuseum.ax/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Åland's maritime history and culture—one of the world's best maritime museums.",
      "price_range_en": "€12",
      "official_link_en": "https://sjofartsmuseum.ax/en/"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛",
      "cityname_en": "Åland Islands",
      "attractions_name": "奥兰博物馆",
      "attractions_name_en": "Åland Museum",
      "description": "展示奥兰群岛的历史、考古和自然。",
      "official_link": "hhttps://www.museum.ax/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Åland's history, archaeology and nature.",
      "price_range_en": "€10",
      "official_link_en": "hhttps://www.museum.ax/"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛",
      "cityname_en": "Åland Islands",
      "attractions_name": "雅各布斯教堂",
      "attractions_name_en": "Jomala Church",
      "description": "芬兰最古老的石教堂之一，历史悠久，建筑精美。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Finland's oldest stone churches—fine architecture.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛",
      "cityname_en": "Åland Islands",
      "attractions_name": "萨尔特维克教堂",
      "attractions_name_en": "Saltvik Church",
      "description": "另一座古老的教堂，位于奥兰群岛，具有历史意义。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Another ancient church in Åland—historic.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛",
      "cityname_en": "Åland Islands",
      "attractions_name": "博克霍尔姆岛",
      "attractions_name_en": "Båtskär Islet",
      "description": "奥兰群岛中的小岛，以其独特的红色岩石和海景而闻名。",
      "official_link": "渡轮前往，无官方购票链接",
      "price_range": "免费（渡轮费另计）",
      "currency": "EUR",
      "description_en": "Island in Åland—famous for red rocks and sea views.",
      "price_range_en": "Free (ferry extra)",
      "official_link_en": "渡轮前往，无官方购票链接"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛",
      "cityname_en": "Åland Islands",
      "attractions_name": "格兰霍尔姆露天博物馆",
      "attractions_name_en": "Jan Karlsgården Open-Air Museum",
      "description": "位于卡斯特霍尔姆城堡附近，展示奥兰的传统农场和生活方式。",
      "official_link": "无需购票",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Near Kastelholm Castle—traditional Åland farm life.",
      "price_range_en": "Free",
      "official_link_en": "No ticket required"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛",
      "cityname_en": "Åland Islands",
      "attractions_name": "哥特兰岛的海岸线",
      "attractions_name_en": "Åland Archipelago Coastline",
      "description": "探索奥兰群岛独特的海岸线，有许多小岛、海湾和渔村。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Explore Åland's coastline—islets, bays and fishing villages.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "FI",
      "cityname": "奥兰群岛",
      "cityname_en": "Åland Islands",
      "attractions_name": "玛丽港市中心",
      "attractions_name_en": "Mariehamn City Centre",
      "description": "奥兰群岛的首府，有商店、餐厅和海滨风光。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Capital of Åland—shops, restaurants and harbour.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "大广场",
      "attractions_name_en": "Grand Place",
      "description": "联合国教科文组织世界遗产，布鲁塞尔的心脏，被华丽的行会建筑和市政厅环绕。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—Brussels' heart; guild houses and town hall.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "撒尿小童",
      "attractions_name_en": "Manneken Pis",
      "description": "布鲁塞尔的标志性雕塑，一个正在撒尿的小男孩，常穿着各种服装。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Brussels' icon—little boy statue; often dressed in costumes.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "原子塔",
      "attractions_name_en": "Atomium",
      "description": "布鲁塞尔的标志，由九个不锈钢球组成，代表铁的晶体结构，可登顶观景。",
      "official_link": "https://atomium.be/",
      "price_range": "18",
      "currency": "EUR",
      "description_en": "Brussels' landmark—nine steel spheres (iron crystal); climb for views.",
      "price_range_en": "€18",
      "official_link_en": "https://atomium.be/"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "圣米歇尔和圣古都勒大教堂",
      "attractions_name_en": "Cathedral of St. Michael and St. Gudula",
      "description": "布鲁塞尔重要的哥特式大教堂，拥有精美的彩色玻璃和雕塑。",
      "official_link": "无门票，免费参观（部分区域或展览可能收费）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Brussels' main Gothic cathedral—fine stained glass and sculpture.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（部分区域或展览可能收费）"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "皇家美术博物馆群",
      "attractions_name_en": "Royal Museums of Fine Arts of Belgium",
      "description": "包含古代艺术博物馆、现代艺术博物馆等，收藏了大量比利时和国际艺术珍品。",
      "official_link": "https://www.fine-arts-museum.be/en",
      "price_range": "15 (永久藏品)",
      "currency": "EUR",
      "description_en": "Ancient and modern art museums—Belgian and international masterpieces.",
      "price_range_en": "€15 (permanent)",
      "official_link_en": "https://www.fine-arts-museum.be/en"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "漫画博物馆 (比利时漫画艺术中心)",
      "attractions_name_en": "Belgian Comic Strip Centre",
      "description": "位于一座精美的Art Nouveau建筑内，展示比利时漫画的历史和著名角色。",
      "official_link": "https://www.comicscenter.net/en/home",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "In a fine Art Nouveau building—Belgian comics history and famous characters.",
      "price_range_en": "€12",
      "official_link_en": "https://www.comicscenter.net/en/home"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "欧盟委员会 (欧洲议会游客中心)",
      "attractions_name_en": "European Parliament Parlamentarium",
      "description": "互动式展览，了解欧洲议会的运作、欧洲历史和欧盟政策。",
      "official_link": "https://www.europarl.europa.eu/visiting/en/parlamentarium",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Interactive exhibition—how the European Parliament works, EU history and policy.",
      "price_range_en": "Free",
      "official_link_en": "https://www.europarl.europa.eu/visiting/en/parlamentarium"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "小尿女和撒尿狗 (Jeanneke Pis & Zinneke Pis)",
      "attractions_name_en": "Jeanneke Pis & Zinneke Pis",
      "description": "撒尿小童的女性版本和狗狗版本，位于布鲁塞尔的不同角落。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Female and dog versions of Manneken Pis—in different corners of Brussels.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "皇家圣休伯特长廊",
      "attractions_name_en": "Galeries Royales Saint-Hubert",
      "description": "欧洲最古老的购物长廊之一，有商店、餐厅和巧克力店，华丽而优雅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "One of Europe's oldest shopping arcades—shops, restaurants and chocolate; elegant.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "布鲁塞尔",
      "cityname_en": "Brussels",
      "attractions_name": "布鲁塞尔公园",
      "attractions_name_en": "Parc de Bruxelles (Warandepark)",
      "description": "布鲁塞尔市中心最大的公园，位于皇宫对面，是休闲放松的好地方。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Brussels' largest central park—opposite the palace; relax and unwind.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "布鲁日钟楼",
      "attractions_name_en": "Belfry of Bruges",
      "description": "联合国教科文组织世界遗产，布鲁日的标志，可登顶俯瞰城市全景。",
      "official_link": "https://www.museabrugge.be/en/visit-our-museums/our-museums-and-monuments/belfort",
      "price_range": "14",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—Bruges' icon; climb for city views.",
      "price_range_en": "€14",
      "official_link_en": "https://www.museabrugge.be/en/visit-our-museums/our-museums-and-monuments/belfort"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "市集广场 (Grote Markt)",
      "attractions_name_en": "Market Square (Grote Markt)",
      "description": "布鲁日的心脏，被历史建筑、餐厅和咖啡馆环绕，有钟楼和省议会。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Bruges' heart—historic buildings, restaurants and cafés; belfry and provincial court.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "圣血教堂",
      "attractions_name_en": "Basilica of the Holy Blood",
      "description": "独特的教堂，内有据说收集了基督圣血的遗物。",
      "official_link": "无门票，免费参观（珍宝室可能收费）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Unique church—relic said to contain Christ's Holy Blood.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（珍宝室可能收费）"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "运河游船",
      "attractions_name_en": "Bruges Canal Tour",
      "description": "乘坐游船穿梭于布鲁日的运河之中，是欣赏“北方威尼斯”的最佳方式。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "12～15 ",
      "currency": "EUR",
      "description_en": "Boat trip along Bruges' canals—best way to see \"Venice of the North\".",
      "price_range_en": "€12–€15",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "圣母教堂",
      "attractions_name_en": "Church of Our Lady Bruges",
      "description": "收藏了米开朗基罗的《圣母与子》雕塑，以及布鲁日重要的艺术品。",
      "official_link": "https://www.visitbruges.be/en/things-to-do/culture-and-heritage/olv-kerk-museum-museum-church-our-lady",
      "price_range": "7",
      "currency": "EUR",
      "description_en": "Houses Michelangelo's Madonna and Child—and other Bruges art.",
      "price_range_en": "€7",
      "official_link_en": "https://www.visitbruges.be/en/things-to-do/culture-and-heritage/olv-kerk-museum-museum-church-our-lady"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "贝居安会院",
      "attractions_name_en": "Beguinage (Begijnhof)",
      "description": "联合国教科文组织世界遗产，宁静的院落，曾是贝居安会女修道士居住的地方。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—peaceful courtyard; former Beguine convent.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "啤酒博物馆",
      "attractions_name_en": "Bruges Beer Experience",
      "description": "互动式博物馆，了解比利时啤酒的历史、酿造过程和品鉴。",
      "official_link": "https://mybeerexperience.com/",
      "price_range": "14",
      "currency": "EUR",
      "description_en": "Interactive museum—Belgian beer history, brewing and tasting.",
      "price_range_en": "€14",
      "official_link_en": "https://mybeerexperience.com/"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "巧克力博物馆",
      "attractions_name_en": "Choco-Story (The Chocolate Museum)",
      "description": "了解巧克力的历史、制作过程，并品尝各种巧克力。",
      "official_link": "https://choco-story-brugge.be/en/",
      "price_range": "12.5",
      "currency": "EUR",
      "description_en": "Chocolate history, making and tasting.",
      "price_range_en": "€12.50",
      "official_link_en": "https://choco-story-brugge.be/en/"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "弗拉芒原始艺术博物馆",
      "attractions_name_en": "Groeninge Museum",
      "description": "收藏了弗拉芒原始艺术和文艺复兴时期的绘画作品。",
      "official_link": "https://www.museabrugge.be/en/visit-our-museums/our-museums-and-monuments/groeningemuseum",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "Flemish Primitives and Renaissance paintings.",
      "price_range_en": "€15",
      "official_link_en": "https://www.museabrugge.be/en/visit-our-museums/our-museums-and-monuments/groeningemuseum"
    },
    {
      "id": "BE",
      "cityname": "布鲁日",
      "cityname_en": "Bruges",
      "attractions_name": "爱之湖公园",
      "attractions_name_en": "Minnewater Park (Lake of Love)",
      "description": "宁静的公园和湖泊，传说情侣在此散步会拥有永恒的爱情。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Peaceful park and lake—legend says couples who walk here find eternal love.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "圣巴夫主教座堂",
      "attractions_name_en": "Saint Bavo's Cathedral",
      "description": "宏伟的哥特式大教堂，收藏了世界名画《根特祭坛画》。",
      "official_link": "无门票，免费参观（《根特祭坛画》需额外购票）",
      "price_range": "免费（《根特祭坛画》12.50）",
      "currency": "EUR",
      "description_en": "Grand Gothic cathedral—houses the world-famous Ghent Altarpiece.",
      "price_range_en": "Free (Ghent Altarpiece €12.50)",
      "official_link_en": "无门票，免费参观（《根特祭坛画》需额外购票）"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "伯爵城堡",
      "attractions_name_en": "Gravensteen Castle",
      "description": "雄伟的中世纪城堡，保存完好，可登顶俯瞰根特。",
      "official_link": "https://gravensteen.stad.gent/en",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Imposing medieval castle—well preserved; climb for views over Ghent.",
      "price_range_en": "€12",
      "official_link_en": "https://gravensteen.stad.gent/en"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "根特钟楼",
      "attractions_name_en": "Ghent Belfry",
      "description": "联合国教科文组织世界遗产，可登顶俯瞰根特全景。",
      "official_link": "https://visit.gent.be/en/see-do/ghent-belfry-world-heritage",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—climb for panoramic views of Ghent.",
      "price_range_en": "€10",
      "official_link_en": "https://visit.gent.be/en/see-do/ghent-belfry-world-heritage"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "香草河岸和香草广场",
      "attractions_name_en": "Graslei and Korenlei",
      "description": "根特最美的河岸景色，两旁是历史悠久的行会房屋和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮消费另计）",
      "currency": "EUR",
      "description_en": "Ghent's prettiest waterfront—historic guild houses and restaurants.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "圣尼古拉斯教堂",
      "attractions_name_en": "Saint Nicholas' Church",
      "description": "根特最古老的教堂之一，位于市中心，是典型的斯海尔德哥特式建筑。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Ghent's oldest churches—typical Scheldt Gothic.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "设计博物馆根特",
      "attractions_name_en": "Design Museum Gent",
      "description": "收藏了20世纪至今的比利时和国际设计作品。",
      "official_link": "https://www.designmuseumgent.be/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Belgian and international design from the 20th century.",
      "price_range_en": "€12",
      "official_link_en": "https://www.designmuseumgent.be/en/"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "根特市立博物馆 (STAM)",
      "attractions_name_en": "STAM - Ghent City Museum",
      "description": "位于一座修道院内，通过互动式展览讲述根特的历史。",
      "official_link": "https://stamgent.be/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "In a former abbey—Ghent's history through interactive exhibits.",
      "price_range_en": "€12",
      "official_link_en": "https://stamgent.be/en/"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "涂鸦街 (Werregarenstraatje)",
      "attractions_name_en": "Werregarenstraatje (Graffiti Alley)",
      "description": "根特市中心的一条小巷，墙上布满了不断更新的涂鸦艺术。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Alley in the centre—walls covered in ever-changing street art.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "根特美术博物馆",
      "attractions_name_en": "Museum of Fine Arts Ghent (MSK)",
      "description": "收藏了从15世纪到20世纪的弗拉芒和国际艺术作品。",
      "official_link": "https://mskgent.be/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Flemish and international art from the 15th to 20th century.",
      "price_range_en": "€12",
      "official_link_en": "https://mskgent.be/en/"
    },
    {
      "id": "BE",
      "cityname": "根特",
      "cityname_en": "Ghent",
      "attractions_name": "根特大学植物园",
      "attractions_name_en": "Ghent University Botanical Garden",
      "description": "美丽的植物园，有各种植物收藏和温室。",
      "official_link": "无需购票",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Beautiful botanical garden—plant collections and greenhouses.",
      "price_range_en": "Free",
      "official_link_en": "No ticket required"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "安特卫普大教堂",
      "attractions_name_en": "Cathedral of Our Lady Antwerp",
      "description": "联合国教科文组织世界遗产，比利时最大的哥特式教堂，收藏了鲁本斯的画作。",
      "official_link": "https://www.dekathedraal.be/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—Belgium's largest Gothic church; Rubens paintings.",
      "price_range_en": "€12",
      "official_link_en": "https://www.dekathedraal.be/en/"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "安特卫普中央车站",
      "attractions_name_en": "Antwerp Central Station",
      "description": "被誉为“铁路大教堂”，世界上最美丽的火车站之一，宏伟的建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Called \"Railway Cathedral\"—one of the world's most beautiful stations.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "鲁本斯故居",
      "attractions_name_en": "Rubenshuis (Rubens House)",
      "description": "著名画家鲁本斯的故居兼工作室，展示其生活和作品。",
      "official_link": "https://www.rubenshuis.be/en",
      "price_range": "12 (正在翻修，部分区域开放)",
      "currency": "EUR",
      "description_en": "Rubens' house and studio—his life and work. (Under renovation; partial access.)",
      "price_range_en": "€12 (partial access during renovation)",
      "official_link_en": "https://www.rubenshuis.be/en"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "市集广场 (Grote Markt)",
      "attractions_name_en": "Grote Markt (Main Square)",
      "description": "安特卫普的心脏，有市政厅、行会建筑和布拉博喷泉。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Antwerp's heart—town hall, guild houses and Brabo fountain.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "河畔博物馆 (MAS)",
      "attractions_name_en": "MAS - Museum aan de Stroom",
      "description": "现代化的博物馆，展示安特卫普与河流和世界的关系，可登顶观景。",
      "official_link": "https://www.mas.be/en",
      "price_range": "15 (展览), 免费 (登顶)",
      "currency": "EUR",
      "description_en": "Modern museum—Antwerp and the world; rooftop views free.",
      "price_range_en": "€15 (exhibitions), Free (rooftop)",
      "official_link_en": "https://www.mas.be/en"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "普朗坦-莫雷图斯博物馆",
      "attractions_name_en": "Plantin-Moretus Museum",
      "description": "联合国教科文组织世界遗产，历史悠久的印刷和出版博物馆。",
      "official_link": "https://museumplantinmoretus.be/en",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—historic printing and publishing museum.",
      "price_range_en": "€12",
      "official_link_en": "https://museumplantinmoretus.be/en"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "安特卫普钻石区",
      "attractions_name_en": "Antwerp Diamond Quarter",
      "description": "世界著名的钻石贸易中心，有许多钻石商店和交易所。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "World-famous diamond district—shops and exchanges.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "红灯区",
      "attractions_name_en": "Red Light District (Schipperskwartier)",
      "description": "合法且受监管的红灯区，位于市中心附近。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Legal, regulated red-light district—near the centre.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "河畔隧道 (圣安娜隧道)",
      "attractions_name_en": "St. Anna's Tunnel (Pedestrian Tunnel)",
      "description": "连接安特卫普市中心和左岸的古老隧道，可步行或骑行通过。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Historic tunnel linking centre and left bank—walk or cycle.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "安特卫普",
      "cityname_en": "Antwerp",
      "attractions_name": "时尚博物馆 (MoMu)",
      "attractions_name_en": "MoMu - Fashion Museum Antwerp",
      "description": "展示比利时和国际时尚设计。",
      "official_link": "https://www.momu.be/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Belgian and international fashion design.",
      "price_range_en": "€12",
      "official_link_en": "https://www.momu.be/en/"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔 (瓦隆区)",
      "cityname_en": "Liège/Namur (Wallonia)",
      "attractions_name": "列日大教堂",
      "attractions_name_en": "Cathédrale Saint-Paul de Liège",
      "description": "列日的主要教堂，哥特式风格，收藏有珍宝。",
      "official_link": "无门票，免费参观（珍宝室可能收费）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Liège's main church—Gothic; treasury.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（珍宝室可能收费）"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔",
      "cityname_en": "Liège/Namur",
      "attractions_name": "蒙特佛斯城堡 (列日)",
      "attractions_name_en": "Montagne de Bueren (Liège)",
      "description": "列日著名的374级阶梯，连接山顶城堡与市中心，可俯瞰城市。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Liège's famous 374 steps—from castle hill to centre; city views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔",
      "cityname_en": "Liège/Namur",
      "attractions_name": "列日王子主教宫",
      "attractions_name_en": "Prince-Bishops' Palace (Liège)",
      "description": "宏伟的宫殿建筑，曾是列日王子主教的住所，现在是法院。",
      "official_link": "无官方购票链接，外部参观免费（部分区域可入内）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Grand palace—former Prince-Bishops' residence; now law courts.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费（部分区域可入内）"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔",
      "cityname_en": "Liège/Namur",
      "attractions_name": "圣巴多罗买教堂 (列日)",
      "attractions_name_en": "Collegiate Church of St. Bartholomew (Liège)",
      "description": "罗马式教堂，以其独特的洗礼字体而闻名。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Romanesque church—famous baptismal font.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔",
      "cityname_en": "Liège/Namur",
      "attractions_name": "那慕尔城堡",
      "attractions_name_en": "Citadel of Namur",
      "description": "位于那慕尔市中心高处的古老城堡，可俯瞰默兹河和萨姆布尔河的交汇处。",
      "official_link": "https://citadelle.namur.be/en",
      "price_range": "7 - 10 (根据参观范围)",
      "currency": "EUR",
      "description_en": "Ancient citadel above Namur—views over Meuse and Sambre confluence.",
      "price_range_en": "€7–€10 (by areas)",
      "official_link_en": "https://citadelle.namur.be/en"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔",
      "cityname_en": "Liège/Namur",
      "attractions_name": "列日吉耶曼车站",
      "attractions_name_en": "Liège-Guillemins Railway Station",
      "description": "由圣地亚哥·卡拉特拉瓦设计的现代化火车站，具有独特的建筑风格。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Modern station by Santiago Calatrava—striking architecture.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔",
      "cityname_en": "Liège/Namur",
      "attractions_name": "那慕尔默兹河游船",
      "attractions_name_en": "Namur Meuse River Cruise",
      "description": "乘坐游船沿着默兹河欣赏那慕尔和周边风景。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "上午/下午 00時00分00秒 ",
      "currency": "EUR",
      "description_en": "Boat trip on the Meuse—Namur and surroundings.",
      "price_range_en": "Varies (check operator)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔",
      "cityname_en": "Liège/Namur",
      "attractions_name": "斯帕弗朗科尔尚赛道 (附近)",
      "attractions_name_en": "Circuit de Spa-Francorchamps (nearby)",
      "description": "世界著名的F1赛道，可参观或观看比赛。",
      "official_link": "https://www.spa-francorchamps.be/en",
      "price_range": "参观/比赛票价另计",
      "currency": "EUR",
      "description_en": "World-famous F1 circuit nearby—tours or race tickets.",
      "price_range_en": "Tours/race tickets extra",
      "official_link_en": "https://www.spa-francorchamps.be/en"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔",
      "cityname_en": "Liège/Namur",
      "attractions_name": "瓦隆生活博物馆 (列日)",
      "attractions_name_en": "Museum of Walloon Life (Liège)",
      "description": "展示瓦隆地区的文化、传统和日常生活。",
      "official_link": "https://www.viewallonne.be/en/",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "Walloon culture, traditions and daily life.",
      "price_range_en": "€5",
      "official_link_en": "https://www.viewallonne.be/en/"
    },
    {
      "id": "BE",
      "cityname": "列日/那慕尔",
      "cityname_en": "Liège/Namur",
      "attractions_name": "那慕尔历史中心",
      "attractions_name_en": "Namur Historic Centre",
      "description": "探索那慕尔的老城，有步行街、商店和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Explore Namur's old town—pedestrian streets, shops and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "匈牙利国会大厦",
      "attractions_name_en": "Hungarian Parliament Building",
      "description": "哥特复兴式建筑杰作，位于多瑙河畔，是布达佩斯的标志性地标。",
      "official_link": "https://www.parlament.hu/web/visitors",
      "price_range": "4000 - 6000 (欧盟公民与非欧盟公民有差异)",
      "currency": "HUF",
      "description_en": "Gothic Revival masterpiece on the Danube—Budapest's icon.",
      "price_range_en": "HUF 4000–6000 (EU/non-EU differ)",
      "official_link_en": "https://www.parlament.hu/web/visitors"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "链子桥",
      "attractions_name_en": "Széchenyi Chain Bridge",
      "description": "连接布达和佩斯两岸的标志性桥梁，夜景尤其壮观。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Iconic bridge linking Buda and Pest—spectacular at night.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "渔人堡",
      "attractions_name_en": "Fisherman's Bastion",
      "description": "位于布达城堡山，新哥特式和新罗马式观景台，可俯瞰多瑙河和佩斯全景。",
      "official_link": "无官方购票链接，部分观景台收费",
      "price_range": "免费（部分塔楼约1000）",
      "currency": "HUF",
      "description_en": "On Castle Hill—Neo-Gothic and Neo-Romanesque terraces; Danube and Pest views.",
      "price_range_en": "Free (some towers ~HUF 1000)",
      "official_link_en": "无官方购票链接，部分观景台收费"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "马加什教堂",
      "attractions_name_en": "Matthias Church",
      "description": "位于布达城堡山，拥有独特的彩色屋顶和精美的内部装饰。",
      "official_link": "https://matyas-templom.hu/en/",
      "price_range": "2500",
      "currency": "HUF",
      "description_en": "On Castle Hill—colourful roof and fine interior.",
      "price_range_en": "HUF 2500",
      "official_link_en": "https://matyas-templom.hu/en/"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "布达城堡",
      "attractions_name_en": "Buda Castle",
      "description": "联合国教科文组织世界遗产，历史悠久的皇宫，内有博物馆和国家画廊。",
      "official_link": "无官方购票链接（博物馆和画廊单独售票）",
      "price_range": "2000 - 4000 (根据博物馆)",
      "currency": "HUF",
      "description_en": "UNESCO World Heritage—historic royal palace; museums and National Gallery.",
      "price_range_en": "HUF 2000–4000 (by museum)",
      "official_link_en": "无官方购票链接（博物馆和画廊单独售票）"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "塞切尼温泉浴场",
      "attractions_name_en": "Széchenyi Thermal Bath",
      "description": "欧洲最大的药用温泉浴场之一，历史悠久，是放松身心的好去处。",
      "official_link": "https://www.szechenyibath.hu/",
      "price_range": "9000 - 12000 (根据周中/周末和储物柜/更衣室)",
      "currency": "HUF",
      "description_en": "One of Europe's largest thermal baths—historic; relax and unwind.",
      "price_range_en": "HUF 9000–12000 (weekday/weekend, cabin/cabinet)",
      "official_link_en": "https://www.szechenyibath.hu/"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "圣伊什特万大教堂",
      "attractions_name_en": "St. Stephen's Basilica",
      "description": "布达佩斯最大的教堂，可登顶欣赏城市全景，内部保存有圣伊什特万国王的木乃伊右手。",
      "official_link": "https://www.budapest.org/en/things-to-do-budapest/st-stephens-basilica/",
      "price_range": "免费（捐赠建议200），登顶1000",
      "currency": "HUF",
      "description_en": "Budapest's largest church—climb for city views; St Stephen's mummified right hand inside.",
      "price_range_en": "Free (donation ~HUF 200), tower HUF 1000",
      "official_link_en": "https://www.budapest.org/en/things-to-do-budapest/st-stephens-basilica/"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "英雄广场",
      "attractions_name_en": "Heroes' Square",
      "description": "布达佩斯的主要广场，有纪念碑和艺术博物馆，纪念匈牙利历史上的重要人物。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Main square—monument and art museum; honours key figures in Hungarian history.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "中央市场大厅",
      "attractions_name_en": "Central Market Hall",
      "description": "宏伟的室内市场，出售新鲜农产品、肉类、香料和纪念品。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "HUF",
      "description_en": "Grand indoor market—fresh produce, meat, spices and souvenirs.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "HU",
      "cityname": "布达佩斯",
      "cityname_en": "Budapest",
      "attractions_name": "犹太会堂 (大犹太会堂)",
      "attractions_name_en": "Dohány Street Synagogue (Great Synagogue)",
      "description": "欧洲最大的犹太会堂，哥特复兴式建筑，内有犹太博物馆和纪念园。",
      "official_link": "https://www.termalfurdo.hu/latnivalo/dohany-utcai-zsinagoga-147",
      "price_range": "9000",
      "currency": "HUF",
      "description_en": "Europe's largest synagogue—Gothic Revival; Jewish Museum and memorial garden.",
      "price_range_en": "HUF 9000",
      "official_link_en": "https://www.termalfurdo.hu/latnivalo/dohany-utcai-zsinagoga-147"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "埃格尔城堡",
      "attractions_name_en": "Eger Castle",
      "description": "历史悠久的城堡，在16世纪成功抵御奥斯曼帝国进攻，内有博物馆。",
      "official_link": "https://egrivar.hu/en/",
      "price_range": "2000 - 3000 (根据参观范围)",
      "currency": "HUF",
      "description_en": "Historic castle—held off Ottomans in the 16th century; museum inside.",
      "price_range_en": "HUF 2000–3000 (by areas)",
      "official_link_en": "https://egrivar.hu/en/"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "埃格尔大教堂",
      "attractions_name_en": "Eger Basilica",
      "description": "新古典主义风格的大教堂，匈牙利第二大教堂。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Neoclassical cathedral—Hungary's second largest.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "尖塔",
      "attractions_name_en": "Eger Minaret",
      "description": "欧洲最北端的奥斯曼尖塔，可登顶俯瞰城市。",
      "official_link": "http://www.minareteger.hu/Nyitvatartas",
      "price_range": "600 - 800",
      "currency": "HUF",
      "description_en": "Europe's northernmost Ottoman minaret—climb for city views.",
      "price_range_en": "HUF 600–800",
      "official_link_en": "http://www.minareteger.hu/Nyitvatartas"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "美女谷",
      "attractions_name_en": "Valley of the Beautiful Woman (Szépasszony-völgy)",
      "description": "埃格尔葡萄酒产区的中心，有数百个酒窖，可品尝当地葡萄酒。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（品酒/购物另计）",
      "currency": "HUF",
      "description_en": "Heart of Eger wine region—hundreds of cellars; taste local wines.",
      "price_range_en": "Free (tasting/shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "埃格尔利采乌姆",
      "attractions_name_en": "Eszterházy Károly University (Lyceum)",
      "description": "历史悠久的大学建筑，有天文台和图书馆可参观。",
      "official_link": "https://uni-eszterhazy.hu/en",
      "price_range": "1000 - 2000 (部分区域)",
      "currency": "HUF",
      "description_en": "Historic university building—observatory and library to visit.",
      "price_range_en": "HUF 1000–2000 (some areas)",
      "official_link_en": "https://uni-eszterhazy.hu/en"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "埃格尔城堡博物馆",
      "attractions_name_en": "Castle Museum of Eger",
      "description": "位于埃格尔城堡内，展示城堡历史和当地文物。",
      "official_link": "包含在埃格尔城堡门票内",
      "price_range": "包含在埃格尔城堡门票内",
      "currency": "HUF",
      "description_en": "Inside Eger Castle—castle history and local artefacts.",
      "price_range_en": "Included in castle ticket",
      "official_link_en": "包含在埃格尔城堡门票内"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "温泉浴场",
      "attractions_name_en": "Eger Thermal Bath",
      "description": "埃格尔的温泉浴场，提供休闲和疗养服务。",
      "official_link": "无线上购买链接",
      "price_range": "4000 - 6000",
      "currency": "HUF",
      "description_en": "Eger's thermal baths—relaxation and wellness.",
      "price_range_en": "HUF 4000–6000",
      "official_link_en": "No online ticket link"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "埃格尔市中心",
      "attractions_name_en": "Eger City Centre",
      "description": "探索埃格尔的老城区，有巴洛克式建筑和咖啡馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Explore Eger's old town—Baroque buildings and cafés.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "马约利卡博物馆",
      "attractions_name_en": "Marzipan Museum (Kopcsik Marcipánia)",
      "description": "展示各种精美的杏仁糖雕塑和艺术品。",
      "official_link": "https://kopcsikmarcipania.hu/",
      "price_range": "800 - 1000",
      "currency": "HUF",
      "description_en": "Marzipan sculptures and confectionery art.",
      "price_range_en": "HUF 800–1000",
      "official_link_en": "https://kopcsikmarcipania.hu/"
    },
    {
      "id": "HU",
      "cityname": "埃格尔",
      "cityname_en": "Eger",
      "attractions_name": "地下酒窖",
      "attractions_name_en": "Underground Cellars",
      "description": "埃格尔拥有 extensive 的地下酒窖网络，可参加品酒之旅。",
      "official_link": "各酒窖有独立购票，无官方统一链接",
      "price_range": "2000 - 5000+ (品酒)",
      "currency": "HUF",
      "description_en": "Eger's extensive underground cellars—wine tours and tastings.",
      "price_range_en": "HUF 2000–5000+ (tasting)",
      "official_link_en": "各酒窖有独立购票，无官方统一链接"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "佩奇主教座堂",
      "attractions_name_en": "Pécs Cathedral",
      "description": "宏伟的教堂，结合了罗马式、哥特式和文艺复兴风格。",
      "official_link": "https://pecsiegyhazmegye.hu/en/attractions/the-cathedral",
      "price_range": "1500 - 2000",
      "currency": "HUF",
      "description_en": "Grand cathedral—Romanesque, Gothic and Renaissance.",
      "price_range_en": "HUF 1500–2000",
      "official_link_en": "https://pecsiegyhazmegye.hu/en/attractions/the-cathedral"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "早期基督教墓地",
      "attractions_name_en": "Early Christian Necropolis of Pécs",
      "description": "联合国教科文组织世界遗产，罗马帝国时期的地下墓室和教堂遗址。",
      "official_link": "https://www.pecsorokseg.hu/en/",
      "price_range": "1500 - 2000",
      "currency": "HUF",
      "description_en": "UNESCO World Heritage—Roman-era underground tombs and church remains.",
      "price_range_en": "HUF 1500–2000",
      "official_link_en": "https://www.pecsorokseg.hu/en/"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "盖兹·帕夏清真寺",
      "attractions_name_en": "Mosque of Pasha Qasim",
      "description": "曾是清真寺，现在是天主教堂，体现了奥斯曼帝国对佩奇的影响。",
      "official_link": "免费（捐赠建议）",
      "price_range": "免费（捐赠建议）",
      "currency": "HUF",
      "description_en": "Former mosque, now Catholic church—Ottoman influence on Pécs.",
      "price_range_en": "Free (donation suggested)",
      "official_link_en": "免费（捐赠建议）"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "兹索尔奈文化区",
      "attractions_name_en": "Zsolnay Cultural Quarter",
      "description": "曾经的瓷器工厂区，现已改造成文化中心，有博物馆、画廊和商店。",
      "official_link": "https://www.zsolnaynegyed.hu/en",
      "price_range": "2500 - 4000 (联票)",
      "currency": "HUF",
      "description_en": "Former porcelain factory area—now culture centre; museums, galleries and shops.",
      "price_range_en": "HUF 2500–4000 (combined)",
      "official_link_en": "https://www.zsolnaynegyed.hu/en"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "瓦萨雷利博物馆",
      "attractions_name_en": "Victor Vasarely Museum",
      "description": "纪念欧普艺术创始人维克托·瓦萨雷利的博物馆，展示其作品。",
      "official_link": "https://en.vasarely.hu/",
      "price_range": "1000 - 1500",
      "currency": "HUF",
      "description_en": "Museum dedicated to Victor Vasarely—Op Art founder; his works.",
      "price_range_en": "HUF 1000–1500",
      "official_link_en": "https://en.vasarely.hu/"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "佩奇市中心",
      "attractions_name_en": "Pécs City Centre",
      "description": "探索佩奇的历史老城，有步行街、广场和咖啡馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Explore Pécs' historic old town—pedestrian streets, squares and cafés.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "佩奇大学",
      "attractions_name_en": "University of Pécs",
      "description": "匈牙利最古老的大学之一，校园美丽，有许多历史建筑。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "One of Hungary's oldest universities—beautiful campus and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "巴兰亚博物馆",
      "attractions_name_en": "Csontváry Museum",
      "description": "收藏了匈牙利著名画家蒂瓦达尔·科松特瓦里·科斯蒂的画作。",
      "official_link": "不支持线上购票",
      "price_range": "1000 - 1500",
      "currency": "HUF",
      "description_en": "Works by Hungarian painter Tivadar Kosztka Csontváry.",
      "price_range_en": "HUF 1000–1500",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "佩奇电视塔",
      "attractions_name_en": "Pécs TV Tower",
      "description": "可登塔俯瞰佩奇和周边地区的全景。",
      "official_link": "不支持线上购票",
      "price_range": "1500 - 2000",
      "currency": "HUF",
      "description_en": "Climb the tower for panoramic views of Pécs and surroundings.",
      "price_range_en": "HUF 1500–2000",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "佩奇",
      "cityname_en": "Pécs",
      "attractions_name": "佩奇美术馆",
      "attractions_name_en": "Pécs Gallery",
      "description": "展示当地和匈牙利当代艺术作品。",
      "official_link": "不支持线上购票",
      "price_range": "800 - 1200",
      "currency": "HUF",
      "description_en": "Local and Hungarian contemporary art.",
      "price_range_en": "HUF 800–1200",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "塞格德大教堂",
      "attractions_name_en": "Szeged Cathedral (Votive Church)",
      "description": "塞格德的标志性建筑，宏伟的砖砌教堂，拥有高耸的钟楼。",
      "official_link": "不支持线上购票",
      "price_range": "1000 - 1500",
      "currency": "HUF",
      "description_en": "Szeged's icon—grand brick cathedral with tall bell tower.",
      "price_range_en": "HUF 1000–1500",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "塞格德新犹太会堂",
      "attractions_name_en": "New Synagogue of Szeged",
      "description": "欧洲最美丽的犹太会堂之一，摩尔复兴式建筑，内部装饰华丽。",
      "official_link": "不支持线上购票",
      "price_range": "1000 - 1500",
      "currency": "HUF",
      "description_en": "One of Europe's most beautiful synagogues—Moorish Revival; lavish interior.",
      "price_range_en": "HUF 1000–1500",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "塞格德大学",
      "attractions_name_en": "University of Szeged",
      "description": "匈牙利最重要的大学之一，校园美丽，有许多历史建筑。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "One of Hungary's leading universities—beautiful campus and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "多姆广场",
      "attractions_name_en": "Dóm tér (Dóm Square)",
      "description": "塞格德的主要广场，有大教堂和音乐钟，夏季常有户外活动。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Szeged's main square—cathedral and musical clock; outdoor events in summer.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "塞格德国家剧院",
      "attractions_name_en": "National Theatre of Szeged",
      "description": "重要的文化场所，可观看歌剧、戏剧和音乐会。",
      "official_link": "无官方购票链接，演出票价另计",
      "price_range": "演出票价另计",
      "currency": "HUF",
      "description_en": "Key venue—opera, theatre and concerts.",
      "price_range_en": "Performance tickets extra",
      "official_link_en": "无官方购票链接，演出票价另计"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "费伦茨·莫拉博物馆",
      "attractions_name_en": "Ferenc Móra Museum",
      "description": "位于蒂萨河畔，展示塞格德地区考古、历史和艺术。",
      "official_link": "https://moramuzeum.hu/en/",
      "price_range": "800 - 1200",
      "currency": "HUF",
      "description_en": "By the Tisza—Szeged region archaeology, history and art.",
      "price_range_en": "HUF 800–1200",
      "official_link_en": "https://moramuzeum.hu/en/"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "厄特沃什广场",
      "attractions_name_en": "Széchenyi Square",
      "description": "塞格德的另一个重要广场，有树木、喷泉和历史建筑。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Another key square in Szeged—trees, fountains and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "塞格德水上乐园",
      "attractions_name_en": "Napfényfürdő Aquapolis Szeged",
      "description": "塞格德的大型水上乐园和温泉中心，适合家庭。",
      "official_link": "不支持线上购票",
      "price_range": "6000 - 8000 (全天票)",
      "currency": "HUF",
      "description_en": "Large water park and thermal centre—family-friendly.",
      "price_range_en": "HUF 6000–8000 (day pass)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "塞格德动物园",
      "attractions_name_en": "Szeged Zoo",
      "description": "位于塞格德郊区，拥有来自世界各地的动物。",
      "official_link": "不支持线上购票",
      "price_range": "3000 - 4000",
      "currency": "HUF",
      "description_en": "On the outskirts—animals from around the world.",
      "price_range_en": "HUF 3000–4000",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "塞格德",
      "cityname_en": "Szeged",
      "attractions_name": "塞格德老城桥",
      "attractions_name_en": "Old Bridge (Bridge of Peace)",
      "description": "跨越蒂萨河的历史桥梁，可欣赏河畔风光。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Historic bridge over the Tisza—riverside views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔 (西匈牙利)",
      "cityname_en": "Sopron/Győr (Western Hungary)",
      "attractions_name": "火灾瞭望塔 (肖普朗)",
      "attractions_name_en": "Firewatch Tower (Sopron)",
      "description": "肖普朗的标志，中世纪瞭望塔，可登顶俯瞰城市和周边地区。",
      "official_link": "不支持线上购票",
      "price_range": "1000 - 1500",
      "currency": "HUF",
      "description_en": "Sopron's icon—medieval fire tower; climb for city and region views.",
      "price_range_en": "HUF 1000–1500",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔",
      "cityname_en": "Sopron/Győr",
      "attractions_name": "肖普朗老城",
      "attractions_name_en": "Sopron Old Town",
      "description": "保存完好的中世纪老城，有狭窄的街道和历史建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Well-preserved medieval old town—narrow streets and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔",
      "cityname_en": "Sopron/Győr",
      "attractions_name": "杰尔主教座堂",
      "attractions_name_en": "Győr Basilica",
      "description": "杰尔的主教堂，拥有重要的宗教艺术品和文物。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Győr's main cathedral—important religious art and relics.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔",
      "cityname_en": "Sopron/Győr",
      "attractions_name": "肖普朗圣乔治教堂",
      "attractions_name_en": "St. George's Church (Sopron)",
      "description": "肖普朗的历史教堂，具有独特的建筑风格。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Historic church in Sopron—distinctive architecture.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔",
      "cityname_en": "Sopron/Győr",
      "attractions_name": "杰尔市政厅",
      "attractions_name_en": "Győr City Hall",
      "description": "杰尔市中心的重要建筑，具有独特的建筑风格。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Key building in Győr's centre—distinctive architecture.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔",
      "cityname_en": "Sopron/Győr",
      "attractions_name": "塞切尼宫 (肖普朗)",
      "attractions_name_en": "Széchenyi Palace (Sopron)",
      "description": "肖普朗的一座历史悠久的宫殿建筑。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Historic palace in Sopron.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔",
      "cityname_en": "Sopron/Győr",
      "attractions_name": "杰尔河畔",
      "attractions_name_en": "Rába Riverfront (Győr)",
      "description": "沿着拉巴河畔散步，欣赏河畔风光和历史建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Stroll along the Rába—riverside views and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔",
      "cityname_en": "Sopron/Győr",
      "attractions_name": "杰尔艺术博物馆",
      "attractions_name_en": "Xantus János Museum (Győr)",
      "description": "杰尔的主要博物馆，展示当地历史、考古和艺术。",
      "official_link": "不支持线上购票",
      "price_range": "800 - 1200",
      "currency": "HUF",
      "description_en": "Győr's main museum—local history, archaeology and art.",
      "price_range_en": "HUF 800–1200",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔",
      "cityname_en": "Sopron/Győr",
      "attractions_name": "索科尔城堡 (附近)",
      "attractions_name_en": "Sárvár Castle (nearby)",
      "description": "位于肖普朗附近，一座保存完好的文艺复兴时期城堡，内有博物馆。",
      "official_link": "不支持线上购票",
      "price_range": "2500 - 3500",
      "currency": "HUF",
      "description_en": "Near Sopron—well-preserved Renaissance castle with museum.",
      "price_range_en": "HUF 2500–3500",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "HU",
      "cityname": "肖普朗/杰尔",
      "cityname_en": "Sopron/Győr",
      "attractions_name": "杰尔老城",
      "attractions_name_en": "Győr Old Town",
      "description": "探索杰尔的历史老城，有巴洛克式建筑和教堂。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "HUF",
      "description_en": "Explore Győr's historic old town—Baroque buildings and churches.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "华沙老城",
      "attractions_name_en": "Warsaw Old Town",
      "description": "联合国教科文组织世界遗产，二战后重建的市中心，保留了中世纪风貌。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "UNESCO World Heritage—rebuilt after WWII; medieval character preserved.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "皇家城堡",
      "attractions_name_en": "Royal Castle in Warsaw",
      "description": "联合国教科文组织世界遗产，曾是波兰国王的居所，内有博物馆和历史展品。",
      "official_link": "https://www.zamek-krolewski.pl/en",
      "price_range": "40 - 50 (根据参观范围)",
      "currency": "PLN",
      "description_en": "UNESCO World Heritage—former royal residence; museums and history.",
      "price_range_en": "PLN 40–50 (by areas)",
      "official_link_en": "https://www.zamek-krolewski.pl/en"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "华沙起义博物馆",
      "attractions_name_en": "Warsaw Rising Museum",
      "description": "纪念1944年华沙起义的互动式博物馆，深入了解这段悲壮历史。",
      "official_link": "https://www.1944.pl/en/",
      "price_range": "30",
      "currency": "PLN",
      "description_en": "Interactive museum—1944 Warsaw Uprising; powerful history.",
      "price_range_en": "PLN 30",
      "official_link_en": "https://www.1944.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "华沙科学文化宫",
      "attractions_name_en": "Palace of Culture and Science",
      "description": "斯大林时期建造的标志性建筑，可登顶俯瞰华沙全景。",
      "official_link": "https://pkin.pl/en/",
      "price_range": "25 - 30 (观景台)",
      "currency": "PLN",
      "description_en": "Stalin-era landmark—climb for panoramic views of Warsaw.",
      "price_range_en": "PLN 25–30 (viewing terrace)",
      "official_link_en": "https://pkin.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "肖邦博物馆",
      "attractions_name_en": "Fryderyk Chopin Museum",
      "description": "专门纪念波兰著名作曲家肖邦的现代化互动式博物馆。",
      "official_link": "https://muzeum.nifc.pl/en",
      "price_range": "25",
      "currency": "PLN",
      "description_en": "Modern interactive museum dedicated to Chopin.",
      "price_range_en": "PLN 25",
      "official_link_en": "https://muzeum.nifc.pl/en"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "华沙大学图书馆屋顶花园",
      "attractions_name_en": "University of Warsaw Library Roof Garden",
      "description": "欧洲最大的屋顶花园之一，提供独特的城市景观和休闲空间。",
      "official_link": "https://www.buw.uw.edu.pl/en/",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "One of Europe's largest rooftop gardens—city views and relaxation.",
      "price_range_en": "Free",
      "official_link_en": "https://www.buw.uw.edu.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "瓦津基公园 (皇家浴场公园)",
      "attractions_name_en": "Łazienki Park (Royal Baths Park)",
      "description": "华沙最大的公园，有宫殿、剧院和花园，夏季有肖邦音乐会。",
      "official_link": "无官方购票链接，为公共公园（部分宫殿/展览收费）",
      "price_range": "免费（部分景点如水上宫殿约30）",
      "currency": "PLN",
      "description_en": "Warsaw's largest park—palaces, theatre and gardens; Chopin concerts in summer.",
      "price_range_en": "Free (some sites e.g. Palace on the Isle ~PLN 30)",
      "official_link_en": "无官方购票链接，为公共公园（部分宫殿/展览收费）"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "POLIN波兰犹太历史博物馆",
      "attractions_name_en": "POLIN Museum of the History of Polish Jews",
      "description": "获得国际奖项的博物馆，通过多媒体展览讲述波兰犹太人的千年历史。",
      "official_link": "https://polin.pl/en",
      "price_range": "35",
      "currency": "PLN",
      "description_en": "Award-winning museum—1000 years of Polish Jewish history, multimedia.",
      "price_range_en": "PLN 35",
      "official_link_en": "https://polin.pl/en"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "哥白尼科学中心",
      "attractions_name_en": "Copernicus Science Centre",
      "description": "互动式科学博物馆，适合所有年龄段的游客。",
      "official_link": "https://www.kopernik.org.pl/en/",
      "price_range": "35 - 40",
      "currency": "PLN",
      "description_en": "Interactive science museum—all ages.",
      "price_range_en": "PLN 35–40",
      "official_link_en": "https://www.kopernik.org.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "华沙",
      "cityname_en": "Warsaw",
      "attractions_name": "圣十字教堂",
      "attractions_name_en": "Holy Cross Church (Kościół Świętego Krzyża)",
      "description": "重要的巴洛克式教堂，内部柱子中埋葬着肖邦的心脏。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "Important Baroque church—Chopin's heart is buried in a pillar.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "瓦维尔城堡与大教堂",
      "attractions_name_en": "Wawel Royal Castle and Cathedral",
      "description": "联合国教科文组织世界遗产，波兰君主故居，内有皇家宫殿和国王陵墓。",
      "official_link": "https://wawel.krakow.pl/en",
      "price_range": "30 - 60 (根据参观区域)",
      "currency": "PLN",
      "description_en": "UNESCO World Heritage—Polish kings' residence; royal palace and royal tombs.",
      "price_range_en": "PLN 30–60 (by areas)",
      "official_link_en": "https://wawel.krakow.pl/en"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "大市集广场",
      "attractions_name_en": "Main Market Square (Rynek Główny)",
      "description": "联合国教科文组织世界遗产，欧洲最大的中世纪广场之一，有纺织会馆、圣玛丽教堂等。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "UNESCO World Heritage—one of Europe's largest medieval squares; Cloth Hall, St Mary's and more.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "圣玛丽教堂",
      "attractions_name_en": "St. Mary's Basilica",
      "description": "位于大市集广场，哥特式教堂，每小时有号角表演，内部有精美木雕祭坛。",
      "official_link": "https://mariacki.com/en/",
      "price_range": "15 (游客入内)",
      "currency": "PLN",
      "description_en": "On the main square—Gothic church; hourly trumpet call; fine wooden altarpiece inside.",
      "price_range_en": "PLN 15 (tourist entry)",
      "official_link_en": "https://mariacki.com/en/"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "纺织会馆 (中央市场)",
      "attractions_name_en": "Cloth Hall (Sukiennice)",
      "description": "位于大市集广场中央，历史悠久的贸易中心，现在出售纪念品和手工艺品。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "PLN",
      "description_en": "Centre of the main square—historic trading hall; souvenirs and crafts.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "卡齐米日区 (犹太区)",
      "attractions_name_en": "Kazimierz (Jewish Quarter)",
      "description": "联合国教科文组织世界遗产，克拉科夫的历史犹太区，有犹太教堂、博物馆和独特氛围。",
      "official_link": "无官方购票链接，为公共区域（部分犹太教堂/博物馆收费）",
      "price_range": "免费（部分景点约10-20）",
      "currency": "PLN",
      "description_en": "UNESCO World Heritage—Kraków's historic Jewish quarter; synagogues, museums and atmosphere.",
      "price_range_en": "Free (some sites ~PLN 10–20)",
      "official_link_en": "无官方购票链接，为公共区域（部分犹太教堂/博物馆收费）"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "奥斯卡·辛德勒工厂",
      "attractions_name_en": "Oskar Schindler's Enamel Factory",
      "description": "电影《辛德勒的名单》原型地，现为博物馆，展示二战期间克拉科夫的历史。",
      "official_link": "https://muzeumkrakowa.pl/en/branches/oskar-schindlers-enamel-factory",
      "price_range": "32",
      "currency": "PLN",
      "description_en": "Schindler's List filming location—museum of Kraków under Nazi occupation.",
      "price_range_en": "PLN 32",
      "official_link_en": "https://muzeumkrakowa.pl/en/branches/oskar-schindlers-enamel-factory"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "龙洞与瓦维尔龙",
      "attractions_name_en": "Dragon's Den and Wawel Dragon",
      "description": "瓦维尔山下的洞穴，传说有龙居住，洞口有会喷火的龙雕塑。",
      "official_link": "无官方链接",
      "price_range": "10",
      "currency": "PLN",
      "description_en": "Cave under Wawel Hill—legendary dragon; fire-breathing dragon statue at the entrance.",
      "price_range_en": "PLN 10",
      "official_link_en": "无官方链接"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "地下市场博物馆",
      "attractions_name_en": "Rynek Underground Museum",
      "description": "位于大市集广场下方，展示中世纪克拉科夫的考古遗迹。",
      "official_link": "https://muzeumkrakowa.pl/en/branches/rynek-underground",
      "price_range": "32",
      "currency": "PLN",
      "description_en": "Under the main square—medieval Kraków archaeology.",
      "price_range_en": "PLN 32",
      "official_link_en": "https://muzeumkrakowa.pl/en/branches/rynek-underground"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "基督圣体教堂",
      "attractions_name_en": "Corpus Christi Basilica",
      "description": "位于卡齐米日区，宏伟的哥特式教堂，内部装饰精美。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "In Kazimierz—grand Gothic church; fine interior.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "PL",
      "cityname": "克拉科夫",
      "cityname_en": "Kraków",
      "attractions_name": "波德古泽区 (原犹太区贫民窟)",
      "attractions_name_en": "Podgórze (former Jewish Ghetto)",
      "description": "曾是二战期间犹太区贫民窟所在地，有“鹰药房”和英雄广场等纪念地。",
      "official_link": "无官方购票链接，为公共区域（部分景点收费）",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "Site of the wartime ghetto—Eagle Pharmacy and Heroes' Square memorials.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为公共区域（部分景点收费）"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "长街与长市集",
      "attractions_name_en": "Long Lane and Long Market (Długi Targ)",
      "description": "格但斯克历史中心最著名的街道，两旁是色彩斑斓的房屋、餐厅和景点。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "Gdańsk's most famous street—colourful houses, restaurants and sights.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "海神喷泉",
      "attractions_name_en": "Neptune's Fountain",
      "description": "位于长市集中央，格但斯克的标志性喷泉。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "In the centre of Long Market—Gdańsk's iconic fountain.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "圣玛丽教堂",
      "attractions_name_en": "St. Mary's Church (Kościół Mariacki)",
      "description": "世界上最大的砖砌教堂之一，可登顶俯瞰格但斯克全景。",
      "official_link": "https://mariacki.com/",
      "price_range": "15 (登塔)",
      "currency": "PLN",
      "description_en": "One of the world's largest brick churches—climb the tower for city views.",
      "price_range_en": "PLN 15 (tower)",
      "official_link_en": "https://mariacki.com/"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "琥珀博物馆",
      "attractions_name_en": "Amber Museum",
      "description": "展示琥珀的历史、形成和各种琥珀艺术品。",
      "official_link": "https://muzeumgdansk.pl/en/oddzialy-muzeum/museum-of-amber/",
      "price_range": "25",
      "currency": "PLN",
      "description_en": "Amber—history, formation and amber art.",
      "price_range_en": "PLN 25",
      "official_link_en": "https://muzeumgdansk.pl/en/oddzialy-muzeum/museum-of-amber/"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "波兰团结中心",
      "attractions_name_en": "European Solidarity Centre",
      "description": "现代化的博物馆，讲述团结工会运动和波兰推翻共产主义的历史。",
      "official_link": "https://ecs.gda.pl/en/",
      "price_range": "30",
      "currency": "PLN",
      "description_en": "Modern museum—Solidarity movement and fall of communism in Poland.",
      "price_range_en": "PLN 30",
      "official_link_en": "https://ecs.gda.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "格但斯克港口与起重机 (Zuraw)",
      "attractions_name_en": "Gdańsk Port & Crane (Zuraw)",
      "description": "历史悠久的港口和标志性的中世纪港口起重机。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "Historic harbour and iconic medieval crane.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "金门和绿门",
      "attractions_name_en": "Golden Gate and Green Gate",
      "description": "格但斯克老城的入口和出口，都是精美的历史建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "Entrance and exit of the old town—fine historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "奥利瓦大教堂",
      "attractions_name_en": "Oliwa Cathedral",
      "description": "位于格但斯克郊区，以其独特的风琴音乐会而闻名。",
      "official_link": "无门票，免费参观（风琴音乐会可能收费）",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "In Gdańsk's suburbs—famous for organ concerts.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（风琴音乐会可能收费）"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "二战博物馆",
      "attractions_name_en": "Museum of the Second World War",
      "description": "现代化的博物馆，以多角度展示二战对波兰和世界的影响。",
      "official_link": "https://muzeum1939.pl/en",
      "price_range": "25",
      "currency": "PLN",
      "description_en": "Modern museum—WWII's impact on Poland and the world.",
      "price_range_en": "PLN 25",
      "official_link_en": "https://muzeum1939.pl/en"
    },
    {
      "id": "PL",
      "cityname": "格但斯克",
      "cityname_en": "Gdańsk",
      "attractions_name": "索波特栈桥 (Sopot Pier)",
      "attractions_name_en": "Sopot Pier",
      "description": "位于格但斯克附近的索波特市，欧洲最长的木制海滨栈桥。",
      "official_link": "不支持线上购买",
      "price_range": "9 (旺季)",
      "currency": "PLN",
      "description_en": "In Sopot near Gdańsk—Europe's longest wooden pier.",
      "price_range_en": "PLN 9 (peak season)",
      "official_link_en": "不支持线上购买"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "弗罗茨瓦夫市集广场",
      "attractions_name_en": "Wrocław Market Square (Rynek)",
      "description": "欧洲最大的中世纪广场之一，被历史建筑、市政厅和餐馆环绕。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "One of Europe's largest medieval squares—historic buildings, town hall and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "大教堂岛",
      "attractions_name_en": "Cathedral Island (Ostrów Tumski)",
      "description": "弗罗茨瓦夫最古老的部分，有许多教堂和修道院，夜间灯光璀璨。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "Wrocław's oldest part—churches and monasteries; lit up at night.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "弗罗茨瓦夫大学",
      "attractions_name_en": "University of Wrocław",
      "description": "拥有历史悠久的建筑，包括“大学之珠”——巴洛克式的奥拉厅。",
      "official_link": "https://uni.wroc.pl/en/",
      "price_range": "15 (奥拉厅)",
      "currency": "PLN",
      "description_en": "Historic buildings—including the Baroque Aula Leopoldina, \"university jewel\".",
      "price_range_en": "PLN 15 (Aula)",
      "official_link_en": "https://uni.wroc.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "百年厅",
      "attractions_name_en": "Centennial Hall (Hala Stulecia)",
      "description": "联合国教科文组织世界遗产，现代主义建筑杰作，是大型活动的场所。",
      "official_link": "无线上链接",
      "price_range": "15 - 20 (根据展览)",
      "currency": "PLN",
      "description_en": "UNESCO World Heritage—modernist masterpiece; venue for major events.",
      "price_range_en": "PLN 15–20 (by exhibition)",
      "official_link_en": "无线上链接"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "弗罗茨瓦夫小矮人",
      "attractions_name_en": "Wrocław Dwarfs",
      "description": "弗罗茨瓦夫的特色，城市各处有数百个小矮人雕塑，寻找它们是乐趣。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "Wrocław's quirk—hundreds of dwarf statues around the city; hunting them is fun.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "日本园",
      "attractions_name_en": "Japanese Garden",
      "description": "位于百年厅附近，日式园林风格，是放松身心的好地方。",
      "official_link": "https://ogrod-japonski.wroclaw.pl/en/",
      "price_range": "15",
      "currency": "PLN",
      "description_en": "Near the Centennial Hall—Japanese-style garden; relax and unwind.",
      "price_range_en": "PLN 15",
      "official_link_en": "https://ogrod-japonski.wroclaw.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "全景画博物馆 (拉茨瓦维采战役全景图)",
      "attractions_name_en": "Racławice Panorama",
      "description": "巨大的360度全景画，描绘了1794年的拉茨瓦维采战役。",
      "official_link": "https://mnwr.pl/category/oddzialy/panorama-raclawicka/",
      "price_range": "50",
      "currency": "PLN",
      "description_en": "Huge 360° panorama—Battle of Racławice 1794.",
      "price_range_en": "PLN 50",
      "official_link_en": "https://mnwr.pl/category/oddzialy/panorama-raclawicka/"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "圣伊丽莎白教堂",
      "attractions_name_en": "St. Elisabeth's Church",
      "description": "位于市集广场附近，可登塔俯瞰弗罗茨瓦夫全景。",
      "official_link": "不支持线上购票",
      "price_range": "10 - 15 (登塔)",
      "currency": "PLN",
      "description_en": "Near the market square—climb the tower for city views.",
      "price_range_en": "PLN 10–15 (tower)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "弗罗茨瓦夫动物园和非洲馆",
      "attractions_name_en": "Wrocław Zoo and Africarium",
      "description": "弗罗茨瓦夫动物园是波兰最古老的动物园，非洲馆尤其受欢迎。",
      "official_link": "https://zoo.wroclaw.pl/en/",
      "price_range": "60 - 70",
      "currency": "PLN",
      "description_en": "Poland's oldest zoo—African Pavilion especially popular.",
      "price_range_en": "PLN 60–70",
      "official_link_en": "https://zoo.wroclaw.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "弗罗茨瓦夫",
      "cityname_en": "Wrocław",
      "attractions_name": "弗罗茨瓦夫国家博物馆",
      "attractions_name_en": "National Museum in Wrocław",
      "description": "收藏了西里西亚艺术、波兰艺术和欧洲艺术品。",
      "official_link": "https://mnwr.pl/en/",
      "price_range": "20",
      "currency": "PLN",
      "description_en": "Silesian, Polish and European art.",
      "price_range_en": "PLN 20",
      "official_link_en": "https://mnwr.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "波兹南老城广场",
      "attractions_name_en": "Poznań Old Town Square (Stary Rynek)",
      "description": "波兹南的心脏，有市政厅和色彩斑斓的房屋，每天中午有山羊顶角表演。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "Poznań's heart—town hall and colourful houses; mechanical goats at noon.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "波兹南市政厅",
      "attractions_name_en": "Poznań Town Hall",
      "description": "波兹南老城广场的标志性建筑，文艺复兴风格，每天中午有山羊表演。",
      "official_link": "不支持线上购票",
      "price_range": "15 (内部参观)",
      "currency": "PLN",
      "description_en": "Iconic building on the old town square—Renaissance; mechanical goats at noon.",
      "price_range_en": "PLN 15 (interior)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "圣彼得和圣保罗大教堂",
      "attractions_name_en": "Poznań Cathedral (Archcathedral Basilica of St. Peter and St. Paul)",
      "description": "波兰最古老的主教堂之一，位于大教堂岛，是波兰早期历史的重要地点。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "One of Poland's oldest cathedrals—on Cathedral Island; key to early Polish history.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "大波兰起义博物馆",
      "attractions_name_en": "Museum of the Greater Poland Uprising of 1918–1919",
      "description": "位于市政厅下方，纪念1918-1919年大波兰起义的历史。",
      "official_link": "https://visitpoznan.pl/en/museum-of-the-wielkopolska-uprising-1918-1919",
      "price_range": "15",
      "currency": "PLN",
      "description_en": "Under the town hall—1918–1919 Greater Poland Uprising.",
      "price_range_en": "PLN 15",
      "official_link_en": "https://visitpoznan.pl/en/museum-of-the-wielkopolska-uprising-1918-1919"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "波兹南国际博览会",
      "attractions_name_en": "Poznań International Fair (MTP)",
      "description": "波兰最大的贸易展览中心，常有各种国际展会。",
      "official_link": "https://www.mtp.pl/en/",
      "price_range": "展览票价另计",
      "currency": "PLN",
      "description_en": "Poland's largest trade fair centre—international exhibitions.",
      "price_range_en": "Exhibition tickets extra",
      "official_link_en": "https://www.mtp.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "马耳他湖",
      "attractions_name_en": "Malta Lake (Jezioro Maltańskie)",
      "description": "波兹南的休闲娱乐区，有划船、滑雪道、火车和动物园。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（活动/景点收费）",
      "currency": "PLN",
      "description_en": "Leisure area—boating, ski slope, train and zoo.",
      "price_range_en": "Free (activities/sites charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "帝国城堡 (文化中心)",
      "attractions_name_en": "Imperial Castle (Zamek Cesarski)",
      "description": "德国皇帝威廉二世的宫殿，现在是文化中心和博物馆。",
      "official_link": "https://ckzamek.pl/en/",
      "price_range": "10 - 20 (部分展览)",
      "currency": "PLN",
      "description_en": "Kaiser Wilhelm II's palace—now culture centre and museum.",
      "price_range_en": "PLN 10–20 (some exhibitions)",
      "official_link_en": "https://ckzamek.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "波兹南国家博物馆",
      "attractions_name_en": "National Museum in Poznań",
      "description": "收藏了波兰和欧洲艺术品，包括波兰著名画家马泰伊科的作品。",
      "official_link": "https://mnp.art.pl/en/",
      "price_range": "25",
      "currency": "PLN",
      "description_en": "Polish and European art—including Matejko.",
      "price_range_en": "PLN 25",
      "official_link_en": "https://mnp.art.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "棕榈屋 (植物园)",
      "attractions_name_en": "Poznań Palm House",
      "description": "波兰最大的棕榈屋，有来自世界各地的热带植物。",
      "official_link": "https://palmiarnia.poznan.pl/en/",
      "price_range": "16",
      "currency": "PLN",
      "description_en": "Poland's largest palm house—tropical plants from around the world.",
      "price_range_en": "PLN 16",
      "official_link_en": "https://palmiarnia.poznan.pl/en/"
    },
    {
      "id": "PL",
      "cityname": "波兹南",
      "cityname_en": "Poznań",
      "attractions_name": "圣弗朗西斯教堂",
      "attractions_name_en": "Franciscan Church (Fara Poznańska)",
      "description": "波兹南最美丽的教堂之一，巴洛克式建筑，内部装饰华丽。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "PLN",
      "description_en": "One of Poznań's finest churches—Baroque; lavish interior.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "ME",
      "cityname": "科托尔",
      "cityname_en": "Kotor",
      "attractions_name": "科托尔老城",
      "attractions_name_en": "Kotor Old Town",
      "description": "联合国教科文组织世界遗产，保存完好的中世纪老城，有狭窄的街道、古老建筑和教堂。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—well-preserved medieval old town; narrow streets and churches.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ME",
      "cityname": "科托尔",
      "cityname_en": "Kotor",
      "attractions_name": "圣约翰堡垒 (科托尔城墙)",
      "attractions_name_en": "San Giovanni Fortress (Kotor City Walls)",
      "description": "沿着山坡蜿蜒而上的古老城墙，可攀登至山顶堡垒，俯瞰科托尔湾的壮丽景色。",
      "official_link": "无官方购票链接，但登城墙收费",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Ancient walls winding up the hill—climb to the fortress for bay views.",
      "price_range_en": "€8",
      "official_link_en": "无官方购票链接，但登城墙收费"
    },
    {
      "id": "ME",
      "cityname": "科托尔",
      "cityname_en": "Kotor",
      "attractions_name": "圣特里芬大教堂",
      "attractions_name_en": "Saint Tryphon Cathedral",
      "description": "科托尔的标志性建筑，罗马式大教堂，收藏有珍贵的艺术品和遗物。",
      "official_link": "https://kotorskabiskupija.me/en/katedrala-sv-tripuna/",
      "price_range": "2.5",
      "currency": "EUR",
      "description_en": "Kotor's icon—Romanesque cathedral; precious art and relics.",
      "price_range_en": "€2.50",
      "official_link_en": "https://kotorskabiskupija.me/en/katedrala-sv-tripuna/"
    },
    {
      "id": "ME",
      "cityname": "科托尔",
      "cityname_en": "Kotor",
      "attractions_name": "航海博物馆",
      "attractions_name_en": "Maritime Museum of Montenegro",
      "description": "展示黑山和科托尔湾地区丰富的航海历史和传统。",
      "official_link": "https://museu.ms/museum/details/174/maritime-museum-of-montenegro",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "Montenegro and the Bay of Kotor—maritime history and tradition.",
      "price_range_en": "€5",
      "official_link_en": "https://museu.ms/museum/details/174/maritime-museum-of-montenegro"
    },
    {
      "id": "ME",
      "cityname": "科托尔",
      "cityname_en": "Kotor",
      "attractions_name": "猫博物馆",
      "attractions_name_en": "Cats Museum",
      "description": "科托尔独特的博物馆，展示各种猫咪主题的艺术品和文物，向科托尔的“猫居民”致敬。",
      "official_link": "无官方购票链接，仅限现场",
      "price_range": "1",
      "currency": "EUR",
      "description_en": "Unique museum—cat-themed art and artefacts; tribute to Kotor's cats.",
      "price_range_en": "€1",
      "official_link_en": "无官方购票链接，仅限现场"
    },
    {
      "id": "ME",
      "cityname": "科托尔",
      "cityname_en": "Kotor",
      "attractions_name": "蓝色洞穴 (Blue Grotto)",
      "attractions_name_en": "Blue Grotto",
      "description": "位于科托尔湾外，一个可以通过船只进入的海蚀洞，水面在阳光下呈现出美丽的蓝色。",
      "official_link": "无官方购票链接（乘船游览另计）",
      "price_range": "免费（船费约20-30）",
      "currency": "EUR",
      "description_en": "Sea cave outside the bay—reach by boat; water glows blue in the sun.",
      "price_range_en": "Free (boat ~€20–30)",
      "official_link_en": "无官方购票链接（乘船游览另计）"
    },
    {
      "id": "ME",
      "cityname": "布德瓦",
      "cityname_en": "Budva",
      "attractions_name": "布德瓦老城",
      "attractions_name_en": "Budva Old Town",
      "description": "布德瓦的古老部分，位于海边，有狭窄的街道、历史建筑和教堂。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Budva's ancient part by the sea—narrow streets, historic buildings and churches.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ME",
      "cityname": "布德瓦",
      "cityname_en": "Budva",
      "attractions_name": "圣伊凡教堂",
      "attractions_name_en": "St. Ivan Church",
      "description": "布德瓦老城内的重要教堂，是布德瓦的象征之一，拥有独特的钟楼。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Key church in the old town—one of Budva's symbols; distinctive bell tower.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "ME",
      "cityname": "布德瓦",
      "cityname_en": "Budva",
      "attractions_name": "莫格伦海滩",
      "attractions_name_en": "Mogren Beach",
      "description": "位于布德瓦老城附近，由两个美丽的海湾组成，沙质细腻，海水清澈。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Near the old town—two pretty coves; fine sand and clear water.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "ME",
      "cityname": "布德瓦",
      "cityname_en": "Budva",
      "attractions_name": "圣斯特凡岛",
      "attractions_name_en": "Sveti Stefan Island",
      "description": "黑山最具标志性的景点之一，曾经的渔村，现在是豪华酒店，风景如画。",
      "official_link": "无官方购票链接（仅限酒店客人入内或通过预订餐厅/导览）",
      "price_range": "免费（仅限外观，或通过消费/导览进入）",
      "currency": "EUR",
      "description_en": "One of Montenegro's most iconic sights—former fishing village, now luxury hotel.",
      "price_range_en": "Free (exterior; or via dining/tour)",
      "official_link_en": "无官方购票链接（仅限酒店客人入内或通过预订餐厅/导览）"
    },
    {
      "id": "ME",
      "cityname": "布德瓦",
      "cityname_en": "Budva",
      "attractions_name": "布德瓦城堡",
      "attractions_name_en": "Budva Citadel",
      "description": "布德瓦老城的一部分，曾是防御工事，现在是博物馆和图书馆，可登高俯瞰海景。",
      "official_link": "https://montenegro.org/discover-the-history-and-beauty-of-the-budva-citadel/5",
      "price_range": "3.5",
      "currency": "EUR",
      "description_en": "Part of the old town—former fort; now museum and library; sea views from the top.",
      "price_range_en": "€3.50",
      "official_link_en": "https://montenegro.org/discover-the-history-and-beauty-of-the-budva-citadel/5"
    },
    {
      "id": "ME",
      "cityname": "布德瓦",
      "cityname_en": "Budva",
      "attractions_name": "布德瓦里维埃拉",
      "attractions_name_en": "Budva Riviera",
      "description": "布德瓦沿海地区，拥有众多美丽的海滩、度假村和水上活动。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Budva's coast—beaches, resorts and water activities.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ME",
      "cityname": "波德戈里察",
      "cityname_en": "Podgorica",
      "attractions_name": "千禧桥",
      "attractions_name_en": "Millennium Bridge",
      "description": "波德戈里察的标志性斜拉桥，横跨莫拉查河，夜间灯光璀璨。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Podgorica's icon—cable-stayed bridge over the Morača; lit up at night.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ME",
      "cityname": "波德戈里察",
      "cityname_en": "Podgorica",
      "attractions_name": "基督复活大教堂",
      "attractions_name_en": "Cathedral of the Resurrection of Christ",
      "description": "塞尔维亚东正教大教堂，波德戈里察最大的教堂，拥有宏伟的建筑和精美的壁画。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Serbian Orthodox cathedral—Podgorica's largest; grand building and frescoes.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "ME",
      "cityname": "波德戈里察",
      "cityname_en": "Podgorica",
      "attractions_name": "旧桥 (奥斯曼帝国时期)",
      "attractions_name_en": "Old Bridge (Ribnica Bridge)",
      "description": "位于里布尼察河上的古老石桥，罗马和奥斯曼帝国时期遗迹。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Ancient stone bridge over the Ribnica—Roman and Ottoman remains.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ME",
      "cityname": "波德戈里察",
      "cityname_en": "Podgorica",
      "attractions_name": "波德戈里察博物馆",
      "attractions_name_en": "Podgorica City Museum",
      "description": "展示波德戈里察从史前到现代的历史、文化和考古发现。",
      "official_link": "https://pgmuzeji.me/en/muzej-grada/",
      "price_range": "2",
      "currency": "EUR",
      "description_en": "Podgorica from prehistory to the present—history, culture and archaeology.",
      "price_range_en": "€2",
      "official_link_en": "https://pgmuzeji.me/en/muzej-grada/"
    },
    {
      "id": "ME",
      "cityname": "波德戈里察",
      "cityname_en": "Podgorica",
      "attractions_name": "戈里察山",
      "attractions_name_en": "Gorica Hill",
      "description": "波德戈里察市中心的公园和休闲区，可徒步和观景。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Park and leisure area in the centre—walking and views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "ME",
      "cityname": "波德戈里察",
      "cityname_en": "Podgorica",
      "attractions_name": "奈戈什公园",
      "attractions_name_en": "King's Park (Kraljev Park)",
      "description": "波德戈里察市中心的绿地公园，有雕塑和喷泉。",
      "official_link": "无官方购票链接, 为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Green park in the centre—sculptures and fountains.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接, 为公共公园"
    },
    {
      "id": "SI",
      "cityname": "卢布尔雅那",
      "cityname_en": "Ljubljana",
      "attractions_name": "卢布尔雅那城堡",
      "attractions_name_en": "Ljubljana Castle",
      "description": "位于城市高处的历史城堡，可乘坐缆车或步行抵达，提供城市全景。",
      "official_link": "https://www.ljubljanskigrad.si/en/",
      "price_range": "16 (含缆车往返)",
      "currency": "EUR",
      "description_en": "Historic castle above the city—funicular or walk; city views.",
      "price_range_en": "€16 (incl. funicular return)",
      "official_link_en": "https://www.ljubljanskigrad.si/en/"
    },
    {
      "id": "SI",
      "cityname": "卢布尔雅那",
      "cityname_en": "Ljubljana",
      "attractions_name": "龙桥",
      "attractions_name_en": "Dragon Bridge",
      "description": "卢布尔雅那的标志性桥梁，桥头装饰有四条绿色的龙雕塑，是城市的象征。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Ljubljana's icon—bridge with four green dragon sculptures.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SI",
      "cityname": "卢布尔雅那",
      "cityname_en": "Ljubljana",
      "attractions_name": "普雷舍伦广场与三桥",
      "attractions_name_en": "Prešeren Square & Triple Bridge",
      "description": "卢布尔雅那的中心广场，连接着由三座桥组成的独特桥梁，是城市的主要聚集地。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Central square—Triple Bridge; main meeting point.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SI",
      "cityname": "卢布尔雅那",
      "cityname_en": "Ljubljana",
      "attractions_name": "卢布尔雅那中央市场",
      "attractions_name_en": "Ljubljana Central Market",
      "description": "露天和室内的综合市场，出售新鲜农产品、当地特色食品和手工艺品。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "Open-air and covered market—fresh produce, local food and crafts.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "SI",
      "cityname": "卢布尔雅那",
      "cityname_en": "Ljubljana",
      "attractions_name": "圣尼古拉斯大教堂",
      "attractions_name_en": "St. Nicholas's Cathedral",
      "description": "卢布尔雅那的主要教堂，拥有独特的青铜大门和精美的内部壁画。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Ljubljana's main church—bronze doors and fine interior frescoes.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "SI",
      "cityname": "卢布尔雅那",
      "cityname_en": "Ljubljana",
      "attractions_name": "蒂沃利公园",
      "attractions_name_en": "Tivoli Park",
      "description": "卢布尔雅那最大的公园，有步道、艺术画廊和马术中心，是城市中的绿洲。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Ljubljana's largest park—paths, art gallery and riding centre; urban oasis.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "SI",
      "cityname": "布莱德/朱利安阿尔卑斯",
      "cityname_en": "Bled/Julian Alps",
      "attractions_name": "布莱德湖",
      "attractions_name_en": "Lake Bled",
      "description": "斯洛文尼亚最具代表性的湖泊，湖心有小岛和教堂，湖畔有城堡。",
      "official_link": "无官方购票链接，为公共区域（租船/摆渡另计）",
      "price_range": "免费（船约15-20，教堂约6）",
      "currency": "EUR",
      "description_en": "Slovenia's iconic lake—island with church, castle on the shore.",
      "price_range_en": "Free (boat ~€15–20, church ~€6)",
      "official_link_en": "无官方购票链接，为公共区域（租船/摆渡另计）"
    },
    {
      "id": "SI",
      "cityname": "布莱德/朱利安阿尔卑斯",
      "cityname_en": "Bled/Julian Alps",
      "attractions_name": "布莱德城堡",
      "attractions_name_en": "Bled Castle",
      "description": "位于布莱德湖畔悬崖上的中世纪城堡，斯洛文尼亚最古老的城堡之一，可俯瞰湖景。",
      "official_link": "https://www.blejski-grad.si/en/",
      "price_range": "18",
      "currency": "EUR",
      "description_en": "Medieval castle on the cliff above the lake—one of Slovenia's oldest; lake views.",
      "price_range_en": "€18",
      "official_link_en": "https://www.blejski-grad.si/en/"
    },
    {
      "id": "SI",
      "cityname": "布莱德/朱利安阿尔卑斯",
      "cityname_en": "Bled/Julian Alps",
      "attractions_name": "文特加峡谷",
      "attractions_name_en": "Vintgar Gorge",
      "description": "位于布莱德附近，风景优美的峡谷，有木栈道沿着拉多夫纳河穿行，可欣赏瀑布和激流。",
      "official_link": "https://www.vintgar.si/en/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Scenic gorge near Bled—wooden walkways along the Radovna; waterfalls and rapids.",
      "price_range_en": "€10",
      "official_link_en": "https://www.vintgar.si/en/"
    },
    {
      "id": "SI",
      "cityname": "布莱德/朱利安阿尔卑斯",
      "cityname_en": "Bled/Julian Alps",
      "attractions_name": "特里格拉夫国家公园",
      "attractions_name_en": "Triglav National Park",
      "description": "斯洛文尼亚唯一的国家公园，覆盖朱利安阿尔卑斯山脉，拥有壮丽的自然风光、湖泊和徒步路线。",
      "official_link": "无官方购票链接，为公共区域（部分景点/活动收费）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Slovenia's only national park—Julian Alps; lakes and hiking.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为公共区域（部分景点/活动收费）"
    },
    {
      "id": "SI",
      "cityname": "布莱德/朱利安阿尔卑斯",
      "cityname_en": "Bled/Julian Alps",
      "attractions_name": "博希尼湖",
      "attractions_name_en": "Lake Bohinj",
      "description": "位于特里格拉夫国家公园内，比布莱德湖更大更原始，是户外活动的理想之地。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "In Triglav National Park—larger and wilder than Bled; ideal for outdoor activities.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SI",
      "cityname": "布莱德/朱利安阿尔卑斯",
      "cityname_en": "Bled/Julian Alps",
      "attractions_name": "萨维卡瀑布",
      "attractions_name_en": "Savica Waterfall",
      "description": "位于博希尼湖附近，斯洛文尼亚最著名的瀑布之一，景色优美。",
      "official_link": "不支持线上购买",
      "price_range": "3",
      "currency": "EUR",
      "description_en": "Near Lake Bohinj—one of Slovenia's most famous waterfalls.",
      "price_range_en": "€3",
      "official_link_en": "不支持线上购买"
    },
    {
      "id": "SI",
      "cityname": "波斯托伊纳/皮兰",
      "cityname_en": "Postojna/Piran",
      "attractions_name": "波斯托伊纳洞穴",
      "attractions_name_en": "Postojna Cave",
      "description": "斯洛文尼亚最大的溶洞，乘坐小火车进入，洞内有壮观的石笋和石灰岩构造。",
      "official_link": "https://www.postojnska-jama.eu/en/",
      "price_range": "29.50 (单独), 42.50 (联票含城堡)",
      "currency": "EUR",
      "description_en": "Slovenia's largest cave—train into the cave; stalagmites and formations.",
      "price_range_en": "€29.50 (cave only), €42.50 (with castle)",
      "official_link_en": "https://www.postojnska-jama.eu/en/"
    },
    {
      "id": "SI",
      "cityname": "波斯托伊纳/皮兰",
      "cityname_en": "Postojna/Piran",
      "attractions_name": "普利雅玛城堡",
      "attractions_name_en": "Predjama Castle",
      "description": "世界唯一的洞穴城堡，直接建在悬崖中，历史悠久，充满传奇色彩。",
      "official_link": "https://www.postojnska-jama.eu/en/predjama-castle/",
      "price_range": "17 (单独), 42.50 (联票含洞穴)",
      "currency": "EUR",
      "description_en": "World's only cave castle—built into the cliff; historic and legendary.",
      "price_range_en": "€17 (alone), €42.50 (with cave)",
      "official_link_en": "https://www.postojnska-jama.eu/en/predjama-castle/"
    },
    {
      "id": "SI",
      "cityname": "波斯托伊纳/皮兰",
      "cityname_en": "Postojna/Piran",
      "attractions_name": "皮兰老城",
      "attractions_name_en": "Piran Old Town",
      "description": "斯洛文尼亚亚得里亚海沿岸最美丽的城镇，威尼斯风格，有狭窄的街道和塔塔里尼广场。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Slovenia's prettiest Adriatic town—Venetian style; narrow streets and Tartini Square.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SI",
      "cityname": "波斯托伊纳/皮兰",
      "cityname_en": "Postojna/Piran",
      "attractions_name": "圣乔治教堂 (皮兰)",
      "attractions_name_en": "St. George's Church (Piran)",
      "description": "位于皮兰高处，可登钟楼俯瞰皮兰半岛和亚得里亚海的壮丽景色。",
      "official_link": "不支持线上购买",
      "price_range": "1 - 2 (登钟楼)",
      "currency": "EUR",
      "description_en": "On the hill in Piran—climb the bell tower for peninsula and sea views.",
      "price_range_en": "€1–€2 (bell tower)",
      "official_link_en": "不支持线上购买"
    },
    {
      "id": "SI",
      "cityname": "波斯托伊纳/皮兰",
      "cityname_en": "Postojna/Piran",
      "attractions_name": "波多罗斯 (海滨度假胜地)",
      "attractions_name_en": "Portorož (Coastal Resort)",
      "description": "斯洛文尼亚著名的海滨度假胜地，有海滩、赌场和温泉水疗中心。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Famous Slovenian seaside resort—beach, casino and thermal spa.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SI",
      "cityname": "波斯托伊纳/皮兰",
      "cityname_en": "Postojna/Piran",
      "attractions_name": "斯科契扬洞穴",
      "attractions_name_en": "Škocjan Caves",
      "description": "联合国教科文组织世界遗产，一个巨大的地下河洞穴系统，拥有壮观的峡谷。",
      "official_link": "https://www.park-skocjanske-jame.si/en/",
      "price_range": "20 - 24",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—huge underground river cave system; spectacular canyon.",
      "price_range_en": "€20–€24",
      "official_link_en": "https://www.park-skocjanske-jame.si/en/"
    },
    {
      "id": "NO",
      "cityname": "奥斯陆",
      "cityname_en": "Oslo",
      "attractions_name": "维格兰雕塑公园",
      "attractions_name_en": "Vigeland Park",
      "description": "世界上独一无二的雕塑公园，展示古斯塔夫·维格兰的200多件雕塑作品，以人生百态为主题。",
      "official_link": "https://www.vigeland.museum.no/en/vigeland-park",
      "price_range": "免费",
      "currency": "NOK",
      "description_en": "Unique sculpture park—200+ works by Gustav Vigeland; the human condition.",
      "price_range_en": "Free",
      "official_link_en": "https://www.vigeland.museum.no/en/vigeland-park"
    },
    {
      "id": "NO",
      "cityname": "奥斯陆",
      "cityname_en": "Oslo",
      "attractions_name": "奥斯陆歌剧院",
      "attractions_name_en": "Oslo Opera House",
      "description": "挪威的标志性现代建筑，位于港口，独特的白色大理石屋顶可供游客步行。",
      "official_link": "https://operaen.no/en/",
      "price_range": "免费（演出票价另计）",
      "currency": "NOK",
      "description_en": "Norway's iconic modern building by the harbour—walk on the white marble roof.",
      "price_range_en": "Free (performance tickets extra)",
      "official_link_en": "https://operaen.no/en/"
    },
    {
      "id": "NO",
      "cityname": "奥斯陆",
      "cityname_en": "Oslo",
      "attractions_name": "维京船博物馆",
      "attractions_name_en": "Viking Ship Museum",
      "description": "曾收藏三艘世界上保存最完好的维京船（目前因翻新工程关闭，预计2026年开放新博物馆）。",
      "official_link": "https://www.khm.uio.no/english/visit-us/viking-ship-museum/",
      "price_range": "120 (旧博物馆参考价)",
      "currency": "NOK",
      "description_en": "Three of the world's best-preserved Viking ships. (Closed for renovation; new museum expected 2026.)",
      "price_range_en": "NOK 120 (reference)",
      "official_link_en": "https://www.khm.uio.no/english/visit-us/viking-ship-museum/"
    },
    {
      "id": "NO",
      "cityname": "奥斯陆",
      "cityname_en": "Oslo",
      "attractions_name": "霍尔门科伦滑雪跳台",
      "attractions_name_en": "Holmenkollen Ski Jump",
      "description": "位于奥斯陆郊区，可登顶俯瞰城市和峡湾景色，内有滑雪博物馆。",
      "official_link": "https://www.visitoslo.com/en/product/?tlp=2992333&name=Holmenkollen-Ski-Museum--Tower",
      "price_range": "160 (滑雪博物馆和跳台)",
      "currency": "NOK",
      "description_en": "Outside Oslo—climb for city and fjord views; ski museum inside.",
      "price_range_en": "NOK 160 (museum and jump)",
      "official_link_en": "https://www.visitoslo.com/en/product/?tlp=2992333&name=Holmenkollen-Ski-Museum--Tower"
    },
    {
      "id": "NO",
      "cityname": "奥斯陆",
      "cityname_en": "Oslo",
      "attractions_name": "阿克什胡斯城堡",
      "attractions_name_en": "Akershus Fortress",
      "description": "历史悠久的堡垒，位于奥斯陆港口，曾是皇家住所和监狱，现在是博物馆。",
      "official_link": "https://www.forsvarsbygg.no/no/festninger/akershus-festning/",
      "price_range": "免费（部分博物馆收费）",
      "currency": "NOK",
      "description_en": "Historic fortress by the harbour—former royal residence and prison; now museum.",
      "price_range_en": "Free (some museums charge)",
      "official_link_en": "https://www.forsvarsbygg.no/no/festninger/akershus-festning/"
    },
    {
      "id": "NO",
      "cityname": "奥斯陆",
      "cityname_en": "Oslo",
      "attractions_name": "蒙克博物馆",
      "attractions_name_en": "MUNCH",
      "description": "专门纪念挪威著名表现主义画家爱德华·蒙克的博物馆，收藏其大量作品，包括《呐喊》。",
      "official_link": "https://www.munchmuseet.no/en/",
      "price_range": "160",
      "currency": "NOK",
      "description_en": "Dedicated to Edvard Munch—large collection including The Scream.",
      "price_range_en": "NOK 160",
      "official_link_en": "https://www.munchmuseet.no/en/"
    },
    {
      "id": "NO",
      "cityname": "卑尔根",
      "cityname_en": "Bergen",
      "attractions_name": "布吕根 (码头区)",
      "attractions_name_en": "Bryggen",
      "description": "联合国教科文组织世界遗产，卑尔根的标志，色彩斑斓的木制房屋，历史悠久。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "NOK",
      "description_en": "UNESCO World Heritage—Bergen's icon; colourful wooden houses.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "NO",
      "cityname": "卑尔根",
      "cityname_en": "Bergen",
      "attractions_name": "弗罗伊恩山 (缆车)",
      "attractions_name_en": "Mount Fløyen (Fløibanen)",
      "description": "乘坐缆车抵达山顶，可俯瞰卑尔根城市、峡湾和周边群岛的壮丽景色。",
      "official_link": "https://floyen.no/en/",
      "price_range": "往返 180 - 200 (根据季节)",
      "currency": "NOK",
      "description_en": "Funicular to the top—views over Bergen, the fjord and islands.",
      "price_range_en": "NOK 180–200 return (by season)",
      "official_link_en": "https://floyen.no/en/"
    },
    {
      "id": "NO",
      "cityname": "卑尔根",
      "cityname_en": "Bergen",
      "attractions_name": "鱼市",
      "attractions_name_en": "Fish Market (Fisketorget)",
      "description": "卑尔根著名的海鲜市场，出售新鲜海产品、当地特色美食和纪念品。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "NOK",
      "description_en": "Famous fish market—fresh seafood, local food and souvenirs.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "NO",
      "cityname": "卑尔根",
      "cityname_en": "Bergen",
      "attractions_name": "卑尔根水族馆",
      "attractions_name_en": "Bergen Aquarium",
      "description": "挪威最大的水族馆，有各种海洋生物，包括海狮和企鹅。",
      "official_link": "https://www.akvariet.no/en/",
      "price_range": "300 - 350",
      "currency": "NOK",
      "description_en": "Norway's largest aquarium—marine life including seals and penguins.",
      "price_range_en": "NOK 300–350",
      "official_link_en": "https://www.akvariet.no/en/"
    },
    {
      "id": "NO",
      "cityname": "卑尔根",
      "cityname_en": "Bergen",
      "attractions_name": "汉萨博物馆",
      "attractions_name_en": "Hanseatic Museum and Schøtstuene",
      "description": "了解汉萨同盟在卑尔根的历史，展示中世纪商人的生活。",
      "official_link": "https://hanseatiskemuseum.museumvest.no/en/",
      "price_range": "120",
      "currency": "NOK",
      "description_en": "Hanseatic history in Bergen—medieval merchant life.",
      "price_range_en": "NOK 120",
      "official_link_en": "https://hanseatiskemuseum.museumvest.no/en/"
    },
    {
      "id": "NO",
      "cityname": "卑尔根",
      "cityname_en": "Bergen",
      "attractions_name": "特罗尔豪根 (格里格故居)",
      "attractions_name_en": "Troldhaugen (Edvard Grieg Museum)",
      "description": "挪威著名作曲家爱德华·格里格的故居和作曲小屋，现为博物馆。",
      "official_link": "不支持线上购票",
      "price_range": "120 - 150",
      "currency": "NOK",
      "description_en": "Edvard Grieg's home and composing hut—now a museum.",
      "price_range_en": "NOK 120–150",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "NO",
      "cityname": "盖朗厄尔峡湾/松恩峡湾 (峡湾地区)",
      "cityname_en": "Geirangerfjord/Sognefjord (Fjord Region)",
      "attractions_name": "盖朗厄尔峡湾游船",
      "attractions_name_en": "Geirangerfjord Cruise",
      "description": "联合国教科文组织世界遗产，乘坐游船欣赏壮丽的峡湾景色、瀑布和陡峭的山壁。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "350 - 500+ (根据时长和公司)",
      "currency": "NOK",
      "description_en": "UNESCO World Heritage—boat trip; fjord, waterfalls and steep cliffs.",
      "price_range_en": "NOK 350–500+ (duration and operator)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "NO",
      "cityname": "盖朗厄尔峡湾/松恩峡湾",
      "cityname_en": "Geirangerfjord/Sognefjord",
      "attractions_name": "七姐妹瀑布",
      "attractions_name_en": "Seven Sisters Waterfall",
      "description": "盖朗厄尔峡湾最著名的瀑布群，由七条独立的瀑布组成，夏季水量充沛。",
      "official_link": "无官方购票链接，为自然景观",
      "price_range": "免费",
      "currency": "NOK",
      "description_en": "Geirangerfjord's most famous waterfalls—seven separate falls; full in summer.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为自然景观"
    },
    {
      "id": "NO",
      "cityname": "盖朗厄尔峡湾/松恩峡湾",
      "cityname_en": "Geirangerfjord/Sognefjord",
      "attractions_name": "老斯特林山路 (国家旅游线路)",
      "attractions_name_en": "Gamle Strynefjellsvegen (National Tourist Route)",
      "description": "挪威最美的山路之一，夏季开放，沿途有壮丽的风景和观景点。",
      "official_link": "无官方购票链接，为公共道路",
      "price_range": "免费",
      "currency": "NOK",
      "description_en": "One of Norway's most scenic mountain roads—open in summer; viewpoints.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public road"
    },
    {
      "id": "NO",
      "cityname": "盖朗厄尔峡湾/松恩峡湾",
      "cityname_en": "Geirangerfjord/Sognefjord",
      "attractions_name": "弗洛姆铁路",
      "attractions_name_en": "Flåm Railway (Flåmsbana)",
      "description": "世界上最陡峭的火车线路之一，穿梭于高山峡谷之间，风景优美。",
      "official_link": "https://en.flamsbana.no/",
      "price_range": "590 - 790 (往返，根据季节)",
      "currency": "NOK",
      "description_en": "One of the world's steepest railway lines—through mountains and valleys.",
      "price_range_en": "NOK 590–790 return (by season)",
      "official_link_en": "https://en.flamsbana.no/"
    },
    {
      "id": "NO",
      "cityname": "盖朗厄尔峡湾/松恩峡湾",
      "cityname_en": "Geirangerfjord/Sognefjord",
      "attractions_name": "纳柔依峡湾游船",
      "attractions_name_en": "Nærøyfjord Cruise",
      "description": "联合国教科文组织世界遗产，松恩峡湾的一个分支，是世界上最狭窄的峡湾之一。",
      "official_link": "各公司提供购票，无官方统一链接",
      "price_range": "400 - 600+ (根据时长和公司)",
      "currency": "NOK",
      "description_en": "UNESCO World Heritage—branch of Sognefjord; one of the world's narrowest fjords.",
      "price_range_en": "NOK 400–600+ (duration and operator)",
      "official_link_en": "各公司提供购票，无官方统一链接"
    },
    {
      "id": "NO",
      "cityname": "盖朗厄尔峡湾/松恩峡湾",
      "cityname_en": "Geirangerfjord/Sognefjord",
      "attractions_name": "约斯特达尔冰川国家公园",
      "attractions_name_en": "Jostedalsbreen National Park",
      "description": "挪威最大的冰川公园，可进行冰川徒步、观赏冰舌等户外活动。",
      "official_link": "无官方购票链接，为公共区域（冰川徒步向导/装备另计）",
      "price_range": "免费（活动费用另计）",
      "currency": "NOK",
      "description_en": "Norway's largest glacier park—glacier walks and outdoor activities.",
      "price_range_en": "Free (activities extra)",
      "official_link_en": "无官方购票链接，为公共区域（冰川徒步向导/装备另计）"
    },
    {
      "id": "RS",
      "cityname": "贝尔格莱德",
      "cityname_en": "Belgrade",
      "attractions_name": "卡莱梅格丹城堡与公园",
      "attractions_name_en": "Belgrade Fortress and Kalemegdan Park",
      "description": "贝尔格莱德的标志，位于萨瓦河和多瑙河交汇处，历史悠久，可俯瞰两河交汇处。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分博物馆/景点收费）",
      "currency": "RSD",
      "description_en": "Belgrade's icon—at the confluence of Sava and Danube; historic fortress and park.",
      "price_range_en": "Free (some museums/sites charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RS",
      "cityname": "贝尔格莱德",
      "cityname_en": "Belgrade",
      "attractions_name": "圣萨瓦大教堂",
      "attractions_name_en": "Temple of Saint Sava",
      "description": "巴尔干半岛最大的东正教教堂，宏伟的建筑，内部仍在装修中，但部分区域已开放参观。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "RSD",
      "description_en": "Balkans' largest Orthodox church—grand building; interior still under restoration.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "RS",
      "cityname": "贝尔格莱德",
      "cityname_en": "Belgrade",
      "attractions_name": "斯卡达利亚 (波西米亚区)",
      "attractions_name_en": "Skadarlija (Bohemian Quarter)",
      "description": "贝尔格莱德的波西米亚风格街区，鹅卵石街道，有传统餐厅、咖啡馆和现场音乐表演。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮消费另计）",
      "currency": "RSD",
      "description_en": "Belgrade's bohemian quarter—cobbled streets; traditional restaurants, cafés and live music.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RS",
      "cityname": "贝尔格莱德",
      "cityname_en": "Belgrade",
      "attractions_name": "尼古拉·特斯拉博物馆",
      "attractions_name_en": "Nikola Tesla Museum",
      "description": "纪念著名科学家尼古拉·特斯拉的博物馆，收藏了他的个人物品和发明。",
      "official_link": "http://www.tesla-museum.org/",
      "price_range": "800 - 1000",
      "currency": "RSD",
      "description_en": "Dedicated to Nikola Tesla—personal items and inventions.",
      "price_range_en": "RSD 800–1000",
      "official_link_en": "http://www.tesla-museum.org/"
    },
    {
      "id": "RS",
      "cityname": "贝尔格莱德",
      "cityname_en": "Belgrade",
      "attractions_name": "共和国广场",
      "attractions_name_en": "Republic Square",
      "description": "贝尔格莱德的中心广场，周围有国家博物馆和国家剧院等重要建筑。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "RSD",
      "description_en": "Belgrade's central square—National Museum and National Theatre nearby.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "RS",
      "cityname": "贝尔格莱德",
      "cityname_en": "Belgrade",
      "attractions_name": "铁托墓 (南斯拉夫历史博物馆)",
      "attractions_name_en": "House of Flowers (Museum of Yugoslav History)",
      "description": "南斯拉夫前领导人约瑟普·布罗兹·铁托的陵墓，以及展示南斯拉夫历史的博物馆。",
      "official_link": "https://www.muzej-jugoslavije.org/en/",
      "price_range": "600 - 800",
      "currency": "RSD",
      "description_en": "Tito's mausoleum and museum of Yugoslav history.",
      "price_range_en": "RSD 600–800",
      "official_link_en": "https://www.muzej-jugoslavije.org/en/"
    },
    {
      "id": "RS",
      "cityname": "诺维萨德",
      "cityname_en": "Novi Sad",
      "attractions_name": "彼得罗瓦拉丁要塞",
      "attractions_name_en": "Petrovaradin Fortress",
      "description": "位于多瑙河畔的巨大堡垒，欧洲保存最好的防御工事之一，也是Exit音乐节的举办地。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（博物馆/画廊收费）",
      "currency": "RSD",
      "description_en": "Huge fortress above the Danube—one of Europe's best-preserved; Exit Festival venue.",
      "price_range_en": "Free (museums/galleries charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RS",
      "cityname": "诺维萨德",
      "cityname_en": "Novi Sad",
      "attractions_name": "自由广场",
      "attractions_name_en": "Liberty Square (Trg Slobode)",
      "description": "诺维萨德的中心广场，周围有市政厅、天主教堂和重要的历史建筑。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "RSD",
      "description_en": "Novi Sad's central square—town hall, Catholic church and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "RS",
      "cityname": "诺维萨德",
      "cityname_en": "Novi Sad",
      "attractions_name": "圣玛丽教堂 (名店圣母教堂)",
      "attractions_name_en": "Name of Mary Church (Catholic Cathedral)",
      "description": "诺维萨德的标志性教堂，新哥特式建筑，拥有高耸的尖顶。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "RSD",
      "description_en": "Novi Sad's icon—Neo-Gothic church with tall spire.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "RS",
      "cityname": "诺维萨德",
      "cityname_en": "Novi Sad",
      "attractions_name": "伏伊伏丁那博物馆",
      "attractions_name_en": "Museum of Vojvodina",
      "description": "展示伏伊伏丁那地区从史前到现代的历史、考古和民族学藏品。",
      "official_link": "https://www.muzejvojvodine.org.rs/",
      "price_range": "300 - 500",
      "currency": "RSD",
      "description_en": "Vojvodina from prehistory to the present—history, archaeology and ethnology.",
      "price_range_en": "RSD 300–500",
      "official_link_en": "https://www.muzejvojvodine.org.rs/"
    },
    {
      "id": "RS",
      "cityname": "诺维萨德",
      "cityname_en": "Novi Sad",
      "attractions_name": "伏伊伏丁那议会大楼",
      "attractions_name_en": "Assembly of Vojvodina",
      "description": "位于自由广场附近，雄伟的建筑，是伏伊伏丁那自治省的议会所在地。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "RSD",
      "description_en": "Near Liberty Square—grand building; Vojvodina parliament.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "RS",
      "cityname": "诺维萨德",
      "cityname_en": "Novi Sad",
      "attractions_name": "多瑙河公园",
      "attractions_name_en": "Danube Park",
      "description": "诺维萨德市中心的多瑙河畔公园，是休闲散步的好地方，有湖泊和雕塑。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "RSD",
      "description_en": "Park by the Danube in the centre—stroll, lake and sculptures.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "RS",
      "cityname": "兹拉蒂博尔/乌日策 (西塞尔维亚)",
      "cityname_en": "Zlatibor/Užice (Western Serbia)",
      "attractions_name": "兹拉蒂博尔山",
      "attractions_name_en": "Zlatibor Mountain",
      "description": "塞尔维亚最受欢迎的山区度假胜地之一，以其新鲜空气、自然美景和户外活动闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（缆车/活动收费）",
      "currency": "RSD",
      "description_en": "One of Serbia's most popular mountain resorts—fresh air, nature and outdoor activities.",
      "price_range_en": "Free (cable car/activities charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RS",
      "cityname": "兹拉蒂博尔/乌日策",
      "cityname_en": "Zlatibor/Užice",
      "attractions_name": "莫克拉戈拉的木头城",
      "attractions_name_en": "Drvengrad (Küstendorf)",
      "description": "电影导演埃米尔·库斯图里察建造的传统木制村庄，仿佛置身童话世界。",
      "official_link": "https://www.mecavnik.info/",
      "price_range": "350 - 500",
      "currency": "RSD",
      "description_en": "Traditional wooden village built by Emir Kusturica—like a fairy tale.",
      "price_range_en": "RSD 350–500",
      "official_link_en": "https://www.mecavnik.info/"
    },
    {
      "id": "RS",
      "cityname": "兹拉蒂博尔/乌日策",
      "cityname_en": "Zlatibor/Užice",
      "attractions_name": "莎尔甘8号铁路",
      "attractions_name_en": "Šargan Eight Railway",
      "description": "狭窄的蒸汽火车线路，以其独特的“8”字形轨道设计而闻名，沿途风景优美。",
      "official_link": "https://taratours.rs/sargan-eight/?lang=en",
      "price_range": "1000 - 1500",
      "currency": "RSD",
      "description_en": "Narrow-gauge steam railway—famous figure-of-eight loop; scenic ride.",
      "price_range_en": "RSD 1000–1500",
      "official_link_en": "https://taratours.rs/sargan-eight/?lang=en"
    },
    {
      "id": "RS",
      "cityname": "兹拉蒂博尔/乌日策",
      "cityname_en": "Zlatibor/Užice",
      "attractions_name": "乌日策老城与要塞",
      "attractions_name_en": "Užice Old Town and Fortress",
      "description": "乌日策的历史中心和位于高处的古老要塞遗址，可俯瞰杰蒂尼亚河。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RSD",
      "description_en": "Užice's historic centre and ancient fortress above—views over the Đetinja.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RS",
      "cityname": "兹拉蒂博尔/乌日策",
      "cityname_en": "Zlatibor/Užice",
      "attractions_name": "斯塔拉普拉尼纳 (老山)",
      "attractions_name_en": "Stara Planina (Old Mountain)",
      "description": "塞尔维亚东部与保加利亚边境的山脉，拥有未受污染的自然风光和滑雪场。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（滑雪票另计）",
      "currency": "RSD",
      "description_en": "Mountain range on the Serbia–Bulgaria border—unspoilt nature and ski resorts.",
      "price_range_en": "Free (ski pass extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RS",
      "cityname": "兹拉蒂博尔/乌日策",
      "cityname_en": "Zlatibor/Užice",
      "attractions_name": "泰拉泽村 (Tornik滑雪中心)",
      "attractions_name_en": "Terzić Yard Ethno Village (near Požega)",
      "description": "距离兹拉蒂博尔不远，一个展示塞尔维亚传统村庄生活的民族村。",
      "official_link": "无需购票",
      "price_range": "免费（住宿/餐饮另计）",
      "currency": "RSD",
      "description_en": "Near Zlatibor—ethno village of traditional Serbian village life.",
      "price_range_en": "Free (accommodation/meals extra)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "RO",
      "cityname": "布加勒斯特",
      "cityname_en": "Bucharest",
      "attractions_name": "议会宫 (人民宫)",
      "attractions_name_en": "Palace of the Parliament (People's Palace)",
      "description": "世界第二大行政建筑，查乌塞斯库时代建造的宏伟建筑，可内部参观。",
      "official_link": "https://rolandia.eu/romania-travel-guide/places-to-visit-in-romania/palace-of-the-parliament/",
      "price_range": "60 - 80 (根据路线)",
      "currency": "RON",
      "description_en": "World's second-largest administrative building—Ceaușescu-era; guided tours inside.",
      "price_range_en": "RON 60–80 (by route)",
      "official_link_en": "https://rolandia.eu/romania-travel-guide/places-to-visit-in-romania/palace-of-the-parliament/"
    },
    {
      "id": "RO",
      "cityname": "布加勒斯特",
      "cityname_en": "Bucharest",
      "attractions_name": "老城 (老城区)",
      "attractions_name_en": "Old Town (Centrul Vechi)",
      "description": "布加勒斯特的历史中心，鹅卵石街道，有许多酒吧、餐厅、咖啡馆和历史建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮消费另计）",
      "currency": "RON",
      "description_en": "Bucharest's historic centre—cobbled streets; bars, restaurants, cafés and historic buildings.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RO",
      "cityname": "布加勒斯特",
      "cityname_en": "Bucharest",
      "attractions_name": "雅典娜神庙",
      "attractions_name_en": "Romanian Athenaeum",
      "description": "精美的新古典主义音乐厅，是布加勒斯特的标志性建筑和文化中心。",
      "official_link": "无需购票",
      "price_range": "免费（演出票价另计）",
      "currency": "RON",
      "description_en": "Elegant neoclassical concert hall—Bucharest's icon and cultural centre.",
      "price_range_en": "Free (performance tickets extra)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "RO",
      "cityname": "布加勒斯特",
      "cityname_en": "Bucharest",
      "attractions_name": "迪米特里·古斯蒂国家乡村博物馆",
      "attractions_name_en": "Dimitrie Gusti National Village Museum",
      "description": "露天博物馆，展示罗马尼亚各地的传统乡村建筑、农具和生活方式。",
      "official_link": "https://muzeul-satului.ro/en/",
      "price_range": "20",
      "currency": "RON",
      "description_en": "Open-air museum—traditional Romanian village buildings, tools and life.",
      "price_range_en": "RON 20",
      "official_link_en": "https://muzeul-satului.ro/en/"
    },
    {
      "id": "RO",
      "cityname": "布加勒斯特",
      "cityname_en": "Bucharest",
      "attractions_name": "罗马尼亚国家艺术博物馆",
      "attractions_name_en": "National Museum of Art of Romania",
      "description": "位于前皇家宫殿内，收藏了罗马尼亚和欧洲的艺术品，包括中世纪、现代和当代艺术。",
      "official_link": "http://www.mnar.arts.ro/en",
      "price_range": "20 - 40 (根据展厅)",
      "currency": "RON",
      "description_en": "In the former royal palace—Romanian and European art; medieval to contemporary.",
      "price_range_en": "RON 20–40 (by wing)",
      "official_link_en": "http://www.mnar.arts.ro/en"
    },
    {
      "id": "RO",
      "cityname": "布加勒斯特",
      "cityname_en": "Bucharest",
      "attractions_name": "统一广场与喷泉",
      "attractions_name_en": "Unirii Square and Fountains",
      "description": "布加勒斯特最大的广场之一，拥有欧洲最大的音乐喷泉系统，夏季夜间有精彩表演。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RON",
      "description_en": "One of Bucharest's largest squares—Europe's biggest musical fountains; summer evening shows.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RO",
      "cityname": "布拉索夫/特兰西瓦尼亚",
      "cityname_en": "Brașov/Transylvania",
      "attractions_name": "布兰城堡 (德古拉城堡)",
      "attractions_name_en": "Bran Castle (Dracula's Castle)",
      "description": "位于布拉索夫附近，与吸血鬼德古拉传说相关联，具有独特的哥特式外观。",
      "official_link": "https://www.bran-castle.com/",
      "price_range": "60",
      "currency": "RON",
      "description_en": "Near Brașov—linked to Dracula legend; distinctive Gothic look.",
      "price_range_en": "RON 60",
      "official_link_en": "https://www.bran-castle.com/"
    },
    {
      "id": "RO",
      "cityname": "布拉索夫/特兰西瓦尼亚",
      "cityname_en": "Brașov/Transylvania",
      "attractions_name": "布拉索夫老城",
      "attractions_name_en": "Brașov Old Town",
      "description": "迷人的中世纪城镇，有狭窄的街道、彩色房屋和坦帕山背景。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RON",
      "description_en": "Charming medieval town—narrow streets, colourful houses and Mt Tâmpa backdrop.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RO",
      "cityname": "布拉索夫/特兰西瓦尼亚",
      "cityname_en": "Brașov/Transylvania",
      "attractions_name": "黑教堂",
      "attractions_name_en": "Black Church (Biserica Neagră)",
      "description": "布拉索夫的标志性哥特式教堂，因1689年大火熏黑而得名，拥有巨大的管风琴。",
      "official_link": "不支持线上购票",
      "price_range": "15",
      "currency": "RON",
      "description_en": "Brașov's icon—Gothic church blackened by 1689 fire; huge organ.",
      "price_range_en": "RON 15",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "RO",
      "cityname": "布拉索夫/特兰西瓦尼亚",
      "cityname_en": "Brașov/Transylvania",
      "attractions_name": "锡纳亚修道院",
      "attractions_name_en": "Sinaia Monastery",
      "description": "位于锡纳亚小镇，是一座历史悠久的东正教修道院，风景优美。",
      "official_link": "无需购票",
      "price_range": "免费（博物馆部分可能收费）",
      "currency": "RON",
      "description_en": "In Sinaia—historic Orthodox monastery; scenic.",
      "price_range_en": "Free (museum may charge)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "RO",
      "cityname": "布拉索夫/特兰西瓦尼亚",
      "cityname_en": "Brașov/Transylvania",
      "attractions_name": "佩莱斯城堡",
      "attractions_name_en": "Peleș Castle",
      "description": "位于锡纳亚，罗马尼亚最美丽的城堡之一，新文艺复兴风格，曾是皇室夏宫。",
      "official_link": "https://peles.ro/",
      "price_range": "50 - 100 (根据参观楼层)",
      "currency": "RON",
      "description_en": "In Sinaia—one of Romania's finest castles; Neo-Renaissance; former royal summer residence.",
      "price_range_en": "RON 50–100 (by floors)",
      "official_link_en": "https://peles.ro/"
    },
    {
      "id": "RO",
      "cityname": "布拉索夫/特兰西瓦尼亚",
      "cityname_en": "Brașov/Transylvania",
      "attractions_name": "拉斯诺夫城堡",
      "attractions_name_en": "Râșnov Fortress",
      "description": "位于布拉索夫附近的山顶要塞，保存完好，可俯瞰周边地区。",
      "official_link": "https://cetatea-rasnov.ro/",
      "price_range": "上午/下午 00時00分00秒 ",
      "currency": "RON",
      "description_en": "Hilltop fortress near Brașov—well preserved; views over the area.",
      "price_range_en": "Varies (check website)",
      "official_link_en": "https://cetatea-rasnov.ro/"
    },
    {
      "id": "RO",
      "cityname": "锡比乌/西吉什瓦拉 (特兰西瓦尼亚)",
      "cityname_en": "Sibiu/Sighisoara (Transylvania)",
      "attractions_name": "锡比乌大广场",
      "attractions_name_en": "Sibiu Grand Square (Piața Mare)",
      "description": "锡比乌的中心广场，被精美的巴洛克式建筑环绕，常有活动。",
      "official_link": "无官方购票链接，为公共广场",
      "price_range": "免费",
      "currency": "RON",
      "description_en": "Sibiu's central square—surrounded by fine Baroque buildings; events.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public square"
    },
    {
      "id": "RO",
      "cityname": "锡比乌/西吉什瓦拉",
      "cityname_en": "Sibiu/Sighisoara",
      "attractions_name": "桥梁 (谎言之桥)",
      "attractions_name_en": "Bridge of Lies (Podul Minciunilor)",
      "description": "锡比乌老城内独特的铸铁桥，传说如果说谎走过桥会发出声音。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RON",
      "description_en": "Unique cast-iron bridge in the old town—legend says it creaks if you lie.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RO",
      "cityname": "锡比乌/西吉什瓦拉",
      "cityname_en": "Sibiu/Sighisoara",
      "attractions_name": "锡比乌开放式博物馆 (Astra国家博物馆建筑群)",
      "attractions_name_en": "Astra National Museum Complex",
      "description": "罗马尼亚最大的露天博物馆之一，展示各地的传统建筑、手工艺和生活方式。",
      "official_link": "https://www.muzeulastra.ro/",
      "price_range": "40",
      "currency": "RON",
      "description_en": "One of Romania's largest open-air museums—traditional buildings, crafts and life.",
      "price_range_en": "RON 40",
      "official_link_en": "https://www.muzeulastra.ro/"
    },
    {
      "id": "RO",
      "cityname": "锡比乌/西吉什瓦拉",
      "cityname_en": "Sibiu/Sighisoara",
      "attractions_name": "西吉什瓦拉历史中心",
      "attractions_name_en": "Sighișoara Historic Centre",
      "description": "联合国教科文组织世界遗产，保存完好的中世纪城堡城市，也是德古拉的诞生地。",
      "official_link": "无官方购票链接，为公共区域（部分景点/塔楼收费）",
      "price_range": "免费（钟楼约15）",
      "currency": "RON",
      "description_en": "UNESCO World Heritage—well-preserved medieval citadel; Dracula's birthplace.",
      "price_range_en": "Free (clock tower ~RON 15)",
      "official_link_en": "无官方购票链接，为公共区域（部分景点/塔楼收费）"
    },
    {
      "id": "RO",
      "cityname": "锡比乌/西吉什瓦拉",
      "cityname_en": "Sibiu/Sighisoara",
      "attractions_name": "西吉什瓦拉钟楼",
      "attractions_name_en": "Clock Tower (Sighișoara)",
      "description": "西吉什瓦拉的标志性建筑，可登顶俯瞰城市全景，内部是历史博物馆。",
      "official_link": "不支持线上购票",
      "price_range": "15 - 20",
      "currency": "RON",
      "description_en": "Sighișoara's icon—climb for city views; history museum inside.",
      "price_range_en": "RON 15–20",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "RO",
      "cityname": "锡比乌/西吉什瓦拉",
      "cityname_en": "Sibiu/Sighisoara",
      "attractions_name": "福加拉什山脉 (喀尔巴阡山脉)",
      "attractions_name_en": "Făgăraș Mountains (Carpathians)",
      "description": "喀尔巴阡山脉的一部分，拥有壮丽的徒步路线和高山湖泊，包括著名的特兰西瓦尼亚阿尔卑斯公路。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RON",
      "description_en": "Part of the Carpathians—hiking trails, alpine lakes and Transfăgărășan road.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AL",
      "cityname": "地拉那",
      "cityname_en": "Tirana",
      "attractions_name": "斯坎德培广场",
      "attractions_name_en": "Skanderbeg Square",
      "description": "地拉那的中心广场，周围环绕着国家历史博物馆、埃特姆贝伊清真寺和钟楼。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ALL",
      "description_en": "Tirana's central square—National History Museum, Et'hem Bey Mosque and clock tower.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AL",
      "cityname": "地拉那",
      "cityname_en": "Tirana",
      "attractions_name": "埃特姆贝伊清真寺",
      "attractions_name_en": "Et'hem Bey Mosque",
      "description": "位于斯坎德培广场，一座精美的奥斯曼时期清真寺，内部装饰有壁画。",
      "official_link": "无门票，免费参观（开放时间有限）",
      "price_range": "免费",
      "currency": "ALL",
      "description_en": "On Skanderbeg Square—fine Ottoman mosque with interior frescoes.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（开放时间有限）"
    },
    {
      "id": "AL",
      "cityname": "地拉那",
      "cityname_en": "Tirana",
      "attractions_name": "国家历史博物馆",
      "attractions_name_en": "National Historical Museum",
      "description": "阿尔巴尼亚最大的博物馆，通过各种展品讲述阿尔巴尼亚从史前到现代的历史。",
      "official_link": "https://www.mhk.gov.al",
      "price_range": "500 - 700",
      "currency": "ALL",
      "description_en": "Albania's largest museum—from prehistory to the present.",
      "price_range_en": "ALL 500–700",
      "official_link_en": "https://www.mhk.gov.al"
    },
    {
      "id": "AL",
      "cityname": "地拉那",
      "cityname_en": "Tirana",
      "attractions_name": "地拉那金字塔",
      "attractions_name_en": "Pyramid of Tirana",
      "description": "曾是霍查女儿的纪念馆，现在是一座废弃的混凝土建筑，正在改造中，成为地拉那的独特地标。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "ALL",
      "description_en": "Former Hoxha daughter's memorial—abandoned concrete pyramid; being repurposed.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "AL",
      "cityname": "地拉那",
      "cityname_en": "Tirana",
      "attractions_name": "恩维尔·霍查故居 (Bunk'Art 1)",
      "attractions_name_en": "Bunk'Art 1",
      "description": "位于地拉那郊区，一个巨大的地下碉堡，现已改造为博物馆，展示冷战时期的历史。",
      "official_link": "https://bunkart.al/",
      "price_range": "500 - 700",
      "currency": "ALL",
      "description_en": "Huge underground bunker in the suburbs—now a Cold War history museum.",
      "price_range_en": "ALL 500–700",
      "official_link_en": "https://bunkart.al/"
    },
    {
      "id": "AL",
      "cityname": "地拉那",
      "cityname_en": "Tirana",
      "attractions_name": "布洛库区",
      "attractions_name_en": "Blloku District",
      "description": "曾是共产主义精英的专属区域，现在是地拉那最时尚的街区，有众多酒吧、餐厅和精品店。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮消费另计）",
      "currency": "ALL",
      "description_en": "Former communist elite area—now Tirana's trendiest quarter; bars, restaurants and boutiques.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AL",
      "cityname": "培拉特",
      "cityname_en": "Berat",
      "attractions_name": "培拉特城堡",
      "attractions_name_en": "Berat Castle",
      "description": "联合国教科文组织世界遗产，位于山顶的古老城堡，内部仍有居民居住和教堂。",
      "official_link": "不支持线上购票",
      "price_range": "300 - 500",
      "currency": "ALL",
      "description_en": "UNESCO World Heritage—ancient castle on the hill; still inhabited; churches inside.",
      "price_range_en": "ALL 300–500",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "AL",
      "cityname": "培拉特",
      "cityname_en": "Berat",
      "attractions_name": "欧努弗里国家图标博物馆",
      "attractions_name_en": "National Iconographic Museum \"\"Onufri\"\"",
      "description": "位于培拉特城堡内，收藏了著名画家欧努弗里及其追随者的拜占庭式图标。",
      "official_link": "不支持线上购票",
      "price_range": "500",
      "currency": "ALL",
      "description_en": "Inside the castle—Byzantine icons by Onufri and followers.",
      "price_range_en": "ALL 500",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "AL",
      "cityname": "培拉特",
      "cityname_en": "Berat",
      "attractions_name": "圣三一教堂",
      "attractions_name_en": "Holy Trinity Church",
      "description": "培拉特城堡内的一座拜占庭式教堂，以其独特的建筑和壁画而闻名。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "ALL",
      "description_en": "Byzantine church inside the castle—distinctive architecture and frescoes.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "AL",
      "cityname": "培拉特",
      "cityname_en": "Berat",
      "attractions_name": "奥苏姆峡谷",
      "attractions_name_en": "Osum Canyon",
      "description": "位于培拉特附近，阿尔巴尼亚最美丽的峡谷之一，夏季可漂流，冬季可观赏景色。",
      "official_link": "无官方购票链接，为自然区域",
      "price_range": "免费（漂流等活动另计）",
      "currency": "ALL",
      "description_en": "Near Berat—one of Albania's most beautiful gorges; rafting in summer.",
      "price_range_en": "Free (rafting etc. extra)",
      "official_link_en": "无官方购票链接，为自然区域"
    },
    {
      "id": "AL",
      "cityname": "培拉特",
      "cityname_en": "Berat",
      "attractions_name": "铅清真寺",
      "attractions_name_en": "Lead Mosque",
      "description": "培拉特的标志性建筑之一，因其铅制穹顶而得名，是奥斯曼时期的建筑。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "ALL",
      "description_en": "One of Berat's icons—lead dome; Ottoman-era mosque.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "AL",
      "cityname": "培拉特",
      "cityname_en": "Berat",
      "attractions_name": "马古勒姆区与戈里察区",
      "attractions_name_en": "Mangalem and Gorica Quarters",
      "description": "培拉特老城区的两个主要部分，拥有独特的奥斯曼风格房屋，被称为“千窗之城”。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ALL",
      "description_en": "Two main quarters of the old town—Ottoman-style houses; \"city of a thousand windows\".",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AL",
      "cityname": "萨兰达/吉诺卡斯特 (阿尔巴尼亚里维埃拉/南部)",
      "cityname_en": "Sarandë/Gjirokastër (Albanian Riviera/South)",
      "attractions_name": "布特林特考古公园",
      "attractions_name_en": "Butrint Archaeological Park",
      "description": "联合国教科文组织世界遗产，位于萨兰达附近，是保存完好的古希腊和罗马遗址。",
      "official_link": "不支持线上购票",
      "price_range": "1000",
      "currency": "ALL",
      "description_en": "UNESCO World Heritage—near Sarandë; well-preserved Greek and Roman ruins.",
      "price_range_en": "ALL 1000",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "AL",
      "cityname": "萨兰达/吉诺卡斯特",
      "cityname_en": "Sarandë/Gjirokastër",
      "attractions_name": "蓝眼睛泉",
      "attractions_name_en": "Blue Eye Spring (Syri i Kaltër)",
      "description": "位于萨兰达和吉诺卡斯特之间，一个深邃的喀斯特泉水，水面呈现出令人惊叹的蓝色。",
      "official_link": "不支持线上购票",
      "price_range": "50 - 100 (入场费)",
      "currency": "ALL",
      "description_en": "Between Sarandë and Gjirokastër—deep karst spring; stunning blue water.",
      "price_range_en": "ALL 50–100 (entry)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "AL",
      "cityname": "萨兰达/吉诺卡斯特",
      "cityname_en": "Sarandë/Gjirokastër",
      "attractions_name": "吉诺卡斯特城堡",
      "attractions_name_en": "Gjirokastër Castle",
      "description": "联合国教科文组织世界遗产，位于高处的城堡，拥有军事博物馆和可俯瞰吉诺卡斯特全景。",
      "official_link": "不支持线上购票",
      "price_range": "400 - 500",
      "currency": "ALL",
      "description_en": "UNESCO World Heritage—castle on the hill; military museum; views over Gjirokastër.",
      "price_range_en": "ALL 400–500",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "AL",
      "cityname": "萨兰达/吉诺卡斯特",
      "cityname_en": "Sarandë/Gjirokastër",
      "attractions_name": "吉诺卡斯特老城",
      "attractions_name_en": "Gjirokastër Old Town",
      "description": "联合国教科文组织世界遗产，独特的奥斯曼风格石屋，被称为“石头之城”。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ALL",
      "description_en": "UNESCO World Heritage—Ottoman stone houses; \"city of stone\".",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AL",
      "cityname": "萨兰达/吉诺卡斯特",
      "cityname_en": "Sarandë/Gjirokastër",
      "attractions_name": "萨兰达海滨",
      "attractions_name_en": "Sarandë Promenade",
      "description": "萨兰达的海滨长廊，有餐厅、咖啡馆和商店，是夏季休闲的好去处。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ALL",
      "description_en": "Sarandë's seafront promenade—restaurants, cafés and shops; summer relaxation.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AL",
      "cityname": "萨兰达/吉诺卡斯特",
      "cityname_en": "Sarandë/Gjirokastër",
      "attractions_name": "克萨米尔海滩",
      "attractions_name_en": "Ksamil Beaches",
      "description": "位于萨兰达附近，以其白色沙滩和清澈碧绿的海水而闻名，被称为“阿尔巴尼亚的马尔代夫”。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费（沙滩椅/遮阳伞租赁另计）",
      "currency": "ALL",
      "description_en": "Near Sarandë—white sand and turquoise water; \"Albanian Maldives\".",
      "price_range_en": "Free (sunbed/umbrella rental extra)",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "BG",
      "cityname": "索非亚",
      "cityname_en": "Sofia",
      "attractions_name": "亚历山大·涅夫斯基大教堂",
      "attractions_name_en": "Alexander Nevsky Cathedral",
      "description": "东南欧最大的东正教教堂之一，宏伟的镀金圆顶建筑，是索非亚的标志。",
      "official_link": "无门票，免费参观（地下室/博物馆可能收费）",
      "price_range": "免费（博物馆约 8）",
      "currency": "BGN",
      "description_en": "One of Southeast Europe's largest Orthodox churches—golden domes; Sofia's icon.",
      "price_range_en": "Free (museum ~BGN 8)",
      "official_link_en": "无门票，免费参观（地下室/博物馆可能收费）"
    },
    {
      "id": "BG",
      "cityname": "索非亚",
      "cityname_en": "Sofia",
      "attractions_name": "维托沙山",
      "attractions_name_en": "Vitosha Mountain",
      "description": "索非亚市郊的天然公园，是徒步、滑雪和休闲的好去处，可俯瞰城市全景。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（缆车票另计）",
      "currency": "BGN",
      "description_en": "Natural park on Sofia's doorstep—hiking, skiing and relaxation; city views.",
      "price_range_en": "Free (cable car extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BG",
      "cityname": "索非亚",
      "cityname_en": "Sofia",
      "attractions_name": "圣乔治圆形教堂",
      "attractions_name_en": "St. George Rotunda Church",
      "description": "索非亚最古老的建筑，罗马时期圆形教堂，位于现代建筑群中，是独特的历史遗迹。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "BGN",
      "description_en": "Sofia's oldest building—Roman rotunda; unique historic site among modern buildings.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BG",
      "cityname": "索非亚",
      "cityname_en": "Sofia",
      "attractions_name": "国家历史博物馆",
      "attractions_name_en": "National Historical Museum",
      "description": "保加利亚最大的博物馆，收藏了从史前到现代的丰富文物，展示保加利亚历史。",
      "official_link": "https://historymuseum.org/entonim-bulgari/",
      "price_range": "10-15",
      "currency": "BGN",
      "description_en": "Bulgaria's largest museum—rich collections from prehistory to the present.",
      "price_range_en": "BGN 10–15",
      "official_link_en": "https://historymuseum.org/entonim-bulgari/"
    },
    {
      "id": "BG",
      "cityname": "索非亚",
      "cityname_en": "Sofia",
      "attractions_name": "博亚纳教堂",
      "attractions_name_en": "Boyana Church",
      "description": "联合国教科文组织世界遗产，位于维托沙山脚，以其精美的中世纪壁画而闻名。",
      "official_link": "https://boyanachurch.org/en/",
      "price_range": "10",
      "currency": "BGN",
      "description_en": "UNESCO World Heritage—at the foot of Vitosha; famous medieval frescoes.",
      "price_range_en": "BGN 10",
      "official_link_en": "https://boyanachurch.org/en/"
    },
    {
      "id": "BG",
      "cityname": "索非亚",
      "cityname_en": "Sofia",
      "attractions_name": "班亚巴什清真寺",
      "attractions_name_en": "Banya Bashi Mosque",
      "description": "索非亚唯一的奥斯曼时期清真寺，以其独特的穹顶和尖塔而闻名。",
      "official_link": "无门票，免费参观（需遵守宗教礼仪）",
      "price_range": "免费",
      "currency": "BGN",
      "description_en": "Sofia's only Ottoman mosque—distinctive dome and minaret.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（需遵守宗教礼仪）"
    },
    {
      "id": "BG",
      "cityname": "普罗夫迪夫",
      "cityname_en": "Plovdiv",
      "attractions_name": "普罗夫迪夫古罗马剧场",
      "attractions_name_en": "Ancient Roman Theatre of Plovdiv",
      "description": "保存完好的古罗马剧场，至今仍用于音乐会和演出，可俯瞰城市。",
      "official_link": "https://oldplovdiv.com/en/sights/ancient-theatre",
      "price_range": "8-10",
      "currency": "BGN",
      "description_en": "Well-preserved Roman theatre—still used for concerts; city views.",
      "price_range_en": "BGN 8–10",
      "official_link_en": "https://oldplovdiv.com/en/sights/ancient-theatre"
    },
    {
      "id": "BG",
      "cityname": "普罗夫迪夫",
      "cityname_en": "Plovdiv",
      "attractions_name": "老城",
      "attractions_name_en": "Old Town (Stari Grad)",
      "description": "普罗夫迪夫历史悠久的老城区，拥有独特的保加利亚复兴时期房屋、鹅卵石街道和艺术画廊。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BGN",
      "description_en": "Historic old town—Bulgarian Revival houses, cobbled streets and art galleries.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BG",
      "cityname": "普罗夫迪夫",
      "cityname_en": "Plovdiv",
      "attractions_name": "查尔斯·卡普勒弗故居博物馆",
      "attractions_name_en": "Balabanov House (Klianti House)",
      "description": "老城内典型的保加利亚复兴时期豪宅，现为博物馆和艺术画廊，展示当地文化。",
      "official_link": "https://oldplovdiv.com/en/museums/balabanov-house",
      "price_range": "5-8",
      "currency": "BGN",
      "description_en": "Typical Bulgarian Revival mansion in the old town—museum and art gallery.",
      "price_range_en": "BGN 5–8",
      "official_link_en": "https://oldplovdiv.com/en/museums/balabanov-house"
    },
    {
      "id": "BG",
      "cityname": "普罗夫迪夫",
      "cityname_en": "Plovdiv",
      "attractions_name": "乌兹哈尔斯基钟楼",
      "attractions_name_en": "Clock Tower (Sahat Tepe)",
      "description": "位于普罗夫迪夫最高点之一的萨哈特山，可登顶俯瞰城市全景。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BGN",
      "description_en": "On one of Plovdiv's hills—climb the clock tower for city views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BG",
      "cityname": "普罗夫迪夫",
      "cityname_en": "Plovdiv",
      "attractions_name": "萨马里坦人雕塑",
      "attractions_name_en": "Alyosha Monument",
      "description": "纪念苏联士兵的巨大雕塑，位于解放者山顶，可俯瞰普罗夫迪夫。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BGN",
      "description_en": "Monument to Soviet soldiers—on Liberators Hill; views over Plovdiv.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BG",
      "cityname": "普罗夫迪夫",
      "cityname_en": "Plovdiv",
      "attractions_name": "卡帕纳区 (创意区)",
      "attractions_name_en": "Kapana Creative District",
      "description": "老城附近的艺术街区，有众多手工艺品店、咖啡馆、酒吧和涂鸦艺术。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（购物消费另计）",
      "currency": "BGN",
      "description_en": "Arts quarter near the old town—crafts, cafés, bars and street art.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BG",
      "cityname": "瓦尔纳/黑海沿岸",
      "cityname_en": "Varna/Black Sea Coast",
      "attractions_name": "瓦尔纳大教堂",
      "attractions_name_en": "Assumption of the Theotokos Cathedral",
      "description": "瓦尔纳的标志，东正教大教堂，拥有精美的壁画和木雕，是保加利亚最大的教堂之一。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "BGN",
      "description_en": "Varna's icon—Orthodox cathedral; frescoes and woodcarving; one of Bulgaria's largest.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BG",
      "cityname": "瓦尔纳/黑海沿岸",
      "cityname_en": "Varna/Black Sea Coast",
      "attractions_name": "瓦尔纳海滨公园",
      "attractions_name_en": "Sea Garden (Morska Gradina)",
      "description": "瓦尔纳的海滨公园，拥有长长的步道、博物馆、水族馆和海豚馆。",
      "official_link": "无官方购票链接，为公共公园（部分景点/场馆收费）",
      "price_range": "免费（海豚馆约 30）",
      "currency": "BGN",
      "description_en": "Seaside park—long promenade, museums, aquarium and dolphinarium.",
      "price_range_en": "Free (dolphinarium ~BGN 30)",
      "official_link_en": "无官方购票链接，为公共公园（部分景点/场馆收费）"
    },
    {
      "id": "BG",
      "cityname": "瓦尔纳/黑海沿岸",
      "cityname_en": "Varna/Black Sea Coast",
      "attractions_name": "瓦尔纳考古博物馆",
      "attractions_name_en": "Varna Archaeological Museum",
      "description": "收藏了“瓦尔纳金”——世界上最古老的黄金工艺品，以及其他罗马和希腊文物。",
      "official_link": "https://www.museumvarna.com/",
      "price_range": "10-15",
      "currency": "BGN",
      "description_en": "\"Varna Gold\"—world's oldest gold work; Roman and Greek artefacts.",
      "price_range_en": "BGN 10–15",
      "official_link_en": "https://www.museumvarna.com/"
    },
    {
      "id": "BG",
      "cityname": "瓦尔纳/黑海沿岸",
      "cityname_en": "Varna/Black Sea Coast",
      "attractions_name": "黄金海岸 (金沙度假村)",
      "attractions_name_en": "Golden Sands Resort",
      "description": "位于瓦尔纳附近，保加利亚最著名的黑海海滨度假胜地，拥有金色沙滩和水上活动。",
      "official_link": "无官方购票链接，为公共海滩/度假区",
      "price_range": "免费（水上活动/设施租赁另计）",
      "currency": "BGN",
      "description_en": "Near Varna—Bulgaria's most famous Black Sea resort; golden sand and water sports.",
      "price_range_en": "Free (activities/rental extra)",
      "official_link_en": "无官方购票链接，为公共海滩/度假区"
    },
    {
      "id": "BG",
      "cityname": "瓦尔纳/黑海沿岸",
      "cityname_en": "Varna/Black Sea Coast",
      "attractions_name": "石森林 (迪维迪卡梅尼)",
      "attractions_name_en": "Pobiti Kamani (Stone Forest)",
      "description": "位于瓦尔纳附近，独特的自然现象，由天然形成的石柱组成，仿佛一片“石树林”。",
      "official_link": "不支持线上购票",
      "price_range": "3-5",
      "currency": "BGN",
      "description_en": "Near Varna—unique natural stone columns; \"petrified forest\".",
      "price_range_en": "BGN 3–5",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "BG",
      "cityname": "瓦尔纳/黑海沿岸",
      "cityname_en": "Varna/Black Sea Coast",
      "attractions_name": "内塞巴尔古城",
      "attractions_name_en": "Nesebar Old Town",
      "description": "联合国教科文组织世界遗产，位于瓦尔纳以南，黑海沿岸的古老城镇，拥有丰富的历史和教堂遗址。",
      "official_link": "无官方购票链接，为公共区域（部分教堂/博物馆收费）",
      "price_range": "免费（部分教堂约 5）",
      "currency": "BGN",
      "description_en": "UNESCO World Heritage—south of Varna; ancient town on the Black Sea; churches and history.",
      "price_range_en": "Free (some churches ~BGN 5)",
      "official_link_en": "无官方购票链接，为公共区域（部分教堂/博物馆收费）"
    },
    {
      "id": "MT",
      "cityname": "瓦莱塔",
      "cityname_en": "Valletta",
      "attractions_name": "圣约翰大教堂",
      "attractions_name_en": "St. John's Co-Cathedral",
      "description": "宏伟的巴洛克式教堂，内部装饰极尽奢华，收藏了卡拉瓦乔的名画《圣约翰的斩首》。",
      "official_link": "https://stjohnscocathedral.com/",
      "price_range": "15",
      "currency": "EUR",
      "description_en": "Grand Baroque church—lavish interior; Caravaggio's Beheading of St John.",
      "price_range_en": "€15",
      "official_link_en": "https://stjohnscocathedral.com/"
    },
    {
      "id": "MT",
      "cityname": "瓦莱塔",
      "cityname_en": "Valletta",
      "attractions_name": "上巴拉卡花园",
      "attractions_name_en": "Upper Barrakka Gardens",
      "description": "位于瓦莱塔高处的公共花园，可俯瞰大港和三姐妹城，每日有礼炮仪式。",
      "official_link": "无官方购票链接，为公共花园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Public gardens on the heights—views over Grand Harbour and Three Cities; daily gun salute.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为公共花园"
    },
    {
      "id": "MT",
      "cityname": "瓦莱塔",
      "cityname_en": "Valletta",
      "attractions_name": "大港",
      "attractions_name_en": "Grand Harbour",
      "description": "欧洲最深的天然港口之一，历史悠久，是马耳他的战略要地，风景优美。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Europe's deepest natural harbours—historic; Malta's strategic heart.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MT",
      "cityname": "瓦莱塔",
      "cityname_en": "Valletta",
      "attractions_name": "马耳他考古博物馆",
      "attractions_name_en": "National Museum of Archaeology",
      "description": "位于一座精美的巴洛克建筑内，收藏了马耳他史前时期的重要文物，包括“马耳他维纳斯”。",
      "official_link": "https://heritagemalta.mt/explore/national-museum-of-archaeology/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "In a fine Baroque building—Malta's prehistoric treasures; \"Venus of Malta\".",
      "price_range_en": "€10",
      "official_link_en": "https://heritagemalta.mt/explore/national-museum-of-archaeology/"
    },
    {
      "id": "MT",
      "cityname": "瓦莱塔",
      "cityname_en": "Valletta",
      "attractions_name": "骑士团宫",
      "attractions_name_en": "Grandmaster's Palace",
      "description": "曾是马耳他骑士团大团长的居所，现在是马耳他总统府和议会所在地，部分区域对外开放。",
      "official_link": "https://heritagemalta.mt/explore/the-grandmasters-palace/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Former Grand Master's palace—now President's office and parliament; parts open to visitors.",
      "price_range_en": "€12",
      "official_link_en": "https://heritagemalta.mt/explore/the-grandmasters-palace/"
    },
    {
      "id": "MT",
      "cityname": "瓦莱塔",
      "cityname_en": "Valletta",
      "attractions_name": "瓦莱塔海滨",
      "attractions_name_en": "Valletta Waterfront",
      "description": "经过翻新的历史码头区，拥有色彩鲜艳的仓库建筑，现在是餐厅、商店和邮轮码头。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮消费另计）",
      "currency": "EUR",
      "description_en": "Renovated historic waterfront—colourful warehouse buildings; restaurants, shops and cruise terminal.",
      "price_range_en": "Free (meals extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MT",
      "cityname": "姆迪纳/拉巴特",
      "cityname_en": "Mdina/Rabat",
      "attractions_name": "姆迪纳古城 (寂静之城)",
      "attractions_name_en": "Mdina Old City (Silent City)",
      "description": "历史悠久的城墙小镇，曾是马耳他首都，保留了中世纪和巴洛克式建筑，氛围宁静。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Historic walled town—former capital; medieval and Baroque; peaceful.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MT",
      "cityname": "姆迪纳/拉巴特",
      "cityname_en": "Mdina/Rabat",
      "attractions_name": "圣保罗大教堂 (姆迪纳)",
      "attractions_name_en": "St. Paul's Cathedral (Mdina)",
      "description": "姆迪纳的标志性教堂，巴洛克风格，内部装饰华丽，有精美的壁画和雕塑。",
      "official_link": "https://metropolitanchapter.com/mdina-metropolitan-cathedral/",
      "price_range": "10 (含博物馆)",
      "currency": "EUR",
      "description_en": "Mdina's icon—Baroque cathedral; lavish interior; frescoes and sculpture.",
      "price_range_en": "€10 (incl. museum)",
      "official_link_en": "https://metropolitanchapter.com/mdina-metropolitan-cathedral/"
    },
    {
      "id": "MT",
      "cityname": "姆迪纳/拉巴特",
      "cityname_en": "Mdina/Rabat",
      "attractions_name": "圣保罗石窟与博物馆 (拉巴特)",
      "attractions_name_en": "St. Paul's Catacombs and Grotto (Rabat)",
      "description": "位于拉巴特，古代地下墓穴和石窟，传说圣保罗曾在此避难。",
      "official_link": "https://heritagemalta.mt/explore/st-pauls-catacombs/",
      "price_range": "6 (石窟), 8 (地下墓穴)",
      "currency": "EUR",
      "description_en": "In Rabat—ancient catacombs and grotto; St Paul said to have sheltered here.",
      "price_range_en": "€6 (grotto), €8 (catacombs)",
      "official_link_en": "https://heritagemalta.mt/explore/st-pauls-catacombs/"
    },
    {
      "id": "MT",
      "cityname": "姆迪纳/拉巴特",
      "cityname_en": "Mdina/Rabat",
      "attractions_name": "罗马别墅 (拉巴特)",
      "attractions_name_en": "Domus Romana (Roman Villa)",
      "description": "位于拉巴特，展示罗马时期别墅遗址，特别是精美的马赛克地板。",
      "official_link": "https://heritagemalta.mt/explore/domus-romana/",
      "price_range": "6",
      "currency": "EUR",
      "description_en": "In Rabat—Roman villa remains; fine mosaic floors.",
      "price_range_en": "€6",
      "official_link_en": "https://heritagemalta.mt/explore/domus-romana/"
    },
    {
      "id": "MT",
      "cityname": "姆迪纳/拉巴特",
      "cityname_en": "Mdina/Rabat",
      "attractions_name": "丁利悬崖",
      "attractions_name_en": "Dingli Cliffs",
      "description": "马耳他岛的最高点，提供壮丽的海景和日落景观，是徒步和观鸟的好地方。",
      "official_link": "无官方购票链接，为自然区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Malta's highest point—dramatic sea and sunset views; hiking and birdwatching.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为自然区域"
    },
    {
      "id": "MT",
      "cityname": "姆迪纳/拉巴特",
      "cityname_en": "Mdina/Rabat",
      "attractions_name": "圣阿加莎教堂和地下室",
      "attractions_name_en": "St. Agatha's Church and Crypt (Rabat)",
      "description": "拉巴特的另一处历史悠久的教堂和地下墓穴，壁画独特。",
      "official_link": "不支持线上购买",
      "price_range": "5",
      "currency": "EUR",
      "description_en": "Another historic church and catacombs in Rabat—distinctive frescoes.",
      "price_range_en": "€5",
      "official_link_en": "不支持线上购买"
    },
    {
      "id": "MT",
      "cityname": "戈佐岛/科米诺岛",
      "cityname_en": "Gozo/Comino",
      "attractions_name": "蓝窗遗址 (达维拉之窗)",
      "attractions_name_en": "Azure Window Site (Dwejra Bay)",
      "description": "虽然著名的蓝窗已坍塌，但该区域仍有壮丽的海岸线、内海和蘑菇岩等自然景观。",
      "official_link": "无官方购票链接，为自然区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Famous Azure Window collapsed—area still has stunning coastline, inland sea and mushroom rock.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为自然区域"
    },
    {
      "id": "MT",
      "cityname": "戈佐岛/科米诺岛",
      "cityname_en": "Gozo/Comino",
      "attractions_name": "奇塔德拉 (维多利亚城堡)",
      "attractions_name_en": "Cittadella (Victoria Citadel)",
      "description": "戈佐岛的中心，一座历史悠久的防御城堡，可俯瞰戈佐岛全景。",
      "official_link": "https://heritagemalta.mt/explore/cittadella-visitor-centre/",
      "price_range": "5 (游客中心/部分博物馆)",
      "currency": "EUR",
      "description_en": "Heart of Gozo—historic citadel; views over the island.",
      "price_range_en": "€5 (visitor centre/some museums)",
      "official_link_en": "https://heritagemalta.mt/explore/cittadella-visitor-centre/"
    },
    {
      "id": "MT",
      "cityname": "戈佐岛/科米诺岛",
      "cityname_en": "Gozo/Comino",
      "attractions_name": "巨石阵庙群 (Ggantija Temples)",
      "attractions_name_en": "Ggantija Temples",
      "description": "联合国教科文组织世界遗产，世界上最古老的独立式巨石建筑之一，比金字塔还古老。",
      "official_link": "https://heritagemalta.mt/explore/gantija-temples/",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—among the world's oldest free-standing stone structures; older than the pyramids.",
      "price_range_en": "€10",
      "official_link_en": "https://heritagemalta.mt/explore/gantija-temples/"
    },
    {
      "id": "MT",
      "cityname": "戈佐岛/科米诺岛",
      "cityname_en": "Gozo/Comino",
      "attractions_name": "蓝泻湖 (科米诺岛)",
      "attractions_name_en": "Blue Lagoon (Comino Island)",
      "description": "位于科米诺岛和科米诺托岛之间，以其令人惊叹的碧蓝色海水而闻名，是游泳和浮潜天堂。",
      "official_link": "无官方购票链接（乘船前往另计）",
      "price_range": "免费（船费约10-20）",
      "currency": "EUR",
      "description_en": "Between Comino and Cominotto—stunning turquoise water; swimming and snorkelling paradise.",
      "price_range_en": "Free (boat ~€10–20)",
      "official_link_en": "无官方购票链接（乘船前往另计）"
    },
    {
      "id": "MT",
      "cityname": "戈佐岛/科米诺岛",
      "cityname_en": "Gozo/Comino",
      "attractions_name": "塔'平教堂",
      "attractions_name_en": "Ta' Pinu Sanctuary",
      "description": "戈佐岛的重要朝圣地，一座美丽的教堂，据说有治愈奇迹。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Important pilgrimage site on Gozo—beautiful church; healing miracles.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "MT",
      "cityname": "戈佐岛/科米诺岛",
      "cityname_en": "Gozo/Comino",
      "attractions_name": "圣母升天大教堂 (维多利亚)",
      "attractions_name_en": "Gozo Cathedral (Victoria)",
      "description": "戈佐岛首府维多利亚的主要教堂，巴洛克风格，以其独特的幻觉圆顶而闻名。",
      "official_link": "无门票，免费参观（博物馆部分可能收费）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Victoria's main church—Baroque; famous trompe-l'œil dome.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（博物馆部分可能收费）"
    },
    {
      "id": "EE",
      "cityname": "塔林",
      "cityname_en": "Tallinn",
      "attractions_name": "塔林老城",
      "attractions_name_en": "Tallinn Old Town",
      "description": "联合国教科文组织世界遗产，保存完好的中世纪老城，拥有鹅卵石街道、历史建筑和城墙。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—well-preserved medieval old town; cobbled streets, walls and buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "EE",
      "cityname": "塔林",
      "cityname_en": "Tallinn",
      "attractions_name": "托姆比亚山与城堡",
      "attractions_name_en": "Toompea Hill & Castle",
      "description": "塔林老城制高点，拥有粉色的里吉科古堡和观景台，可俯瞰城市全景。",
      "official_link": "https://riigikogu.ee/en/visit-us/toompea-castle/",
      "price_range": "免费（部分区域可能收费）",
      "currency": "EUR",
      "description_en": "Highest point of the old town—Toompea Castle and viewpoints; city views.",
      "price_range_en": "Free (some areas may charge)",
      "official_link_en": "https://riigikogu.ee/en/visit-us/toompea-castle/"
    },
    {
      "id": "EE",
      "cityname": "塔林",
      "cityname_en": "Tallinn",
      "attractions_name": "亚历山大·涅夫斯基主教座堂",
      "attractions_name_en": "Alexander Nevsky Cathedral",
      "description": "塔林最大的东正教教堂，宏伟的洋葱头圆顶建筑，内部装饰华丽。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Tallinn's largest Orthodox church—onion domes; lavish interior.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "EE",
      "cityname": "塔林",
      "cityname_en": "Tallinn",
      "attractions_name": "市政厅广场",
      "attractions_name_en": "Town Hall Square (Raekoja Plats)",
      "description": "塔林老城的核心，中世纪风格的广场，周围环绕着哥特式市政厅和历史建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Heart of the old town—medieval square; Gothic town hall and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "EE",
      "cityname": "塔林",
      "cityname_en": "Tallinn",
      "attractions_name": "库姆艺术博物馆",
      "attractions_name_en": "Kumu Art Museum",
      "description": "爱沙尼亚最大的艺术博物馆，展示爱沙尼亚艺术史和国际当代艺术。",
      "official_link": "https://kumu.ekm.ee/en/",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Estonia's largest art museum—Estonian art history and international contemporary.",
      "price_range_en": "€12",
      "official_link_en": "https://kumu.ekm.ee/en/"
    },
    {
      "id": "EE",
      "cityname": "塔林",
      "cityname_en": "Tallinn",
      "attractions_name": "塔林电视塔",
      "attractions_name_en": "Tallinn TV Tower",
      "description": "爱沙尼亚最高的建筑，可登顶俯瞰塔林和芬兰湾的全景，有互动展览。",
      "official_link": "https://teletorn.ee/en/",
      "price_range": "18",
      "currency": "EUR",
      "description_en": "Estonia's tallest building—climb for Tallinn and Gulf of Finland views; interactive exhibits.",
      "price_range_en": "€18",
      "official_link_en": "https://teletorn.ee/en/"
    },
    {
      "id": "EE",
      "cityname": "塔尔图",
      "cityname_en": "Tartu",
      "attractions_name": "塔尔图大学",
      "attractions_name_en": "University of Tartu",
      "description": "爱沙尼亚最古老、最著名的大学，其主楼是塔尔图的标志性建筑。",
      "official_link": "https://www.ut.ee/en",
      "price_range": "免费（部分博物馆/景点收费）",
      "currency": "EUR",
      "description_en": "Estonia's oldest and most famous university—main building is Tartu's icon.",
      "price_range_en": "Free (some museums/sites charge)",
      "official_link_en": "https://www.ut.ee/en"
    },
    {
      "id": "EE",
      "cityname": "塔尔图",
      "cityname_en": "Tartu",
      "attractions_name": "塔尔图市政厅广场",
      "attractions_name_en": "Tartu Town Hall Square",
      "description": "塔尔图的中心，拥有市政厅和倾斜房屋等独特建筑，夏季有露天咖啡馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Tartu's centre—town hall and leaning house; outdoor cafés in summer.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "EE",
      "cityname": "塔尔图",
      "cityname_en": "Tartu",
      "attractions_name": "塔尔图大教堂废墟",
      "attractions_name_en": "Tartu Cathedral Ruins",
      "description": "位于大教堂山，曾经是宏伟的教堂，现在是浪漫的废墟，可登塔观景。",
      "official_link": "无需购票",
      "price_range": "免费（登塔约3）",
      "currency": "EUR",
      "description_en": "On Toomemägi—once grand cathedral; now romantic ruins; climb the tower for views.",
      "price_range_en": "Free (tower ~€3)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "EE",
      "cityname": "塔尔图",
      "cityname_en": "Tartu",
      "attractions_name": "爱沙尼亚国家博物馆",
      "attractions_name_en": "Estonian National Museum",
      "description": "现代化的博物馆，展示爱沙尼亚的文化、历史和民族志，互动性强。",
      "official_link": "https://www.erm.ee/en",
      "price_range": "14",
      "currency": "EUR",
      "description_en": "Modern museum—Estonian culture, history and ethnography; interactive.",
      "price_range_en": "€14",
      "official_link_en": "https://www.erm.ee/en"
    },
    {
      "id": "EE",
      "cityname": "塔尔图",
      "cityname_en": "Tartu",
      "attractions_name": "圣约翰教堂",
      "attractions_name_en": "St. John's Church (Jaani Kirik)",
      "description": "塔尔图最古老的教堂之一，以其独特的赤陶雕塑装饰而闻名。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Tartu's oldest churches—famous terracotta sculpture.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "EE",
      "cityname": "塔尔图",
      "cityname_en": "Tartu",
      "attractions_name": "艺术博物馆",
      "attractions_name_en": "Tartu Art Museum (Tartmus)",
      "description": "位于倾斜房屋内，展示爱沙尼亚和国际艺术品，以当代艺术为主。",
      "official_link": "https://tartmus.ee/en/",
      "price_range": "6-8",
      "currency": "EUR",
      "description_en": "In the leaning house—Estonian and international art; strong on contemporary.",
      "price_range_en": "€6–8",
      "official_link_en": "https://tartmus.ee/en/"
    },
    {
      "id": "EE",
      "cityname": "派尔努",
      "cityname_en": "Pärnu",
      "attractions_name": "派尔努海滩",
      "attractions_name_en": "Pärnu Beach",
      "description": "爱沙尼亚最受欢迎的海滨度假胜地，拥有长长的沙滩、海滨长廊和温泉疗养院。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Estonia's most popular seaside resort—long beach, promenade and spa.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "EE",
      "cityname": "派尔努",
      "cityname_en": "Pärnu",
      "attractions_name": "派尔努老城",
      "attractions_name_en": "Pärnu Old Town",
      "description": "迷人的老城区，有木制房屋、鹅卵石街道和历史建筑，适合漫步。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Charming old town—wooden houses, cobbled streets and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "EE",
      "cityname": "派尔努",
      "cityname_en": "Pärnu",
      "attractions_name": "派尔努博物馆",
      "attractions_name_en": "Pärnu Museum",
      "description": "展示派尔努地区从史前到现代的历史和文化。",
      "official_link": "https://parnumuuseum.ee/en/",
      "price_range": "9",
      "currency": "EUR",
      "description_en": "Pärnu from prehistory to the present—history and culture.",
      "price_range_en": "€9",
      "official_link_en": "https://parnumuuseum.ee/en/"
    },
    {
      "id": "EE",
      "cityname": "派尔努",
      "cityname_en": "Pärnu",
      "attractions_name": "凯旋门 (塔林门)",
      "attractions_name_en": "Tallinna Gate (Tallinn Gate)",
      "description": "派尔努古老城墙的唯一幸存大门，是城市历史的象征。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Only surviving gate of Pärnu's old walls—symbol of the city's history.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "EE",
      "cityname": "派尔努",
      "cityname_en": "Pärnu",
      "attractions_name": "派尔努码头",
      "attractions_name_en": "Pärnu Jetty",
      "description": "伸向波罗的海的长堤，是散步、观赏日落和钓鱼的好地方。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Long pier into the Baltic—stroll, sunset and fishing.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "EE",
      "cityname": "派尔努",
      "cityname_en": "Pärnu",
      "attractions_name": "红塔",
      "attractions_name_en": "Red Tower (Punane Torn)",
      "description": "派尔努最古老的防御建筑，曾是监狱，现在是博物馆和观景台。",
      "official_link": "不支持线上购票",
      "price_range": "5-7",
      "currency": "EUR",
      "description_en": "Pärnu's oldest defensive building—former prison; now museum and viewpoint.",
      "price_range_en": "€5–7",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "CY",
      "cityname": "尼科西亚",
      "cityname_en": "Nicosia",
      "attractions_name": "塞利米耶清真寺 (圣索菲亚大教堂)",
      "attractions_name_en": "Selimiye Mosque (St. Sophia Cathedral)",
      "description": "位于北尼科西亚，曾是哥特式大教堂，后被奥斯曼人改为清真寺，是独特的建筑融合。",
      "official_link": "无门票，免费参观（需遵守宗教礼仪）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "In North Nicosia—former Gothic cathedral, later mosque; unique blend of architecture.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（需遵守宗教礼仪）"
    },
    {
      "id": "CY",
      "cityname": "尼科西亚",
      "cityname_en": "Nicosia",
      "attractions_name": "莱德拉街",
      "attractions_name_en": "Ledra Street",
      "description": "尼科西亚的商业步行街，连接着南北塞浦路斯，有商店、咖啡馆和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Commercial pedestrian street—links north and south Cyprus; shops, cafés and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CY",
      "cityname": "尼科西亚",
      "cityname_en": "Nicosia",
      "attractions_name": "塞浦路斯博物馆",
      "attractions_name_en": "Cyprus Museum",
      "description": "塞浦路斯最大的考古博物馆，收藏了从新石器时代到罗马时期的丰富文物。",
      "official_link": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument",
      "price_range": "4.5",
      "currency": "EUR",
      "description_en": "Cyprus's largest archaeological museum—from Neolithic to Roman.",
      "price_range_en": "€4.50",
      "official_link_en": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument"
    },
    {
      "id": "CY",
      "cityname": "尼科西亚",
      "cityname_en": "Nicosia",
      "attractions_name": "威尼斯城墙",
      "attractions_name_en": "Venetian Walls",
      "description": "环绕尼科西亚老城的巨大防御工事，保存完好，是城市历史的见证。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Massive Venetian fortifications around the old town—well preserved.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CY",
      "cityname": "尼科西亚",
      "cityname_en": "Nicosia",
      "attractions_name": "法马古斯塔门",
      "attractions_name_en": "Famagusta Gate",
      "description": "尼科西亚威尼斯城墙上保存最好的城门之一，现在是文化中心。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Best-preserved gate in Nicosia's Venetian walls—now a culture centre.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "CY",
      "cityname": "尼科西亚",
      "cityname_en": "Nicosia",
      "attractions_name": "拜占庭博物馆",
      "attractions_name_en": "Byzantine Museum",
      "description": "位于圣约翰大教堂旁，收藏了大量拜占庭时期的图标、壁画和宗教文物。",
      "official_link": "https://www.nicosia.org.cy/en-GB/discover/museums/byzantine-museum/",
      "price_range": "4",
      "currency": "EUR",
      "description_en": "Next to St John's Cathedral—Byzantine icons, frescoes and religious art.",
      "price_range_en": "€4",
      "official_link_en": "https://www.nicosia.org.cy/en-GB/discover/museums/byzantine-museum/"
    },
    {
      "id": "CY",
      "cityname": "利马索尔",
      "cityname_en": "Limassol",
      "attractions_name": "利马索尔城堡",
      "attractions_name_en": "Limassol Castle",
      "description": "位于利马索尔老城中心，曾是理查一世结婚的地方，现在是中世纪博物馆。",
      "official_link": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument",
      "price_range": "4.5",
      "currency": "EUR",
      "description_en": "In the old town centre—where Richard I married; now medieval museum.",
      "price_range_en": "€4.50",
      "official_link_en": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument"
    },
    {
      "id": "CY",
      "cityname": "利马索尔",
      "cityname_en": "Limassol",
      "attractions_name": "阿马苏斯遗址",
      "attractions_name_en": "Ancient Amathus",
      "description": "位于利马索尔东部，古老的城邦遗址，有神庙、浴室和墓葬等遗迹。",
      "official_link": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument",
      "price_range": "2.5",
      "currency": "EUR",
      "description_en": "East of Limassol—ancient city-state; temples, baths and tombs.",
      "price_range_en": "€2.50",
      "official_link_en": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument"
    },
    {
      "id": "CY",
      "cityname": "利马索尔",
      "cityname_en": "Limassol",
      "attractions_name": "库里翁古城",
      "attractions_name_en": "Kourion Ancient Site",
      "description": "位于利马索尔西部，壮丽的古罗马和古希腊遗址，拥有剧场、马赛克和公共浴室。",
      "official_link": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument",
      "price_range": "4.5",
      "currency": "EUR",
      "description_en": "West of Limassol—spectacular Greco-Roman ruins; theatre, mosaics and baths.",
      "price_range_en": "€4.50",
      "official_link_en": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument"
    },
    {
      "id": "CY",
      "cityname": "利马索尔",
      "cityname_en": "Limassol",
      "attractions_name": "利马索尔滨海大道",
      "attractions_name_en": "Limassol Marina & Promenade",
      "description": "现代化的港口和海滨长廊，有豪华游艇、餐厅、咖啡馆和精品店。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮购物另计）",
      "currency": "EUR",
      "description_en": "Modern harbour and promenade—yachts, restaurants, cafés and boutiques.",
      "price_range_en": "Free (meals/shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "CY",
      "cityname": "利马索尔",
      "cityname_en": "Limassol",
      "attractions_name": "葡萄酒博物馆",
      "attractions_name_en": "Cyprus Wine Museum",
      "description": "位于利马索尔附近，展示塞浦路斯葡萄酒的历史和酿造过程，可品尝美酒。",
      "official_link": "https://cypruswinemuseum.com/",
      "price_range": "7 (含品酒)",
      "currency": "EUR",
      "description_en": "Near Limassol—Cyprus wine history and making; tastings included.",
      "price_range_en": "€7 (incl. tasting)",
      "official_link_en": "https://cypruswinemuseum.com/"
    },
    {
      "id": "CY",
      "cityname": "利马索尔",
      "cityname_en": "Limassol",
      "attractions_name": "科洛西城堡",
      "attractions_name_en": "Kolossi Castle",
      "description": "位于利马索尔附近，一座保存完好的中世纪十字军城堡，曾是圣约翰骑士团的据点。",
      "official_link": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument",
      "price_range": "2.5",
      "currency": "EUR",
      "description_en": "Near Limassol—well-preserved medieval Crusader castle; Knights of St John.",
      "price_range_en": "€2.50",
      "official_link_en": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument"
    },
    {
      "id": "CY",
      "cityname": "帕福斯/阿依纳帕 (西部/东部海岸)",
      "cityname_en": "Paphos/Ayia Napa (West/East Coast)",
      "attractions_name": "帕福斯考古公园",
      "attractions_name_en": "Paphos Archaeological Park",
      "description": "联合国教科文组织世界遗产，拥有丰富的古希腊和罗马遗址，尤其是精美的马赛克地板。",
      "official_link": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument",
      "price_range": "4.5",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—Greek and Roman ruins; fine mosaic floors.",
      "price_range_en": "€4.50",
      "official_link_en": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument"
    },
    {
      "id": "CY",
      "cityname": "帕福斯/阿依纳帕",
      "cityname_en": "Paphos/Ayia Napa",
      "attractions_name": "国王陵墓",
      "attractions_name_en": "Tombs of the Kings",
      "description": "联合国教科文组织世界遗产，巨大的地下墓穴群，曾是帕福斯贵族的安息之地，而非国王。",
      "official_link": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument",
      "price_range": "2.5",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—huge underground tombs; Paphos nobility, not kings.",
      "price_range_en": "€2.50",
      "official_link_en": "http://www.mcw.gov.cy/mcw/da/da.nsf/dmlindex_en/dmlindex_en?opendocument"
    },
    {
      "id": "CY",
      "cityname": "帕福斯/阿依纳帕",
      "cityname_en": "Paphos/Ayia Napa",
      "attractions_name": "阿芙罗狄蒂岩 (爱神岩)",
      "attractions_name_en": "Petra tou Romiou (Aphrodite's Rock)",
      "description": "传说中爱神阿芙罗狄蒂诞生的地方，风景优美的海蚀柱和海滩。",
      "official_link": "无官方购票链接，为自然区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Legendary birthplace of Aphrodite—scenic sea stacks and beach.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为自然区域"
    },
    {
      "id": "CY",
      "cityname": "帕福斯/阿依纳帕",
      "cityname_en": "Paphos/Ayia Napa",
      "attractions_name": "蓝泻湖 (阿卡马斯半岛)",
      "attractions_name_en": "Blue Lagoon (Akamas Peninsula)",
      "description": "位于阿卡马斯半岛，以其清澈碧蓝的海水而闻名，是游泳和浮潜的理想之地。",
      "official_link": "无官方购票链接（乘船前往另计）",
      "price_range": "免费（船费约20-30）",
      "currency": "EUR",
      "description_en": "On Akamas Peninsula—crystal-clear blue water; swimming and snorkelling.",
      "price_range_en": "Free (boat ~€20–30)",
      "official_link_en": "无官方购票链接（乘船前往另计）"
    },
    {
      "id": "CY",
      "cityname": "帕福斯/阿依纳帕",
      "cityname_en": "Paphos/Ayia Napa",
      "attractions_name": "尼西海滩",
      "attractions_name_en": "Nissi Beach",
      "description": "位于阿依纳帕，塞浦路斯最著名的海滩之一，以其白色沙滩和派对氛围而闻名。",
      "official_link": "无官方购票链接，为公共海滩",
      "price_range": "免费（沙滩椅/遮阳伞租赁另计）",
      "currency": "EUR",
      "description_en": "In Ayia Napa—one of Cyprus's most famous beaches; white sand and party vibe.",
      "price_range_en": "Free (sunbed/umbrella rental extra)",
      "official_link_en": "No official ticket link; public beach"
    },
    {
      "id": "CY",
      "cityname": "帕福斯/阿依纳帕",
      "cityname_en": "Paphos/Ayia Napa",
      "attractions_name": "阿依纳帕修道院",
      "attractions_name_en": "Ayia Napa Monastery",
      "description": "位于阿依纳帕中心，一座中世纪修道院，是该地区的重要历史地标。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "In the centre of Ayia Napa—medieval monastery; key historic landmark.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "SK",
      "cityname": "布拉迪斯拉发",
      "cityname_en": "Bratislava",
      "attractions_name": "布拉迪斯拉发城堡",
      "attractions_name_en": "Bratislava Castle",
      "description": "位于多瑙河畔的山顶，是城市的地标，可俯瞰布拉迪斯拉发全景，内部有历史博物馆。",
      "official_link": "无官方购买链接",
      "price_range": "12",
      "currency": "EUR",
      "description_en": "Castle on the hill above the Danube—city icon; city views; history museum inside.",
      "price_range_en": "€12",
      "official_link_en": "无官方购买链接"
    },
    {
      "id": "SK",
      "cityname": "布拉迪斯拉发",
      "cityname_en": "Bratislava",
      "attractions_name": "圣马丁大教堂",
      "attractions_name_en": "St. Martin's Cathedral",
      "description": "布拉迪斯拉发最古老、最重要的教堂之一，曾是匈牙利国王的加冕教堂。",
      "official_link": "无需购票",
      "price_range": "免费（部分区域可能收费，如登塔）",
      "currency": "EUR",
      "description_en": "One of Bratislava's oldest and most important churches—Hungarian kings' coronation church.",
      "price_range_en": "Free (tower may charge)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "SK",
      "cityname": "布拉迪斯拉发",
      "cityname_en": "Bratislava",
      "attractions_name": "老城 (星城)",
      "attractions_name_en": "Old Town (Staré Mesto)",
      "description": "布拉迪斯拉发历史悠久的中心，鹅卵石街道，有许多酒吧、餐厅和独特雕塑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Bratislava's historic centre—cobbled streets; bars, restaurants and quirky sculptures.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SK",
      "cityname": "布拉迪斯拉发",
      "cityname_en": "Bratislava",
      "attractions_name": "蓝教堂 (圣伊丽莎白教堂)",
      "attractions_name_en": "Blue Church (Church of St. Elisabeth)",
      "description": "布拉迪斯拉发最独特的建筑之一，新艺术风格的蓝色教堂，外观非常引人注目。",
      "official_link": "无门票，免费参观（开放时间有限）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of Bratislava's most distinctive buildings—Art Nouveau blue church.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（开放时间有限）"
    },
    {
      "id": "SK",
      "cityname": "布拉迪斯拉发",
      "cityname_en": "Bratislava",
      "attractions_name": "尤弗卡塔 (圣迈克尔门)",
      "attractions_name_en": "St. Michael's Gate",
      "description": "布拉迪斯拉发老城唯一保存下来的中世纪城门，可登塔俯瞰老城景色。",
      "official_link": "无官方购买链接",
      "price_range": "6",
      "currency": "EUR",
      "description_en": "Only surviving medieval gate in the old town—climb the tower for old town views.",
      "price_range_en": "€6",
      "official_link_en": "无官方购买链接"
    },
    {
      "id": "SK",
      "cityname": "布拉迪斯拉发",
      "cityname_en": "Bratislava",
      "attractions_name": "斯拉维城堡 (斯拉夫纪念碑)",
      "attractions_name_en": "Slavín Memorial",
      "description": "纪念二战中解放布拉迪斯拉发的苏联士兵的纪念碑，位于高处，可俯瞰城市。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Monument to Soviet soldiers who liberated Bratislava in WWII—on the hill; city views.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SK",
      "cityname": "科希策",
      "cityname_en": "Košice",
      "attractions_name": "圣伊丽莎白大教堂",
      "attractions_name_en": "St. Elisabeth Cathedral",
      "description": "斯洛伐克最大的教堂，哥特式建筑杰作，拥有高耸的尖塔和精美的内部装饰。",
      "official_link": "https://www.domsvalzbety.sk/en/",
      "price_range": "免费（登塔/地下室可能收费）",
      "currency": "EUR",
      "description_en": "Slovakia's largest church—Gothic masterpiece; tall spire and fine interior.",
      "price_range_en": "Free (tower/crypt may charge)",
      "official_link_en": "https://www.domsvalzbety.sk/en/"
    },
    {
      "id": "SK",
      "cityname": "科希策",
      "cityname_en": "Košice",
      "attractions_name": "城市公园",
      "attractions_name_en": "City Park (Mestský Park)",
      "description": "科希策市中心的大型公园，是休闲散步的好去处，有湖泊和雕塑。",
      "official_link": "无官方购票链接，为公共公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Large park in the centre—stroll, lake and sculptures.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public park"
    },
    {
      "id": "SK",
      "cityname": "科希策",
      "cityname_en": "Košice",
      "attractions_name": "歌唱喷泉",
      "attractions_name_en": "Singing Fountain",
      "description": "位于科希策市中心的独特喷泉，夏季有灯光和音乐表演，是市民和游客喜爱的景点。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Unique fountain in the centre—light and music shows in summer.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "SK",
      "cityname": "科希策",
      "cityname_en": "Košice",
      "attractions_name": "圣米迦勒礼拜堂",
      "attractions_name_en": "St. Michael's Chapel",
      "description": "位于圣伊丽莎白大教堂旁，一座小型的哥特式礼拜堂，内部保存有壁画。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Next to St Elizabeth's—small Gothic chapel; frescoes inside.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "SK",
      "cityname": "科希策",
      "cityname_en": "Košice",
      "attractions_name": "艺术之家",
      "attractions_name_en": "House of Arts (Dom Umenia)",
      "description": "科希策重要的文化中心，曾是新哥特式犹太教堂，现在用于音乐会和展览。",
      "official_link": "无需购票",
      "price_range": "免费（演出票价另计）",
      "currency": "EUR",
      "description_en": "Key culture centre—former Neo-Gothic synagogue; concerts and exhibitions.",
      "price_range_en": "Free (performance tickets extra)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "SK",
      "cityname": "科希策",
      "cityname_en": "Košice",
      "attractions_name": "东斯洛伐克博物馆",
      "attractions_name_en": "East Slovak Museum",
      "description": "斯洛伐克最古老的博物馆之一，收藏了地区历史、考古和艺术品。",
      "official_link": "https://www.vsmuzeum.sk/en/",
      "price_range": "5 - 8 (根据展览)",
      "currency": "EUR",
      "description_en": "One of Slovakia's oldest museums—regional history, archaeology and art.",
      "price_range_en": "€5–8 (by exhibition)",
      "official_link_en": "https://www.vsmuzeum.sk/en/"
    },
    {
      "id": "SK",
      "cityname": "高塔特拉山/斯皮什地区",
      "cityname_en": "High Tatras/Spiš Region",
      "attractions_name": "斯皮什城堡",
      "attractions_name_en": "Spiš Castle",
      "description": "联合国教科文组织世界遗产，中欧最大的城堡遗址之一，位于高处，气势恢宏。",
      "official_link": "http://www.spisskyhrad.com/",
      "price_range": "8-10",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—one of Central Europe's largest castle ruins; on the hill.",
      "price_range_en": "€8–10",
      "official_link_en": "http://www.spisskyhrad.com/"
    },
    {
      "id": "SK",
      "cityname": "高塔特拉山/斯皮什地区",
      "cityname_en": "High Tatras/Spiš Region",
      "attractions_name": "什特尔布斯凯湖",
      "attractions_name_en": "Štrbské Pleso",
      "description": "高塔特拉山最受欢迎的高山湖泊之一，风景如画，是徒步和划船的好地方。",
      "official_link": "无官方购票链接，为自然区域",
      "price_range": "免费（船只租赁另计）",
      "currency": "EUR",
      "description_en": "One of the High Tatras' most popular alpine lakes—hiking and boating.",
      "price_range_en": "Free (boat rental extra)",
      "official_link_en": "无官方购票链接，为自然区域"
    },
    {
      "id": "SK",
      "cityname": "高塔特拉山/斯皮什地区",
      "cityname_en": "High Tatras/Spiš Region",
      "attractions_name": "洛姆尼茨基峰 (缆车)",
      "attractions_name_en": "Lomnický štít (Cable Car)",
      "description": "斯洛伐克第二高峰，可乘坐缆车抵达山顶，提供令人惊叹的360度全景。",
      "official_link": "不支持线上购票",
      "price_range": "50 - 70 (往返，根据季节)",
      "currency": "EUR",
      "description_en": "Slovakia's second-highest peak—cable car to the top; 360° views.",
      "price_range_en": "€50–70 return (by season)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "SK",
      "cityname": "高塔特拉山/斯皮什地区",
      "cityname_en": "High Tatras/Spiš Region",
      "attractions_name": "斯皮什卡卡皮图拉 (斯皮什章)",
      "attractions_name_en": "Spišská Kapitula (Spiš Chapter)",
      "description": "联合国教科文组织世界遗产，保存完好的中世纪宗教建筑群，被称为“斯洛伐克的梵蒂冈”。",
      "official_link": "无门票，免费参观（部分教堂/博物馆收费）",
      "price_range": "免费（部分景点约2-3）",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—well-preserved medieval religious complex; \"Slovak Vatican\".",
      "price_range_en": "Free (some sites ~€2–3)",
      "official_link_en": "无门票，免费参观（部分教堂/博物馆收费）"
    },
    {
      "id": "SK",
      "cityname": "高塔特拉山/斯皮什地区",
      "cityname_en": "High Tatras/Spiš Region",
      "attractions_name": "莱沃恰",
      "attractions_name_en": "Levoča",
      "description": "联合国教科文组织世界遗产，保存完好的中世纪城镇，有欧洲最高的木制祭坛。",
      "official_link": "无官方购票链接，为公共区域（部分教堂/博物馆收费）",
      "price_range": "免费（圣雅各布教堂约5）",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—well-preserved medieval town; Europe's tallest wooden altarpiece.",
      "price_range_en": "Free (St James's Church ~€5)",
      "official_link_en": "无官方购票链接，为公共区域（部分教堂/博物馆收费）"
    },
    {
      "id": "SK",
      "cityname": "高塔特拉山/斯皮什地区",
      "cityname_en": "High Tatras/Spiš Region",
      "attractions_name": "斯洛伐克天堂国家公园",
      "attractions_name_en": "Slovak Paradise National Park",
      "description": "以其独特的峡谷、瀑布、洞穴和木制梯子步道而闻名，是徒步爱好者的天堂。",
      "official_link": "无官方购票链接，为自然区域（入园费/停车费可能收费）",
      "price_range": "免费（部分小径/洞穴收费）",
      "currency": "EUR",
      "description_en": "Unique gorges, waterfalls, caves and wooden ladder trails—hikers' paradise.",
      "price_range_en": "Free (some trails/caves charge)",
      "official_link_en": "无官方购票链接，为自然区域（入园费/停车费可能收费）"
    },
    {
      "id": "LV",
      "cityname": "里加",
      "cityname_en": "Riga",
      "attractions_name": "里加老城",
      "attractions_name_en": "Riga Old Town",
      "description": "联合国教科文组织世界遗产，保存完好的中世纪老城，拥有独特的哥特式和新艺术风格建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—well-preserved medieval old town; Gothic and Art Nouveau.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LV",
      "cityname": "里加",
      "cityname_en": "Riga",
      "attractions_name": "里加圆顶大教堂",
      "attractions_name_en": "Riga Cathedral",
      "description": "波罗的海国家中最大的中世纪教堂，以其巨大的管风琴和独特的建筑风格而闻名。",
      "official_link": "https://doms.lv/en/",
      "price_range": "5-7",
      "currency": "EUR",
      "description_en": "Baltic states' largest medieval church—huge organ and distinctive architecture.",
      "price_range_en": "€5–7",
      "official_link_en": "https://doms.lv/en/"
    },
    {
      "id": "LV",
      "cityname": "里加",
      "cityname_en": "Riga",
      "attractions_name": "自由纪念碑",
      "attractions_name_en": "Freedom Monument",
      "description": "拉脱维亚的民族象征，纪念为国家独立而牺牲的烈士，雕像顶部是自由女神。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Latvia's national symbol—monument to those who died for independence; Freedom statue on top.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LV",
      "cityname": "里加",
      "cityname_en": "Riga",
      "attractions_name": "中央市场",
      "attractions_name_en": "Riga Central Market",
      "description": "欧洲最大的市场之一，由五个前齐柏林飞艇机库改造而成，出售新鲜农产品、肉类和当地美食。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "EUR",
      "description_en": "One of Europe's largest markets—five former Zeppelin hangars; fresh produce, meat and local food.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "LV",
      "cityname": "里加",
      "cityname_en": "Riga",
      "attractions_name": "新艺术区",
      "attractions_name_en": "Art Nouveau District",
      "description": "里加拥有世界上最集中的新艺术风格建筑群之一，尤其集中在伊丽莎白街和阿尔伯特街。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分博物馆/建筑内部可能收费）",
      "currency": "EUR",
      "description_en": "One of the world's densest concentrations of Art Nouveau—especially Elizabeth and Albert streets.",
      "price_range_en": "Free (some museums/interiors charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LV",
      "cityname": "里加",
      "cityname_en": "Riga",
      "attractions_name": "瑞典门",
      "attractions_name_en": "Swedish Gate",
      "description": "里加老城唯一保存下来的城门，曾经是城市防御系统的一部分。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Only surviving gate of Riga's old town—part of the city's defences.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LV",
      "cityname": "锡古尔达/高亚国家公园",
      "cityname_en": "Sigulda/Gauja National Park",
      "attractions_name": "图赖达城堡",
      "attractions_name_en": "Turaida Castle",
      "description": "位于高亚河谷，一座红砖砌成的中世纪城堡，提供周边自然风光和历史遗迹。",
      "official_link": "无官方链接",
      "price_range": "6-8",
      "currency": "EUR",
      "description_en": "In the Gauja Valley—red-brick medieval castle; nature and history.",
      "price_range_en": "€6–8",
      "official_link_en": "无官方链接"
    },
    {
      "id": "LV",
      "cityname": "锡古尔达/高亚国家公园",
      "cityname_en": "Sigulda/Gauja National Park",
      "attractions_name": "高亚国家公园",
      "attractions_name_en": "Gauja National Park",
      "description": "拉脱维亚最大的国家公园，以其多样的地形、森林、河流和砂岩悬崖而闻名，被称为“拉脱维亚的瑞士”。",
      "official_link": "无官方购票链接，为公共区域（部分景点/活动收费）",
      "price_range": "免费（部分洞穴/城堡收费）",
      "currency": "EUR",
      "description_en": "Latvia's largest national park—varied terrain, forest, rivers and sandstone cliffs; \"Latvian Switzerland\".",
      "price_range_en": "Free (some caves/castles charge)",
      "official_link_en": "无官方购票链接，为公共区域（部分景点/活动收费）"
    },
    {
      "id": "LV",
      "cityname": "锡古尔达/高亚国家公园",
      "cityname_en": "Sigulda/Gauja National Park",
      "attractions_name": "古特曼洞穴",
      "attractions_name_en": "Gutmanis Cave",
      "description": "波罗的海国家最大的洞穴，洞壁上刻有古老的铭文和爱情故事。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Baltic states' largest cave—ancient inscriptions and love story on the walls.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LV",
      "cityname": "锡古尔达/高亚国家公园",
      "cityname_en": "Sigulda/Gauja National Park",
      "attractions_name": "锡古尔达城堡群 (新旧城堡)",
      "attractions_name_en": "Sigulda Castle Complex (New and Old Castles)",
      "description": "锡古尔达镇的历史中心，包括一座中世纪城堡遗址和一座新哥特式新城堡。",
      "official_link": "无需购票",
      "price_range": "免费（部分区域/展览收费）",
      "currency": "EUR",
      "description_en": "Sigulda's historic centre—medieval castle ruins and Neo-Gothic new castle.",
      "price_range_en": "Free (some areas/exhibitions charge)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "LV",
      "cityname": "锡古尔达/高亚国家公园",
      "cityname_en": "Sigulda/高亚国家公园",
      "attractions_name": "锡古尔达高空缆车",
      "attractions_name_en": "Sigulda Cable Car",
      "description": "跨越高亚河谷的缆车，提供壮丽的河谷景色，也是蹦极跳台所在地。",
      "official_link": "不支持线上购票",
      "price_range": "10 (单程), 18 (往返)",
      "currency": "EUR",
      "description_en": "Cable car across the Gauja Valley—valley views; bungee jump site.",
      "price_range_en": "€10 (one-way), €18 (return)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "LV",
      "cityname": "锡古尔达/高亚国家公园",
      "cityname_en": "Sigulda/高亚国家公园",
      "attractions_name": "克里穆尔达庄园",
      "attractions_name_en": "Krimulda Manor",
      "description": "位于高亚河谷的另一侧，拥有历史悠久的庄园建筑和美丽的花园。",
      "official_link": "无官方购票链接，外部参观免费（内部可能收费）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "On the other side of the Gauja—historic manor and gardens.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费（内部可能收费）"
    },
    {
      "id": "LV",
      "cityname": "库尔兰/文茨皮尔斯 (西部地区)",
      "cityname_en": "Kurzeme/Ventspils (Western Region)",
      "attractions_name": "文茨皮尔斯城堡 (利沃尼亚骑士团城堡)",
      "attractions_name_en": "Ventspils Castle (Livonian Order Castle)",
      "description": "文茨皮尔斯最古老的建筑，一座保存完好的中世纪城堡，现在是博物馆。",
      "official_link": "不支持线上购票",
      "price_range": "3～5 ",
      "currency": "EUR",
      "description_en": "Ventspils's oldest building—well-preserved medieval castle; now a museum.",
      "price_range_en": "€3–5",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "LV",
      "cityname": "库尔兰/文茨皮尔斯",
      "cityname_en": "Kurzeme/Ventspils",
      "attractions_name": "文茨皮尔斯海滩与南码头",
      "attractions_name_en": "Ventspils Beach & Southern Pier",
      "description": "文茨皮尔斯著名的蓝旗海滩，拥有细沙和海滨长廊，南码头有灯塔。",
      "official_link": "无官方购票链接，为公共海滩/区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Famous Blue Flag beach—fine sand and promenade; lighthouse on South Pier.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为公共海滩/区域"
    },
    {
      "id": "LV",
      "cityname": "库尔兰/文茨皮尔斯",
      "cityname_en": "Kurzeme/Ventspils",
      "attractions_name": "文茨皮尔斯奥林匹克中心",
      "attractions_name_en": "Ventspils Olympic Centre",
      "description": "现代化的运动和休闲中心，有水上乐园、滑冰场和各种体育设施。",
      "official_link": "https://ocventspils.lv/en/",
      "price_range": "10 - 15 (水上乐园)",
      "currency": "EUR",
      "description_en": "Modern sports and leisure centre—water park, ice rink and sports facilities.",
      "price_range_en": "€10–15 (water park)",
      "official_link_en": "https://ocventspils.lv/en/"
    },
    {
      "id": "LV",
      "cityname": "库尔兰/文茨皮尔斯",
      "cityname_en": "Kurzeme/Ventspils",
      "attractions_name": "库尔迪加老城",
      "attractions_name_en": "Kuldīga Old Town",
      "description": "拉脱维亚西部保存最完好的历史城镇之一，拥有独特的木制房屋和欧洲最宽的瀑布。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of western Latvia's best-preserved historic towns—wooden houses and Europe's widest waterfall.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LV",
      "cityname": "库尔兰/文茨皮尔斯",
      "cityname_en": "Kurzeme/Ventspils",
      "attractions_name": "维也纳河瀑布 (Ventas Rumba)",
      "attractions_name_en": "Venta Rapid (Ventas Rumba)",
      "description": "位于库尔迪加，欧洲最宽的天然瀑布，以春季鲑鱼跃龙门景观而闻名。",
      "official_link": "无官方购票链接，为自然区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "In Kuldīga—Europe's widest natural waterfall; salmon jumping in spring.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为自然区域"
    },
    {
      "id": "LV",
      "cityname": "库尔兰/文茨皮尔斯",
      "cityname_en": "Kurzeme/Ventspils",
      "attractions_name": "列帕亚海滩与公园",
      "attractions_name_en": "Liepāja Beach & Park",
      "description": "列帕亚的海滨长滩，拥有金色沙滩和大型海滨公园，常有音乐节。",
      "official_link": "无官方购票链接，为公共海滩/公园",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Liepāja's long beach—golden sand and large seaside park; music festivals.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为公共海滩/公园"
    },
    {
      "id": "LT",
      "cityname": "维尔纽斯",
      "cityname_en": "Vilnius",
      "attractions_name": "维尔纽斯老城",
      "attractions_name_en": "Vilnius Old Town",
      "description": "联合国教科文组织世界遗产，东欧最大的老城之一，拥有哥特式、文艺复兴和巴洛克式建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—one of Eastern Europe's largest old towns; Gothic, Renaissance and Baroque.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LT",
      "cityname": "维尔纽斯",
      "cityname_en": "Vilnius",
      "attractions_name": "格迪米纳斯塔",
      "attractions_name_en": "Gediminas Tower",
      "description": "维尔纽斯城堡的唯一遗迹，位于高处，可登塔俯瞰维尔纽斯全景。",
      "official_link": "https://www.lnm.lt/en/gediminas-tower/",
      "price_range": "6",
      "currency": "EUR",
      "description_en": "Only remaining tower of Vilnius Castle—on the hill; climb for city views.",
      "price_range_en": "€6",
      "official_link_en": "https://www.lnm.lt/en/gediminas-tower/"
    },
    {
      "id": "LT",
      "cityname": "维尔纽斯",
      "cityname_en": "Vilnius",
      "attractions_name": "圣安妮教堂与贝尔纳丁教堂",
      "attractions_name_en": "St. Anne's Church & Bernardine Church",
      "description": "维尔纽斯最美丽的哥特式教堂，以其独特的砖砌立面和复杂的细节而闻名。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Vilnius's finest Gothic church—distinctive brick façade and intricate detail.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "LT",
      "cityname": "维尔纽斯",
      "cityname_en": "Vilnius",
      "attractions_name": "黎明之门",
      "attractions_name_en": "Gate of Dawn",
      "description": "维尔纽斯老城仅存的城门之一，内部供奉着一幅著名的圣母玛利亚画像。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "One of the old town's only surviving gates—famous Madonna icon inside.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "LT",
      "cityname": "维尔纽斯",
      "cityname_en": "Vilnius",
      "attractions_name": "维尔纽斯大教堂与钟楼",
      "attractions_name_en": "Vilnius Cathedral & Bell Tower",
      "description": "维尔纽斯最重要的教堂，新古典主义风格，内部有地下墓穴和艺术品，可登钟楼。",
      "official_link": "http://www.katedra.lt/en/",
      "price_range": "免费（登钟楼约6）",
      "currency": "EUR",
      "description_en": "Vilnius's main church—Neoclassical; crypts and art inside; climb the bell tower.",
      "price_range_en": "Free (bell tower ~€6)",
      "official_link_en": "http://www.katedra.lt/en/"
    },
    {
      "id": "LT",
      "cityname": "维尔纽斯",
      "cityname_en": "Vilnius",
      "attractions_name": "共和国",
      "attractions_name_en": "Užupis Republic",
      "description": "维尔纽斯老城内一个波西米亚风格的艺术社区，有自己的宪法和独特的氛围。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Bohemian art community inside the old town—its own constitution and vibe.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LT",
      "cityname": "考纳斯",
      "cityname_en": "Kaunas",
      "attractions_name": "考纳斯城堡",
      "attractions_name_en": "Kaunas Castle",
      "description": "考纳斯最古老的建筑，位于尼曼河和内里斯河交汇处，是立陶宛唯一的砖石城堡。",
      "official_link": "https://kaunomuziejus.lt/en/kaunas-castle/",
      "price_range": "3-5",
      "currency": "EUR",
      "description_en": "Kaunas's oldest building—at the confluence of Nemunas and Neris; Lithuania's only brick castle.",
      "price_range_en": "€3–5",
      "official_link_en": "https://kaunomuziejus.lt/en/kaunas-castle/"
    },
    {
      "id": "LT",
      "cityname": "考纳斯",
      "cityname_en": "Kaunas",
      "attractions_name": "考纳斯市政厅",
      "attractions_name_en": "Kaunas Town Hall",
      "description": "位于市政厅广场，被称为“白色天鹅”，是考纳斯的标志性建筑。",
      "official_link": "https://kaunomuziejus.lt/en/kaunas-city-museum/",
      "price_range": "2-3",
      "currency": "EUR",
      "description_en": "On Town Hall Square—nicknamed \"White Swan\"; Kaunas's icon.",
      "price_range_en": "€2–3",
      "official_link_en": "https://kaunomuziejus.lt/en/kaunas-city-museum/"
    },
    {
      "id": "LT",
      "cityname": "考纳斯",
      "cityname_en": "Kaunas",
      "attractions_name": "魔鬼博物馆",
      "attractions_name_en": "Devil's Museum",
      "description": "独特的主题博物馆，收藏了数千个魔鬼雕塑和面具，来自世界各地。",
      "official_link": "https://ciurlionis.lt/en/devils-museum/",
      "price_range": "4-6",
      "currency": "EUR",
      "description_en": "Unique theme museum—thousands of devil sculptures and masks from around the world.",
      "price_range_en": "€4–6",
      "official_link_en": "https://ciurlionis.lt/en/devils-museum/"
    },
    {
      "id": "LT",
      "cityname": "考纳斯",
      "cityname_en": "Kaunas",
      "attractions_name": "考纳斯大教堂",
      "attractions_name_en": "Kaunas Cathedral Basilica",
      "description": "立陶宛最大的哥特式教堂，宏伟的建筑，内部装饰华丽。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Lithuania's largest Gothic church—grand building; lavish interior.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "LT",
      "cityname": "考纳斯",
      "cityname_en": "Kaunas",
      "attractions_name": "佩尔库纳斯之家",
      "attractions_name_en": "House of Perkūnas",
      "description": "位于考纳斯老城，一座独特的哥特式建筑，曾是汉萨同盟商人的住所。",
      "official_link": "https://lietuvosturizmas.lt/en/kaunas-city/house-of-perkunas/",
      "price_range": "3-5",
      "currency": "EUR",
      "description_en": "In the old town—distinctive Gothic building; former Hanseatic merchant house.",
      "price_range_en": "€3–5",
      "official_link_en": "https://lietuvosturizmas.lt/en/kaunas-city/house-of-perkunas/"
    },
    {
      "id": "LT",
      "cityname": "考纳斯",
      "cityname_en": "Kaunas",
      "attractions_name": "第九堡垒",
      "attractions_name_en": "Ninth Fort",
      "description": "考纳斯郊区的一座堡垒，曾是苏联和纳粹占领期间的监狱和集中营，现在是博物馆。",
      "official_link": "不支持线上购票",
      "price_range": "5-7",
      "currency": "EUR",
      "description_en": "Fort on the outskirts—prison and camp under Soviet and Nazi occupation; now a museum.",
      "price_range_en": "€5–7",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "LT",
      "cityname": "特拉凯/库尔斯沙嘴 (湖区/沿海)",
      "cityname_en": "Trakai/Curonian Spit (Lake Region/Coastal)",
      "attractions_name": "特拉凯城堡",
      "attractions_name_en": "Trakai Island Castle",
      "description": "位于维尔纽斯附近，特拉凯湖中的一座标志性岛屿城堡，是立陶宛最著名的景点之一。",
      "official_link": "不支持线上购票",
      "price_range": "12-15",
      "currency": "EUR",
      "description_en": "Near Vilnius—iconic island castle on Lake Trakai; one of Lithuania's top sights.",
      "price_range_en": "€12–15",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "LT",
      "cityname": "特拉凯/库尔斯沙嘴",
      "cityname_en": "Trakai/Curonian Spit",
      "attractions_name": "库尔斯沙嘴",
      "attractions_name_en": "Curonian Spit",
      "description": "联合国教科文组织世界遗产，狭长的沙洲，拥有沙丘、松树林和渔村，自然风光独特。",
      "official_link": "无官方购票链接，为自然区域（入岛费/渡轮另计）",
      "price_range": "免费（入岛费约5，渡轮约12）",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—narrow sand spit; dunes, pine forest and fishing villages.",
      "price_range_en": "Free (entry ~€5, ferry ~€12)",
      "official_link_en": "无官方购票链接，为自然区域（入岛费/渡轮另计）"
    },
    {
      "id": "LT",
      "cityname": "特拉凯/库尔斯沙嘴",
      "cityname_en": "Trakai/Curonian Spit",
      "attractions_name": "尼达 (库尔斯沙嘴)",
      "attractions_name_en": "Nida (Curonian Spit)",
      "description": "库尔斯沙嘴上的一个迷人渔村，以其独特的木制房屋和高大的沙丘而闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Charming fishing village on the Curonian Spit—wooden houses and tall dunes.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LT",
      "cityname": "特拉凯/库尔斯沙嘴",
      "cityname_en": "Trakai/Curonian Spit",
      "attractions_name": "赫尔曼·戈林瞭望台 (尼达沙丘)",
      "attractions_name_en": "Parnidis Dune (near Nida)",
      "description": "尼达附近的巨大沙丘，可登顶俯瞰沙丘、库尔斯泻湖和波罗的海的壮丽景色。",
      "official_link": "无官方购票链接，为自然区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Huge dunes near Nida—climb for views of dunes, Curonian Lagoon and Baltic.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为自然区域"
    },
    {
      "id": "LT",
      "cityname": "特拉凯/库尔斯沙嘴",
      "cityname_en": "Trakai/Curonian Spit",
      "attractions_name": "琥珀博物馆 (尼达)",
      "attractions_name_en": "Amber Gallery-Museum (Nida)",
      "description": "尼达的特色博物馆，展示琥珀的形成、历史和艺术品。",
      "official_link": "https://www.ambergallery.lt/en/",
      "price_range": "2-3",
      "currency": "EUR",
      "description_en": "Nida's specialty museum—amber formation, history and art.",
      "price_range_en": "€2–3",
      "official_link_en": "https://www.ambergallery.lt/en/"
    },
    {
      "id": "LT",
      "cityname": "特拉凯/库尔斯沙嘴",
      "cityname_en": "Trakai/Curonian Spit",
      "attractions_name": "帕兰加琥珀博物馆",
      "attractions_name_en": "Palanga Amber Museum",
      "description": "位于帕兰加（波罗的海沿岸度假城市），收藏了大量琥珀藏品，位于美丽的提什克维奇宫殿内。",
      "official_link": "不支持线上购票",
      "price_range": "8-10",
      "currency": "EUR",
      "description_en": "In Palanga (Baltic resort)—large amber collection; in beautiful Tiškevičiai Palace.",
      "price_range_en": "€8–10",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MC",
      "cityname": "摩纳哥",
      "cityname_en": "Monaco",
      "attractions_name": "摩纳哥亲王宫",
      "attractions_name_en": "Prince's Palace of Monaco",
      "description": "摩纳哥亲王的官方住所，位于摩纳哥城高处，每日有卫兵换岗仪式。",
      "official_link": "https://palais.mc/en/index.html",
      "price_range": "10",
      "currency": "EUR",
      "description_en": "Prince's official residence—on the Rock; daily changing of the guard.",
      "price_range_en": "€10",
      "official_link_en": "https://palais.mc/en/index.html"
    },
    {
      "id": "MC",
      "cityname": "摩纳哥",
      "cityname_en": "Monaco",
      "attractions_name": "蒙特卡洛赌场",
      "attractions_name_en": "Casino de Monte-Carlo",
      "description": "世界著名的赌场，以其华丽的建筑和奢华的氛围而闻名，也是摩纳哥的标志性地标。",
      "official_link": "无需购票",
      "price_range": "免费（进入赌场区可能收费，约 17）",
      "currency": "EUR",
      "description_en": "World-famous casino—grand building and lavish atmosphere; Monaco's icon.",
      "price_range_en": "Free (casino area ~€17)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "MC",
      "cityname": "摩纳哥",
      "cityname_en": "Monaco",
      "attractions_name": "摩纳哥海洋博物馆",
      "attractions_name_en": "Oceanographic Museum of Monaco",
      "description": "位于悬崖边，由阿尔贝一世亲王创立，是世界顶级的海洋科学博物馆和水族馆。",
      "official_link": "https://www.oceano.mc/en/",
      "price_range": "18",
      "currency": "EUR",
      "description_en": "On the cliff—founded by Prince Albert I; top ocean science museum and aquarium.",
      "price_range_en": "€18",
      "official_link_en": "https://www.oceano.mc/en/"
    },
    {
      "id": "MC",
      "cityname": "摩纳哥",
      "cityname_en": "Monaco",
      "attractions_name": "摩纳哥大教堂",
      "attractions_name_en": "Monaco Cathedral",
      "description": "摩纳哥的罗马天主教大教堂，是格蕾丝王妃和雷尼尔三世亲王的安息之地。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Monaco's Roman Catholic cathedral—resting place of Princess Grace and Prince Rainier III.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "MC",
      "cityname": "摩纳哥",
      "cityname_en": "Monaco",
      "attractions_name": "摩纳哥大奖赛赛道",
      "attractions_name_en": "Circuit de Monaco",
      "description": "每年F1摩纳哥大奖赛的举办地，部分赛道穿梭于城市街道，是赛车迷的朝圣地。",
      "official_link": "无官方购票链接，为公共道路（比赛期间另计）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "F1 Monaco Grand Prix circuit—through the streets; pilgrimage for racing fans.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为公共道路（比赛期间另计）"
    },
    {
      "id": "MC",
      "cityname": "摩纳哥",
      "cityname_en": "Monaco",
      "attractions_name": "异域花园",
      "attractions_name_en": "Exotic Garden of Monaco",
      "description": "位于悬崖峭壁上的植物园，收集了大量多肉植物，并提供摩纳哥和海岸线的壮丽景色。",
      "official_link": "https://jardin-exotique.mc/en/",
      "price_range": "7.5",
      "currency": "EUR",
      "description_en": "Botanical garden on the cliff—succulents; views over Monaco and the coast.",
      "price_range_en": "€7.50",
      "official_link_en": "https://jardin-exotique.mc/en/"
    },
    {
      "id": "LU",
      "cityname": "卢森堡市",
      "cityname_en": "Luxembourg City",
      "attractions_name": "卢森堡古城与要塞",
      "attractions_name_en": "Luxembourg Old City and Fortifications",
      "description": "联合国教科文组织世界遗产，拥有壮丽的峡谷、历史悠久的防御工事和风景如画的老城区。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "UNESCO World Heritage—dramatic gorge, historic fortifications and picturesque old town.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LU",
      "cityname": "卢森堡市",
      "cityname_en": "Luxembourg City",
      "attractions_name": "阿道夫桥",
      "attractions_name_en": "Adolphe Bridge",
      "description": "卢森堡市的标志性地标，一座宏伟的石拱桥，连接着城市的上城和下城（佩特吕斯峡谷）。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Luxembourg's icon—grand stone arch bridge; links upper and lower town (Pétrusse Valley).",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LU",
      "cityname": "卢森堡市",
      "cityname_en": "Luxembourg City",
      "attractions_name": "佩特吕斯峡谷",
      "attractions_name_en": "Pétrusse Casemates (Bock Casemates)",
      "description": "城市下方的巨大地下防御工事网络，可探索历史悠久的隧道和洞穴，了解城市防御历史。",
      "official_link": "不支持线上购票",
      "price_range": "8",
      "currency": "EUR",
      "description_en": "Vast underground fortifications below the city—tunnels and casemates; defence history.",
      "price_range_en": "€8",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "LU",
      "cityname": "卢森堡市",
      "cityname_en": "Luxembourg City",
      "attractions_name": "大公宫殿",
      "attractions_name_en": "Grand Ducal Palace",
      "description": "卢森堡大公的官方住所，文艺复兴风格的建筑，夏季部分时间对游客开放。",
      "official_link": "无需购票",
      "price_range": "免费 (仅限夏季导览团)",
      "currency": "EUR",
      "description_en": "Grand Duke's official residence—Renaissance building; guided tours in summer only.",
      "price_range_en": "Free (guided tours summer only)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "LU",
      "cityname": "卢森堡市",
      "cityname_en": "Luxembourg City",
      "attractions_name": "宪法广场",
      "attractions_name_en": "Place de la Constitution",
      "description": "位于阿道夫桥附近，有“金色少女”纪念碑，可俯瞰佩特吕斯峡谷。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Near Adolphe Bridge—\"Gëlle Fra\" monument; views over Pétrusse Valley.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LU",
      "cityname": "卢森堡市",
      "cityname_en": "Luxembourg City",
      "attractions_name": "圣母大教堂",
      "attractions_name_en": "Notre-Dame Cathedral",
      "description": "卢森堡的主要罗马天主教大教堂，晚期哥特式和文艺复兴风格，拥有独特的彩绘玻璃窗。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Luxembourg's main Roman Catholic cathedral—Late Gothic and Renaissance; stained glass.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BA",
      "cityname": "萨拉热窝",
      "cityname_en": "Sarajevo",
      "attractions_name": "巴什查尔希亚老城",
      "attractions_name_en": "Baščaršija Old Bazaar",
      "description": "萨拉热窝的历史中心，鹅卵石街道，有许多奥斯曼风格的商店、咖啡馆和清真寺。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "Sarajevo's historic centre—cobbled streets; Ottoman-style shops, cafés and mosques.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BA",
      "cityname": "萨拉热窝",
      "cityname_en": "Sarajevo",
      "attractions_name": "拉丁桥",
      "attractions_name_en": "Latin Bridge",
      "description": "萨拉热窝的重要历史地标，奥匈帝国费迪南大公遇刺的地点，引发了第一次世界大战。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "Historic landmark—where Archduke Franz Ferdinand was assassinated; triggered WWI.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BA",
      "cityname": "萨拉热窝",
      "cityname_en": "Sarajevo",
      "attractions_name": "萨拉热窝隧道博物馆",
      "attractions_name_en": "Tunnel of Hope Museum",
      "description": "纪念萨拉热窝围城期间，用于运输物资和人员的地下隧道，展示了战争的残酷。",
      "official_link": "https://tunelspasa.ba/en/",
      "price_range": "10-15",
      "currency": "BAM",
      "description_en": "Underground tunnel used during the siege—supply and evacuation; war's brutality.",
      "price_range_en": "€10–15",
      "official_link_en": "https://tunelspasa.ba/en/"
    },
    {
      "id": "BA",
      "cityname": "萨拉热窝",
      "cityname_en": "Sarajevo",
      "attractions_name": "加兹·胡斯列夫贝格清真寺",
      "attractions_name_en": "Gazi Husrev-beg Mosque",
      "description": "萨拉热窝最重要的清真寺之一，奥斯曼时期建筑杰作，位于巴什查尔希亚老城。",
      "official_link": "无门票，免费参观（部分区域可能收费）",
      "price_range": "免费（进入主祷告厅可能约3）",
      "currency": "BAM",
      "description_en": "One of Sarajevo's most important mosques—Ottoman masterpiece; in Baščaršija.",
      "price_range_en": "Free (main prayer hall ~€3)",
      "official_link_en": "无门票，免费参观（部分区域可能收费）"
    },
    {
      "id": "BA",
      "cityname": "萨拉热窝",
      "cityname_en": "Sarajevo",
      "attractions_name": "黄堡",
      "attractions_name_en": "Yellow Fortress (Žuta Tabija)",
      "description": "位于高处，是萨拉热窝古老防御工事的一部分，可俯瞰萨拉热窝全景，是观赏日落的好地方。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "On the hill—part of old fortifications; panoramic views; great for sunset.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BA",
      "cityname": "萨拉热窝",
      "cityname_en": "Sarajevo",
      "attractions_name": "永恒之火",
      "attractions_name_en": "Eternal Flame",
      "description": "纪念二战解放萨拉热窝的纪念碑，火焰不熄，象征自由。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "Monument to WWII liberation of Sarajevo—eternal flame; symbol of freedom.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BA",
      "cityname": "莫斯塔尔",
      "cityname_en": "Mostar",
      "attractions_name": "老桥",
      "attractions_name_en": "Stari Most (Old Bridge)",
      "description": "联合国教科文组织世界遗产，莫斯塔尔的标志，奥斯曼时期石拱桥，夏季有跳水表演。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "UNESCO World Heritage—Mostar's icon; Ottoman stone bridge; diving in summer.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BA",
      "cityname": "莫斯塔尔",
      "cityname_en": "Mostar",
      "attractions_name": "库由吉卢卡清真寺",
      "attractions_name_en": "Koski Mehmed Paša Mosque",
      "description": "莫斯塔尔重要的清真寺，可登塔俯瞰老桥和城市全景。",
      "official_link": "不支持线上购票",
      "price_range": "5 - 8 (含登塔)",
      "currency": "BAM",
      "description_en": "Important mosque in Mostar—climb the tower for bridge and city views.",
      "price_range_en": "€5–8 (incl. tower)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "BA",
      "cityname": "莫斯塔尔",
      "cityname_en": "Mostar",
      "attractions_name": "老城集市",
      "attractions_name_en": "Old Town Bazaar",
      "description": "莫斯塔尔老桥两岸的传统集市，出售手工艺品、纪念品和当地美食。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（购物消费另计）",
      "currency": "BAM",
      "description_en": "Traditional bazaar on both sides of the bridge—crafts, souvenirs and local food.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BA",
      "cityname": "莫斯塔尔",
      "cityname_en": "Mostar",
      "attractions_name": "胡斯列夫·卡哈清真寺",
      "attractions_name_en": "Karađoz-beg Mosque",
      "description": "莫斯塔尔另一座重要的奥斯曼时期清真寺，拥有精美的内部装饰和花园。",
      "official_link": "不支持线上购票 ",
      "price_range": "3～5",
      "currency": "BAM",
      "description_en": "Another important Ottoman mosque in Mostar—fine interior and garden.",
      "price_range_en": "€3–5",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "BA",
      "cityname": "莫斯塔尔",
      "cityname_en": "Mostar",
      "attractions_name": "幸福之屋 (比什切维奇之家)",
      "attractions_name_en": "Bišćevića House",
      "description": "莫斯塔尔老城内保存完好的奥斯曼时期房屋，展示了传统的波斯尼亚生活方式。",
      "official_link": "不支持线上购票 ",
      "price_range": "2～3",
      "currency": "BAM",
      "description_en": "Well-preserved Ottoman house in the old town—traditional Bosnian life.",
      "price_range_en": "€2–3",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "BA",
      "cityname": "莫斯塔尔",
      "cityname_en": "Mostar",
      "attractions_name": "克拉维采瀑布",
      "attractions_name_en": "Kravice Waterfalls",
      "description": "位于莫斯塔尔附近，波黑最美丽的自然景点之一，夏季可游泳和休闲。",
      "official_link": "不支持线上购票",
      "price_range": "10 - 15 (根据季节)",
      "currency": "BAM",
      "description_en": "Near Mostar—one of BiH's most beautiful natural sights; swimming in summer.",
      "price_range_en": "€10–15 (by season)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "BA",
      "cityname": "巴尼亚卢卡/普罗科萨尔湖 (波斯尼亚地区/自然风光)",
      "cityname_en": "Banja Luka/Prokoško Lake (Bosnian Region/Nature)",
      "attractions_name": "基督救世主大教堂",
      "attractions_name_en": "Christ the Saviour Cathedral",
      "description": "巴尼亚卢卡的标志性东正教教堂，金色的圆顶和精美的外观非常引人注目。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "Banja Luka's icon—Orthodox cathedral; golden dome and fine exterior.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BA",
      "cityname": "巴尼亚卢卡/普罗科萨尔湖",
      "cityname_en": "Banja Luka/Prokoško Lake",
      "attractions_name": "巴尼亚卢卡城堡 (卡斯特尔堡垒)",
      "attractions_name_en": "Kastel Fortress (Banja Luka)",
      "description": "巴尼亚卢卡市中心的古老堡垒，拥有悠久的历史，是城市重要的考古遗址。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "Ancient fortress in the centre—long history; important archaeological site.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BA",
      "cityname": "巴尼亚卢卡/普罗科萨尔湖",
      "cityname_en": "Banja Luka/Prokoško Lake",
      "attractions_name": "费尔哈迪亚清真寺",
      "attractions_name_en": "Ferhadija Mosque",
      "description": "巴尼亚卢卡最重要的奥斯曼时期清真寺，重建后重新开放，被认为是波黑的杰作之一。",
      "official_link": "无门票，免费参观（需遵守宗教礼仪）",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "Banja Luka's most important Ottoman mosque—rebuilt and reopened; one of BiH's masterpieces.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（需遵守宗教礼仪）"
    },
    {
      "id": "BA",
      "cityname": "巴尼亚卢卡/普罗科萨尔湖",
      "cityname_en": "Banja Luka/Prokoško Lake",
      "attractions_name": "普罗科萨尔湖",
      "attractions_name_en": "Prokoško Lake",
      "description": "位于维拉尼察山脉深处的高山湖泊，风景如画，周围有传统的木屋，是徒步爱好者的天堂。",
      "official_link": "无官方购票链接，为自然区域（入山费/停车费可能收费）",
      "price_range": "免费（部分交通/住宿另计）",
      "currency": "BAM",
      "description_en": "Alpine lake deep in the Vranica mountains—scenic; traditional wooden huts; hikers' paradise.",
      "price_range_en": "Free (transport/accommodation extra)",
      "official_link_en": "无官方购票链接，为自然区域（入山费/停车费可能收费）"
    },
    {
      "id": "BA",
      "cityname": "巴尼亚卢卡/普罗科萨尔湖",
      "cityname_en": "Banja Luka/Prokoško Lake",
      "attractions_name": "圣波纳文图尔教堂",
      "attractions_name_en": "Cathedral of Saint Bonaventure",
      "description": "巴尼亚卢卡的主要罗马天主教堂，现代建筑风格。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "Banja Luka's main Roman Catholic church—modern architecture.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BA",
      "cityname": "巴尼亚卢卡/普罗科萨尔湖",
      "cityname_en": "Banja Luka/Prokoško Lake",
      "attractions_name": "特雷比什尼察河 (特雷比涅)",
      "attractions_name_en": "Trebišnjica River (Trebinje)",
      "description": "位于波黑南部，特雷比涅市的河流，以其美丽的河畔风景和历史桥梁而闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BAM",
      "description_en": "River in southern BiH—Trebinje; beautiful riverside and historic bridges.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MK",
      "cityname": "斯科普里",
      "cityname_en": "Skopje",
      "attractions_name": "马其顿广场",
      "attractions_name_en": "Macedonia Square",
      "description": "斯科普里市中心的主广场，周围环绕着许多新古典主义建筑和纪念碑，包括巨大的亚历山大大帝雕像。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "MKD",
      "description_en": "Skopje's central square—Neoclassical buildings and monuments; huge Alexander the Great statue.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MK",
      "cityname": "斯科普里",
      "cityname_en": "Skopje",
      "attractions_name": "老巴扎 (奥斯曼老城)",
      "attractions_name_en": "Old Bazaar (Ottoman Old Town)",
      "description": "斯科普里历史最悠久的部分，拥有奥斯曼风格的街道、商店、清真寺和土耳其浴室。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（购物消费另计）",
      "currency": "MKD",
      "description_en": "Skopje's oldest part—Ottoman streets, shops, mosques and Turkish baths.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MK",
      "cityname": "斯科普里",
      "cityname_en": "Skopje",
      "attractions_name": "石桥",
      "attractions_name_en": "Stone Bridge",
      "description": "斯科普里的标志性建筑，连接着马其顿广场和老巴扎，是瓦尔达尔河上的一座历史悠久的桥梁。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "MKD",
      "description_en": "Skopje's icon—links Macedonia Square and Old Bazaar; historic bridge over the Vardar.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MK",
      "cityname": "斯科普里",
      "cityname_en": "Skopje",
      "attractions_name": "卡列堡 (斯科普里城堡)",
      "attractions_name_en": "Skopje Fortress (Kale Fortress)",
      "description": "位于高处，可俯瞰斯科普里全景的古老堡垒遗址，历史悠久。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "MKD",
      "description_en": "Ancient fortress on the hill—views over Skopje; historic.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MK",
      "cityname": "斯科普里",
      "cityname_en": "Skopje",
      "attractions_name": "德蕾莎修女纪念馆",
      "attractions_name_en": "Memorial House of Mother Teresa",
      "description": "纪念德蕾莎修女的出生地和生平，内部有她的个人物品和照片。",
      "official_link": "https://memorialhouseofmotherteresa.com/",
      "price_range": "免费",
      "currency": "MKD",
      "description_en": "Memorial to Mother Teresa—birthplace and life; personal items and photos.",
      "price_range_en": "Free",
      "official_link_en": "https://memorialhouseofmotherteresa.com/"
    },
    {
      "id": "MK",
      "cityname": "斯科普里",
      "cityname_en": "Skopje",
      "attractions_name": "马特卡峡谷",
      "attractions_name_en": "Matka Canyon",
      "description": "位于斯科普里附近，风景优美的峡谷，有湖泊、洞穴和修道院，可划船或徒步。",
      "official_link": "无官方购票链接，为自然区域（船费/洞穴参观另计）",
      "price_range": "免费（船约400，洞穴约100）",
      "currency": "MKD",
      "description_en": "Near Skopje—scenic gorge; lake, caves and monastery; boating or hiking.",
      "price_range_en": "Free (boat ~MKD 400, cave ~MKD 100)",
      "official_link_en": "无官方购票链接，为自然区域（船费/洞穴参观另计）"
    },
    {
      "id": "MK",
      "cityname": "奥赫里德",
      "cityname_en": "Ohrid",
      "attractions_name": "奥赫里德湖",
      "attractions_name_en": "Lake Ohrid",
      "description": "联合国教科文组织世界遗产，欧洲最古老、最深的湖泊之一，清澈见底，被山脉环绕。",
      "official_link": "无官方购票链接，为自然区域（船只租赁另计）",
      "price_range": "免费",
      "currency": "MKD",
      "description_en": "UNESCO World Heritage—one of Europe's oldest and deepest lakes; crystal clear; mountains around.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，为自然区域（船只租赁另计）"
    },
    {
      "id": "MK",
      "cityname": "奥赫里德",
      "cityname_en": "Ohrid",
      "attractions_name": "圣约翰卡内奥教堂",
      "attractions_name_en": "St. John at Kaneo Church",
      "description": "位于奥赫里德湖畔的悬崖上，风景如画，是北马其顿最具标志性的教堂之一。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "MKD",
      "description_en": "On the cliff above Lake Ohrid—picturesque; one of North Macedonia's most iconic churches.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "MK",
      "cityname": "奥赫里德",
      "cityname_en": "Ohrid",
      "attractions_name": "萨缪尔要塞",
      "attractions_name_en": "Samuel's Fortress",
      "description": "位于奥赫里德高处，是保加利亚皇帝萨缪尔时期建造的堡垒，可俯瞰奥赫里德湖和城市。",
      "official_link": "不支持线上购票",
      "price_range": "60 - 100",
      "currency": "MKD",
      "description_en": "Fortress on the hill—built under Tsar Samuel; views over Lake Ohrid and town.",
      "price_range_en": "MKD 60–100",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MK",
      "cityname": "奥赫里德",
      "cityname_en": "Ohrid",
      "attractions_name": "古罗马剧场 (奥赫里德)",
      "attractions_name_en": "Ancient Theatre of Ohrid",
      "description": "奥赫里德的古希腊-罗马剧场，保存完好，至今仍用于夏季演出和音乐会。",
      "official_link": "不支持线上购票",
      "price_range": "100 - 150",
      "currency": "MKD",
      "description_en": "Ohrid's Greco-Roman theatre—well preserved; still used for summer performances.",
      "price_range_en": "MKD 100–150",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MK",
      "cityname": "奥赫里德",
      "cityname_en": "Ohrid",
      "attractions_name": "圣纳姆修道院",
      "attractions_name_en": "Monastery of St. Naum",
      "description": "位于奥赫里德湖东南岸，一座美丽的修道院，周围环境宁静，有孔雀和清澈的泉水。",
      "official_link": "不支持线上购票",
      "price_range": "50 - 100",
      "currency": "MKD",
      "description_en": "On the southeast shore of Lake Ohrid—beautiful monastery; peacocks and spring water.",
      "price_range_en": "MKD 50–100",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MK",
      "cityname": "奥赫里德",
      "cityname_en": "Ohrid",
      "attractions_name": "圣潘捷列伊蒙修道院 (普劳什尼克)",
      "attractions_name_en": "St. Panteleimon Monastery (Plaošnik)",
      "description": "位于奥赫里德的普劳什尼克，重要的考古遗址和重建的教堂，斯拉夫字母的发源地。",
      "official_link": "不支持线上购票",
      "price_range": "100 - 150",
      "currency": "MKD",
      "description_en": "In Plaošnik, Ohrid—important archaeological site and rebuilt church; birthplace of Cyrillic.",
      "price_range_en": "MKD 100–150",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MK",
      "cityname": "比托拉/马其顿南部",
      "cityname_en": "Bitola/Southern Macedonia",
      "attractions_name": "马格达尼亚罗马城 (赫拉克利亚·林克斯蒂斯)",
      "attractions_name_en": "Heraclea Lyncestis",
      "description": "位于比托拉附近，古罗马城市遗址，拥有精美的马赛克地板、剧场和教堂遗迹。",
      "official_link": "不支持线上购票",
      "price_range": "100 - 150",
      "currency": "MKD",
      "description_en": "Near Bitola—Roman city ruins; fine mosaics, theatre and church remains.",
      "price_range_en": "MKD 100–150",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MK",
      "cityname": "比托拉/马其顿南部",
      "cityname_en": "Bitola/Southern Macedonia",
      "attractions_name": "希罗基索卡克街",
      "attractions_name_en": "Shirok Sokak Street",
      "description": "比托拉的主步行街，以其奥斯曼时期和新古典主义建筑、咖啡馆和商店而闻名。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（餐饮购物另计）",
      "currency": "MKD",
      "description_en": "Bitola's main pedestrian street—Ottoman and Neoclassical buildings; cafés and shops.",
      "price_range_en": "Free (meals/shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MK",
      "cityname": "比托拉/马其顿南部",
      "cityname_en": "Bitola/Southern Macedonia",
      "attractions_name": "纪念塔",
      "attractions_name_en": "Memorial House of Bitola (Bitola Museum)",
      "description": "位于比托拉市中心，一座纪念城市历史和文化的博物馆。",
      "official_link": "不支持线上购票",
      "price_range": "100 - 150",
      "currency": "MKD",
      "description_en": "In the centre of Bitola—museum of the city's history and culture.",
      "price_range_en": "MKD 100–150",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MK",
      "cityname": "比托拉/马其顿南部",
      "cityname_en": "Bitola/Southern Macedonia",
      "attractions_name": "佩利斯特国家公园",
      "attractions_name_en": "Pelister National Park",
      "description": "北马其顿最古老的国家公园，以其多样的生物、冰川湖泊和徒步路线而闻名。",
      "official_link": "无官方购票链接，为自然区域（入园费/停车费可能收费）",
      "price_range": "免费（部分活动另计）",
      "currency": "MKD",
      "description_en": "North Macedonia's oldest national park—diverse wildlife, glacial lakes and hiking.",
      "price_range_en": "Free (some activities extra)",
      "official_link_en": "无官方购票链接，为自然区域（入园费/停车费可能收费）"
    },
    {
      "id": "MK",
      "cityname": "比托拉/马其顿南部",
      "cityname_en": "Bitola/Southern Macedonia",
      "attractions_name": "圣迪米特里大教堂 (比托拉)",
      "attractions_name_en": "St. Demetrius Church (Bitola)",
      "description": "比托拉的重要东正教教堂，以其精美的木雕和图标而闻名。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "MKD",
      "description_en": "Important Orthodox church in Bitola—fine woodcarving and icons.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "MK",
      "cityname": "比托拉/马其顿南部",
      "cityname_en": "Bitola/Southern Macedonia",
      "attractions_name": "蒂托元帅大道 (马其顿南部)",
      "attractions_name_en": "Marshal Tito Street (Strumica)",
      "description": "斯特鲁米察市中心的主步行街，城市重要地标，有商店和餐厅。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "MKD",
      "description_en": "Main pedestrian street in Strumica—city landmark; shops and restaurants.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AD",
      "cityname": "安道尔城/恩坎普 (核心区)",
      "cityname_en": "Andorra la Vella/Encamp (Core Area)",
      "attractions_name": "安道尔城老城区",
      "attractions_name_en": "Andorra la Vella Old Quarter",
      "description": "安道尔首都的历史中心，有狭窄的街道、石砌房屋和议会大厦。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "Historic centre of Andorra's capital—narrow streets, stone houses and parliament.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "AD",
      "cityname": "安道尔城/恩坎普",
      "cityname_en": "Andorra la Vella/Encamp",
      "attractions_name": "卡尔迪亚温泉中心",
      "attractions_name_en": "Caldea Thermal Spa",
      "description": "欧洲最大的高山温泉中心之一，提供各种水疗和放松体验，现代建筑风格独特。",
      "official_link": "https://www.caldea.com/en/",
      "price_range": "40 - 60 (根据套餐)",
      "currency": "EUR",
      "description_en": "One of Europe's largest mountain spa centres—thermal baths and relaxation; distinctive modern building.",
      "price_range_en": "€40–60 (by package)",
      "official_link_en": "https://www.caldea.com/en/"
    },
    {
      "id": "AD",
      "cityname": "安道尔城/恩坎普",
      "cityname_en": "Andorra la Vella/Encamp",
      "attractions_name": "圣埃斯特凡教堂",
      "attractions_name_en": "Sant Esteve Church",
      "description": "位于安道尔城，一座历史悠久的罗马式教堂，内部有精美的木制祭坛。",
      "official_link": "无门票，免费参观（部分区域可能收费）",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "In Andorra la Vella—historic Romanesque church; fine wooden altarpiece.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（部分区域可能收费）"
    },
    {
      "id": "AD",
      "cityname": "安道尔城/恩坎普",
      "cityname_en": "Andorra la Vella/Encamp",
      "attractions_name": "恩坎普缆车",
      "attractions_name_en": "Funicamp (Encamp)",
      "description": "连接恩坎普镇和格朗瓦利拉滑雪区的缆车，提供壮丽的山景。",
      "official_link": "不支持线上购票",
      "price_range": "约 15 (往返，非滑雪季)",
      "currency": "EUR",
      "description_en": "Cable car linking Encamp and Grandvalira ski area—mountain views.",
      "price_range_en": "~€15 return (non-ski season)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "AD",
      "cityname": "安道尔城/恩坎普",
      "cityname_en": "Andorra la Vella/Encamp",
      "attractions_name": "圣科洛马教堂",
      "attractions_name_en": "Sant Coloma Church",
      "description": "位于安道尔城郊，安道尔最古老的教堂之一，拥有独特的圆形钟楼。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "On the outskirts of Andorra la Vella—one of Andorra's oldest churches; unique round bell tower.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "AD",
      "cityname": "安道尔城/恩坎普",
      "cityname_en": "Andorra la Vella/Encamp",
      "attractions_name": "议会大厦 (Casa de la Vall)",
      "attractions_name_en": "Casa de la Vall (Parliament House)",
      "description": "曾是安道尔议会的所在地，一座历史悠久的石头建筑，现在是博物馆。",
      "official_link": "无需购票",
      "price_range": "免费 (预约参观)",
      "currency": "EUR",
      "description_en": "Former seat of Andorra's parliament—historic stone building; now a museum.",
      "price_range_en": "Free (book ahead)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "SM",
      "cityname": "圣马力诺城 (首都)",
      "cityname_en": "San Marino City (Capital)",
      "attractions_name": "瓜伊塔塔 (第一塔)",
      "attractions_name_en": "Guaita Tower (First Tower)",
      "description": "圣马力诺的标志性建筑，位于蒂塔诺山顶，是最古老、保存最完好的防御塔之一，可俯瞰壮丽景色。",
      "official_link": "不支持线上购票",
      "price_range": "5 (单塔), 7.5 (两塔联票)",
      "currency": "EUR",
      "description_en": "San Marino's icon—oldest and best-preserved tower on Monte Titano; stunning views.",
      "price_range_en": "€5 (one tower), €7.50 (two towers)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "SM",
      "cityname": "圣马力诺城",
      "cityname_en": "San Marino City",
      "attractions_name": "切斯塔塔 (第二塔)",
      "attractions_name_en": "Cesta Tower (Second Tower)",
      "description": "位于蒂塔诺山顶的另一座塔，比瓜伊塔塔更高，内部设有圣马力诺古代武器博物馆。",
      "official_link": "不支持线上购票",
      "price_range": "5 (单塔), 7.5 (两塔联票)",
      "currency": "EUR",
      "description_en": "Second tower on Monte Titano—taller than Guaita; Museum of Ancient Arms inside.",
      "price_range_en": "€5 (one tower), €7.50 (two towers)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "SM",
      "cityname": "圣马力诺城",
      "cityname_en": "San Marino City",
      "attractions_name": "自由广场与政府宫",
      "attractions_name_en": "Piazza della Libertà & Palazzo Pubblico",
      "description": "圣马力诺城的中心广场，政府宫是共和国的市政厅和官方建筑，有卫兵换岗仪式。",
      "official_link": "无需购票",
      "price_range": "免费（进入政府宫可能收费，约 3）",
      "currency": "EUR",
      "description_en": "Central square—Government Palace is the town hall; changing of the guard.",
      "price_range_en": "Free (Government Palace ~€3)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "SM",
      "cityname": "圣马力诺城",
      "cityname_en": "San Marino City",
      "attractions_name": "圣马力诺大教堂 (圣马力诺圣徒大教堂)",
      "attractions_name_en": "Basilica di San Marino (Basilica of Saint Marinus)",
      "description": "圣马力诺最重要的教堂，供奉共和国的守护神圣马力诺。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "EUR",
      "description_en": "San Marino's main church—dedicated to the republic's patron saint.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "SM",
      "cityname": "圣马力诺城",
      "cityname_en": "San Marino City",
      "attractions_name": "圣马力诺国家博物馆",
      "attractions_name_en": "State Museum of San Marino",
      "description": "收藏了从新石器时代到现代的考古发现、艺术品和历史文物。",
      "official_link": "不支持线上购票",
      "price_range": "4.5",
      "currency": "EUR",
      "description_en": "Archaeology, art and history from the Neolithic to the present.",
      "price_range_en": "€4.50",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "SM",
      "cityname": "圣马力诺城",
      "cityname_en": "San Marino City",
      "attractions_name": "蒂塔诺山缆车",
      "attractions_name_en": "San Marino Cable Car (Funivia)",
      "description": "连接圣马力诺城（上城）与博尔戈马焦雷（下城）的缆车，提供便捷交通和沿途风景。",
      "official_link": "不支持线上购票",
      "price_range": "3 (单程), 5.50 (往返)",
      "currency": "EUR",
      "description_en": "Cable car linking San Marino (upper) and Borgo Maggiore (lower)—views along the way.",
      "price_range_en": "€3 (one-way), €5.50 (return)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "LI",
      "cityname": "瓦杜兹 (首都)",
      "cityname_en": "Vaduz (Capital)",
      "attractions_name": "瓦杜兹城堡",
      "attractions_name_en": "Vaduz Castle",
      "description": "列支敦士登亲王的官方住所，位于高处，是国家象征。不对公众开放参观，但可在外观赏。",
      "official_link": "https://tourismus.li/en/",
      "price_range": "免费（外部参观）",
      "currency": "CHF",
      "description_en": "Prince's official residence—on the hill; national symbol. Not open to the public; view from outside.",
      "price_range_en": "Free (exterior only)",
      "official_link_en": "https://tourismus.li/en/"
    },
    {
      "id": "LI",
      "cityname": "瓦杜兹",
      "cityname_en": "Vaduz",
      "attractions_name": "邮票博物馆",
      "attractions_name_en": "Postage Stamp Museum",
      "description": "瓦杜兹最受欢迎的博物馆之一，展示列支敦士登丰富多彩的邮票发行历史和设计。",
      "official_link": "无需购票",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "One of Vaduz's most popular museums—Liechtenstein's stamp history and design.",
      "price_range_en": "Free",
      "official_link_en": "No ticket required"
    },
    {
      "id": "LI",
      "cityname": "瓦杜兹",
      "cityname_en": "Vaduz",
      "attractions_name": "列支敦士登国家博物馆",
      "attractions_name_en": "Liechtenstein National Museum",
      "description": "深入了解列支敦士登的历史、文化、艺术和自然，展览丰富多样。",
      "official_link": "https://www.landesmuseum.li/en",
      "price_range": "12",
      "currency": "CHF",
      "description_en": "Liechtenstein's history, culture, art and nature—varied exhibitions.",
      "price_range_en": "CHF 12",
      "official_link_en": "https://www.landesmuseum.li/en"
    },
    {
      "id": "LI",
      "cityname": "瓦杜兹",
      "cityname_en": "Vaduz",
      "attractions_name": "艺术博物馆",
      "attractions_name_en": "Kunstmuseum Liechtenstein",
      "description": "现代化的黑色立方体建筑，收藏了20世纪和当代艺术品，以及亲王家族的部分收藏。",
      "official_link": "https://www.kunstmuseum.li/en",
      "price_range": "15",
      "currency": "CHF",
      "description_en": "Modern black cube building—20th-century and contemporary art; part of the princely collection.",
      "price_range_en": "CHF 15",
      "official_link_en": "https://www.kunstmuseum.li/en"
    },
    {
      "id": "LI",
      "cityname": "瓦杜兹",
      "cityname_en": "Vaduz",
      "attractions_name": "瓦杜兹步行区 (市中心)",
      "attractions_name_en": "Vaduz Pedestrian Area (City Center)",
      "description": "瓦杜兹的商业和文化中心，有商店、餐馆、雕塑和艺术画廊。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（购物消费另计）",
      "currency": "CHF",
      "description_en": "Vaduz's commercial and cultural centre—shops, restaurants, sculptures and galleries.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "LI",
      "cityname": "瓦杜兹",
      "cityname_en": "Vaduz",
      "attractions_name": "红屋 (Red House)",
      "attractions_name_en": "Red House (Das Rote Haus)",
      "description": "瓦杜兹老城区的标志性建筑，一座历史悠久的红色阶梯式房屋，非常上镜。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "CHF",
      "description_en": "Iconic building in the old town—historic red stepped house; very photogenic.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "MD",
      "cityname": "基希讷乌",
      "cityname_en": "Chișinău",
      "attractions_name": "史蒂芬大帝公园与纪念碑",
      "attractions_name_en": "Stefan the Great Park and Monument",
      "description": "基希讷乌市中心的标志性公园，以摩尔多瓦民族英雄史蒂芬大帝的雕像为中心。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "MDL",
      "description_en": "Central park in Chișinău—monument to Moldovan hero Stephen the Great.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MD",
      "cityname": "基希讷乌",
      "cityname_en": "Chișinău",
      "attractions_name": "摩尔多瓦国家历史博物馆",
      "attractions_name_en": "National Museum of History of Moldova",
      "description": "摩尔多瓦最大的博物馆，通过考古发现和历史文物，展示摩尔多瓦的历史和文化。",
      "official_link": "不支持线上购票",
      "price_range": "10～20",
      "currency": "MDL",
      "description_en": "Moldova's largest museum—history and culture through archaeology and artefacts.",
      "price_range_en": "MDL 10–20",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MD",
      "cityname": "基希讷乌",
      "cityname_en": "Chișinău",
      "attractions_name": "大教堂公园与基督诞生主教座堂",
      "attractions_name_en": "Cathedral Park & Nativity Cathedral",
      "description": "基希讷乌的中心绿地，拥有新古典主义风格的教堂和钟楼，是城市的地标。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "MDL",
      "description_en": "Central green space—Neoclassical cathedral and bell tower; city landmark.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "MD",
      "cityname": "基希讷乌",
      "cityname_en": "Chișinău",
      "attractions_name": "凯旋门",
      "attractions_name_en": "Triumphal Arch (Holy Gates)",
      "description": "位于大教堂公园旁，为纪念1812年俄土战争胜利而建，是基希讷乌的标志性建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "MDL",
      "description_en": "Next to Cathedral Park—built to mark 1812 Russo-Turkish victory; Chișinău icon.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MD",
      "cityname": "基希讷乌",
      "cityname_en": "Chișinău",
      "attractions_name": "阿列克谢·什丘谢夫国家美术博物馆",
      "attractions_name_en": "National Museum of Fine Arts of Moldova",
      "description": "收藏了摩尔多瓦和一些国际艺术家的作品，包括绘画、雕塑和装饰艺术。",
      "official_link": "不支持线上购票",
      "price_range": "10～20",
      "currency": "MDL",
      "description_en": "Moldovan and international art—painting, sculpture and decorative art.",
      "price_range_en": "MDL 10–20",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MD",
      "cityname": "基希讷乌",
      "cityname_en": "Chișinău",
      "attractions_name": "酒窖 (例如 Cricova 或 Mileștii Mici)",
      "attractions_name_en": "Wine Cellars (e.g., Cricova or Mileștii Mici)",
      "description": "摩尔多瓦以其葡萄酒而闻名，Cricova和Mileștii Mici是世界上最大的地下酒窖之一，提供导览和品酒。",
      "official_link": "https://www.cricova.md/en/ 或 https://milestii-mici.md/en/",
      "price_range": "300 - 800 (根据套餐)",
      "currency": "MDL",
      "description_en": "Moldova is famous for wine—Cricova and Mileștii Mici among the world's largest underground cellars; tours and tastings.",
      "price_range_en": "MDL 300–800 (by package)",
      "official_link_en": "https://www.cricova.md/en/ 或 https://milestii-mici.md/en/"
    },
    {
      "id": "MD",
      "cityname": "奥尔赫伊老城/特兰西斯特里亚 (历史与地区)",
      "cityname_en": "Orheiul Vechi/Transnistria (History & Region)",
      "attractions_name": "奥尔赫伊老城",
      "attractions_name_en": "Orheiul Vechi",
      "description": "联合国教科文组织世界遗产预备名录，一个独特的考古和自然综合体，有洞穴修道院、修道院和古老遗址。",
      "official_link": "无需购票",
      "price_range": "免费（部分博物馆/洞穴约 10 - 20）",
      "currency": "MDL",
      "description_en": "UNESCO tentative list—unique archaeological and natural complex; cave monasteries and ancient sites.",
      "price_range_en": "Free (some museums/caves MDL 10–20)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "MD",
      "cityname": "奥尔赫伊老城/特兰西斯特里亚",
      "cityname_en": "Orheiul Vechi/Transnistria",
      "attractions_name": "新赫尔基亚修道院",
      "attractions_name_en": "New Hîrjauca Monastery",
      "description": "位于奥尔赫伊老城附近，一个美丽的修道院，被森林和丘陵环绕。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "MDL",
      "description_en": "Near Old Orhei—beautiful monastery surrounded by forest and hills.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "MD",
      "cityname": "奥尔赫伊老城/特兰西斯特里亚",
      "cityname_en": "Orheiul Vechi/Transnistria",
      "attractions_name": "蒂拉斯波尔 (德涅斯特河沿岸首都)",
      "attractions_name_en": "Tiraspol (Capital of Transnistria)",
      "description": "德涅斯特河沿岸共和国（未被普遍承认）的首都，保留了许多苏联时代的标志和氛围。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（部分博物馆可能收费）",
      "currency": "ROU (特兰西斯特里亚卢布)",
      "description_en": "Capital of Transnistria (unrecognised)—Soviet-era symbols and atmosphere.",
      "price_range_en": "Free (some museums may charge)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MD",
      "cityname": "奥尔赫伊老城/特兰西斯特里亚",
      "cityname_en": "Orheiul Vechi/Transnistria",
      "attractions_name": "基茨卡尼修道院 (特兰西斯特里亚)",
      "attractions_name_en": "Chițcani Monastery (Transnistria)",
      "description": "德涅斯特河沿岸最大的东正教修道院之一，建筑宏伟，环境宁静。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "ROU (特兰西斯特里亚卢布)",
      "description_en": "One of Transnistria's largest Orthodox monasteries—grand building; peaceful.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "MD",
      "cityname": "奥尔赫伊老城/特兰西斯特里亚",
      "cityname_en": "Orheiul Vechi/Transnistria",
      "attractions_name": "本德尔堡垒 (特兰西斯特里亚)",
      "attractions_name_en": "Bender Fortress (Transnistria)",
      "description": "位于本德尔市，一座历史悠久的奥斯曼时期堡垒，见证了该地区的复杂历史。",
      "official_link": "不支持线上购票",
      "price_range": "10 - 30 (特兰西斯特里亚卢布)",
      "currency": "ROU (特兰西斯特里亚卢布)",
      "description_en": "In Bender—historic Ottoman fortress; complex regional history.",
      "price_range_en": "10–30 (Transnistrian rubles)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MD",
      "cityname": "奥尔赫伊老城/特兰西斯特里亚",
      "cityname_en": "Orheiul Vechi/Transnistria",
      "attractions_name": "索罗卡堡垒",
      "attractions_name_en": "Soroca Fortress",
      "description": "位于德涅斯特河畔，一座保存完好的中世纪堡垒，具有重要的历史意义。",
      "official_link": "不支持线上购票",
      "price_range": "10～20",
      "currency": "MDL",
      "description_en": "On the Dniester—well-preserved medieval fortress; historically important.",
      "price_range_en": "MDL 10–20",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MD",
      "cityname": "蒂拉斯波尔/本德尔 (德涅斯特河沿岸)",
      "cityname_en": "Tiraspol/Bender (Transnistria)",
      "attractions_name": "德涅斯特河沿岸国家博物馆",
      "attractions_name_en": "Transnistrian State Museum",
      "description": "蒂拉斯波尔的主要博物馆，展示德涅斯特河沿岸地区的历史和文化，尤其侧重于苏联时期。",
      "official_link": "不支持线上购票",
      "price_range": "5 - 10 (特兰西斯特里亚卢布)",
      "currency": "ROU (特兰西斯特里亚卢布)",
      "description_en": "Tiraspol's main museum—Transnistria's history and culture; Soviet period focus.",
      "price_range_en": "5–10 (Transnistrian rubles)",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "MD",
      "cityname": "蒂拉斯波尔/本德尔",
      "cityname_en": "Tiraspol/Bender",
      "attractions_name": "苏维埃街 (蒂拉斯波尔)",
      "attractions_name_en": "Suvorov Square (Tiraspol)",
      "description": "蒂拉斯波尔的主要广场，有苏沃洛夫将军的雕像和典型的苏联时期建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ROU (特兰西斯特里亚卢布)",
      "description_en": "Tiraspol's main square—General Suvorov statue and typical Soviet-era buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MD",
      "cityname": "蒂拉斯波尔/本德尔",
      "cityname_en": "Tiraspol/Bender",
      "attractions_name": "本德尔革命广场",
      "attractions_name_en": "Revolution Square (Bender)",
      "description": "本德尔市的中心广场，有列宁雕像和纪念碑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ROU (特兰西斯特里亚卢布)",
      "description_en": "Central square in Bender—Lenin statue and monuments.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MD",
      "cityname": "蒂拉斯波尔/本德尔",
      "cityname_en": "Tiraspol/Bender",
      "attractions_name": "绿堡 (蒂拉斯波尔)",
      "attractions_name_en": "Green Market (Tiraspol)",
      "description": "蒂拉斯波尔的当地市场，出售新鲜农产品和当地特色商品。",
      "official_link": "无官方购票链接，为公共市场",
      "price_range": "免费（购物消费另计）",
      "currency": "ROU (特兰西斯特里亚卢布)",
      "description_en": "Local market in Tiraspol—fresh produce and local goods.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public market"
    },
    {
      "id": "MD",
      "cityname": "蒂拉斯波尔/本德尔",
      "cityname_en": "Tiraspol/Bender",
      "attractions_name": "苏联纪念碑 (蒂拉斯波尔)",
      "attractions_name_en": "Tank Monument (Tiraspol)",
      "description": "蒂拉斯波尔的标志性苏联时代纪念碑，一辆真实的T-34坦克作为纪念物。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ROU (特兰西斯特里亚卢布)",
      "description_en": "Tiraspol's iconic Soviet-era monument—real T-34 tank as memorial.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "MD",
      "cityname": "蒂拉斯波尔/本德尔",
      "cityname_en": "Tiraspol/Bender",
      "attractions_name": "二战纪念碑 (蒂拉斯波尔)",
      "attractions_name_en": "Memorial of Glory (Tiraspol)",
      "description": "纪念二战和特兰西斯特里亚冲突的纪念碑群，包括永恒之火。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "ROU (特兰西斯特里亚卢布)",
      "description_en": "Monuments to WWII and Transnistria conflict—eternal flame.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BY",
      "cityname": "明斯克",
      "cityname_en": "Minsk",
      "attractions_name": "胜利广场",
      "attractions_name_en": "Victory Square",
      "description": "明斯克市中心的重要广场，有二战胜利纪念碑和永恒之火，纪念苏联人民在二战中的胜利。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BYN",
      "description_en": "Important square in the centre—WWII Victory monument and eternal flame.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BY",
      "cityname": "明斯克",
      "cityname_en": "Minsk",
      "attractions_name": "眼泪岛",
      "attractions_name_en": "Island of Tears (Ostrov Slyoz)",
      "description": "位于特罗伊茨科耶郊区河边，一座纪念阿富汗战争中牺牲的白俄罗斯士兵的纪念碑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BYN",
      "description_en": "On an island in the river in Troitskoye—memorial to Belarusian soldiers who died in Afghanistan.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BY",
      "cityname": "明斯克",
      "cityname_en": "Minsk",
      "attractions_name": "圣西蒙和圣海伦教堂 (红教堂)",
      "attractions_name_en": "Church of Saints Simon and Helena (Red Church)",
      "description": "明斯克市中心的标志性教堂，哥特复兴式建筑，因其红砖外观而得名。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "BYN",
      "description_en": "Iconic church in the centre—Gothic Revival; red brick gives it its name.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BY",
      "cityname": "明斯克",
      "cityname_en": "Minsk",
      "attractions_name": "白俄罗斯国家历史博物馆",
      "attractions_name_en": "National Historical Museum of Belarus",
      "description": "白俄罗斯最大的博物馆，通过考古发现和历史文物，展示白俄罗斯从远古到现代的历史。",
      "official_link": "http://history.museum.by/en",
      "price_range": "5～10",
      "currency": "BYN",
      "description_en": "Belarus's largest museum—from ancient times to the present.",
      "price_range_en": "BYN 5–10",
      "official_link_en": "http://history.museum.by/en"
    },
    {
      "id": "BY",
      "cityname": "明斯克",
      "cityname_en": "Minsk",
      "attractions_name": "明斯克市政厅",
      "attractions_name_en": "Minsk City Hall",
      "description": "明斯克市中心的重建建筑，新古典主义风格，是城市重要的行政和文化地标。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "BYN",
      "description_en": "Reconstructed building in the centre—Neoclassical; administrative and cultural landmark.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "BY",
      "cityname": "明斯克",
      "cityname_en": "Minsk",
      "attractions_name": "国家歌剧和芭蕾舞剧院",
      "attractions_name_en": "National Academic Bolshoi Opera and Ballet Theatre",
      "description": "白俄罗斯最大的剧院，宏伟的建筑，提供高水平的歌剧和芭蕾舞表演。",
      "official_link": "无需购票",
      "price_range": "免费（演出票价另计）",
      "currency": "BYN",
      "description_en": "Belarus's largest theatre—grand building; opera and ballet.",
      "price_range_en": "Free (performance tickets extra)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "BY",
      "cityname": "布列斯特",
      "cityname_en": "Brest",
      "attractions_name": "布列斯特要塞",
      "attractions_name_en": "Brest Fortress",
      "description": "纪念二战初期防御战的英雄要塞，巨大的纪念碑和博物馆群，是白俄罗斯最重要的历史遗迹之一。",
      "official_link": "无需购票",
      "price_range": "免费（部分博物馆收费，约 10 - 15）",
      "currency": "BYN",
      "description_en": "Hero fortress of early WWII defence—huge monument and museum complex; one of Belarus's most important sites.",
      "price_range_en": "Free (some museums ~BYN 10–15)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "BY",
      "cityname": "布列斯特",
      "cityname_en": "Brest",
      "attractions_name": "布列斯特铁路博物馆",
      "attractions_name_en": "Brest Railway Museum",
      "description": "露天博物馆，展示了各种历史悠久的火车头和车厢，是铁路爱好者的天堂。",
      "official_link": "不支持线上购票",
      "price_range": "5～10",
      "currency": "BYN",
      "description_en": "Open-air museum—historic locomotives and carriages; railway enthusiasts' paradise.",
      "price_range_en": "BYN 5–10",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "BY",
      "cityname": "布列斯特",
      "cityname_en": "Brest",
      "attractions_name": "苏维埃街 (步行街)",
      "attractions_name_en": "Sovetskaya Street (Pedestrian Street)",
      "description": "布列斯特市中心的主要步行街，有商店、咖啡馆、餐厅和独特的灯夫点灯仪式。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费（购物消费另计）",
      "currency": "BYN",
      "description_en": "Main pedestrian street in the centre—shops, cafés, restaurants and unique lamplighter ceremony.",
      "price_range_en": "Free (shopping extra)",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "BY",
      "cityname": "布列斯特",
      "cityname_en": "Brest",
      "attractions_name": "圣西蒙大教堂",
      "attractions_name_en": "St. Simeon Cathedral",
      "description": "布列斯特的主要东正教教堂，宏伟的建筑，内部装饰精美。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "BYN",
      "description_en": "Brest's main Orthodox church—grand building; fine interior.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BY",
      "cityname": "布列斯特",
      "cityname_en": "Brest",
      "attractions_name": "阿列伊卡灯具博物馆",
      "attractions_name_en": "Alley of Lights (Lights Museum)",
      "description": "位于苏维埃街附近，展示了布列斯特历史上的各种街灯和照明设备。",
      "official_link": "免费",
      "price_range": "免费",
      "currency": "BYN",
      "description_en": "Near Sovetskaya Street—street lamps and lighting through Brest's history.",
      "price_range_en": "Free",
      "official_link_en": "免费"
    },
    {
      "id": "BY",
      "cityname": "布列斯特",
      "cityname_en": "Brest",
      "attractions_name": "贝尔韦日国家公园 (部分)",
      "attractions_name_en": "Belovezhskaya Pushcha National Park (part)",
      "description": "联合国教科文组织世界遗产，欧洲最古老的原始森林之一，是欧洲野牛的家园，布列斯特是其主要入口之一。",
      "official_link": "无需购票",
      "price_range": "免费（部分活动/博物馆收费，约 10 - 20）",
      "currency": "BYN",
      "description_en": "UNESCO World Heritage—one of Europe's oldest primeval forests; home to European bison; Brest is one main entrance.",
      "price_range_en": "Free (some activities/museums ~BYN 10–20)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "BY",
      "cityname": "格罗德诺/涅斯维日 (西部/历史古迹)",
      "cityname_en": "Grodno/Nesvizh (West/Historical Sites)",
      "attractions_name": "格罗德诺旧城堡",
      "attractions_name_en": "Old Castle Grodno",
      "description": "位于涅曼河畔，格罗德诺最古老的城堡，曾是立陶宛大公国的皇家住所，正在重建中。",
      "official_link": "不支持线上购票",
      "price_range": "5～8",
      "currency": "BYN",
      "description_en": "On the Nemunas—Grodno's oldest castle; former Lithuanian Grand Duchy royal residence; under reconstruction.",
      "price_range_en": "BYN 5–8",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "BY",
      "cityname": "格罗德诺/涅斯维日",
      "cityname_en": "Grodno/Nesvizh",
      "attractions_name": "格罗德诺新城堡",
      "attractions_name_en": "New Castle Grodno",
      "description": "位于旧城堡旁边，曾是国王的夏宫，现在是历史博物馆。",
      "official_link": "不支持线上购票",
      "price_range": "5～8",
      "currency": "BYN",
      "description_en": "Next to the Old Castle—former royal summer residence; now history museum.",
      "price_range_en": "BYN 5–8",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "BY",
      "cityname": "格罗德诺/涅斯维日",
      "cityname_en": "Grodno/Nesvizh",
      "attractions_name": "圣弗朗西斯·泽维尔大教堂",
      "attractions_name_en": "St. Francis Xavier Cathedral (Grodno)",
      "description": "格罗德诺最宏伟的教堂，巴洛克式建筑杰作，内部装饰华丽。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "BYN",
      "description_en": "Grodno's grandest church—Baroque masterpiece; lavish interior.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "BY",
      "cityname": "格罗德诺/涅斯维日",
      "cityname_en": "Grodno/Nesvizh",
      "attractions_name": "涅斯维日城堡",
      "attractions_name_en": "Nesvizh Castle",
      "description": "联合国教科文组织世界遗产，拉济维乌家族的宏伟宫殿建筑群，融合了文艺复兴、巴洛克和古典主义风格。",
      "official_link": "https://niasvizh.by/en/",
      "price_range": "15 - 20 (城堡和公园)",
      "currency": "BYN",
      "description_en": "UNESCO World Heritage—Radziwiłł family palace complex; Renaissance, Baroque and Neoclassical.",
      "price_range_en": "BYN 15–20 (castle and park)",
      "official_link_en": "https://niasvizh.by/en/"
    },
    {
      "id": "BY",
      "cityname": "格罗德诺/涅斯维日",
      "cityname_en": "Grodno/Nesvizh",
      "attractions_name": "米尔城堡",
      "attractions_name_en": "Mir Castle Complex",
      "description": "联合国教科文组织世界遗产，一座保存完好的中世纪城堡，具有独特的哥特式、文艺复兴和巴洛克元素。",
      "official_link": "不支持线上购票",
      "price_range": "15 - 20",
      "currency": "BYN",
      "description_en": "UNESCO World Heritage—well-preserved medieval castle; Gothic, Renaissance and Baroque.",
      "price_range_en": "BYN 15–20",
      "official_link_en": "不支持线上购票"
    },
    {
      "id": "BY",
      "cityname": "格罗德诺/涅斯维日",
      "cityname_en": "Grodno/Nesvizh",
      "attractions_name": "格罗德诺火车站",
      "attractions_name_en": "Grodno Railway Station",
      "description": "格罗德诺历史悠久的火车站，是城市的重要地标，具有独特的建筑风格。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "BYN",
      "description_en": "Historic railway station in Grodno—city landmark; distinctive architecture.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "红场",
      "attractions_name_en": "Red Square",
      "description": "俄罗斯的象征，世界著名的广场，周围环绕着克里姆林宫、圣瓦西里大教堂和国家历史博物馆。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Russia's symbol—world-famous square; Kremlin, St Basil's and State Historical Museum.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "克里姆林宫",
      "attractions_name_en": "Moscow Kremlin",
      "description": "俄罗斯的政治和精神中心，包含多座教堂、宫殿和博物馆（如武器库和钻石库），是世界遗产。",
      "official_link": "https://kreml.ru/en-us/museums-moscow-kremlin/",
      "price_range": "500到1000 (根据区域)",
      "currency": "RUB",
      "description_en": "Russia's political and spiritual centre—churches, palaces and museums (Armoury, Diamond Fund); World Heritage.",
      "price_range_en": "RUB 500–1000 (by area)",
      "official_link_en": "https://kreml.ru/en-us/museums-moscow-kremlin/"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "圣瓦西里大教堂",
      "attractions_name_en": "St. Basil's Cathedral",
      "description": "红场上的标志性教堂，以其独特的洋葱头圆顶和鲜艳的色彩而闻名，是俄罗斯建筑的杰作。",
      "official_link": "https://shm.ru/",
      "price_range": "800到1000",
      "currency": "RUB",
      "description_en": "Iconic church on Red Square—distinctive onion domes and bright colours; Russian architectural masterpiece.",
      "price_range_en": "RUB 800–1000",
      "official_link_en": "https://shm.ru/"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "特列季亚科夫画廊",
      "attractions_name_en": "Tretyakov Gallery",
      "description": "俄罗斯最大的艺术博物馆之一，收藏了大量俄罗斯艺术品，涵盖从古老图标到现代艺术的时期。",
      "official_link": "https://www.tretyakovgallery.ru/en/",
      "price_range": "500到700",
      "currency": "RUB",
      "description_en": "One of Russia's largest art museums—Russian art from ancient icons to modern.",
      "price_range_en": "RUB 500–700",
      "official_link_en": "https://www.tretyakovgallery.ru/en/"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "普希金造型艺术博物馆",
      "attractions_name_en": "Pushkin State Museum of Fine Arts",
      "description": "俄罗斯最大的欧洲和美国艺术收藏馆，拥有从古埃及到20世纪的艺术品。",
      "official_link": "https://pushkinmuseum.art/",
      "price_range": "400到600",
      "currency": "RUB",
      "description_en": "Russia's largest European and American art collection—from ancient Egypt to the 20th century.",
      "price_range_en": "RUB 400–600",
      "official_link_en": "https://pushkinmuseum.art/"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "莫斯科地铁",
      "attractions_name_en": "Moscow Metro",
      "description": "被誉为世界上最美丽的地铁系统之一，许多车站装饰有大理石、雕塑、马赛克和吊灯。",
      "official_link": "无官方购票链接，为公共交通",
      "price_range": "65 (单程)",
      "currency": "RUB",
      "description_en": "One of the world's most beautiful metro systems—marble, sculpture, mosaics and chandeliers.",
      "price_range_en": "RUB 65 (single ride)",
      "official_link_en": "无官方购票链接，为公共交通"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "麻雀山",
      "attractions_name_en": "Sparrow Hills (Vorobyovy Gory)",
      "description": "位于莫斯科河畔的高地，可俯瞰莫斯科全景，莫斯科国立大学主楼坐落于此。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Heights above the Moscow River—panoramic views; Moscow State University main building.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "高尔基公园",
      "attractions_name_en": "Gorky Park",
      "description": "莫斯科最著名的公园之一，集休闲、娱乐和文化于一体，有湖泊、花园和各种活动。",
      "official_link": "无需购票",
      "price_range": "免费（部分活动另计）",
      "currency": "RUB",
      "description_en": "One of Moscow's most famous parks—leisure, entertainment and culture; lake, gardens and events.",
      "price_range_en": "Free (some activities extra)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "沙皇村 (科洛缅斯科耶庄园)",
      "attractions_name_en": "Kolomenskoye Estate",
      "description": "曾是沙皇的乡村居所，拥有独特的木制教堂和宫殿建筑，是联合国教科文组织世界遗产。",
      "official_link": "无需购票",
      "price_range": "免费（部分建筑/展览收费，约 100到300）",
      "currency": "RUB",
      "description_en": "Former tsars' country residence—unique wooden churches and palace; UNESCO World Heritage.",
      "price_range_en": "Free (some buildings/exhibitions RUB 100–300)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "RU",
      "cityname": "莫斯科",
      "cityname_en": "Moscow",
      "attractions_name": "VDNKh (国民经济成就展览馆)",
      "attractions_name_en": "VDNKh (Exhibition of Achievements of National Economy)",
      "description": "巨大的展览中心，拥有宏伟的苏维埃时期建筑、喷泉、公园和各种主题展馆。",
      "official_link": "无需购票",
      "price_range": "免费（部分展馆收费）",
      "currency": "RUB",
      "description_en": "Huge exhibition centre—grand Soviet-era buildings, fountains, park and themed pavilions.",
      "price_range_en": "Free (some pavilions charge)",
      "official_link_en": "No ticket required"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "冬宫 (埃尔米塔日博物馆)",
      "attractions_name_en": "The State Hermitage Museum (Winter Palace)",
      "description": "世界四大博物馆之一，曾是俄罗斯沙皇的冬宫，收藏了三百万件艺术品和文化珍宝。",
      "official_link": "https://www.hermitagemuseum.org/",
      "price_range": "800到1000",
      "currency": "RUB",
      "description_en": "One of the world's top four museums—former tsars' Winter Palace; three million works.",
      "price_range_en": "RUB 800–1000",
      "official_link_en": "https://www.hermitagemuseum.org/"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "滴血救世主教堂",
      "attractions_name_en": "Church of the Savior on Spilled Blood",
      "description": "圣彼得堡的标志性教堂，以其华丽的俄罗斯风格建筑和内部精美的马赛克而闻名。",
      "official_link": "https://cathedral.ru/en/spas-na-krovi",
      "price_range": "450到500",
      "currency": "RUB",
      "description_en": "St Petersburg's icon—lavish Russian-style building; fine interior mosaics.",
      "price_range_en": "RUB 450–500",
      "official_link_en": "https://cathedral.ru/en/spas-na-krovi"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "彼得霍夫宫 (夏宫)",
      "attractions_name_en": "Peterhof Palace (Summer Palace)",
      "description": "俄罗斯的“凡尔赛宫”，以其壮丽的宫殿、园林和金色喷泉而闻名。",
      "official_link": "https://peterhofmuseum.ru/en/",
      "price_range": "600到1500 (根据季节和区域)",
      "currency": "RUB",
      "description_en": "Russia's \"Versailles\"—grand palace, gardens and golden fountains.",
      "price_range_en": "RUB 600–1500 (season and areas)",
      "official_link_en": "https://peterhofmuseum.ru/en/"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "叶卡捷琳娜宫与琥珀屋",
      "attractions_name_en": "Catherine Palace and Amber Room",
      "description": "曾是沙皇的夏日行宫，以其奢华的巴洛克式建筑和闻名于世的琥珀屋而著称。",
      "official_link": "https://tzar.ru/en/",
      "price_range": "700到1500 (根据季节和区域)",
      "currency": "RUB",
      "description_en": "Former tsars' summer residence—lavish Baroque; world-famous Amber Room.",
      "price_range_en": "RUB 700–1500 (season and areas)",
      "official_link_en": "https://tzar.ru/en/"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "喀山大教堂",
      "attractions_name_en": "Kazan Cathedral",
      "description": "圣彼得堡的主要东正教教堂，新古典主义风格，有半圆形柱廊，内部收藏了喀山圣母像。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "St Petersburg's main Orthodox church—Neoclassical; semicircular colonnade; Kazan Icon inside.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "马林斯基剧院",
      "attractions_name_en": "Mariinsky Theatre",
      "description": "世界顶级的歌剧和芭蕾舞剧院之一，以其高水平的演出和悠久的历史而闻名。",
      "official_link": "https://www.mariinsky.ru/en/",
      "price_range": "免费（演出票价另计）",
      "currency": "RUB",
      "description_en": "One of the world's top opera and ballet theatres—high-level performances and long history.",
      "price_range_en": "Free (performance tickets extra)",
      "official_link_en": "https://www.mariinsky.ru/en/"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "圣以撒大教堂",
      "attractions_name_en": "St. Isaac's Cathedral",
      "description": "圣彼得堡最大的教堂，宏伟的新古典主义建筑，可登顶俯瞰城市全景。",
      "official_link": "https://cathedral.ru/en/isaakievskii-sobor",
      "price_range": "450到500 (登顶另计)",
      "currency": "RUB",
      "description_en": "St Petersburg's largest church—grand Neoclassical; climb for city views.",
      "price_range_en": "RUB 450–500 (dome extra)",
      "official_link_en": "https://cathedral.ru/en/isaakievskii-sobor"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "涅瓦大街",
      "attractions_name_en": "Nevsky Prospekt",
      "description": "圣彼得堡最著名的街道，繁华的商业和文化中心，有许多商店、餐厅、咖啡馆和历史建筑。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "St Petersburg's most famous street—busy commercial and cultural centre; shops, restaurants and historic buildings.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "俄罗斯博物馆",
      "attractions_name_en": "State Russian Museum",
      "description": "收藏了大量俄罗斯艺术品，是世界上最大的俄罗斯艺术博物馆之一，位于米哈伊洛夫斯基宫内。",
      "official_link": "https://rusmuseum.ru/",
      "price_range": "500到600",
      "currency": "RUB",
      "description_en": "Large collection of Russian art—one of the world's largest Russian art museums; in Mikhailovsky Palace.",
      "price_range_en": "RUB 500–600",
      "official_link_en": "https://rusmuseum.ru/"
    },
    {
      "id": "RU",
      "cityname": "圣彼得堡",
      "cityname_en": "St. Petersburg",
      "attractions_name": "海军部大厦",
      "attractions_name_en": "Admiralty Building",
      "description": "圣彼得堡的标志性建筑之一，金色尖顶是城市天际线的重要组成部分，象征俄罗斯海军力量。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "One of St Petersburg's icons—golden spire; key part of the skyline; symbol of Russian naval power.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "RU",
      "cityname": "金环小镇 (历史与文化)",
      "cityname_en": "Golden Ring (History & Culture)",
      "attractions_name": "谢尔吉耶夫波萨德 (三圣大教堂)",
      "attractions_name_en": "Sergiyev Posad (Trinity Lavra of St. Sergius)",
      "description": "俄罗斯金环小镇之一，重要的东正教朝圣中心，拥有宏伟的修道院建筑群，是世界遗产。",
      "official_link": "https://lavra.ru/",
      "price_range": "免费（部分博物馆/展览收费）",
      "currency": "RUB",
      "description_en": "One of the Golden Ring towns—major Orthodox pilgrimage centre; grand monastery complex; World Heritage.",
      "price_range_en": "Free (some museums/exhibitions charge)",
      "official_link_en": "https://lavra.ru/"
    },
    {
      "id": "RU",
      "cityname": "金环小镇",
      "cityname_en": "Golden Ring",
      "attractions_name": "苏兹达尔",
      "attractions_name_en": "Suzdal",
      "description": "金环小镇之一，被誉为“博物馆小镇”，拥有众多古老的教堂、修道院和木屋，是世界遗产。",
      "official_link": "无官方购票链接（部分景点收费）",
      "price_range": "免费（教堂/修道院约 100到300）",
      "currency": "RUB",
      "description_en": "Golden Ring town—\"museum town\"; ancient churches, monasteries and wooden houses; World Heritage.",
      "price_range_en": "Free (churches/monasteries RUB 100–300)",
      "official_link_en": "无官方购票链接（部分景点收费）"
    },
    {
      "id": "RU",
      "cityname": "金环小镇",
      "cityname_en": "Golden Ring",
      "attractions_name": "弗拉基米尔 (圣母升天大教堂)",
      "attractions_name_en": "Vladimir (Assumption Cathedral)",
      "description": "金环小镇之一，曾是中世纪俄罗斯的首都，拥有多座白石建筑，如圣母升天大教堂和德米特里大教堂，是世界遗产。",
      "official_link": "无官方购票链接（部分教堂/博物馆收费）",
      "price_range": "免费（教堂约 150到300）",
      "currency": "RUB",
      "description_en": "Golden Ring town—former medieval Russian capital; white-stone buildings; Assumption and St Demetrius cathedrals; World Heritage.",
      "price_range_en": "Free (churches RUB 150–300)",
      "official_link_en": "无官方购票链接（部分教堂/博物馆收费）"
    },
    {
      "id": "RU",
      "cityname": "金环小镇",
      "cityname_en": "Golden Ring",
      "attractions_name": "雅罗斯拉夫尔",
      "attractions_name_en": "Yaroslavl",
      "description": "伏尔加河畔的历史名城，金环小镇之一，拥有众多17世纪的教堂，老城是世界遗产。",
      "official_link": "无官方购票链接（部分教堂/博物馆收费）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Historic city on the Volga—Golden Ring town; 17th-century churches; old town is World Heritage.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接（部分教堂/博物馆收费）"
    },
    {
      "id": "RU",
      "cityname": "金环小镇",
      "cityname_en": "Golden Ring",
      "attractions_name": "科斯特罗马",
      "attractions_name_en": "Kostroma",
      "description": "伏尔加河畔的另一个金环小镇，罗斯托夫王朝的发源地，有伊帕季耶夫修道院。",
      "official_link": "无官方购票链接（部分教堂/博物馆收费）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Another Golden Ring town on the Volga—birthplace of the Romanov dynasty; Ipatiev Monastery.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接（部分教堂/博物馆收费）"
    },
    {
      "id": "RU",
      "cityname": "金环小镇",
      "cityname_en": "Golden Ring",
      "attractions_name": "佩列斯拉夫尔-扎列斯基",
      "attractions_name_en": "Pereslavl-Zalessky",
      "description": "金环小镇之一，位于普列谢耶沃湖畔，拥有多座修道院和教堂，是普京的故乡。",
      "official_link": "无官方购票链接（部分教堂/博物馆收费）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Golden Ring town on Lake Pleshcheyevo—monasteries and churches; Putin's birthplace.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接（部分教堂/博物馆收费）"
    },
    {
      "id": "RU",
      "cityname": "金环小镇",
      "cityname_en": "Golden Ring",
      "attractions_name": "罗斯托夫",
      "attractions_name_en": "Rostov Veliky",
      "description": "金环小镇中最古老的城镇之一，以其宏伟的克里姆林宫和古老的教堂而闻名。",
      "official_link": "无官方购票链接（部分教堂/博物馆收费）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "One of the oldest Golden Ring towns—grand Kremlin and ancient churches.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接（部分教堂/博物馆收费）"
    },
    {
      "id": "RU",
      "cityname": "金环小镇",
      "cityname_en": "Golden Ring",
      "attractions_name": "尤里耶夫-波利斯基",
      "attractions_name_en": "Yuryev-Polsky",
      "description": "金环小镇之一，以其白石建造的圣乔治大教堂和独特的雕刻艺术而闻名。",
      "official_link": "无官方购票链接（部分教堂/博物馆收费）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Golden Ring town—white-stone St George's Cathedral and distinctive carving.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接（部分教堂/博物馆收费）"
    },
    {
      "id": "RU",
      "cityname": "金环小镇",
      "cityname_en": "Golden Ring",
      "attractions_name": "帕列赫",
      "attractions_name_en": "Palekh",
      "description": "俄罗斯著名的传统漆画艺术中心，小镇本身就是一个活的博物馆。",
      "official_link": "无官方购票链接（部分博物馆/工作室收费）",
      "price_range": "免费（博物馆约 100到200）",
      "currency": "RUB",
      "description_en": "Famous Russian lacquer miniature centre—town itself is a living museum.",
      "price_range_en": "Free (museum RUB 100–200)",
      "official_link_en": "无官方购票链接（部分博物馆/工作室收费）"
    },
    {
      "id": "RU",
      "cityname": "金环小镇",
      "cityname_en": "Golden Ring",
      "attractions_name": "伊万诺沃",
      "attractions_name_en": "Ivanovo",
      "description": "金环小镇中最年轻的城市，被称为“纺织城”，拥有独特的构成主义建筑。",
      "official_link": "无官方购票链接（部分博物馆收费）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Youngest Golden Ring city—\"textile city\"; distinctive Constructivist architecture.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接（部分博物馆收费）"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸 (文化与多民族)",
      "cityname_en": "Kazan/Volga Region (Culture & Multi-ethnic)",
      "attractions_name": "喀山克里姆林宫",
      "attractions_name_en": "Kazan Kremlin",
      "description": "联合国教科文组织世界遗产，融合了俄罗斯和鞑靼建筑风格，内有库尔沙里夫清真寺和报喜大教堂。",
      "official_link": "https://kazan-kremlin.ru/en/",
      "price_range": "免费（部分区域/博物馆收费）",
      "currency": "RUB",
      "description_en": "UNESCO World Heritage—Russian and Tatar architecture; Kul Sharif Mosque and Annunciation Cathedral.",
      "price_range_en": "Free (some areas/museums charge)",
      "official_link_en": "https://kazan-kremlin.ru/en/"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸",
      "cityname_en": "Kazan/Volga Region",
      "attractions_name": "库尔沙里夫清真寺",
      "attractions_name_en": "Kul Sharif Mosque",
      "description": "位于喀山克里姆林宫内，是欧洲最大的清真寺之一，也是喀山的标志性建筑。",
      "official_link": "无门票，免费参观（需遵守宗教礼仪）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Inside the Kazan Kremlin—one of Europe's largest mosques; Kazan's icon.",
      "price_range_en": "Free",
      "official_link_en": "无门票，免费参观（需遵守宗教礼仪）"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸",
      "cityname_en": "Kazan/Volga Region",
      "attractions_name": "报喜大教堂",
      "attractions_name_en": "Annunciation Cathedral (Kazan)",
      "description": "位于喀山克里姆林宫内，东正教大教堂，与清真寺并立，象征城市的多元文化。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Inside the Kremlin—Orthodox cathedral; stands beside the mosque; symbol of multicultural city.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸",
      "cityname_en": "Kazan/Volga Region",
      "attractions_name": "巴乌曼街",
      "attractions_name_en": "Bauman Street",
      "description": "喀山市中心的主要步行街，充满活力，有商店、餐馆、咖啡馆和街头艺人。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Main pedestrian street in the centre—lively; shops, restaurants, cafés and street performers.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸",
      "cityname_en": "Kazan/Volga Region",
      "attractions_name": "喀山家庭中心 (喀山碗)",
      "attractions_name_en": "Kazan Family Center (Kazan Bowl)",
      "description": "独特的婚礼宫殿建筑，形似巨型大锅，是喀山市的新地标，可登顶俯瞰城市。",
      "official_link": "无官方购票链接，外部参观免费（登顶约 100）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Unique wedding palace building—shaped like a giant bowl; Kazan's new landmark; climb for city views.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费（登顶约 100）"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸",
      "cityname_en": "Kazan/Volga Region",
      "attractions_name": "农夫宫 (农业部大楼)",
      "attractions_name_en": "Farmers' Palace (Ministry of Agriculture Building)",
      "description": "喀山一座引人注目的华丽建筑，拥有独特的树状金属雕塑。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Striking ornate building in Kazan—distinctive tree-like metal sculpture.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸",
      "cityname_en": "Kazan/Volga Region",
      "attractions_name": "全宗教寺庙",
      "attractions_name_en": "Temple of All Religions (Universal Temple)",
      "description": "位于喀山郊区，一座独特的建筑群，融合了世界各地多种宗教的建筑风格，象征和平与统一。",
      "official_link": "无门票，免费参观",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "On the outskirts of Kazan—unique complex blending religious architecture from around the world; peace and unity.",
      "price_range_en": "Free",
      "official_link_en": "Free admission"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸",
      "cityname_en": "Kazan/Volga Region",
      "attractions_name": "喀山国立大学",
      "attractions_name_en": "Kazan Federal University",
      "description": "俄罗斯最古老的大学之一，其历史建筑和校园本身也是一道风景。",
      "official_link": "无官方购票链接，外部参观免费",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "One of Russia's oldest universities—historic buildings and campus are a sight in themselves.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接，外部参观免费"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸",
      "cityname_en": "Kazan/Volga Region",
      "attractions_name": "伏尔加河游船",
      "attractions_name_en": "Volga River Cruise",
      "description": "乘坐游船欣赏伏尔加河两岸的城市风光和自然景色。",
      "official_link": "无官方购票链接（多家公司运营）",
      "price_range": "500到1500",
      "currency": "RUB",
      "description_en": "Boat trip on the Volga—city and natural scenery along the banks.",
      "price_range_en": "RUB 500–1500",
      "official_link_en": "无官方购票链接（多家公司运营）"
    },
    {
      "id": "RU",
      "cityname": "喀山/伏尔加河沿岸",
      "cityname_en": "Kazan/Volga Region",
      "attractions_name": "伊奇诺什宫 (喀山国家博物馆)",
      "attractions_name_en": "Ichonoshe Palace (National Museum of the Republic of Tatarstan)",
      "description": "喀山主要的博物馆，展示鞑靼斯坦共和国的历史、文化和民族志。",
      "official_link": "不支持线上购买",
      "price_range": "200到300",
      "currency": "RUB",
      "description_en": "Kazan's main museum—Tatarstan Republic's history, culture and ethnography.",
      "price_range_en": "RUB 200–300",
      "official_link_en": "不支持线上购买"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东 (自然与冒险)",
      "cityname_en": "Siberia/Russian Far East (Nature & Adventure)",
      "attractions_name": "贝加尔湖",
      "attractions_name_en": "Lake Baikal",
      "description": "世界上最深、最古老的淡水湖，联合国教科文组织世界遗产，以其清澈的水和独特的生态系统而闻名。",
      "official_link": "无官方购票链接，为自然区域（游船/活动另计）",
      "price_range": "免费（游船约 1000到3000）",
      "currency": "RUB",
      "description_en": "World's deepest and oldest freshwater lake—UNESCO World Heritage; clear water and unique ecosystem.",
      "price_range_en": "Free (boat RUB 1000–3000)",
      "official_link_en": "无官方购票链接，为自然区域（游船/活动另计）"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东",
      "cityname_en": "Siberia/Russian Far East",
      "attractions_name": "奥利洪岛 (贝加尔湖)",
      "attractions_name_en": "Olkhon Island (Lake Baikal)",
      "description": "贝加尔湖上最大的岛屿，被认为是西伯利亚的萨满教中心，有独特的自然风光和萨满柱。",
      "official_link": "无官方购票链接（渡轮/交通另计）",
      "price_range": "免费（当地交通/住宿另计）",
      "currency": "RUB",
      "description_en": "Largest island on Lake Baikal—considered Siberia's shamanic centre; unique nature and shaman poles.",
      "price_range_en": "Free (local transport/accommodation extra)",
      "official_link_en": "无官方购票链接（渡轮/交通另计）"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东",
      "cityname_en": "Siberia/Russian Far East",
      "attractions_name": "伊尔库茨克",
      "attractions_name_en": "Irkutsk",
      "description": "西伯利亚的重要城市，被称为“西伯利亚的巴黎”，是前往贝加尔湖的主要门户，拥有独特的木制房屋。",
      "official_link": "无官方购票链接（部分博物馆收费）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Key Siberian city—\"Paris of Siberia\"; main gateway to Baikal; distinctive wooden houses.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接（部分博物馆收费）"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东",
      "cityname_en": "Siberia/Russian Far East",
      "attractions_name": "海参崴 (符拉迪沃斯托克)",
      "attractions_name_en": "Vladivostok",
      "description": "俄罗斯远东地区最大的城市和主要港口，太平洋舰队的基地，有独特的山地地形和金角湾大桥。",
      "official_link": "无官方购票链接（部分博物馆/景点收费）",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Russia's largest Far Eastern city and main port—Pacific Fleet base; mountainous terrain and Golden Horn Bridge.",
      "price_range_en": "Free",
      "official_link_en": "无官方购票链接（部分博物馆/景点收费）"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东",
      "cityname_en": "Siberia/Russian Far East",
      "attractions_name": "金角湾大桥 (海参崴)",
      "attractions_name_en": "Golden Bridge (Vladivostok)",
      "description": "海参崴的标志性建筑，横跨金角湾的壮观斜拉桥，连接城市两岸。",
      "official_link": "无官方购票链接，为公共区域",
      "price_range": "免费",
      "currency": "RUB",
      "description_en": "Vladivostok's icon—spectacular cable-stayed bridge across Golden Horn Bay.",
      "price_range_en": "Free",
      "official_link_en": "No official ticket link; public area"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东",
      "cityname_en": "Siberia/Russian Far East",
      "attractions_name": "西伯利亚大铁路",
      "attractions_name_en": "Trans-Siberian Railway",
      "description": "世界上最长的铁路，连接莫斯科和海参崴，是一次史诗般的火车旅行体验。",
      "official_link": "https://www.russiantrain.com/trans_siberian",
      "price_range": "价格根据行程距离和等级而定",
      "currency": "RUB",
      "description_en": "World's longest railway—Moscow to Vladivostok; epic train journey.",
      "price_range_en": "Price by distance and class",
      "official_link_en": "https://www.russiantrain.com/trans_siberian"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东",
      "cityname_en": "Siberia/俄罗斯远东",
      "attractions_name": "勘察加半岛 (火山与野生动物)",
      "attractions_name_en": "Kamchatka Peninsula (Volcanoes & Wildlife)",
      "description": "俄罗斯远东的火山活跃区，拥有壮观的火山、冰川、间歇泉和棕熊，是极限探险目的地。",
      "official_link": "无官方购票链接（旅行团/许可证另计）",
      "price_range": "价格根据旅行团而定",
      "currency": "RUB",
      "description_en": "Volcanically active region in the Russian Far East—volcanoes, glaciers, geysers and brown bears; adventure destination.",
      "price_range_en": "Price by tour",
      "official_link_en": "无官方购票链接（旅行团/许可证另计）"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东",
      "cityname_en": "Siberia/俄罗斯远东",
      "attractions_name": "火山博物馆 (彼得罗巴甫洛夫斯克)",
      "attractions_name_en": "Volcanological Museum (Petropavlovsk-Kamchatsky)",
      "description": "勘察加半岛彼得罗巴甫洛夫斯克市的博物馆，介绍当地的火山活动和地质特征。",
      "official_link": "不支持线上购买",
      "price_range": "200到300",
      "currency": "RUB",
      "description_en": "Museum in Petropavlovsk-Kamchatsky—local volcanic activity and geology.",
      "price_range_en": "RUB 200–300",
      "official_link_en": "不支持线上购买"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东",
      "cityname_en": "Siberia/俄罗斯远东",
      "attractions_name": "列娜河柱状地质公园",
      "attractions_name_en": "Lena Pillars Nature Park",
      "description": "联合国教科文组织世界遗产，位于雅库茨克附近，独特的巨大石柱群，是徒步和游船的理想之地。",
      "official_link": "无官方购票链接（游船/入园费另计）",
      "price_range": "免费（游船约 3000到5000）",
      "currency": "RUB",
      "description_en": "UNESCO World Heritage—near Yakutsk; unique giant stone pillars; hiking and boat trips.",
      "price_range_en": "Free (boat RUB 3000–5000)",
      "official_link_en": "无官方购票链接（游船/入园费另计）"
    },
    {
      "id": "RU",
      "cityname": "西伯利亚/远东",
      "cityname_en": "Siberia/俄罗斯远东",
      "attractions_name": "贝加尔湖沿岸铁路",
      "attractions_name_en": "Circum-Baikal Railway",
      "description": "贝加尔湖沿岸的历史悠久的铁路，提供独特的湖畔火车之旅，风景优美。",
      "official_link": "可自行搜索购买方式",
      "price_range": "价格根据行程和等级而定",
      "currency": "RUB",
      "description_en": "Historic railway along Lake Baikal—unique lakeside train journey; scenic.",
      "price_range_en": "Price by route and class",
      "official_link_en": "可自行搜索购买方式"
    }
  ],
  "cityPasses": [
    {
      "country_id": "FR",
      "city_name": "巴黎",
      "city_name_en": "Paris",
      "transportation": "地铁 (Métro)、公交 (Bus)、有轨电车 (Tram)、RER (市郊快线)",
      "recommendation": "售票机、人工售票窗口、报刊亭、Tabac商店、手机应用 (Île-de-France Mobilités App)",
      "buy_ticket": "购买“Navigo Découverte”周票/月票更划算；单次票(Ticket t+)可在地铁和RER换乘，但公交不可。多日票（如Paris Visite）通常覆盖地铁、公交、有轨电车和RER，可在地铁站售票机或人工窗口购买。",
      "transportation_en": "Metro, Bus, Tram, RER (suburban)",
      "recommendation_en": "Ticket machines, staff counters, kiosks, Tabac, Île-de-France Mobilités App",
      "buy_ticket_en": "Navigo Découverte weekly/monthly pass is good value; single Ticket t+ works on Metro and RER, not on bus. Multi-day passes (e.g. Paris Visite) cover Metro, Bus, Tram, RER; buy at Metro machines or counters."
    },
    {
      "country_id": "FR",
      "city_name": "尼斯",
      "city_name_en": "Nice",
      "transportation": "有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "售票机、公交车上购票（需准备零钱）、手机应用 (Lignes d'Azur App)",
      "buy_ticket": "购买“Pass Sud Azur”可用于蔚蓝海岸地区公共交通。",
      "transportation_en": "Tram, Bus",
      "recommendation_en": "Ticket machines, on-board (have change), Lignes d'Azur App",
      "buy_ticket_en": "Pass Sud Azur covers Côte d'Azur public transport."
    },
    {
      "country_id": "FR",
      "city_name": "里昂",
      "city_name_en": "Lyon",
      "transportation": "地铁 (Métro)、有轨电车 (Tram)、公交 (Bus)、缆车 (Funicular)",
      "recommendation": "售票机、人工售票窗口、手机应用 (TCL App)",
      "buy_ticket": "购买“Lyon City Card”可包含交通和景点门票。",
      "transportation_en": "Metro, Tram, Bus, Funicular",
      "recommendation_en": "Ticket machines, staff counters, TCL App",
      "buy_ticket_en": "Lyon City Card can include transport and attractions."
    },
    {
      "country_id": "IT",
      "city_name": "罗马",
      "city_name_en": "Rome",
      "transportation": "地铁 (Metro)、公交 (Bus)、有轨电车 (Tram)",
      "recommendation": "烟草店 (Tabaccheria)、报刊亭、地铁站售票机、ATAC售票点、手机应用 (MyCicero, Moovit)",
      "buy_ticket": "购买Roma Pass可包含交通和景点门票。24/48/72小时票（BIT/CIS）通常覆盖地铁、公交、有轨电车，可在烟草店、报刊亭、地铁站售票机购买。",
      "transportation_en": "Metro, Bus, Tram",
      "recommendation_en": "Tabaccheria, kiosks, Metro machines, ATAC, MyCicero/Moovit",
      "buy_ticket_en": "Roma Pass can include transport and attractions. 24/48/72h (BIT/CIS) cover Metro, Bus, Tram; buy at Tabaccheria, kiosks, Metro machines."
    },
    {
      "country_id": "IT",
      "city_name": "米兰",
      "city_name_en": "Milan",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "地铁站售票机、报刊亭、Tabaccheria、手机应用 (ATM Milano App, MyCicero)",
      "buy_ticket": "24/48小时票通常覆盖地铁、有轨电车、公交，可在地铁站售票机、报刊亭、Tabaccheria购买。",
      "transportation_en": "Metro, Tram, Bus",
      "recommendation_en": "Metro machines, kiosks, Tabaccheria, ATM Milano/MyCicero",
      "buy_ticket_en": "24/48h passes cover Metro, Tram, Bus; buy at Metro machines, kiosks, Tabaccheria."
    },
    {
      "country_id": "IT",
      "city_name": "佛罗伦萨",
      "city_name_en": "Florence",
      "transportation": "公交 (Bus)、有轨电车 (Tram)",
      "recommendation": "烟草店 (Tabaccheria)、报刊亭、ATAF售票点、手机应用 (ATAF App, MyCicero)",
      "buy_ticket": "佛罗伦萨市中心步行即可，公共交通主要用于连接郊区或景点。",
      "transportation_en": "Bus, Tram",
      "recommendation_en": "Tabaccheria, kiosks, ATAF, ATAF/MyCicero",
      "buy_ticket_en": "Florence centre is walkable; public transport mainly for suburbs and sights."
    },
    {
      "country_id": "ES",
      "city_name": "马德里",
      "city_name_en": "Madrid",
      "transportation": "地铁 (Metro)、公交 (Bus)、市郊火车 (Cercanías)",
      "recommendation": "地铁站售票机、烟草店 (Estancos)、报刊亭、手机应用 (EMT Madrid App, CRTM App)",
      "buy_ticket": "购买“Tarjeta Multi”交通卡充值使用。游客日票（Tourist Travel Pass）通常覆盖地铁和公交，可在地铁站售票机购买。",
      "transportation_en": "Metro, Bus, Cercanías",
      "recommendation_en": "Metro machines, Estancos, kiosks, EMT Madrid/CRTM App",
      "buy_ticket_en": "Tarjeta Multi rechargeable card. Tourist Travel Pass covers Metro and Bus; buy at Metro machines."
    },
    {
      "country_id": "ES",
      "city_name": "巴塞罗那",
      "city_name_en": "Barcelona",
      "transportation": "地铁 (Metro)、公交 (Bus)、有轨电车 (Tram)、火车 (FGC/Rodalies)",
      "recommendation": "地铁站售票机、报刊亭、Tabac商店、手机应用 (TMB App, Hola Barcelona App)",
      "buy_ticket": "购买“Hola Barcelona Travel Card”或T-Casual票（10次票）。“Hola Barcelona Travel Card”通常覆盖地铁、公交、有轨电车、火车（部分区域），可在地铁站售票机购买。",
      "transportation_en": "Metro, Bus, Tram, FGC/Rodalies",
      "recommendation_en": "Metro machines, kiosks, Tabac, TMB/Hola Barcelona App",
      "buy_ticket_en": "Hola Barcelona Travel Card or T-Casual (10 trips). Hola Barcelona covers Metro, Bus, Tram, train (part); buy at Metro machines."
    },
    {
      "country_id": "ES",
      "city_name": "塞维利亚",
      "city_name_en": "Seville",
      "transportation": "地铁 (Metro)、公交 (Bus)、有轨电车 (Tram)",
      "recommendation": "售票机、公交车上购票、手机应用 (Tussam App)",
      "buy_ticket": "塞维利亚市中心步行即可，公共交通主要用于连接郊区。",
      "transportation_en": "Metro, Bus, Tram",
      "recommendation_en": "Ticket machines, on-board, Tussam App",
      "buy_ticket_en": "Seville centre is walkable; public transport mainly for suburbs."
    },
    {
      "country_id": "DE",
      "city_name": "柏林",
      "city_name_en": "Berlin",
      "transportation": "地铁 (U-Bahn)、城铁 (S-Bahn)、公交 (Bus)、有轨电车 (Tram)",
      "recommendation": "售票机（地铁站、公交站）、BVG客户中心、手机应用 (BVG Fahrinfo App, Jelbi App)",
      "buy_ticket": "柏林欢迎卡（Berlin Welcome Card）包含交通和景点折扣。24/48/72小时票通常覆盖U-Bahn、S-Bahn、公交、有轨电车，可在售票机、BVG客户中心、手机应用购买。",
      "transportation_en": "U-Bahn, S-Bahn, Bus, Tram",
      "recommendation_en": "Machines (U-Bahn/Bus), BVG centres, BVG Fahrinfo/Jelbi App",
      "buy_ticket_en": "Berlin Welcome Card includes transport and attraction discounts. 24/48/72h cover U-Bahn, S-Bahn, Bus, Tram; buy at machines, BVG, app."
    },
    {
      "country_id": "DE",
      "city_name": "慕尼黑",
      "city_name_en": "Munich",
      "transportation": "地铁 (U-Bahn)、城铁 (S-Bahn)、有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "售票机（地铁站、公交站）、MVV客户中心、手机应用 (MVV App, DB Navigator App)",
      "buy_ticket": "单日票（Day Ticket）或周票（Weekly Ticket）通常覆盖U-Bahn、S-Bahn、有轨电车、公交，可在售票机、MVV客户中心、手机应用购买。",
      "transportation_en": "U-Bahn, S-Bahn, Tram, Bus",
      "recommendation_en": "Machines, MVV centres, MVV/DB Navigator App",
      "buy_ticket_en": "Day or Weekly Ticket cover U-Bahn, S-Bahn, Tram, Bus; buy at machines, MVV, app."
    },
    {
      "country_id": "DE",
      "city_name": "汉堡",
      "city_name_en": "Hamburg",
      "transportation": "地铁 (U-Bahn)、城铁 (S-Bahn)、公交 (Bus)、渡轮 (Ferry)",
      "recommendation": "售票机、HVV客户中心、手机应用 (HVV App, DB Navigator App)",
      "buy_ticket": "汉堡交通系统发达，渡轮也是公共交通的一部分。",
      "transportation_en": "U-Bahn, S-Bahn, Bus, Ferry",
      "recommendation_en": "Machines, HVV centres, HVV/DB Navigator App",
      "buy_ticket_en": "Hamburg has a developed network; ferries are part of public transport."
    },
    {
      "country_id": "GB",
      "city_name": "伦敦",
      "city_name_en": "London",
      "transportation": "地铁 (Underground/Tube)、公交 (Bus)、火车 (Overground/National Rail)、轻轨 (DLR)、有轨电车 (Tram)",
      "recommendation": "Oyster Card、非接触式银行卡/手机支付、纸质票（较少用）、手机应用 (TfL Go App)",
      "buy_ticket": "伦敦交通分区，跨区票价不同；使用Oyster Card或非接触式支付更划算。Travelcard（日票/周票）通常覆盖地铁、公交、火车、轻轨、有轨电车，可在地铁站售票机、人工窗口购买。",
      "transportation_en": "Underground/Tube, Bus, Overground/National Rail, DLR, Tram",
      "recommendation_en": "Oyster Card, contactless card/phone, paper (rare), TfL Go App",
      "buy_ticket_en": "London is zoned; Oyster or contactless is best. Travelcard (day/week) covers Tube, Bus, Rail, DLR, Tram; buy at Tube machines or counters."
    },
    {
      "country_id": "GB",
      "city_name": "爱丁堡",
      "city_name_en": "Edinburgh",
      "transportation": "公交 (Bus)、有轨电车 (Tram)",
      "recommendation": "公交车上刷卡（非接触式银行卡/Apple Pay/Google Pay）、购票机、手机应用 (Lothian Buses App)",
      "buy_ticket": "日票通常覆盖公交和有轨电车，可在公交车上（非接触式支付）、有轨电车购票机或手机应用购买。",
      "transportation_en": "Bus, Tram",
      "recommendation_en": "Contactless on bus, machines, Lothian Buses App",
      "buy_ticket_en": "Day pass covers Bus and Tram; buy on bus (contactless), Tram machines or app."
    },
    {
      "country_id": "GB",
      "city_name": "曼彻斯特",
      "city_name_en": "Manchester",
      "transportation": "有轨电车 (Metrolink)、公交 (Bus)、火车 (National Rail)",
      "recommendation": "售票机、非接触式银行卡/手机支付、手机应用 (Bee Network App)",
      "buy_ticket": "Metrolink是曼彻斯特主要的有轨电车系统。",
      "transportation_en": "Metrolink, Bus, National Rail",
      "recommendation_en": "Machines, contactless, Bee Network App",
      "buy_ticket_en": "Metrolink is the main tram system in Manchester."
    },
    {
      "country_id": "GR",
      "city_name": "雅典",
      "city_name_en": "Athens",
      "transportation": "地铁 (Metro)、公交 (Bus)、有轨电车 (Tram)、无轨电车 (Trolleybus)",
      "recommendation": "地铁站售票机、报刊亭、售票处、手机应用 (TfA App)",
      "buy_ticket": "24/72小时票通常覆盖地铁、公交、有轨电车、无轨电车，可在地铁站售票机、报刊亭、售票处购买。",
      "transportation_en": "Metro, Bus, Tram, Trolleybus",
      "recommendation_en": "Metro machines, kiosks, ticket offices, TfA App",
      "buy_ticket_en": "24/72h cover Metro, Bus, Tram, Trolleybus; buy at Metro machines, kiosks, offices."
    },
    {
      "country_id": "GR",
      "city_name": "塞萨洛尼基",
      "city_name_en": "Thessaloniki",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票（需准备零钱）、售票亭、手机应用 (OASTH App)",
      "buy_ticket": "塞萨洛尼基的公共交通主要依靠公交车。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (have change), kiosks, OASTH App",
      "buy_ticket_en": "Thessaloniki relies mainly on buses."
    },
    {
      "country_id": "GR",
      "city_name": "圣托里尼",
      "city_name_en": "Santorini",
      "transportation": "公交 (Bus)、出租车",
      "recommendation": "公交车上购票（需准备零钱）",
      "buy_ticket": "岛上公交线路有限，租车或ATV更方便探索。",
      "transportation_en": "Bus, Taxi",
      "recommendation_en": "On-board (have change)",
      "buy_ticket_en": "Limited bus routes; car or ATV rental is handy for exploring."
    },
    {
      "country_id": "HR",
      "city_name": "萨格勒布",
      "city_name_en": "Zagreb",
      "transportation": "有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "报刊亭 (Tisak)、ZET售票处、公交车上（需准备零钱）、手机应用 (ZET App)",
      "buy_ticket": "日票或多日票通常覆盖有轨电车和公交，可在报刊亭、ZET售票处购买。",
      "transportation_en": "Tram, Bus",
      "recommendation_en": "Tisak kiosks, ZET offices, on-board (change), ZET App",
      "buy_ticket_en": "Day/multi-day cover Tram and Bus; buy at kiosks, ZET offices."
    },
    {
      "country_id": "HR",
      "city_name": "杜布罗夫尼克",
      "city_name_en": "Dubrovnik",
      "transportation": "公交 (Bus)",
      "recommendation": "报刊亭、公交车上（需准备零钱）、手机应用 (Libertas Dubrovnik App)",
      "buy_ticket": "日票或“Dubrovnik Card”通常覆盖公交，可在报刊亭或旅游信息中心购买。",
      "transportation_en": "Bus",
      "recommendation_en": "Kiosks, on-board (change), Libertas Dubrovnik App",
      "buy_ticket_en": "Day pass or Dubrovnik Card cover Bus; buy at kiosks or tourist info."
    },
    {
      "country_id": "HR",
      "city_name": "斯普利特",
      "city_name_en": "Split",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票（需准备零钱）、售票亭、手机应用 (Promet Split App)",
      "buy_ticket": "斯普利特市中心步行即可，公交主要用于连接周边区域和海滩。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (change), kiosks, Promet Split App",
      "buy_ticket_en": "Split centre is walkable; buses link suburbs and beaches."
    },
    {
      "country_id": "TR",
      "city_name": "伊斯坦布尔",
      "city_name_en": "Istanbul",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、渡轮 (Ferry)、公交 (Bus)、小巴 (Dolmuş)、缆车 (Funicular)",
      "recommendation": "Istanbulkart (交通卡)、一次性票、手机应用 (Istanbulkart App)",
      "buy_ticket": "建议购买Istanbulkart，充值使用，可用于多种交通工具。Istanbulkart充值后可用于所有公共交通工具，可在地铁站、码头、报刊亭、便利店购买和充值。",
      "transportation_en": "Metro, Tram, Ferry, Bus, Dolmuş, Funicular",
      "recommendation_en": "Istanbulkart, single tickets, Istanbulkart App",
      "buy_ticket_en": "Istanbulkart is recommended; top up and use on all modes. Buy/reload at Metro, piers, kiosks, convenience stores."
    },
    {
      "country_id": "TR",
      "city_name": "安卡拉",
      "city_name_en": "Ankara",
      "transportation": "地铁 (Metro)、公交 (Bus)",
      "recommendation": "Ankarakart (交通卡)、售票机",
      "buy_ticket": "安卡拉的公共交通主要依靠地铁和公交。",
      "transportation_en": "Metro, Bus",
      "recommendation_en": "Ankarakart, machines",
      "buy_ticket_en": "Ankara relies on Metro and Bus."
    },
    {
      "country_id": "TR",
      "city_name": "伊兹密尔",
      "city_name_en": "Izmir",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、渡轮 (Ferry)、公交 (Bus)",
      "recommendation": "Izmirim Kart (交通卡)、售票机",
      "buy_ticket": "伊兹密尔的公共交通系统较为现代化。",
      "transportation_en": "Metro, Tram, Ferry, Bus",
      "recommendation_en": "Izmirim Kart, machines",
      "buy_ticket_en": "Izmir has a modern public transport system."
    },
    {
      "country_id": "PT",
      "city_name": "里斯本",
      "city_name_en": "Lisbon",
      "transportation": "地铁 (Metro)、公交 (Bus)、有轨电车 (Tram)、升降机/缆车 (Funicular/Elevator)",
      "recommendation": "Viva Viagem卡（充值卡）、售票机、报刊亭、手机应用 (Viva Viagem App)",
      "buy_ticket": "Viva Viagem卡可充值不同票种（如单次票、日票、Zapping余额）。24小时票通常覆盖地铁、公交、有轨电车、升降机/缆车，可在地铁站售票机或报刊亭购买。",
      "transportation_en": "Metro, Bus, Tram, Funicular/Elevator",
      "recommendation_en": "Viva Viagem card, machines, kiosks, Viva Viagem App",
      "buy_ticket_en": "Viva Viagem can be loaded with single, day or Zapping. 24h covers Metro, Bus, Tram, Funicular; buy at Metro machines or kiosks."
    },
    {
      "country_id": "PT",
      "city_name": "波尔图",
      "city_name_en": "Porto",
      "transportation": "地铁 (Metro)、公交 (Bus)、有轨电车 (Tram)",
      "recommendation": "Andante卡（交通卡）、售票机、报刊亭、手机应用 (Andante App)",
      "buy_ticket": "Andante卡按区计费，可充值Z-titles（单次票）或24小时票。24小时票通常覆盖地铁、公交、有轨电车，可在地铁站售票机或报刊亭购买。",
      "transportation_en": "Metro, Bus, Tram",
      "recommendation_en": "Andante card, machines, kiosks, Andante App",
      "buy_ticket_en": "Andante is zonal; load Z-titles or 24h. 24h covers Metro, Bus, Tram; buy at Metro machines or kiosks."
    },
    {
      "country_id": "PT",
      "city_name": "法鲁",
      "city_name_en": "Faro",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票（需准备零钱）",
      "buy_ticket": "法鲁市中心步行即可，公交主要用于连接机场和周边城镇。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (have change)",
      "buy_ticket_en": "Faro centre is walkable; buses link airport and nearby towns."
    },
    {
      "country_id": "NL",
      "city_name": "阿姆斯特丹",
      "city_name_en": "Amsterdam",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、地铁 (Metro)、渡轮 (Ferry)",
      "recommendation": "OV-chipkaart (交通卡)、一次性芯片卡、GVB售票处、售票机、手机应用 (GVB App, 9292 App)",
      "buy_ticket": "游客可购买Amsterdam Travel Card或GVB日票/多日票。GVB日票/多日票通常覆盖有轨电车、公交、地铁，可在GVB售票处、售票机、部分便利店购买。",
      "transportation_en": "Tram, Bus, Metro, Ferry",
      "recommendation_en": "OV-chipkaart, single-use chip card, GVB offices/machines, GVB/9292 App",
      "buy_ticket_en": "Amsterdam Travel Card or GVB day/multi-day. GVB day/multi-day cover Tram, Bus, Metro; buy at GVB, machines, some convenience stores."
    },
    {
      "country_id": "NL",
      "city_name": "鹿特丹",
      "city_name_en": "Rotterdam",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)、水上巴士 (Waterbus)",
      "recommendation": "OV-chipkaart (交通卡)、一次性芯片卡、售票机、手机应用 (RET App, 9292 App)",
      "buy_ticket": "鹿特丹的地铁系统发达，水上巴士是独特的交通方式。",
      "transportation_en": "Metro, Tram, Bus, Waterbus",
      "recommendation_en": "OV-chipkaart, single-use chip, machines, RET/9292 App",
      "buy_ticket_en": "Rotterdam has a good Metro; Waterbus is a distinctive option."
    },
    {
      "country_id": "NL",
      "city_name": "海牙",
      "city_name_en": "The Hague",
      "transportation": "有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "OV-chipkaart (交通卡)、一次性芯片卡、售票机、手机应用 (HTM App, 9292 App)",
      "buy_ticket": "海牙的有轨电车网络非常便利。",
      "transportation_en": "Tram, Bus",
      "recommendation_en": "OV-chipkaart, single-use chip, machines, HTM/9292 App",
      "buy_ticket_en": "The Hague has a convenient tram network."
    },
    {
      "country_id": "CH",
      "city_name": "苏黎世",
      "city_name_en": "Zurich",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、S-Bahn (市郊火车)、渡轮 (Ferry)",
      "recommendation": "售票机、ZVV客户端、Swiss Pass/Half Fare Card、手机应用 (ZVV App, SBB Mobile App)",
      "buy_ticket": "日票（Day Pass）或Zurich Card通常覆盖有轨电车、公交、S-Bahn、渡轮（部分），可在售票机、ZVV客户端、火车站售票处购买。",
      "transportation_en": "Tram, Bus, S-Bahn, Ferry",
      "recommendation_en": "Machines, ZVV counters, Swiss Pass/Half Fare, ZVV/SBB Mobile App",
      "buy_ticket_en": "Day Pass or Zurich Card cover Tram, Bus, S-Bahn, Ferry (part); buy at machines, ZVV, station counters."
    },
    {
      "country_id": "CH",
      "city_name": "日内瓦",
      "city_name_en": "Geneva",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、渡轮 (Mouettes)",
      "recommendation": "售票机、TPG客户端、Swiss Pass/Half Fare Card、手机应用 (TPG App, SBB Mobile App)",
      "buy_ticket": "入住酒店通常可获得免费“Geneva Transport Card”。日票通常覆盖有轨电车、公交、渡轮，可在售票机、TPG客户端购买。",
      "transportation_en": "Tram, Bus, Mouettes (ferry)",
      "recommendation_en": "Machines, TPG counters, Swiss Pass/Half Fare, TPG/SBB Mobile App",
      "buy_ticket_en": "Hotel stays often include free Geneva Transport Card. Day pass covers Tram, Bus, Ferry; buy at machines, TPG."
    },
    {
      "country_id": "CH",
      "city_name": "伯尔尼",
      "city_name_en": "Bern",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、S-Bahn (市郊火车)",
      "recommendation": "售票机、Libero客户端、Swiss Pass/Half Fare Card、手机应用 (Libero App, SBB Mobile App)",
      "buy_ticket": "伯尔尼市中心较小，步行即可，公共交通连接周边区域。",
      "transportation_en": "Tram, Bus, S-Bahn",
      "recommendation_en": "Machines, Libero counters, Swiss Pass/Half Fare, Libero/SBB Mobile App",
      "buy_ticket_en": "Bern centre is small and walkable; public transport links suburbs."
    },
    {
      "country_id": "AT",
      "city_name": "维也纳",
      "city_name_en": "Vienna",
      "transportation": "地铁 (U-Bahn)、有轨电车 (Tram)、公交 (Bus)、S-Bahn (市郊火车)",
      "recommendation": "售票机、烟草店 (Trafik)、Wiener Linien客户中心、手机应用 (WienMobil App)",
      "buy_ticket": "24/48/72小时票或周票通常覆盖U-Bahn、有轨电车、公交、S-Bahn，可在售票机、烟草店、Wiener Linien客户中心、手机应用购买。",
      "transportation_en": "U-Bahn, Tram, Bus, S-Bahn",
      "recommendation_en": "Machines, Trafik, Wiener Linien centres, WienMobil App",
      "buy_ticket_en": "24/48/72h or weekly cover U-Bahn, Tram, Bus, S-Bahn; buy at machines, Trafik, Wiener Linien, app."
    },
    {
      "country_id": "AT",
      "city_name": "萨尔茨堡",
      "city_name_en": "Salzburg",
      "transportation": "公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "售票机、报刊亭、公交车上购票、手机应用 (Salzburg Verkehr App)",
      "buy_ticket": "萨尔茨堡市中心步行即可，公交主要用于连接周边景点。",
      "transportation_en": "Bus, Trolleybus",
      "recommendation_en": "Machines, kiosks, on-board, Salzburg Verkehr App",
      "buy_ticket_en": "Salzburg centre is walkable; buses link sights."
    },
    {
      "country_id": "AT",
      "city_name": "因斯布鲁克",
      "city_name_en": "Innsbruck",
      "transportation": "有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "售票机、报刊亭、公交车上购票、手机应用 (IVB App)",
      "buy_ticket": "因斯布鲁克城市不大，有轨电车和公交覆盖主要区域。",
      "transportation_en": "Tram, Bus",
      "recommendation_en": "Machines, kiosks, on-board, IVB App",
      "buy_ticket_en": "Innsbruck is compact; tram and bus cover main areas."
    },
    {
      "country_id": "IS",
      "city_name": "雷克雅未克",
      "city_name_en": "Reykjavik",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上（需准备零钱，不找零）、手机应用 (Strætó App)、售票点",
      "buy_ticket": "公交车班次相对较少，步行或租车是常见方式。日票通常覆盖公交，可在公交车上（部分）、手机应用、部分售票点购买。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (exact change), Strætó App, ticket points",
      "buy_ticket_en": "Buses are infrequent; walking or car rental common. Day pass covers Bus; buy on board (some), app, some points."
    },
    {
      "country_id": "IS",
      "city_name": "阿库雷里",
      "city_name_en": "Akureyri",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上（需准备零钱，不找零）",
      "buy_ticket": "阿库雷里公交系统较小，市中心步行可达。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (exact change)",
      "buy_ticket_en": "Akureyri has a small bus system; centre is walkable."
    },
    {
      "country_id": "IS",
      "city_name": "维克",
      "city_name_en": "Vik",
      "transportation": "无公共交通",
      "recommendation": "无",
      "buy_ticket": "维克及周边地区主要依靠自驾或旅游团。",
      "transportation_en": "No public transport",
      "recommendation_en": "N/A",
      "buy_ticket_en": "Vik and surroundings rely on car or tours."
    },
    {
      "country_id": "CZ",
      "city_name": "布拉格",
      "city_name_en": "Prague",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "售票机、报刊亭、烟草店 (Tabák)、手机应用 (PID Lítačka App)",
      "buy_ticket": "24/72小时票通常覆盖地铁、有轨电车、公交，可在售票机、报刊亭、烟草店、手机应用购买。",
      "transportation_en": "Metro, Tram, Bus",
      "recommendation_en": "Machines, kiosks, Tabák, PID Lítačka App",
      "buy_ticket_en": "24/72h cover Metro, Tram, Bus; buy at machines, kiosks, Tabák, app."
    },
    {
      "country_id": "CZ",
      "city_name": "捷克克鲁姆洛夫",
      "city_name_en": "Český Krumlov",
      "transportation": "步行",
      "recommendation": "无",
      "buy_ticket": "捷克克鲁姆洛夫是小镇，主要依靠步行游览。",
      "transportation_en": "Walking",
      "recommendation_en": "N/A",
      "buy_ticket_en": "Český Krumlov is a small town; explore on foot."
    },
    {
      "country_id": "CZ",
      "city_name": "卡罗维发利",
      "city_name_en": "Karlovy Vary",
      "transportation": "公交 (Bus)、缆车 (Funicular)",
      "recommendation": "公交车上购票、售票亭",
      "buy_ticket": "卡罗维发利主要依靠步行和缆车。",
      "transportation_en": "Bus, Funicular",
      "recommendation_en": "On-board, kiosks",
      "buy_ticket_en": "Karlovy Vary is mainly walking and funicular."
    },
    {
      "country_id": "IE",
      "city_name": "都柏林",
      "city_name_en": "Dublin",
      "transportation": "公交 (Bus)、轻轨 (Luas)、火车 (DART)",
      "recommendation": "Leap Card (交通卡)、公交车上（需准备零钱）、售票机、手机应用 (Leap Card Top-Up App)",
      "buy_ticket": "建议购买Leap Card充值使用。Leap Card充值后可用于公交、轻轨、DART，可在便利店、售票机、Leap Card网站购买。",
      "transportation_en": "Bus, Luas, DART",
      "recommendation_en": "Leap Card, on-board (change), machines, Leap Card Top-Up App",
      "buy_ticket_en": "Leap Card recommended; top up for Bus, Luas, DART. Buy at convenience stores, machines, Leap Card website."
    },
    {
      "country_id": "IE",
      "city_name": "科克",
      "city_name_en": "Cork",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票（需准备零钱）、Leap Card",
      "buy_ticket": "科克市中心步行即可，公交主要连接周边区域。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (change), Leap Card",
      "buy_ticket_en": "Cork centre is walkable; buses link suburbs."
    },
    {
      "country_id": "IE",
      "city_name": "戈尔韦",
      "city_name_en": "Galway",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票（需准备零钱）、Leap Card",
      "buy_ticket": "戈尔韦市中心步行可达，公交主要连接周边。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (change), Leap Card",
      "buy_ticket_en": "Galway centre is walkable; buses link surroundings."
    },
    {
      "country_id": "DK",
      "city_name": "哥本哈根",
      "city_name_en": "Copenhagen",
      "transportation": "地铁 (Metro)、S-Train (市郊火车)、公交 (Bus)",
      "recommendation": "售票机、DSB客户中心、手机应用 (DOT Tickets App)",
      "buy_ticket": "购买Copenhagen Card可包含交通和景点门票。24/72小时票通常覆盖地铁、S-Train、公交，可在售票机、DSB客户中心、手机应用购买。",
      "transportation_en": "Metro, S-Train, Bus",
      "recommendation_en": "Machines, DSB centres, DOT Tickets App",
      "buy_ticket_en": "Copenhagen Card can include transport and attractions. 24/72h cover Metro, S-Train, Bus; buy at machines, DSB, app."
    },
    {
      "country_id": "DK",
      "city_name": "奥胡斯",
      "city_name_en": "Aarhus",
      "transportation": "轻轨 (Letbane)、公交 (Bus)",
      "recommendation": "售票机、公交车上购票、手机应用 (Midttrafik App)",
      "buy_ticket": "奥胡斯有轻轨系统，方便市区出行。",
      "transportation_en": "Letbane, Bus",
      "recommendation_en": "Machines, on-board, Midttrafik App",
      "buy_ticket_en": "Aarhus has a light rail for city travel."
    },
    {
      "country_id": "DK",
      "city_name": "欧登塞",
      "city_name_en": "Odense",
      "transportation": "轻轨 (Letbane)、公交 (Bus)",
      "recommendation": "售票机、公交车上购票、手机应用 (FynBus App)",
      "buy_ticket": "欧登塞有新开通的轻轨线路。",
      "transportation_en": "Letbane, Bus",
      "recommendation_en": "Machines, on-board, FynBus App",
      "buy_ticket_en": "Odense has a new light rail line."
    },
    {
      "country_id": "SE",
      "city_name": "斯德哥尔摩",
      "city_name_en": "Stockholm",
      "transportation": "地铁 (Tunnelbana)、通勤火车 (Commuter Rail)、公交 (Bus)、有轨电车 (Tram)、渡轮 (Ferry)",
      "recommendation": "SL Access卡 (交通卡)、SL中心、手机应用 (SL-Reseplanerare och biljetter App)",
      "buy_ticket": "24/72小时或7日票通常覆盖地铁、通勤火车、公交、有轨电车、渡轮（部分），可在SL中心、地铁站售票处、便利店购买。",
      "transportation_en": "Tunnelbana, Commuter Rail, Bus, Tram, Ferry",
      "recommendation_en": "SL Access card, SL centres, SL App",
      "buy_ticket_en": "24/72h or 7-day cover Metro, Commuter, Bus, Tram, Ferry (part); buy at SL centres, Metro counters, convenience stores."
    },
    {
      "country_id": "SE",
      "city_name": "哥德堡",
      "city_name_en": "Gothenburg",
      "transportation": "有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "Västtrafik卡、售票机、手机应用 (Västtrafik To Go App)",
      "buy_ticket": "哥德堡的有轨电车网络非常发达。",
      "transportation_en": "Tram, Bus",
      "recommendation_en": "Västtrafik card, machines, Västtrafik To Go App",
      "buy_ticket_en": "Gothenburg has a strong tram network."
    },
    {
      "country_id": "SE",
      "city_name": "马尔默",
      "city_name_en": "Malmö",
      "transportation": "公交 (Bus)、火车 (Pågatågen/Öresundståg)",
      "recommendation": "Skånetrafiken卡、售票机、手机应用 (Skånetrafiken App)",
      "buy_ticket": "马尔默主要依靠公交和火车连接周边。",
      "transportation_en": "Bus, Pågatågen/Öresundståg",
      "recommendation_en": "Skånetrafiken card, machines, Skånetrafiken App",
      "buy_ticket_en": "Malmö relies on Bus and train for city and region."
    },
    {
      "country_id": "FI",
      "city_name": "赫尔辛基",
      "city_name_en": "Helsinki",
      "transportation": "有轨电车 (Tram)、地铁 (Metro)、公交 (Bus)、通勤火车 (Commuter Train)、渡轮 (Ferry)",
      "recommendation": "HSL区域票、售票机、手机应用 (HSL App)、R-kioski便利店",
      "buy_ticket": "日票（Day Ticket）通常覆盖有轨电车、地铁、公交、通勤火车、渡轮（部分），可在售票机、手机应用、R-kioski便利店购买。",
      "transportation_en": "Tram, Metro, Bus, Commuter Train, Ferry",
      "recommendation_en": "HSL regional ticket, machines, HSL App, R-kioski",
      "buy_ticket_en": "Day Ticket covers Tram, Metro, Bus, Commuter, Ferry (part); buy at machines, app, R-kioski."
    },
    {
      "country_id": "FI",
      "city_name": "坦佩雷",
      "city_name_en": "Tampere",
      "transportation": "有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "Nysse卡、售票机、手机应用 (Nysse Mobiili App)",
      "buy_ticket": "坦佩雷有新开通的有轨电车线路。",
      "transportation_en": "Tram, Bus",
      "recommendation_en": "Nysse card, machines, Nysse Mobiili App",
      "buy_ticket_en": "Tampere has new tram lines."
    },
    {
      "country_id": "FI",
      "city_name": "图尔库",
      "city_name_en": "Turku",
      "transportation": "公交 (Bus)",
      "recommendation": "Föli卡、公交车上购票、手机应用 (Föli App)",
      "buy_ticket": "图尔库主要依靠公交系统。",
      "transportation_en": "Bus",
      "recommendation_en": "Föli card, on-board, Föli App",
      "buy_ticket_en": "Turku relies on bus."
    },
    {
      "country_id": "BE",
      "city_name": "布鲁塞尔",
      "city_name_en": "Brussels",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "MOBIB卡 (交通卡)、售票机 (GO machine)、售票处、手机应用 (STIB-MIVB App)",
      "buy_ticket": "多日票通常覆盖地铁、有轨电车、公交，可在售票机 (GO machine)、售票处购买。",
      "transportation_en": "Metro, Tram, Bus",
      "recommendation_en": "MOBIB card, GO machines, ticket offices, STIB-MIVB App",
      "buy_ticket_en": "Multi-day cover Metro, Tram, Bus; buy at GO machines, offices."
    },
    {
      "country_id": "BE",
      "city_name": "布鲁日",
      "city_name_en": "Bruges",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票、售票亭",
      "buy_ticket": "布鲁日市中心步行即可，公交主要连接火车站和周边。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board, kiosks",
      "buy_ticket_en": "Bruges centre is walkable; buses link station and surroundings."
    },
    {
      "country_id": "BE",
      "city_name": "安特卫普",
      "city_name_en": "Antwerp",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、地铁 (Pre-metro)",
      "recommendation": "De Lijn卡、售票机、手机应用 (De Lijn App)",
      "buy_ticket": "安特卫普有有轨电车和地下轻轨系统。",
      "transportation_en": "Tram, Bus, Pre-metro",
      "recommendation_en": "De Lijn card, machines, De Lijn App",
      "buy_ticket_en": "Antwerp has tram and underground light rail."
    },
    {
      "country_id": "HU",
      "city_name": "布达佩斯",
      "city_name_en": "Budapest",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "售票机、报刊亭、BKK客户中心、手机应用 (BudapestGO App)",
      "buy_ticket": "24/72小时或7日旅行卡通常覆盖地铁、有轨电车、公交、无轨电车，可在售票机、报刊亭、BKK客户中心、手机应用购买。",
      "transportation_en": "Metro, Tram, Bus, Trolleybus",
      "recommendation_en": "Machines, kiosks, BKK centres, BudapestGO App",
      "buy_ticket_en": "24/72h or 7-day travel card cover Metro, Tram, Bus, Trolleybus; buy at machines, kiosks, BKK, app."
    },
    {
      "country_id": "HU",
      "city_name": "埃格尔",
      "city_name_en": "Eger",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票、售票亭",
      "buy_ticket": "埃格尔小镇步行即可，公交主要连接周边。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board, kiosks",
      "buy_ticket_en": "Eger is small and walkable; buses link surroundings."
    },
    {
      "country_id": "HU",
      "city_name": "塞格德",
      "city_name_en": "Szeged",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "售票机、售票亭",
      "buy_ticket": "塞格德有有轨电车和无轨电车系统。",
      "transportation_en": "Tram, Bus, Trolleybus",
      "recommendation_en": "Machines, kiosks",
      "buy_ticket_en": "Szeged has tram and trolleybus."
    },
    {
      "country_id": "PL",
      "city_name": "华沙",
      "city_name_en": "Warsaw",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "售票机、报刊亭、ZTM客户中心、手机应用 (Jakdojade App, moBILET App)",
      "buy_ticket": "24/72小时票通常覆盖地铁、有轨电车、公交，可在售票机、报刊亭、ZTM客户中心、手机应用购买。",
      "transportation_en": "Metro, Tram, Bus",
      "recommendation_en": "Machines, kiosks, ZTM centres, Jakdojade/moBILET App",
      "buy_ticket_en": "24/72h cover Metro, Tram, Bus; buy at machines, kiosks, ZTM, app."
    },
    {
      "country_id": "PL",
      "city_name": "克拉科夫",
      "city_name_en": "Krakow",
      "transportation": "有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "售票机、报刊亭、公交车上购票、手机应用 (Jakdojade App, moBILET App)",
      "buy_ticket": "克拉科夫市中心步行即可，有轨电车覆盖主要区域。",
      "transportation_en": "Tram, Bus",
      "recommendation_en": "Machines, kiosks, on-board, Jakdojade/moBILET App",
      "buy_ticket_en": "Krakow centre is walkable; tram covers main areas."
    },
    {
      "country_id": "PL",
      "city_name": "格但斯克",
      "city_name_en": "Gdansk",
      "transportation": "有轨电车 (Tram)、公交 (Bus)",
      "recommendation": "售票机、报刊亭、公交车上购票、手机应用 (Jakdojade App, moBILET App)",
      "buy_ticket": "格但斯克有轨电车是主要的公共交通方式。",
      "transportation_en": "Tram, Bus",
      "recommendation_en": "Machines, kiosks, on-board, Jakdojade/moBILET App",
      "buy_ticket_en": "Gdansk tram is the main public transport."
    },
    {
      "country_id": "ME",
      "city_name": "科托尔",
      "city_name_en": "Kotor",
      "transportation": "公交 (Bus)、出租车",
      "recommendation": "公交车上购票（需准备零钱）",
      "buy_ticket": "小城步行即可，公交主要用于周边小镇。",
      "transportation_en": "Bus, Taxi",
      "recommendation_en": "On-board (have change)",
      "buy_ticket_en": "Town is walkable; buses for nearby towns."
    },
    {
      "country_id": "SI",
      "city_name": "卢布尔雅那",
      "city_name_en": "Ljubljana",
      "transportation": "公交 (Bus)",
      "recommendation": "Urbana卡 (交通卡)、报刊亭、旅游信息中心、手机应用 (Urbana App)",
      "buy_ticket": "Urbana卡可充值，也可用于租用城市自行车。多日票通常覆盖公交，可在报刊亭、旅游信息中心购买。",
      "transportation_en": "Bus",
      "recommendation_en": "Urbana card, kiosks, tourist info, Urbana App",
      "buy_ticket_en": "Urbana can be topped up and used for city bikes. Multi-day cover Bus; buy at kiosks, tourist info."
    },
    {
      "country_id": "NO",
      "city_name": "奥斯陆",
      "city_name_en": "Oslo",
      "transportation": "地铁 (T-bane)、有轨电车 (Tram)、公交 (Bus)、渡轮 (Ferry)",
      "recommendation": "RuterBillett应用、售票机、便利店 (Narvesen/7-Eleven)、手机应用 (RuterBillett App)",
      "buy_ticket": "24/48/72小时票或7日票通常覆盖地铁、有轨电车、公交、渡轮，可在RuterBillett应用、售票机、便利店购买。",
      "transportation_en": "T-bane, Tram, Bus, Ferry",
      "recommendation_en": "RuterBillett app, machines, Narvesen/7-Eleven, RuterBillett App",
      "buy_ticket_en": "24/48/72h or 7-day cover T-bane, Tram, Bus, Ferry; buy via app, machines, convenience stores."
    },
    {
      "country_id": "NO",
      "city_name": "卑尔根",
      "city_name_en": "Bergen",
      "transportation": "有轨电车 (Bybanen)、公交 (Bus)",
      "recommendation": "Skyss Ticket应用、售票机、便利店 (Narvesen/7-Eleven)、手机应用 (Skyss Billett App)",
      "buy_ticket": "24小时票通常覆盖有轨电车和公交，可在Skyss Ticket应用、售票机、便利店购买。",
      "transportation_en": "Bybanen, Bus",
      "recommendation_en": "Skyss Ticket app, machines, Narvesen/7-Eleven, Skyss Billett App",
      "buy_ticket_en": "24h cover Bybanen and Bus; buy via Skyss app, machines, convenience stores."
    },
    {
      "country_id": "NO",
      "city_name": "特罗姆瑟",
      "city_name_en": "Tromsø",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票、售票亭、手机应用 (Troms Billett App)",
      "buy_ticket": "特罗姆瑟在冬季是观赏极光的热门地点。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board, kiosks, Troms Billett App",
      "buy_ticket_en": "Tromsø is popular for northern lights in winter."
    },
    {
      "country_id": "RS",
      "city_name": "贝尔格莱德",
      "city_name_en": "Belgrade",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "BusPlus卡 (交通卡)、报刊亭、BusPlus售票处",
      "buy_ticket": "日票通常覆盖有轨电车、公交、无轨电车，可在报刊亭、BusPlus售票处购买。",
      "transportation_en": "Tram, Bus, Trolleybus",
      "recommendation_en": "BusPlus card, kiosks, BusPlus offices",
      "buy_ticket_en": "Day pass cover Tram, Bus, Trolleybus; buy at kiosks, BusPlus offices."
    },
    {
      "country_id": "RO",
      "city_name": "布加勒斯特",
      "city_name_en": "Bucharest",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "Activ卡/Multiplu卡 (交通卡)、售票亭",
      "buy_ticket": "Activ卡可充值，Multiplu卡为一次性卡。多日票通常覆盖有轨电车、公交、无轨电车，可在售票亭购买。地铁票需单独购买。",
      "transportation_en": "Metro, Tram, Bus, Trolleybus",
      "recommendation_en": "Activ/Multiplu card, kiosks",
      "buy_ticket_en": "Activ is rechargeable; Multiplu is single-use. Multi-day cover Tram, Bus, Trolleybus; buy at kiosks. Metro tickets sold separately."
    },
    {
      "country_id": "AL",
      "city_name": "地拉那",
      "city_name_en": "Tirana",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票（需准备零钱）",
      "buy_ticket": "公交线路覆盖有限，很多地方需要步行或打车。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (have change)",
      "buy_ticket_en": "Bus coverage is limited; walking or taxi common."
    },
    {
      "country_id": "BG",
      "city_name": "索非亚",
      "city_name_en": "Sofia",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "售票机、报刊亭、地铁站售票处",
      "buy_ticket": "日票或多日票通常覆盖地铁、有轨电车、公交、无轨电车，可在售票机、报刊亭、地铁站售票处购买。",
      "transportation_en": "Metro, Tram, Bus, Trolleybus",
      "recommendation_en": "Machines, kiosks, Metro offices",
      "buy_ticket_en": "Day/multi-day cover Metro, Tram, Bus, Trolleybus; buy at machines, kiosks, Metro offices."
    },
    {
      "country_id": "MT",
      "city_name": "瓦莱塔",
      "city_name_en": "Valletta",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票（需准备零钱或银行卡）、Tallinja Card (交通卡)",
      "buy_ticket": "建议购买Tallinja Card或多日票，岛上公交覆盖广。Tallinja Card或多日票通常覆盖公交，可在机场、主要公交总站、部分便利店购买。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (change or card), Tallinja Card",
      "buy_ticket_en": "Tallinja Card or multi-day recommended; island buses cover well. Buy at airport, main bus terminals, some convenience stores."
    },
    {
      "country_id": "EE",
      "city_name": "塔林",
      "city_name_en": "Tallinn",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "Ühiskaart (交通卡)、售票机、R-Kiosk便利店、手机应用 (Pilet.ee App)",
      "buy_ticket": "日票或Tallinn Card通常覆盖有轨电车、公交、无轨电车，可在售票机、R-Kiosk便利店、旅游信息中心、手机应用购买。",
      "transportation_en": "Tram, Bus, Trolleybus",
      "recommendation_en": "Ühiskaart, machines, R-Kiosk, Pilet.ee App",
      "buy_ticket_en": "Day pass or Tallinn Card cover Tram, Bus, Trolleybus; buy at machines, R-Kiosk, tourist info, app."
    },
    {
      "country_id": "CY",
      "city_name": "尼科西亚",
      "city_name_en": "Nicosia",
      "transportation": "公交 (Bus)",
      "recommendation": "公交车上购票（需准备零钱）",
      "buy_ticket": "公交系统不如欧洲大陆完善，租车更便捷。",
      "transportation_en": "Bus",
      "recommendation_en": "On-board (have change)",
      "buy_ticket_en": "Bus system is less developed than mainland Europe; car rental is convenient."
    },
    {
      "country_id": "SK",
      "city_name": "布拉迪斯拉发",
      "city_name_en": "Bratislava",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "售票机、报刊亭、DPB客户中心、手机应用 (IDS BK App)",
      "buy_ticket": "24/72小时票通常覆盖有轨电车、公交、无轨电车，可在售票机、报刊亭、DPB客户中心、手机应用购买。",
      "transportation_en": "Tram, Bus, Trolleybus",
      "recommendation_en": "Machines, kiosks, DPB centres, IDS BK App",
      "buy_ticket_en": "24/72h cover Tram, Bus, Trolleybus; buy at machines, kiosks, DPB, app."
    },
    {
      "country_id": "LV",
      "city_name": "里加",
      "city_name_en": "Riga",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "E-ticket (电子票卡)、售票机、Narvesen便利店、司机处、手机应用 (Rīgas Satiksme App)",
      "buy_ticket": "24/48/72小时或5日票通常覆盖有轨电车、公交、无轨电车，可在售票机、Narvesen便利店、Rīgas Satiksme客户中心购买。",
      "transportation_en": "Tram, Bus, Trolleybus",
      "recommendation_en": "E-ticket, machines, Narvesen, driver, Rīgas Satiksme App",
      "buy_ticket_en": "24/48/72h or 5-day cover Tram, Bus, Trolleybus; buy at machines, Narvesen, Rīgas Satiksme centres."
    },
    {
      "country_id": "LT",
      "city_name": "维尔纽斯",
      "city_name_en": "Vilnius",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "Vilniečio kortelė (维尔纽斯卡)、售票机、Kioskas便利店、手机应用 (Trafi App, m.Ticket App)",
      "buy_ticket": "24/72小时或10日票通常覆盖有轨电车、公交、无轨电车，可在售票机、Kioskas便利店、旅游信息中心、手机应用购买。",
      "transportation_en": "Tram, Bus, Trolleybus",
      "recommendation_en": "Vilniečio kortelė, machines, Kioskas, Trafi/m.Ticket App",
      "buy_ticket_en": "24/72h or 10-day cover Tram, Bus, Trolleybus; buy at machines, Kioskas, tourist info, app."
    },
    {
      "country_id": "MC",
      "city_name": "摩纳哥城",
      "city_name_en": "Monaco City",
      "transportation": "公交 (Bus)、出租车",
      "recommendation": "公交车上购票",
      "buy_ticket": "摩纳哥城不大，步行即可游览大部分景点。",
      "transportation_en": "Bus, Taxi",
      "recommendation_en": "On-board",
      "buy_ticket_en": "Monaco is small; most sights are walkable."
    },
    {
      "country_id": "LU",
      "city_name": "卢森堡市",
      "city_name_en": "Luxembourg City",
      "transportation": "公交 (Bus)、有轨电车 (Tram)、火车 (Train)",
      "recommendation": "卢森堡公共交通全部免费",
      "buy_ticket": "无需购票，所有公共交通免费乘坐。",
      "transportation_en": "Bus, Tram, Train",
      "recommendation_en": "All public transport in Luxembourg is free",
      "buy_ticket_en": "No ticket needed; all public transport is free."
    },
    {
      "country_id": "BA",
      "city_name": "萨拉热窝",
      "city_name_en": "Sarajevo",
      "transportation": "有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "司机处购票",
      "buy_ticket": "公交系统相对老旧，但覆盖主要区域。",
      "transportation_en": "Tram, Bus, Trolleybus",
      "recommendation_en": "Buy from driver",
      "buy_ticket_en": "Bus system is older but covers main areas."
    },
    {
      "country_id": "MK",
      "city_name": "斯科普里",
      "city_name_en": "Skopje",
      "transportation": "公交 (Bus)",
      "recommendation": "Skopska kartica (斯科普里卡)、司机处购票",
      "buy_ticket": "公交车是主要的公共交通方式。",
      "transportation_en": "Bus",
      "recommendation_en": "Skopska kartica, buy from driver",
      "buy_ticket_en": "Bus is the main public transport."
    },
    {
      "country_id": "AD",
      "city_name": "安道尔城",
      "city_name_en": "Andorra la Vella",
      "transportation": "公交 (Bus)",
      "recommendation": "司机处购票",
      "buy_ticket": "主要依靠公交连接城镇和滑雪区。",
      "transportation_en": "Bus",
      "recommendation_en": "Buy from driver",
      "buy_ticket_en": "Buses link towns and ski areas."
    },
    {
      "country_id": "SM",
      "city_name": "圣马力诺城",
      "city_name_en": "San Marino City",
      "transportation": "公交 (Bus)",
      "recommendation": "司机处购票",
      "buy_ticket": "景点集中，步行是主要方式，有缆车连接上下城区。",
      "transportation_en": "Bus",
      "recommendation_en": "Buy from driver",
      "buy_ticket_en": "Sights are compact; walking and cable car between upper and lower town."
    },
    {
      "country_id": "LI",
      "city_name": "瓦杜兹",
      "city_name_en": "Vaduz",
      "transportation": "公交 (Bus)",
      "recommendation": "司机处购票",
      "buy_ticket": "瓦杜兹不大，步行即可，公交连接周边城镇。",
      "transportation_en": "Bus",
      "recommendation_en": "Buy from driver",
      "buy_ticket_en": "Vaduz is small and walkable; buses link nearby towns."
    },
    {
      "country_id": "MD",
      "city_name": "基希讷乌",
      "city_name_en": "Chișinău",
      "transportation": "无轨电车 (Trolleybus)、公交 (Bus)",
      "recommendation": "司机处购票",
      "buy_ticket": "无轨电车是主要的公共交通工具。",
      "transportation_en": "Trolleybus, Bus",
      "recommendation_en": "Buy from driver",
      "buy_ticket_en": "Trolleybus is the main public transport."
    },
    {
      "country_id": "BY",
      "city_name": "明斯克",
      "city_name_en": "Minsk",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "地铁代币、公交车上购票、售票亭",
      "buy_ticket": "多日票通常覆盖地铁、有轨电车、公交、无轨电车，可在地铁站、售票亭购买。",
      "transportation_en": "Metro, Tram, Bus, Trolleybus",
      "recommendation_en": "Metro tokens, on-board, kiosks",
      "buy_ticket_en": "Multi-day cover Metro, Tram, Bus, Trolleybus; buy at Metro stations, kiosks."
    },
    {
      "country_id": "RU",
      "city_name": "莫斯科",
      "city_name_en": "Moscow",
      "transportation": "地铁 (Metro)、公交 (Bus)、有轨电车 (Tram)、无轨电车 (Trolleybus)",
      "recommendation": "Troika卡 (交通卡)、售票机、售票处、手机应用 (Moscow Metro App)",
      "buy_ticket": "建议购买Troika卡，可充值，价格更优惠。Troika卡充值后可用于地铁、公交、有轨电车、无轨电车，可在地铁站售票机或人工窗口购买。",
      "transportation_en": "Metro, Bus, Tram, Trolleybus",
      "recommendation_en": "Troika card, machines, offices, Moscow Metro App",
      "buy_ticket_en": "Troika card is recommended and rechargeable. Use on Metro, Bus, Tram, Trolleybus; buy at Metro machines or counters."
    },
    {
      "country_id": "RU",
      "city_name": "圣彼得堡",
      "city_name_en": "Saint Petersburg",
      "transportation": "地铁 (Metro)、公交 (Bus)、有轨电车 (Tram)、无轨电车 (Trolleybus)",
      "recommendation": "Podorozhnik卡 (交通卡)、售票机、售票处、手机应用 (St. Petersburg Metro App)",
      "buy_ticket": "地铁是主要交通方式，且站台设计精美。Podorozhnik卡充值后可用于地铁、公交、有轨电车、无轨电车，可在地铁站售票机或人工窗口购买。",
      "transportation_en": "Metro, Bus, Tram, Trolleybus",
      "recommendation_en": "Podorozhnik card, machines, offices, St. Petersburg Metro App",
      "buy_ticket_en": "Metro is the main transport and stations are ornate. Podorozhnik can be topped up for Metro, Bus, Tram, Trolleybus; buy at Metro machines or counters."
    },
    {
      "country_id": "UA",
      "city_name": "基辅",
      "city_name_en": "Kyiv",
      "transportation": "地铁 (Metro)、有轨电车 (Tram)、公交 (Bus)、无轨电车 (Trolleybus)",
      "recommendation": "地铁代币、Kiev Smart Card (交通卡)、售票亭、公交车上购票、手机应用 (Kyiv Digital App)",
      "buy_ticket": "地铁是快速方便的选择。Kiev Smart Card充值后可用于地铁、有轨电车、公交、无轨电车，可在地铁站、售票亭购买。",
      "transportation_en": "Metro, Tram, Bus, Trolleybus",
      "recommendation_en": "Metro tokens, Kiev Smart Card, kiosks, on-board, Kyiv Digital App",
      "buy_ticket_en": "Metro is fast and convenient. Kiev Smart Card for Metro, Tram, Bus, Trolleybus; buy at Metro, kiosks."
    },
    {
      "country_id": "VA",
      "city_name": "梵蒂冈城",
      "city_name_en": "Vatican City",
      "transportation": "步行",
      "recommendation": "无",
      "buy_ticket": "梵蒂冈城面积很小，所有景点均可步行到达。",
      "transportation_en": "Walking",
      "recommendation_en": "N/A",
      "buy_ticket_en": "Vatican City is very small; all sights are within walking distance."
    }
  ],
  "travelInfo": [
    {
      "country_id": "FR",
      "peak_season": "6月-8月 (夏季), 12月 (圣诞季)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "春秋两季气候宜人，游客相对较少，物价也可能更合理。夏季热门景点人流非常大，需提前预订。",
      "recent_notices": "巴黎等大城市扒手较多，尤其在热门景点和地铁上。看管好个人财物，避免在人少的地方独行，注意恐怖袭击风险。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "French",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer), Dec (Christmas)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Spring and autumn are pleasant with fewer tourists and often better prices. Summer attractions are very crowded; book ahead.",
      "recent_notices_en": "Pickpockets are common in Paris and other major cities, especially at sights and on the metro. Keep valuables safe, avoid walking alone in quiet areas; be aware of terrorism risk."
    },
    {
      "country_id": "IT",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "春秋两季天气凉爽，适合徒步和探索古迹，避开夏季酷热和人潮。",
      "recent_notices": "罗马、米兰等大城市扒手和小偷盛行，尤其在火车站、景点和公共交通上。晚上避免前往偏僻区域。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Italian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Spring and autumn are cooler, good for walking and exploring ancient sites; avoid summer heat and crowds.",
      "recent_notices_en": "Pickpockets and theft are common in Rome, Milan and other cities, especially at stations, sights and on public transport. Avoid remote areas at night."
    },
    {
      "country_id": "ES",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "西班牙夏季炎热，尤其南部地区。春秋两季气候温和，适合观光和海滩活动。",
      "recent_notices": "巴塞罗那、马德里等旅游热点扒手多发，警惕假警察、吉普赛算命等骗局。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Spanish",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Spain is hot in summer, especially in the south. Spring and autumn are mild, good for sightseeing and beaches.",
      "recent_notices_en": "Pickpockets are common in Barcelona, Madrid and other tourist spots; beware of fake police and street scams."
    },
    {
      "country_id": "DE",
      "peak_season": "6月-8月 (夏季), 12月 (圣诞市集)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季日照时间长，适合户外活动。春末和初秋天气舒适，是避开高峰的好选择。",
      "recent_notices": "德国总体治安良好，但火车站和旅游区仍需注意小偷。警惕陌生人搭讪或推销。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "German",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer), Dec (Christmas markets)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Long daylight in summer, good for outdoor activities. Late spring and early autumn are comfortable and less crowded.",
      "recent_notices_en": "Germany is generally safe; still watch for thieves at stations and tourist areas. Be cautious of strangers offering help or selling."
    },
    {
      "country_id": "GB",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "英国天气多变，夏季相对稳定，但游客众多。春末和初秋气候宜人，适合城市漫步。",
      "recent_notices": "伦敦等大城市需警惕扒手和诈骗。夜晚在某些区域行走时要小心，注意交通安全（靠左行驶）。",
      "Currency Code": "GBP",
      "Currency Symbol": "£",
      "Language": "English",
      "Time Zone (GMT Offset)": "GMT+0 (winter), GMT+1 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "UK weather is changeable; summer is relatively stable but crowded. Late spring and early autumn are pleasant for city walks.",
      "recent_notices_en": "Watch for pickpockets and scams in London and other cities. Be careful at night in some areas; drive on the left."
    },
    {
      "country_id": "GR",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "夏季爱琴海岛屿非常热门且炎热。春秋两季气温适中，适合岛屿游览和历史遗迹参观。",
      "recent_notices": "雅典热门景点和地铁上扒手较多。注意交通安全，尤其在岛屿租车自驾时。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Greek",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Aegean islands are very busy and hot in summer. Spring and autumn are mild, good for islands and ancient sites.",
      "recent_notices_en": "Pickpockets are common at Athens sights and on the metro. Mind road safety, especially when renting cars on islands."
    },
    {
      "country_id": "HR",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "克罗地亚夏季海边人流密集，物价上涨。春末和初秋是享受海滨风光和古城的好时机。",
      "recent_notices": "总体治安良好，但旅游旺季海滨城市扒手增多。在人多的地方看管好随身物品。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Croatian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Croatian coast is crowded and pricier in summer. Late spring and early autumn are good for coast and old towns.",
      "recent_notices_en": "Generally safe; pickpockets increase in coastal cities in peak season. Keep an eye on belongings in crowds."
    },
    {
      "country_id": "TR",
      "peak_season": "6月-8月 (夏季), 9月-10月 (卡帕多奇亚)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "春秋两季气候舒适，适合城市观光和乘坐热气球。夏季地中海沿岸热门。",
      "recent_notices": "伊斯坦布尔等大城市需警惕扒手、鞋油骗局等。避免与陌生人过度攀谈，注意政治敏感话题。",
      "Currency Code": "TRY",
      "Currency Symbol": "₺",
      "Language": "Turkish",
      "Time Zone (GMT Offset)": "GMT+3",
      "peak_season_en": "Jun-Aug (summer), Sep-Oct (Cappadocia)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Spring and autumn are comfortable for city visits and hot-air balloons. Mediterranean coast is busy in summer.",
      "recent_notices_en": "In Istanbul and other cities watch for pickpockets and shoe-shine scams. Avoid long chats with strangers; avoid sensitive political topics."
    },
    {
      "country_id": "PT",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "4月-6月, 9月-10月",
      "climate_info": "夏季炎热，尤其内陆。春秋两季天气温和，适合探索城市和海滩。",
      "recent_notices": "里斯本、波尔图等大城市扒手和抢劫事件偶有发生，尤其在公共交通和旅游景点。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Portuguese",
      "Time Zone (GMT Offset)": "GMT+0 (winter), GMT+1 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "Apr-Jun, Sep-Oct",
      "climate_info_en": "Summer is hot, especially inland. Spring and autumn are mild, good for cities and beaches.",
      "recent_notices_en": "Pickpockets and theft occur in Lisbon, Porto and other cities, especially on public transport and at sights."
    },
    {
      "country_id": "NL",
      "peak_season": "4月 (郁金香季), 7月-8月 (夏季)",
      "best_months": "4月 (郁金香季), 5月-6月, 9月",
      "climate_info": "4月是郁金香盛开期，游客众多。春秋两季气候宜人，适合骑行和城市游览。",
      "recent_notices": "阿姆斯特丹红灯区和旅游区扒手较多。注意保管好财物，尤其在拥挤区域。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Dutch",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Apr (tulips), Jul-Aug (summer)",
      "best_months_en": "Apr (tulips), May-Jun, Sep",
      "climate_info_en": "April is tulip season and very busy. Spring and autumn are pleasant for cycling and city visits.",
      "recent_notices_en": "Pickpockets are common in Amsterdam red-light and tourist areas. Keep valuables safe, especially in crowds."
    },
    {
      "country_id": "CH",
      "peak_season": "7月-8月 (夏季), 12月-次年3月 (滑雪季)",
      "best_months": "5月-6月, 9月-10月",
      "climate_info": "夏季适合徒步和湖光山色，冬季适合滑雪。春秋两季游客较少，可享受宁静的自然风光。",
      "recent_notices": "瑞士治安非常好，但仍需注意火车站和旅游景点的小偷。山区徒步注意天气变化和安全。",
      "Currency Code": "CHF",
      "Currency Symbol": "CHF",
      "Language": "German, French, Italian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jul-Aug (summer), Dec-Mar (ski)",
      "best_months_en": "May-Jun, Sep-Oct",
      "climate_info_en": "Summer is good for hiking and lakes; winter for skiing. Spring and autumn are quieter with nice scenery.",
      "recent_notices_en": "Switzerland is very safe; still watch for thieves at stations and sights. In the mountains, check weather and safety."
    },
    {
      "country_id": "AT",
      "peak_season": "6月-8月 (夏季), 12月 (圣诞季), 2月-3月 (滑雪季)",
      "best_months": "5月-6月, 9月-10月",
      "climate_info": "夏季适合山地和湖区活动。春秋两季气候宜人，适合城市观光和文化体验。",
      "recent_notices": "维也纳等城市扒手较多，尤其在公共交通和旅游景点。警惕假冒警察的骗局。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "German",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer), Dec (Christmas), Feb-Mar (ski)",
      "best_months_en": "May-Jun, Sep-Oct",
      "climate_info_en": "Summer is good for mountains and lakes. Spring and autumn are pleasant for cities and culture.",
      "recent_notices_en": "Pickpockets are common in Vienna and other cities, especially on public transport and at sights. Beware of fake police."
    },
    {
      "country_id": "IS",
      "peak_season": "6月-8月 (夏季), 12月-次年3月 (极光季)",
      "best_months": "6月-8月 (夏季观光), 9月-次年4月 (极光)",
      "climate_info": "夏季白昼长，适合自驾和户外。冬季可观赏极光，但气候严寒，需做好保暖准备。",
      "recent_notices": "冰岛犯罪率极低，但自驾游需注意天气变化和路况，避免在非指定区域徒步或进入危险地带。",
      "Currency Code": "ISK",
      "Currency Symbol": "kr, Íkr",
      "Language": "Icelandic",
      "Time Zone (GMT Offset)": "GMT+0",
      "peak_season_en": "Jun-Aug (summer), Dec-Mar (northern lights)",
      "best_months_en": "Jun-Aug (sightseeing), Sep-Apr (northern lights)",
      "climate_info_en": "Summer has long daylight, good for driving and outdoors. Winter is for northern lights but very cold; dress warmly.",
      "recent_notices_en": "Crime is very low. For self-drive, watch weather and road conditions; do not hike or enter dangerous areas off-limits."
    },
    {
      "country_id": "CZ",
      "peak_season": "6月-8月 (夏季), 12月 (圣诞市集)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "春秋两季气候温和，游客相对较少，适合漫步古城。",
      "recent_notices": "布拉格旅游区扒手非常多，尤其在查理大桥、老城广场和公共交通上。警惕换钱陷阱和出租车诈骗。",
      "Currency Code": "CZK",
      "Currency Symbol": "Kč",
      "Language": "Czech",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer), Dec (Christmas markets)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Spring and autumn are mild with fewer tourists, good for old towns.",
      "recent_notices_en": "Pickpockets are very common in Prague, especially on Charles Bridge, Old Town Square and public transport. Beware of exchange and taxi scams."
    },
    {
      "country_id": "IE",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "爱尔兰夏季是最佳季节，天气相对干燥，绿意盎然。春秋两季游客减少，但也适合旅行。",
      "recent_notices": "都柏林市中心和酒吧区需警惕醉酒者和扒手。夜晚尽量避免独行。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "English, Irish",
      "Time Zone (GMT Offset)": "GMT+0 (winter), GMT+1 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is the best season, relatively dry and green. Spring and autumn are less crowded but still fine.",
      "recent_notices_en": "Watch for drunk behaviour and pickpockets in Dublin centre and pub areas. Avoid walking alone at night."
    },
    {
      "country_id": "DK",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "丹麦夏季气候舒适，日照时间长。春末和初秋是体验北欧风情的好时机。",
      "recent_notices": "丹麦治安良好，但在哥本哈根火车站和旅游区仍需注意小偷。",
      "Currency Code": "DKK",
      "Currency Symbol": "kr",
      "Language": "Danish",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is comfortable with long daylight. Late spring and early autumn are good for Nordic trips.",
      "recent_notices_en": "Denmark is generally safe; still watch for thieves at Copenhagen station and tourist areas."
    },
    {
      "country_id": "SE",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "6月-8月",
      "climate_info": "瑞典夏季气候宜人，适合户外活动和探索群岛。",
      "recent_notices": "瑞典总体治安良好，斯德哥尔摩市中心和公共交通上偶尔有扒手，注意保管财物。",
      "Currency Code": "SEK",
      "Currency Symbol": "kr",
      "Language": "Swedish",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "Jun-Aug",
      "climate_info_en": "Swedish summer is pleasant, good for outdoor activities and archipelago.",
      "recent_notices_en": "Sweden is generally safe; occasional pickpockets in Stockholm centre and on public transport. Keep valuables safe."
    },
    {
      "country_id": "FI",
      "peak_season": "7月-8月 (夏季), 12月-次年3月 (极光/冰雪)",
      "best_months": "6月-8月 (夏季), 9月-次年4月 (极光)",
      "climate_info": "夏季是湖泊和森林活动的好时机。冬季则可体验冰雪运动和追寻极光。",
      "recent_notices": "芬兰治安非常好，犯罪率低。冬季户外活动注意保暖和防滑。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Finnish, Swedish",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jul-Aug (summer), Dec-Mar (northern lights/snow)",
      "best_months_en": "Jun-Aug (summer), Sep-Apr (northern lights)",
      "climate_info_en": "Summer is good for lakes and forests; winter for snow activities and northern lights.",
      "recent_notices_en": "Finland is very safe with low crime. In winter, dress warmly and watch for ice."
    },
    {
      "country_id": "BE",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "春秋两季气候宜人，适合城市观光和品尝啤酒巧克力。",
      "recent_notices": "布鲁塞尔等城市扒手较多，尤其在火车站和旅游景点。晚上避免在个别区域独行。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Dutch, French, German",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Spring and autumn are pleasant for city visits and beer/chocolate.",
      "recent_notices_en": "Pickpockets are common in Brussels and other cities, especially at stations and sights. Avoid some areas alone at night."
    },
    {
      "country_id": "HU",
      "peak_season": "6月-8月 (夏季), 12月 (圣诞市集)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "布达佩斯春秋两季气候舒适，适合温泉和城市探索。",
      "recent_notices": "布达佩斯扒手和出租车诈骗较多。警惕推销香水或提供“帮助”的陌生人。",
      "Currency Code": "HUF",
      "Currency Symbol": "Ft",
      "Language": "Hungarian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer), Dec (Christmas markets)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Budapest is comfortable in spring and autumn for thermal baths and city exploring.",
      "recent_notices_en": "Pickpockets and taxi scams are common in Budapest. Beware of strangers offering perfume or \"help\"."
    },
    {
      "country_id": "PL",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "波兰夏季气候宜人，适合探索历史文化。春秋两季游客相对较少。",
      "recent_notices": "华沙、克拉科夫等旅游区扒手和小偷偶有发生，尤其在火车站和公共交通上。",
      "Currency Code": "PLN",
      "Currency Symbol": "zł",
      "Language": "Polish",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Polish summer is pleasant for history and culture. Spring and autumn are less crowded.",
      "recent_notices_en": "Pickpockets and theft occur in Warsaw, Krakow and other tourist areas, especially at stations and on public transport."
    },
    {
      "country_id": "ME",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季海滨城市非常热门。春秋两季气温舒适，适合探索峡湾和古城。",
      "recent_notices": "总体治安良好，但旅游旺季在热门景点仍需注意扒手。山区自驾注意路况。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Montenegrin",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Coastal towns are very busy in summer. Spring and autumn are comfortable for fjords and old towns.",
      "recent_notices_en": "Generally safe; in peak season watch for pickpockets at popular sights. Mind road conditions when driving in mountains."
    },
    {
      "country_id": "SI",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季适合湖区和山区活动。春秋两季是避开高峰，享受自然风光的好时机。",
      "recent_notices": "斯洛文尼亚治安良好，犯罪率低。在热门旅游区仍需注意小偷。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Slovenian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is good for lakes and mountains. Spring and autumn are good for avoiding crowds and enjoying nature.",
      "recent_notices_en": "Slovenia is safe with low crime. Still watch for thieves in tourist areas."
    },
    {
      "country_id": "NO",
      "peak_season": "6月-8月 (夏季), 10月-次年3月 (极光季)",
      "best_months": "6月-8月 (夏季峡湾), 9月-次年3月 (极光)",
      "climate_info": "夏季是游览峡湾的最佳时期，冬季则是追寻极光的理想季节。",
      "recent_notices": "挪威治安良好，但物价高昂。冬季自驾需非常小心冰雪路面，并备好冬季装备。",
      "Currency Code": "NOK",
      "Currency Symbol": "kr",
      "Language": "Norwegian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer), Oct-Mar (northern lights)",
      "best_months_en": "Jun-Aug (fjords), Sep-Mar (northern lights)",
      "climate_info_en": "Summer is best for fjords; winter is ideal for northern lights.",
      "recent_notices_en": "Norway is safe but expensive. Winter driving requires extra care on ice and snow; have winter gear."
    },
    {
      "country_id": "RS",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "塞尔维亚夏季气候炎热。春秋两季气温适中，适合城市探索和户外活动。",
      "recent_notices": "贝尔格莱德等大城市扒手和小偷偶有发生，尤其在市场和公共交通上。",
      "Currency Code": "RSD",
      "Currency Symbol": "RSD",
      "Language": "Serbian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Serbian summer is hot. Spring and autumn are mild, good for cities and outdoors.",
      "recent_notices_en": "Pickpockets and theft occur in Belgrade and other cities, especially at markets and on public transport."
    },
    {
      "country_id": "RO",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季适合探索喀尔巴阡山脉和黑海海岸。春秋两季是城市观光的好选择。",
      "recent_notices": "布加勒斯特扒手和诈骗较多，尤其在旅游景点和火车站。避免在夜晚偏僻地区独行。",
      "Currency Code": "RON",
      "Currency Symbol": "lei",
      "Language": "Romanian",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is good for Carpathians and Black Sea coast. Spring and autumn are good for city sightseeing.",
      "recent_notices_en": "Pickpockets and scams are common in Bucharest, especially at sights and stations. Avoid remote areas at night."
    },
    {
      "country_id": "AL",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季海滨地区热门。春秋两季气温舒适，适合探索古城和自然风光。",
      "recent_notices": "总体治安正在改善，但仍需注意扒手。避免在夜晚前往不熟悉的区域。",
      "Currency Code": "ALL",
      "Currency Symbol": "L",
      "Language": "Albanian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Coast is busy in summer. Spring and autumn are comfortable for old towns and nature.",
      "recent_notices_en": "Safety is improving; still watch for pickpockets. Avoid unfamiliar areas at night."
    },
    {
      "country_id": "BG",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季黑海沿岸热门。春秋两季适合探索历史遗迹和玫瑰谷。",
      "recent_notices": "索非亚等城市扒手和小偷较多，尤其在公共交通和市场。注意换汇安全。",
      "Currency Code": "BGN",
      "Currency Symbol": "лв",
      "Language": "Bulgarian",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Black Sea coast is busy in summer. Spring and autumn are good for history and Rose Valley.",
      "recent_notices_en": "Pickpockets and theft are common in Sofia and other cities, especially on public transport and at markets. Use safe exchange."
    },
    {
      "country_id": "MT",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "马耳他夏季炎热且游客众多。春秋两季气候宜人，适合游泳和探索历史遗迹。",
      "recent_notices": "马耳他总体安全，但热门旅游区仍需注意扒手和财物安全。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Maltese, English",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Malta is hot and crowded in summer. Spring and autumn are pleasant for swimming and historic sites.",
      "recent_notices_en": "Malta is generally safe; still watch for pickpockets and valuables in tourist areas."
    },
    {
      "country_id": "EE",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季是探索塔林老城和海岛的最佳时期。春秋两季游客较少，气候凉爽。",
      "recent_notices": "爱沙尼亚治安良好，但在塔林老城和旅游区仍需注意扒手。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Estonian",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is best for Tallinn Old Town and islands. Spring and autumn are cooler with fewer tourists.",
      "recent_notices_en": "Estonia is safe; watch for pickpockets in Tallinn Old Town and tourist areas."
    },
    {
      "country_id": "CY",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "4月-6月, 9月-10月",
      "climate_info": "塞浦路斯夏季酷热。春秋两季气候温和，适合海滩活动和历史遗迹参观。",
      "recent_notices": "塞浦路斯总体安全，但热门旅游区仍需注意小偷。租车自驾时注意交通规则。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Greek, Turkish",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "Apr-Jun, Sep-Oct",
      "climate_info_en": "Cyprus is very hot in summer. Spring and autumn are mild, good for beaches and historic sites.",
      "recent_notices_en": "Cyprus is generally safe; watch for thieves in tourist areas. Mind traffic rules when renting a car."
    },
    {
      "country_id": "SK",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季适合登山和湖泊活动。春秋两季气温舒适，适合城市观光。",
      "recent_notices": "布拉迪斯拉发等城市扒手和小偷偶有发生，尤其在旅游景点和公共交通上。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Slovak",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is good for mountains and lakes. Spring and autumn are comfortable for city visits.",
      "recent_notices_en": "Pickpockets and theft occur in Bratislava and other cities, especially at sights and on public transport."
    },
    {
      "country_id": "LV",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季气候宜人，适合探索里加老城和海滩。",
      "recent_notices": "里加老城和旅游区扒手较多，尤其在夜间酒吧附近。注意保管好财物。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Latvian",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is pleasant for Riga Old Town and beaches.",
      "recent_notices_en": "Pickpockets are common in Riga Old Town and tourist areas, especially near bars at night. Keep valuables safe."
    },
    {
      "country_id": "LT",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季气候舒适，适合探索维尔纽斯和自然风光。",
      "recent_notices": "维尔纽斯等城市扒手和小偷偶有发生，尤其在旅游景点和公共交通上。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Lithuanian",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is comfortable for Vilnius and nature.",
      "recent_notices_en": "Pickpockets and theft occur in Vilnius and other cities, especially at sights and on public transport."
    },
    {
      "country_id": "MC",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "摩纳哥夏季人流密集，物价高昂。春秋两季气候宜人，适合漫步和参观景点。",
      "recent_notices": "摩纳哥治安非常好，但仍建议保管好贵重物品。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "French",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Monaco is crowded and expensive in summer. Spring and autumn are pleasant for walking and sights.",
      "recent_notices_en": "Monaco is very safe; still keep valuables secure."
    },
    {
      "country_id": "LU",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "卢森堡夏季气候温和，适合城市漫步和郊外探索。",
      "recent_notices": "卢森堡治安良好，但在主要交通枢纽和旅游区仍需注意小偷。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Luxembourgish, French, German",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Luxembourg summer is mild, good for city walks and countryside.",
      "recent_notices_en": "Luxembourg is safe; watch for thieves at main hubs and tourist areas."
    },
    {
      "country_id": "BA",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季气候炎热。春秋两季气温适中，适合探索历史遗迹和自然风光。",
      "recent_notices": "萨拉热窝等城市扒手和小偷偶有发生。避免前往未排雷区域，听从当地安全指示。",
      "Currency Code": "BAM",
      "Currency Symbol": "KM",
      "Language": "Bosnian, Croatian, Serbian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is hot. Spring and autumn are mild, good for history and nature.",
      "recent_notices_en": "Pickpockets and theft occur in Sarajevo and other cities. Avoid uncleared mine areas; follow local safety advice."
    },
    {
      "country_id": "MK",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季内陆地区炎热。春秋两季气候舒适，适合探索古迹和湖泊。",
      "recent_notices": "斯科普里等城市扒手偶有发生。避免在夜晚前往偏僻区域。",
      "Currency Code": "MKD",
      "Currency Symbol": "ден",
      "Language": "Macedonian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Inland is hot in summer. Spring and autumn are comfortable for ancient sites and lakes.",
      "recent_notices_en": "Pickpockets occur in Skopje. Avoid remote areas at night."
    },
    {
      "country_id": "AD",
      "peak_season": "7月-8月 (夏季), 12月-次年3月 (滑雪季)",
      "best_months": "6月-9月 (夏季), 12月-次年3月 (冬季)",
      "climate_info": "夏季适合山地徒步，冬季是滑雪胜地。",
      "recent_notices": "安道尔治安良好，但滑雪和山地活动注意安全。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Catalan",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jul-Aug (summer), Dec-Mar (ski)",
      "best_months_en": "Jun-Sep (summer), Dec-Mar (winter)",
      "climate_info_en": "Summer is good for mountain hiking; winter is ski season.",
      "recent_notices_en": "Andorra is safe; take care with skiing and mountain activities."
    },
    {
      "country_id": "SM",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "4月-6月, 9月-10月",
      "climate_info": "夏季游客众多。春秋两季气候宜人，适合漫步古城和欣赏风景。",
      "recent_notices": "圣马力诺治安良好，主要游客区安全。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Italian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "Apr-Jun, Sep-Oct",
      "climate_info_en": "Summer is crowded. Spring and autumn are pleasant for old town and views.",
      "recent_notices_en": "San Marino is safe; main tourist areas are secure."
    },
    {
      "country_id": "LI",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季适合徒步和探索山间小镇。",
      "recent_notices": "列支敦士登治安非常好，犯罪率极低。",
      "Currency Code": "CHF",
      "Currency Symbol": "CHF",
      "Language": "German",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is good for hiking and mountain towns.",
      "recent_notices_en": "Liechtenstein is very safe with very low crime."
    },
    {
      "country_id": "MD",
      "peak_season": "7月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "摩尔多瓦夏季气候炎热。春秋两季气候宜人，适合品酒和探索乡村。",
      "recent_notices": "摩尔多瓦治安一般，基希讷乌等城市需注意扒手和诈骗。夜晚避免独行。",
      "Currency Code": "MDL",
      "Currency Symbol": "L",
      "Language": "Romanian",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jul-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Moldova is hot in summer. Spring and autumn are pleasant for wine and countryside.",
      "recent_notices_en": "Safety is moderate; watch for pickpockets and scams in Chișinău. Avoid walking alone at night."
    },
    {
      "country_id": "BY",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "夏季气候舒适，适合城市观光和探索自然风光。",
      "recent_notices": "白俄罗斯总体治安良好，但仍需注意个人财物安全。",
      "Currency Code": "BYN",
      "Currency Symbol": "Br",
      "Language": "Belarusian, Russian",
      "Time Zone (GMT Offset)": "GMT+3",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Summer is comfortable for city and nature.",
      "recent_notices_en": "Belarus is generally safe; still keep valuables secure."
    },
    {
      "country_id": "RU",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "俄罗斯夏季气候宜人，日照时间长。春秋两季游客相对较少。",
      "recent_notices": "莫斯科、圣彼得堡等大城市扒手和小偷较多，警惕街头诈骗和假警察。注意人身安全，避免单独前往偏僻区域。",
      "Currency Code": "RUB",
      "Currency Symbol": "₽",
      "Language": "Russian",
      "Time Zone (GMT Offset)": "GMT+2 to GMT+12 (multiple time zones)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Russian summer is pleasant with long daylight. Spring and autumn are less crowded.",
      "recent_notices_en": "Pickpockets and theft are common in Moscow, Saint Petersburg and other cities; beware of street scams and fake police. Stay safe and avoid remote areas alone."
    },
    {
      "country_id": "UA",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "5月-6月, 9月",
      "climate_info": "乌克兰夏季气候舒适，适合城市观光。",
      "recent_notices": "鉴于当前地缘政治局势，不建议前往乌克兰旅行。如必须前往，请密切关注官方旅行建议，避免前往冲突地区，并高度警惕安全风险。",
      "Currency Code": "UAH",
      "Currency Symbol": "₴",
      "Language": "Ukrainian",
      "Time Zone (GMT Offset)": "GMT+2 (winter), GMT+3 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "May-Jun, Sep",
      "climate_info_en": "Ukrainian summer is comfortable for city visits.",
      "recent_notices_en": "Given current geopolitical situation, travel to Ukraine is not recommended. If you must go, follow official travel advice, avoid conflict zones, and take security seriously."
    },
    {
      "country_id": "VA",
      "peak_season": "6月-8月 (夏季)",
      "best_months": "4月-5月, 9月-10月",
      "climate_info": "梵蒂冈与罗马相邻，旅行季节与罗马相同。夏季游客众多且炎热。",
      "recent_notices": "梵蒂冈区域游客众多，扒手盛行。注意保管好钱包、手机等贵重物品，避免与陌生人搭讪。",
      "Currency Code": "EUR",
      "Currency Symbol": "€",
      "Language": "Italian",
      "Time Zone (GMT Offset)": "GMT+1 (winter), GMT+2 (summer)",
      "peak_season_en": "Jun-Aug (summer)",
      "best_months_en": "Apr-May, Sep-Oct",
      "climate_info_en": "Vatican shares Rome's season; summer is hot and crowded.",
      "recent_notices_en": "The Vatican area is very crowded; pickpockets are common. Keep wallets and phones safe; avoid engaging with strangers."
    }
  ],
  "food": [
    {
      "country_id": "FR",
      "food": "可颂 (Croissant), 法棍 (Baguette), 鹅肝 (Foie Gras), 法式蜗牛 (Escargots), 勃艮第红酒炖牛肉 (Boeuf Bourguignon), 马卡龙 (Macaron), 奶酪 (Cheese)",
      "price_per_meal": "€15-€30 (中档餐厅); €8-€15 (简餐)",
      "tips": "5-10%, 小费并非强制，但服务到位可留；通常刷卡支付，小费可现金或刷卡添加。",
      "notification": "在法式餐厅用餐时，点菜前通常会提供面包和水。面包免费，但如果点瓶装水则需付费。",
      "find_local_food": "避开游客区，寻找小巷里的Bistro或Brasserie。观察当地人光顾的咖啡馆和面包店。在市场品尝新鲜奶酪、熟食和烘焙品。",
      "food_en": "Croissant, Baguette, Foie Gras, Escargots, Boeuf Bourguignon, Macaron, Cheese",
      "price_per_meal_en": "€15-€30 (mid-range); €8-€15 (casual)",
      "tips_en": "5-10%, tipping not mandatory but appreciated for good service; cards accepted, tip in cash or on card.",
      "notification_en": "In French restaurants, bread and water are often served before ordering. Bread is free; bottled water may be charged.",
      "find_local_food_en": "Avoid tourist areas; look for Bistros or Brasseries in side streets. Follow locals to cafés and bakeries. Try cheese, charcuterie and pastries at markets."
    },
    {
      "country_id": "IT",
      "food": "披萨 (Pizza), 意大利面 (Pasta), 提拉米苏 (Tiramisu), 意式冰淇淋 (Gelato), 佛罗伦萨牛排 (Bistecca alla Fiorentina), 帕尔马火腿 (Prosciutto di Parma), 意式浓缩咖啡 (Espresso)",
      "price_per_meal": "€12-€25 (中档餐厅); €7-€12 (简餐/披萨店)",
      "tips": "5-10%或四舍五入，服务费(coperto)常已包含；通常刷卡支付，小费可现金。",
      "notification": "许多餐厅会收取“Coperto”（餐位费）或“Servizio”（服务费），请留意账单。",
      "find_local_food": "寻找Trattoria或Osteria，它们通常提供更传统的家庭式菜肴。在午餐时间观察当地工人的去向。**Gelateria（冰淇淋店）**选择手工制作的Gelato。",
      "food_en": "Pizza, Pasta, Tiramisu, Gelato, Bistecca alla Fiorentina, Prosciutto di Parma, Espresso",
      "price_per_meal_en": "€12-€25 (mid-range); €7-€12 (casual/pizzeria)",
      "tips_en": "5-10% or round up; coperto (cover) often included; cards accepted, tip in cash.",
      "notification_en": "Many restaurants charge \"Coperto\" (cover) or \"Servizio\" (service); check the bill.",
      "find_local_food_en": "Look for Trattoria or Osteria for traditional home-style dishes. See where locals go at lunch. Choose hand-made Gelato at a Gelateria."
    },
    {
      "country_id": "ES",
      "food": "西班牙海鲜饭 (Paella), 小吃 (Tapas), 西班牙火腿 (Jamón Ibérico), 西班牙油条 (Churros), 桑格利亚汽酒 (Sangria), 西班牙土豆饼 (Tortilla Española)",
      "price_per_meal": "€10-€25 (中档餐厅); €5-€12 (小吃/简餐)",
      "tips": "5-10%, 小费非强制，但服务好可留零钱；通常刷卡支付，小费现金较常见。",
      "notification": "在小吃店用餐时，可以尝试点多种小吃分享。午餐通常是主餐，晚餐较晚。",
      "find_local_food": "寻找当地市场，如巴塞罗那的波盖利亚市场，品尝小吃和新鲜农产品。晚上跟随当地人，去Tapas Bar hopping。",
      "food_en": "Paella, Tapas, Jamón Ibérico, Churros, Sangria, Tortilla Española",
      "price_per_meal_en": "€10-€25 (mid-range); €5-€12 (tapas/casual)",
      "tips_en": "5-10%, tipping not mandatory but leave change for good service; cards accepted, cash tip common.",
      "notification_en": "At tapas bars you can order several small dishes to share. Lunch is the main meal; dinner is late.",
      "find_local_food_en": "Visit local markets like La Boqueria in Barcelona for tapas and fresh produce. Follow locals for Tapas Bar hopping in the evening."
    },
    {
      "country_id": "DE",
      "food": "德国香肠 (Wurst), 猪肘 (Schweinshaxe), 啤酒 (Bier), 酸菜 (Sauerkraut), 椒盐脆饼 (Pretzel), 黑森林蛋糕 (Schwarzwälder Kirschtorte)",
      "price_per_meal": "€12-€25 (中档餐厅); €6-€12 (简餐/快餐)",
      "tips": "5-10%或四舍五入，可直接告诉服务员包含小费的总金额；通常刷卡支付，小费现金或刷卡。",
      "notification": "在德国，通常会将找零四舍五入作为小费。",
      "find_local_food": "参观当地啤酒花园 (Biergarten)或传统酒馆 (Gasthof/Gaststätte)。在面包店品尝新鲜出炉的Pretzel。街头小吃摊的香肠也是不错的选择。",
      "food_en": "Wurst, Schweinshaxe, Beer, Sauerkraut, Pretzel, Schwarzwälder Kirschtorte",
      "price_per_meal_en": "€12-€25 (mid-range); €6-€12 (casual/fast)",
      "tips_en": "5-10% or round up; you can tell the server the total including tip; cards accepted, tip in cash or on card.",
      "notification_en": "In Germany, change is often rounded up as tip.",
      "find_local_food_en": "Visit beer gardens (Biergarten) or traditional inns (Gasthof/Gaststätte). Try fresh Pretzels at bakeries. Sausage stands are a good option."
    },
    {
      "country_id": "GB",
      "food": "炸鱼薯条 (Fish and Chips), 英式早餐 (Full English Breakfast), 烤牛肉 (Roast Beef and Yorkshire Pudding), 下午茶 (Afternoon Tea), 牧羊人派 (Shepherd's Pie)",
      "price_per_meal": "£15-£30 (中档餐厅); £8-£15 (简餐/酒吧)",
      "tips": "10-15%, 服务费(Service Charge)有时已包含；通常刷卡支付，小费可刷卡或现金。",
      "notification": "许多餐厅会额外收取服务费，请检查账单。在酒吧通常无需给小费。",
      "find_local_food": "寻找传统英式酒吧 (Pub)享用美食和啤酒。在当地市场或农夫市集寻找新鲜食材和街头小吃。下午茶建议预订酒店或茶馆。",
      "food_en": "Fish and Chips, Full English Breakfast, Roast Beef and Yorkshire Pudding, Afternoon Tea, Shepherd's Pie",
      "price_per_meal_en": "£15-£30 (mid-range); £8-£15 (casual/pub)",
      "tips_en": "10-15%; service charge sometimes included; cards accepted, tip on card or cash.",
      "notification_en": "Many restaurants add a service charge; check the bill. Tipping is not expected in pubs.",
      "find_local_food_en": "Look for traditional pubs for food and beer. Visit local or farmers' markets for fresh produce and street food. Book afternoon tea at hotels or tea rooms."
    },
    {
      "country_id": "GR",
      "food": "希腊沙拉 (Greek Salad), 烤肉串 (Souvlaki), 穆萨卡 (Moussaka), 羊肉串 (Gyros), 炸丸子 (Tzatziki), 希腊咖啡 (Greek Coffee)",
      "price_per_meal": "€10-€20 (中档餐厅); €5-€10 (简餐/快餐)",
      "tips": "5-10%或四舍五入，在小酒馆或家庭餐厅通常不强制；通常现金支付，部分餐厅可刷卡。",
      "notification": "许多餐馆会在餐前送上免费面包，但有时会收取少量费用。",
      "find_local_food": "寻找Taverna（小酒馆）或Psistaria（烧烤店）。在当地的面包店或糕点店品尝传统甜点。在港口城市寻找新鲜海鲜。",
      "food_en": "Greek Salad, Souvlaki, Moussaka, Gyros, Tzatziki, Greek Coffee",
      "price_per_meal_en": "€10-€20 (mid-range); €5-€10 (casual/fast)",
      "tips_en": "5-10% or round up; not mandatory in tavernas; cash common, some restaurants take cards.",
      "notification_en": "Many restaurants serve free bread before the meal, but a small charge may apply sometimes.",
      "find_local_food_en": "Look for Taverna or Psistaria (grill house). Try traditional sweets at local bakeries. Seek fresh seafood in port towns."
    },
    {
      "country_id": "HR",
      "food": "海鲜 (Seafood), 佩卡 (Peka), 黑米饭 (Crni Rižot), 帕格奶酪 (Paški sir), 特制烤肉 (Čevapi), 松露 (Truffle)",
      "price_per_meal": "€15-€30 (中档餐厅); €7-€15 (简餐)",
      "tips": "5-10%或四舍五入，通常不强制；现金支付较常见，部分餐厅可刷卡。",
      "notification": "在沿海地区，海鲜非常新鲜且价格合理。",
      "find_local_food": "在沿海地区选择海鲜餐厅 (Konoba)，通常提供当天捕捞的新鲜海鲜。在内陆地区尝试当地的烤肉店。",
      "food_en": "Seafood, Peka, Crni Rižot, Paški sir, Čevapi, Truffle",
      "price_per_meal_en": "€15-€30 (mid-range); €7-€15 (casual)",
      "tips_en": "5-10% or round up, usually not mandatory; cash common, some restaurants take cards.",
      "notification_en": "On the coast, seafood is very fresh and reasonably priced.",
      "find_local_food_en": "Choose a Konoba (seafood restaurant) on the coast for daily catch. Try local grill houses inland."
    },
    {
      "country_id": "TR",
      "food": "烤肉 (Kebap), 土耳其软糖 (Lokum), 土耳其茶 (Çay), 薄饼 (Gözleme), 土耳其咖啡 (Türk Kahvesi), 土耳其冰淇淋 (Dondurma), 肉丸 (Köfte)",
      "price_per_meal": "₺150-₺300 (中档餐厅); ₺70-₺150 (简餐)",
      "tips": "5-10%，在小餐馆通常不强制；现金支付较常见，部分餐厅可刷卡。",
      "notification": "在伊斯坦布尔，很多小吃店只收现金。",
      "find_local_food": "探索当地集市 (Bazaar)，那里有各种街头小吃和甜点。在居民区寻找小餐馆，通常提供更地道的家常菜。",
      "food_en": "Kebap, Turkish Delight (Lokum), Çay, Gözleme, Turkish Coffee, Dondurma, Köfte",
      "price_per_meal_en": "₺150-₺300 (mid-range); ₺70-₺150 (casual)",
      "tips_en": "5-10%; not mandatory in small eateries; cash common, some take cards.",
      "notification_en": "In Istanbul, many small eateries are cash-only.",
      "find_local_food_en": "Explore local bazaars for street food and sweets. Look for small restaurants in residential areas for homestyle dishes."
    },
    {
      "country_id": "PT",
      "food": "葡式蛋挞 (Pastel de Nata), 烤沙丁鱼 (Sardinhas Assadas), 鳕鱼 (Bacalhau), 绿酒 (Vinho Verde), 葡式烤鸡 (Frango Piri-Piri)",
      "price_per_meal": "€12-€25 (中档餐厅); €6-€12 (简餐/小吃)",
      "tips": "5-10%，小费非强制，但可留下零钱；通常现金支付，部分餐厅可刷卡。",
      "notification": "很多餐厅在餐前提供的面包和橄榄会收费，不吃可以退回。",
      "find_local_food": "寻找小酒馆 (Tasca)，品尝传统葡式菜肴。参观烘焙店 (Pastelaria)，品尝新鲜出炉的蛋挞。在沿海地区寻找海鲜餐厅。",
      "food_en": "Pastel de Nata, Sardinhas Assadas, Bacalhau, Vinho Verde, Frango Piri-Piri",
      "price_per_meal_en": "€12-€25 (mid-range); €6-€12 (casual/snacks)",
      "tips_en": "5-10%, not mandatory but leaving change is appreciated; cash common, some take cards.",
      "notification_en": "Bread and olives served before the meal may be charged; you can decline.",
      "find_local_food_en": "Look for Tasca (tavern) for traditional Portuguese dishes. Visit Pastelaria for fresh Pastel de Nata. Seek seafood restaurants on the coast."
    },
    {
      "country_id": "NL",
      "food": "薯条 (Patat/Fries with sauce), 鲱鱼 (Haring), 荷式华夫饼 (Stroopwafel), 荷式煎饼 (Pannenkoeken), 炸肉丸 (Bitterballen)",
      "price_per_meal": "€15-€25 (中档餐厅); €7-€12 (简餐/快餐)",
      "tips": "5-10%，小费非强制，但服务好可留；刷卡支付为主，小费可刷卡添加。",
      "notification": "在咖啡馆和酒吧，通常会四舍五入或给少量零钱作为小费。",
      "find_local_food": "在街头小吃摊品尝薯条和鲱鱼。寻找**Pannenkoekenhuis (煎饼屋)**体验荷式煎饼。在当地咖啡馆品尝Stroopwafel。",
      "food_en": "Patat/Fries with sauce, Haring, Stroopwafel, Pannenkoeken, Bitterballen",
      "price_per_meal_en": "€15-€25 (mid-range); €7-€12 (casual/fast)",
      "tips_en": "5-10%, not mandatory but appreciated; cards main, tip can be added on card.",
      "notification_en": "In cafés and bars, rounding up or a small change is common for tip.",
      "find_local_food_en": "Try fries and herring at street stalls. Look for Pannenkoekenhuis (pancake house). Enjoy Stroopwafel at local cafés."
    },
    {
      "country_id": "CH",
      "food": "芝士火锅 (Cheese Fondue), 巧克力 (Swiss Chocolate), 芝士片 (Raclette), 伯尔尼高地肉盘 (Berner Platte), 瑞士军刀巧克力 (Army Knife Chocolate)",
      "price_per_meal": "CHF 25-CHF 50 (中档餐厅); CHF 15-CHF 25 (简餐)",
      "tips": "通常已包含在账单中，无需额外支付，服务员不期待小费；刷卡支付为主。",
      "notification": "在瑞士，服务费通常已包含在价格中，无需额外给小费。",
      "find_local_food": "在山间小木屋或传统餐厅品尝芝士火锅和Raclette。参观当地巧克力店或作坊。在农夫市集寻找当地特产。",
      "food_en": "Cheese Fondue, Swiss Chocolate, Raclette, Berner Platte, Army Knife Chocolate",
      "price_per_meal_en": "CHF 25-CHF 50 (mid-range); CHF 15-CHF 25 (casual)",
      "tips_en": "Usually included in the bill; no need to tip; cards main.",
      "notification_en": "In Switzerland, service is usually included in the price; no need to tip.",
      "find_local_food_en": "Try fondue and Raclette at mountain chalets or traditional restaurants. Visit chocolate shops or workshops. Look for local produce at farmers' markets."
    },
    {
      "country_id": "AT",
      "food": "维也纳炸肉排 (Wiener Schnitzel), 萨赫蛋糕 (Sachertorte), 苹果卷 (Apfelstrudel), 清炖牛肉 (Tafelspitz), 咖啡 (Kaffee)",
      "price_per_meal": "€15-€30 (中档餐厅); €8-€15 (简餐/咖啡馆)",
      "tips": "5-10%或四舍五入，可直接告诉服务员包含小费的总金额；通常刷卡支付，小费现金或刷卡。",
      "notification": "维也纳的咖啡馆文化非常盛行，值得体验。",
      "find_local_food": "在**传统维也纳咖啡馆 (Kaffeehaus)品尝萨赫蛋糕和咖啡。选择Gasthaus (传统餐馆)**享用维也纳炸肉排。",
      "food_en": "Wiener Schnitzel, Sachertorte, Apfelstrudel, Tafelspitz, Coffee",
      "price_per_meal_en": "€15-€30 (mid-range); €8-€15 (casual/café)",
      "tips_en": "5-10% or round up; you can tell the server the total including tip; cards accepted, tip cash or card.",
      "notification_en": "Vienna's café culture is famous and worth experiencing.",
      "find_local_food_en": "Try Sachertorte and coffee at a traditional Viennese Kaffeehaus. Have Wiener Schnitzel at a Gasthaus."
    },
    {
      "country_id": "IS",
      "food": "羊肉汤 (Kjötsúpa), 热狗 (Pylsur), 发酵鲨鱼肉 (Hákarl), 冰岛酸奶 (Skyr), 龙虾汤 (Humarsúpa)",
      "price_per_meal": "ISK 3000-ISK 6000 (中档餐厅); ISK 1500-ISK 3000 (简餐)",
      "tips": "不强制，但服务好可留下少量零钱；刷卡支付为主，现金小费罕见。",
      "notification": "冰岛物价较高，尤其是餐饮。",
      "find_local_food": "尝试当地快餐亭的热狗，这是冰岛的标志性小吃。在餐厅尝试羊肉汤和新鲜海鲜。",
      "food_en": "Kjötsúpa (lamb soup), Pylsur (hot dog), Hákarl (fermented shark), Skyr, Humarsúpa (lobster soup)",
      "price_per_meal_en": "ISK 3000-ISK 6000 (mid-range); ISK 1500-ISK 3000 (casual)",
      "tips_en": "Not mandatory; leave small change for good service; cards main, cash tip rare.",
      "notification_en": "Prices in Iceland are high, especially for dining.",
      "find_local_food_en": "Try hot dogs at local stands—an Icelandic staple. Have lamb soup and fresh seafood at restaurants."
    },
    {
      "country_id": "CZ",
      "food": "烤猪肘 (Pečené Koleno), 炖牛肉 (Goulash), 炸奶酪 (Smažený Sýr), 啤酒 (Pivo), 甜甜圈 (Trdelník), 饺子 (Knedlíky)",
      "price_per_meal": "CZK 300-CZK 600 (中档餐厅); CZK 150-CZK 300 (简餐)",
      "tips": "5-10%或四舍五入，可直接告诉服务员包含小费的总金额；现金支付较常见，部分餐厅可刷卡。",
      "notification": "啤酒在捷克非常便宜且受欢迎。",
      "find_local_food": "寻找传统捷克酒馆 (Hospoda)，品尝地道菜肴和啤酒。在老城广场尝试街头小吃Trdelník。",
      "food_en": "Pečené Koleno (roast knee), Goulash, Smažený Sýr (fried cheese), Pivo (beer), Trdelník, Knedlíky (dumplings)",
      "price_per_meal_en": "CZK 300-CZK 600 (mid-range); CZK 150-CZK 300 (casual)",
      "tips_en": "5-10% or round up; you can tell the server the total including tip; cash common, some take cards.",
      "notification_en": "Beer is very cheap and popular in the Czech Republic.",
      "find_local_food_en": "Look for traditional Hospoda (pub) for authentic food and beer. Try street Trdelník in Old Town Square."
    },
    {
      "country_id": "IE",
      "food": "爱尔兰炖肉 (Irish Stew), 健力士黑啤 (Guinness), 薯条 (Chips), 爱尔兰咖啡 (Irish Coffee), 索达面包 (Soda Bread)",
      "price_per_meal": "€15-€30 (中档餐厅); €8-€15 (酒吧餐)",
      "tips": "10-15%，服务费有时已包含；通常刷卡支付，小费可刷卡或现金。",
      "notification": "在酒吧通常无需给小费。",
      "find_local_food": "在传统爱尔兰酒吧品尝当地美食和健力士啤酒。在当地面包店购买索达面包。",
      "food_en": "Irish Stew, Guinness, Chips, Irish Coffee, Soda Bread",
      "price_per_meal_en": "€15-€30 (mid-range); €8-€15 (pub food)",
      "tips_en": "10-15%; service charge sometimes included; cards accepted, tip card or cash.",
      "notification_en": "Tipping is not expected in pubs.",
      "find_local_food_en": "Try local food and Guinness at traditional Irish pubs. Buy Soda Bread at local bakeries."
    },
    {
      "country_id": "DK",
      "food": "开放式三明治 (Smørrebrød), 肉丸 (Frikadeller), 丹麦酥 (Danish Pastry), 热狗 (Pølser)",
      "price_per_meal": "DKK 150-DKK 300 (中档餐厅); DKK 70-DKK 150 (简餐/快餐)",
      "tips": "不强制，服务费通常已包含，但服务好可留少量零钱；刷卡支付为主。",
      "notification": "丹麦物价较高。",
      "find_local_food": "在专门的Smørrebrød餐厅或咖啡馆品尝开放式三明治。在街头小吃摊尝试热狗。",
      "food_en": "Smørrebrød, Frikadeller, Danish Pastry, Pølser (hot dog)",
      "price_per_meal_en": "DKK 150-DKK 300 (mid-range); DKK 70-DKK 150 (casual/fast)",
      "tips_en": "Not mandatory; service usually included; leave small change for good service; cards main.",
      "notification_en": "Prices in Denmark are high.",
      "find_local_food_en": "Try Smørrebrød at dedicated restaurants or cafés. Try hot dogs at street stalls."
    },
    {
      "country_id": "SE",
      "food": "瑞典肉丸 (Köttbullar), 鲱鱼 (Herring), 瑞典薄煎饼 (Pancakes), 肉桂卷 (Kanelbullar), 越橘酱 (Lingonberry Jam)",
      "price_per_meal": "SEK 150-SEK 300 (中档餐厅); SEK 80-SEK 150 (简餐/咖啡馆)",
      "tips": "不强制，服务费通常已包含，但可四舍五入；刷卡支付为主。",
      "notification": "瑞典人习惯在账单上四舍五入，而不是额外给小费。",
      "find_local_food": "在当地餐馆或百货公司美食区品尝瑞典肉丸。在咖啡馆享用Fika（咖啡和肉桂卷）。",
      "food_en": "Köttbullar (meatballs), Herring, Pancakes, Kanelbullar (cinnamon buns), Lingonberry Jam",
      "price_per_meal_en": "SEK 150-SEK 300 (mid-range); SEK 80-SEK 150 (casual/café)",
      "tips_en": "Not mandatory; service usually included; rounding up is common; cards main.",
      "notification_en": "Swedes often round the bill rather than leave a separate tip.",
      "find_local_food_en": "Try meatballs at local restaurants or department store food halls. Enjoy Fika (coffee and cinnamon bun) at cafés."
    },
    {
      "country_id": "FI",
      "food": "驯鹿肉 (Reindeer Meat), 鲑鱼汤 (Lohikeitto), 黑麦面包 (Rye Bread), 卡累利阿派 (Karelian Pastry), 肉桂卷 (Cinnamon Bun)",
      "price_per_meal": "€15-€30 (中档餐厅); €8-€15 (简餐/咖啡馆)",
      "tips": "不强制，服务费通常已包含；刷卡支付为主。",
      "notification": "芬兰物价较高，特别是在赫尔辛基。",
      "find_local_food": "尝试**当地市场大厅 (Market Hall)**的餐厅和摊位。在面包店品尝黑麦面包和肉桂卷。",
      "food_en": "Reindeer Meat, Lohikeitto (salmon soup), Rye Bread, Karelian Pastry, Cinnamon Bun",
      "price_per_meal_en": "€15-€30 (mid-range); €8-€15 (casual/café)",
      "tips_en": "Not mandatory; service usually included; cards main.",
      "notification_en": "Prices are high in Finland, especially in Helsinki.",
      "find_local_food_en": "Try Market Hall (Kauppahalli) for restaurants and stalls. Have rye bread and cinnamon buns at bakeries."
    },
    {
      "country_id": "BE",
      "food": "贻贝薯条 (Moules Frites), 华夫饼 (Belgian Waffle), 巧克力 (Belgian Chocolate), 啤酒 (Belgian Beer), 淡菜 (Speculoos)",
      "price_per_meal": "€15-€30 (中档餐厅); €8-€15 (简餐/快餐)",
      "tips": "5-10%，服务费通常已包含，但可留下零钱；通常刷卡支付，小费现金或刷卡。",
      "notification": "啤酒种类繁多，是比利时特色。",
      "find_local_food": "寻找专门的**薯条店 (Frituur)**品尝贻贝和薯条。在街头小吃摊或咖啡馆品尝华夫饼。",
      "food_en": "Moules Frites, Belgian Waffle, Belgian Chocolate, Belgian Beer, Speculoos",
      "price_per_meal_en": "€15-€30 (mid-range); €8-€15 (casual/fast)",
      "tips_en": "5-10%; service often included but leaving change is fine; cards accepted, tip cash or card.",
      "notification_en": "Belgium is famous for its variety of beers.",
      "find_local_food_en": "Look for a Frituur for mussels and fries. Try waffles at street stalls or cafés."
    },
    {
      "country_id": "HU",
      "food": "匈牙利炖牛肉 (Goulash), 渔夫汤 (Halászlé), 薄饼 (Lángos), 烟囱蛋糕 (Kürtőskalács), 鹅肝 (Libamáj)",
      "price_per_meal": "HUF 3000-HUF 6000 (中档餐厅); HUF 1500-HUF 3000 (简餐)",
      "tips": "10-15%，服务费有时已包含，注意查看账单；现金支付较常见，部分餐厅可刷卡。",
      "notification": "匈牙利的鹅肝价格相对亲民。",
      "find_local_food": "在**当地市场 (Market Hall)尝试Lángos。寻找提供每日特色菜 (Daily Menu)**的餐厅，通常更地道。",
      "food_en": "Goulash, Halászlé (fisherman's soup), Lángos, Kürtőskalács (chimney cake), Goose liver",
      "price_per_meal_en": "HUF 3000-HUF 6000 (mid-range); HUF 1500-HUF 3000 (casual)",
      "tips_en": "10-15%; service sometimes included—check the bill; cash common, some take cards.",
      "notification_en": "Goose liver is relatively affordable in Hungary.",
      "find_local_food_en": "Try Lángos at Market Hall. Look for restaurants with daily specials (Daily Menu) for authentic dishes."
    },
    {
      "country_id": "PL",
      "food": "波兰饺子 (Pierogi), 猎人炖肉 (Bigos), 甜甜圈 (Pączki), 罗宋汤 (Barszcz), 波兰香肠 (Kiełbasa)",
      "price_per_meal": "PLN 40-PLN 80 (中档餐厅); PLN 20-PLN 40 (简餐)",
      "tips": "5-10%，小费非强制，但服务好可留；现金支付较常见，部分餐厅可刷卡。",
      "notification": "波兰的食物分量通常很大。",
      "find_local_food": "寻找牛奶吧 (Bar Mleczny)，它们提供经济实惠的传统波兰菜。在老城区的小餐馆尝试Pierogi和Bigos。",
      "food_en": "Pierogi, Bigos, Pączki, Barszcz, Kiełbasa",
      "price_per_meal_en": "PLN 40-PLN 80 (mid-range); PLN 20-PLN 40 (casual)",
      "tips_en": "5-10%, not mandatory but appreciated; cash common, some take cards.",
      "notification_en": "Portions in Poland are usually large.",
      "find_local_food_en": "Look for Bar Mleczny (milk bar) for affordable traditional Polish food. Try Pierogi and Bigos at old town eateries."
    },
    {
      "country_id": "ME",
      "food": "海鲜 (Seafood), 腌肉 (Pršut), 芝士 (Sir), 烤肉 (Roštilj), 葡萄酒 (Vino)",
      "price_per_meal": "€10-€25 (中档餐厅); €5-€10 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "在沿海地区可以品尝到新鲜的海鲜。",
      "find_local_food": "在科托尔湾的Konoba寻找新鲜海鲜。在农村地区尝试家庭农场的腌肉和奶酪。",
      "food_en": "Seafood, Pršut (prosciutto), Sir (cheese), Roštilj (grill), Vino (wine)",
      "price_per_meal_en": "€10-€25 (mid-range); €5-€10 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Fresh seafood is available on the coast.",
      "find_local_food_en": "Look for Konoba in Kotor Bay for fresh seafood. Try farmhouse pršut and cheese in the countryside."
    },
    {
      "country_id": "SI",
      "food": "克拉尼斯卡香肠 (Kranjska Klobasa), 炖汤 (Jota), 饺子 (Štruklji), 蜂巢面包 (Potica)",
      "price_per_meal": "€12-€25 (中档餐厅); €6-€12 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "斯洛文尼亚菜肴融合了周边国家风味。",
      "find_local_food": "寻找提供传统斯洛文尼亚菜肴的餐馆。在面包店或糕点店品尝Potica。",
      "food_en": "Kranjska Klobasa, Jota (stew), Štruklji, Potica",
      "price_per_meal_en": "€12-€25 (mid-range); €6-€12 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Slovenian cuisine blends influences from neighbouring countries.",
      "find_local_food_en": "Look for restaurants serving traditional Slovenian dishes. Try Potica at bakeries or pastry shops."
    },
    {
      "country_id": "NO",
      "food": "熏鲑鱼 (Smoked Salmon), 棕色奶酪 (Brunost), 驯鹿肉 (Reinsdyrkjøtt), 鱼汤 (Fiskesuppe), 肉桂卷 (Skillingsboller)",
      "price_per_meal": "NOK 250-NOK 500 (中档餐厅); NOK 100-NOK 250 (简餐)",
      "tips": "不强制，服务费通常已包含，但可四舍五入；刷卡支付为主。",
      "notification": "挪威物价非常高。",
      "find_local_food": "在海港城市寻找新鲜的熏鲑鱼和海鲜。在当地咖啡馆品尝肉桂卷。",
      "food_en": "Smoked Salmon, Brunost (brown cheese), Reindeer, Fiskesuppe (fish soup), Skillingsboller (cinnamon buns)",
      "price_per_meal_en": "NOK 250-NOK 500 (mid-range); NOK 100-NOK 250 (casual)",
      "tips_en": "Not mandatory; service usually included; rounding up is fine; cards main.",
      "notification_en": "Prices in Norway are very high.",
      "find_local_food_en": "Look for fresh smoked salmon and seafood in harbour towns. Try cinnamon buns at local cafés."
    },
    {
      "country_id": "RS",
      "food": "烤肉 (Ćevapi), 炖菜 (Sarma), 奶酪派 (Burek), 炸肉排 (Karađorđeva šnicla), 浆果酒 (Rakija)",
      "price_per_meal": "RSD 1000-RSD 2500 (中档餐厅); RSD 500-RSD 1000 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "塞尔维亚的烤肉文化非常盛行。",
      "find_local_food": "寻找传统烤肉店 (Roštilj)或Kafana (传统酒馆)。在当地面包店品尝新鲜出炉的Burek。",
      "food_en": "Ćevapi, Sarma, Burek, Karađorđeva šnicla, Rakija",
      "price_per_meal_en": "RSD 1000-RSD 2500 (mid-range); RSD 500-RSD 1000 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Grill culture is very popular in Serbia.",
      "find_local_food_en": "Look for traditional Roštilj (grill) or Kafana (tavern). Try fresh Burek at local bakeries."
    },
    {
      "country_id": "RO",
      "food": "肉丸汤 (Ciorbă de burtă), 卷心菜卷 (Sarmale), 玉米粥 (Mămăligă), 烤肉串 (Mici), 甜甜圈 (Papanași)",
      "price_per_meal": "RON 50-RON 100 (中档餐厅); RON 20-RON 50 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "罗马尼亚的食物通常分量大且口味浓郁。",
      "find_local_food": "寻找**“Crama”（地窖餐厅）**，通常提供传统罗马尼亚菜。在当地市场附近的小餐馆品尝Mici。",
      "food_en": "Ciorbă de burtă, Sarmale, Mămăligă, Mici, Papanași",
      "price_per_meal_en": "RON 50-RON 100 (mid-range); RON 20-RON 50 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Romanian food is often hearty and flavourful.",
      "find_local_food_en": "Look for \"Crama\" (cellar restaurant) for traditional Romanian dishes. Try Mici at small places near markets."
    },
    {
      "country_id": "AL",
      "food": "烤肉 (Qebap), 馅饼 (Byrek), 酸奶酱 (Tzatziki), 羊肉 (Lamb), 土耳其咖啡 (Turke Kafe)",
      "price_per_meal": "ALL 1000-ALL 2500 (中档餐厅); ALL 500-ALL 1000 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "阿尔巴尼亚的餐饮物价相对较低。",
      "find_local_food": "寻找当地的小烤肉店，品尝新鲜的Qebap和Byrek。在咖啡馆体验土耳其咖啡。",
      "food_en": "Qebap, Byrek, Tzatziki, Lamb, Turkish Coffee",
      "price_per_meal_en": "ALL 1000-ALL 2500 (mid-range); ALL 500-ALL 1000 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Food and drink prices in Albania are relatively low.",
      "find_local_food_en": "Look for small local grill shops for fresh Qebap and Byrek. Try Turkish coffee at cafés."
    },
    {
      "country_id": "BG",
      "food": "沙拉 (Shopska Salata), 酸奶 (Kiselo Mlyako), 烤肉 (Kebapche), 肉丸 (Kyufte), 辣椒粉 (Chubritsa)",
      "price_per_meal": "BGN 20-BGN 40 (中档餐厅); BGN 10-BGN 20 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "保加利亚的酸奶非常有名。",
      "find_local_food": "在**传统保加利亚餐馆 (Mehana)**品尝Shopska Salata和烤肉。在当地超市购买保加利亚酸奶。",
      "food_en": "Shopska Salata, Kiselo Mlyako (yogurt), Kebapche, Kyufte, Chubritsa",
      "price_per_meal_en": "BGN 20-BGN 40 (mid-range); BGN 10-BGN 20 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Bulgarian yogurt is famous.",
      "find_local_food_en": "Try Shopska Salata and grilled meat at a traditional Mehana. Buy Bulgarian yogurt at local shops."
    },
    {
      "country_id": "MT",
      "food": "马耳他炖兔肉 (Fenkata), 马耳他面包 (Ħobż biż-Żejt), 马耳他Pastizzi (Pastizzi), 海鲜 (Seafood), 汤 (Soppa tal-Armla)",
      "price_per_meal": "€15-€30 (中档餐厅); €7-€15 (简餐)",
      "tips": "5-10%，服务费有时已包含；通常现金支付，部分餐厅可刷卡。",
      "notification": "马耳他融合了地中海和北非的烹饪风格。",
      "find_local_food": "在小餐馆 (餐厅)尝试炖兔肉。在当地Pastizzeria品尝Pastizzi。在海边寻找新鲜海鲜。",
      "food_en": "Fenkata (rabbit stew), Ħobż biż-Żejt, Pastizzi, Seafood, Soppa tal-Armla",
      "price_per_meal_en": "€15-€30 (mid-range); €7-€15 (casual)",
      "tips_en": "5-10%; service sometimes included; cash common, some take cards.",
      "notification_en": "Maltese cuisine blends Mediterranean and North African influences.",
      "find_local_food_en": "Try rabbit stew at small restaurants. Visit a Pastizzeria for Pastizzi. Look for fresh seafood by the sea."
    },
    {
      "country_id": "EE",
      "food": "血肠 (Verivorst), 酸奶油炖肉 (Mulgikapsad), 黑麦面包 (Rye Bread), 烟熏鱼 (Smoked Fish), 麦芽饮料 (Kali)",
      "price_per_meal": "€12-€25 (中档餐厅); €6-€12 (简餐)",
      "tips": "5-10%，小费非强制；通常刷卡支付。",
      "notification": "爱沙尼亚的食物以传统、朴实为主。",
      "find_local_food": "在塔林老城的传统餐厅品尝当地菜肴。在面包店寻找黑麦面包。",
      "food_en": "Verivorst (blood sausage), Mulgikapsad, Rye Bread, Smoked Fish, Kali",
      "price_per_meal_en": "€12-€25 (mid-range); €6-€12 (casual)",
      "tips_en": "5-10%, not mandatory; cards accepted.",
      "notification_en": "Estonian food is traditional and hearty.",
      "find_local_food_en": "Try local dishes at traditional restaurants in Tallinn Old Town. Look for rye bread at bakeries."
    },
    {
      "country_id": "CY",
      "food": "烤肉 (Souvla), 霍尔米奶酪 (Halloumi Cheese), 葡萄叶卷 (Koupepia), 鱼 (Fish Meze), 甜点 (Loukoumades)",
      "price_per_meal": "€15-€30 (中档餐厅); €7-€15 (简餐)",
      "tips": "5-10%，服务费有时已包含；通常现金支付，部分餐厅可刷卡。",
      "notification": "塞浦路斯的“Meze”是品尝多种当地美食的好方式。",
      "find_local_food": "寻找提供Meze套餐的餐厅，可以一次品尝多种特色菜。在当地市场寻找新鲜霍尔米奶酪。",
      "food_en": "Souvla, Halloumi Cheese, Koupepia, Fish Meze, Loukoumades",
      "price_per_meal_en": "€15-€30 (mid-range); €7-€15 (casual)",
      "tips_en": "5-10%; service sometimes included; cash common, some take cards.",
      "notification_en": "Meze is a great way to try many local dishes at once.",
      "find_local_food_en": "Look for restaurants offering Meze sets. Find fresh Halloumi at local markets."
    },
    {
      "country_id": "SK",
      "food": "羊奶酪饺子 (Bryndzové Halušky), 大蒜汤 (Cesnaková Polievka), 炸肉排 (Vyprážaný Rezeň), 炖菜 (Guláš), 啤酒 (Pivo)",
      "price_per_meal": "€10-€20 (中档餐厅); €5-€10 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "斯洛伐克菜肴偏重且美味。",
      "find_local_food": "在**传统斯洛伐克餐厅 (Koliba或Reštaurácia)**品尝Bryndzové Halušky。",
      "food_en": "Bryndzové Halušky, Cesnaková Polievka (garlic soup), Vyprážaný Rezeň, Guláš, Pivo (beer)",
      "price_per_meal_en": "€10-€20 (mid-range); €5-€10 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Slovak cuisine is hearty and tasty.",
      "find_local_food_en": "Try Bryndzové Halušky at a traditional Koliba or Reštaurácia."
    },
    {
      "country_id": "LV",
      "food": "灰豌豆培根 (Pelēkie zirņi ar speķi), 黑麦面包 (Rupjmaize), 鲱鱼 (Herring), 大麻黄油 (Kaņepju sviests)",
      "price_per_meal": "€12-€25 (中档餐厅); €6-€12 (简餐)",
      "tips": "5-10%，小费非强制；通常刷卡支付。",
      "notification": "拉脱维亚的传统菜肴朴实而有特色。",
      "find_local_food": "在里加中央市场寻找当地小吃和农产品。尝试提供当地菜肴的餐馆。",
      "food_en": "Pelēkie zirņi ar speķi, Rupjmaize (rye bread), Herring, Hemp butter",
      "price_per_meal_en": "€12-€25 (mid-range); €6-€12 (casual)",
      "tips_en": "5-10%, not mandatory; cards accepted.",
      "notification_en": "Traditional Latvian dishes are hearty and distinctive.",
      "find_local_food_en": "Visit Riga Central Market for local snacks and produce. Try restaurants serving local dishes."
    },
    {
      "country_id": "LT",
      "food": "土豆饺子 (Cepelinai), 冷罗宋汤 (Šaltibarščiai), 炸面包 (Kepta duona), 肉丸 (Kibinai), 大麻籽饮料 (Gira)",
      "price_per_meal": "€10-€20 (中档餐厅); €5-€10 (简餐)",
      "tips": "5-10%，小费非强制；通常刷卡支付。",
      "notification": "立陶宛菜肴以土豆为主。",
      "find_local_food": "寻找提供**“Cepelinai”的当地餐馆**。在琥珀湾地区尝试Kibinai。",
      "food_en": "Cepelinai, Šaltibarščiai (cold beet soup), Kepta duona, Kibinai, Gira",
      "price_per_meal_en": "€10-€20 (mid-range); €5-€10 (casual)",
      "tips_en": "5-10%, not mandatory; cards accepted.",
      "notification_en": "Lithuanian cuisine is potato-based.",
      "find_local_food_en": "Look for restaurants serving Cepelinai. Try Kibinai in the Amber Coast region."
    },
    {
      "country_id": "MC",
      "food": "海鲜 (Seafood), 普罗旺斯炖菜 (Ratatouille), 薄饼 (Socca), 鱼汤 (Bouillabaisse)",
      "price_per_meal": "€40-€80+ (中档餐厅); €20-€40 (简餐)",
      "tips": "10-15%，服务费有时已包含；通常刷卡支付。",
      "notification": "摩纳哥餐饮价格非常昂贵。",
      "find_local_food": "摩纳哥的餐饮价格较高，可以考虑在附近的法国尼斯或意大利边境小镇品尝更经济实惠的地道美食。",
      "food_en": "Seafood, Ratatouille, Socca, Bouillabaisse",
      "price_per_meal_en": "€40-€80+ (mid-range); €20-€40 (casual)",
      "tips_en": "10-15%; service sometimes included; cards accepted.",
      "notification_en": "Dining in Monaco is very expensive.",
      "find_local_food_en": "Prices are high in Monaco; consider Nice or nearby Italian towns for more affordable local food."
    },
    {
      "country_id": "LU",
      "food": "猪肉豆子 (Judd mat Gaardebounen), 卢森堡香肠 (Lëtzebuerger Grillwurscht), 苹果馅饼 (Quetschentaart), 葡萄酒 (Luxembourgish Wine)",
      "price_per_meal": "€20-€40 (中档餐厅); €10-€20 (简餐)",
      "tips": "5-10%，服务费通常已包含，但可留下零钱；通常刷卡支付。",
      "notification": "卢森堡的物价相对较高。",
      "find_local_food": "寻找传统卢森堡餐厅，品尝当地特色菜肴。在面包店品尝苹果馅饼。",
      "food_en": "Judd mat Gaardebounen, Lëtzebuerger Grillwurscht, Quetschentaart, Luxembourgish Wine",
      "price_per_meal_en": "€20-€40 (mid-range); €10-€20 (casual)",
      "tips_en": "5-10%; service usually included but leaving change is fine; cards accepted.",
      "notification_en": "Prices in Luxembourg are relatively high.",
      "find_local_food_en": "Look for traditional Luxembourg restaurants for local dishes. Try apple tart at bakeries."
    },
    {
      "country_id": "BA",
      "food": "烤肉 (Ćevapi), 奶酪派 (Burek), 炖菜 (Bosanski Lonac), 咖啡 (Bosanska Kafa), 甜点 (Baklava)",
      "price_per_meal": "BAM 15-BAM 30 (中档餐厅); BAM 7-BAM 15 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "波黑的咖啡文化浓厚。",
      "find_local_food": "在Baščaršija老城区寻找Ćevabdžinica（烤肉店）。在当地烘焙店品尝Burek。",
      "food_en": "Ćevapi, Burek, Bosanski Lonac, Bosanska Kafa, Baklava",
      "price_per_meal_en": "BAM 15-BAM 30 (mid-range); BAM 7-BAM 15 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Coffee culture is strong in Bosnia.",
      "find_local_food_en": "Look for Ćevabdžinica in Baščaršija (Sarajevo). Try Burek at local bakeries."
    },
    {
      "country_id": "MK",
      "food": "马其顿沙拉 (Macedonian Salad), 肉丸 (Kebapi), 炖豆子 (Tavče Gravče), 奶酪 (Sirene), 甜点 (Tulumba)",
      "price_per_meal": "MKD 500-MKD 1000 (中档餐厅); MKD 200-MKD 500 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "马其顿食物通常份量大，口味浓郁。",
      "find_local_food": "寻找提供传统马其顿菜肴的餐馆。在当地市场品尝新鲜奶酪和蔬菜。",
      "food_en": "Macedonian Salad, Kebapi, Tavče Gravče, Sirene, Tulumba",
      "price_per_meal_en": "MKD 500-MKD 1000 (mid-range); MKD 200-MKD 500 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Macedonian portions are usually large and flavourful.",
      "find_local_food_en": "Look for restaurants serving traditional Macedonian dishes. Try fresh cheese and vegetables at local markets."
    },
    {
      "country_id": "AD",
      "food": "炖菜 (Escudella), 烤肉 (Trinxat), 腌肉 (Embotits), 奶酪 (Cheese)",
      "price_per_meal": "€15-€30 (中档餐厅); €8-€15 (简餐)",
      "tips": "5-10%，小费非强制；通常现金支付。",
      "notification": "安道尔美食融合了法西风味。",
      "find_local_food": "寻找**“Borda”（传统安道尔餐厅）**品尝当地特色菜。",
      "food_en": "Escudella, Trinxat, Embotits, Cheese",
      "price_per_meal_en": "€15-€30 (mid-range); €8-€15 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Andorran cuisine blends French and Spanish influences.",
      "find_local_food_en": "Look for \"Borda\" (traditional Andorran restaurant) for local dishes."
    },
    {
      "country_id": "SM",
      "food": "意面 (Pasta), 披萨 (Pizza), 烤肉 (Grilled Meat), 提拉米苏 (Tiramisu)",
      "price_per_meal": "€12-€25 (中档餐厅); €7-€12 (简餐)",
      "tips": "5-10%或四舍五入，服务费有时已包含；通常刷卡支付，小费现金。",
      "notification": "圣马力诺的食物与意大利相似。",
      "find_local_food": "圣马力诺的餐饮与意大利相似，选择评价较高的Trattoria或Pizzeria。",
      "food_en": "Pasta, Pizza, Grilled Meat, Tiramisu",
      "price_per_meal_en": "€12-€25 (mid-range); €7-€12 (casual)",
      "tips_en": "5-10% or round up; service sometimes included; cards accepted, tip in cash.",
      "notification_en": "Food in San Marino is similar to Italian.",
      "find_local_food_en": "Dining is similar to Italy; choose well-rated Trattoria or Pizzeria."
    },
    {
      "country_id": "LI",
      "food": "Käsknöpfle (奶酪面疙瘩), Ribel (玉米粥), Rösti (土豆饼), Fondue (奶酪火锅)",
      "price_per_meal": "CHF 25-CHF 50 (中档餐厅); CHF 15-CHF 25 (简餐)",
      "tips": "不强制，服务费通常已包含；刷卡支付为主。",
      "notification": "列支敦士登物价较高，与瑞士相似。",
      "find_local_food": "寻找**传统餐厅 (Restaurant)**品尝当地特色菜。",
      "food_en": "Käsknöpfle, Ribel, Rösti, Fondue",
      "price_per_meal_en": "CHF 25-CHF 50 (mid-range); CHF 15-CHF 25 (casual)",
      "tips_en": "Not mandatory; service usually included; cards main.",
      "notification_en": "Prices in Liechtenstein are high, similar to Switzerland.",
      "find_local_food_en": "Look for traditional restaurants for local dishes."
    },
    {
      "country_id": "MD",
      "food": "玉米粥 (Mămăligă), 肉丸 (Mititei), 卷心菜卷 (Sarmale), 葡萄酒 (Wine), 甜甜圈 (Plăcintă)",
      "price_per_meal": "MDL 150-MDL 300 (中档餐厅); MDL 70-MDL 150 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "摩尔多瓦以其葡萄酒闻名。",
      "find_local_food": "在当地餐馆品尝Mămăligă和Sarmale。参观葡萄酒庄品尝当地美酒。",
      "food_en": "Mămăligă, Mititei, Sarmale, Wine, Plăcintă",
      "price_per_meal_en": "MDL 150-MDL 300 (mid-range); MDL 70-MDL 150 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Moldova is famous for its wine.",
      "find_local_food_en": "Try Mămăligă and Sarmale at local restaurants. Visit wineries for local wine."
    },
    {
      "country_id": "BY",
      "food": "土豆饼 (Draniki), 甜菜汤 (Borscht), 香肠 (Kiełbasa), 猪肉冻 (Salad), 格瓦斯 (Kvass)",
      "price_per_meal": "BYN 30-BYN 60 (中档餐厅); BYN 15-BYN 30 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "白俄罗斯的食物以土豆为主。",
      "find_local_food": "寻找提供传统白俄罗斯菜肴的餐厅。在当地市场品尝新鲜农产品。",
      "food_en": "Draniki, Borscht, Kiełbasa, Salad, Kvass",
      "price_per_meal_en": "BYN 30-BYN 60 (mid-range); BYN 15-BYN 30 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Belarusian cuisine is potato-based.",
      "find_local_food_en": "Look for restaurants serving traditional Belarusian dishes. Try fresh produce at local markets."
    },
    {
      "country_id": "RU",
      "food": "罗宋汤 (Borscht), 饺子 (Pelmeni), 馅饼 (Pirozhok), 俄式沙拉 (Olivier Salad), 伏特加 (Vodka), 鱼子酱 (Caviar)",
      "price_per_meal": "RUB 800-RUB 2000 (中档餐厅); RUB 400-RUB 800 (简餐)",
      "tips": "5-10%，服务费有时已包含；通常现金支付，部分餐厅可刷卡。",
      "notification": "在俄罗斯，给小费前最好确认服务费是否已包含在账单中。",
      "find_local_food": "寻找传统俄式餐厅，品尝罗宋汤和Pelmeni。在街头小吃摊尝试Pirozhok。",
      "food_en": "Borscht, Pelmeni, Pirozhok, Olivier Salad, Vodka, Caviar",
      "price_per_meal_en": "RUB 800-RUB 2000 (mid-range); RUB 400-RUB 800 (casual)",
      "tips_en": "5-10%; service sometimes included; cash common, some take cards.",
      "notification_en": "Check if service is included before tipping.",
      "find_local_food_en": "Try borscht and Pelmeni at traditional Russian restaurants. Try Pirozhok at street stalls."
    },
    {
      "country_id": "UA",
      "food": "罗宋汤 (Borscht), 饺子 (Varenyky), 基辅鸡 (Chicken Kyiv), 猪油 (Salo), 格瓦斯 (Kvass)",
      "price_per_meal": "UAH 300-UAH 700 (中档餐厅); UAH 150-UAH 300 (简餐)",
      "tips": "5-10%，小费非强制；现金支付较常见。",
      "notification": "乌克兰的食物价格相对实惠。",
      "find_local_food": "寻找**“Puzata Hata”等连锁餐厅**，提供经济实惠的乌克兰传统菜肴。",
      "food_en": "Borscht, Varenyky, Chicken Kyiv, Salo, Kvass",
      "price_per_meal_en": "UAH 300-UAH 700 (mid-range); UAH 150-UAH 300 (casual)",
      "tips_en": "5-10%, not mandatory; cash common.",
      "notification_en": "Food prices in Ukraine are relatively affordable.",
      "find_local_food_en": "Look for chains like Puzata Hata for affordable traditional Ukrainian dishes."
    },
    {
      "country_id": "VA",
      "food": "梵蒂冈城内没有独立餐厅，通常在罗马用餐。",
      "price_per_meal": "参照意大利",
      "tips": "参照意大利",
      "notification": "梵蒂冈城内主要为小吃摊或咖啡馆，正式用餐通常在罗马进行。",
      "find_local_food": "梵蒂冈城内主要是一些咖啡馆和小吃亭。如需地道美食，建议步行至罗马城内，并参考意大利的地道美食建议。",
      "food_en": "There are no standalone restaurants inside Vatican City; meals are usually taken in Rome.",
      "price_per_meal_en": "See Italy",
      "tips_en": "See Italy",
      "notification_en": "Inside the Vatican there are mainly cafés and kiosks; for full meals, go to Rome.",
      "find_local_food_en": "Inside the Vatican there are mainly cafés and kiosks. For local food, walk to Rome and follow Italy tips."
    }
  ]
};

export type SiteData = typeof SITE_DATA;
